/**
 * GQty AUTO-GENERATED CODE: PLEASE DO NOT MODIFY MANUALLY
 */

import { SchemaUnionsKey, type ScalarsEnumsHash } from "gqty";

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `DateTime` scalar type represents time data, represented as an ISO-8601 encoded UTC date string. */
  DateTime: { input: string; output: string };
  /** The `Void` scalar type represents no value being returned. */
  Void: { input: any; output: any };
}

export interface AIGenInput {
  data: Scalars["String"]["input"];
}

export interface AcceptQuoteInput {
  fileIds?: Array<Scalars["ID"]["input"]>;
  quoteId: Scalars["ID"]["input"];
}

export interface ActAsUserFilterInput {
  and?: InputMaybe<Array<ActAsUserFilterInput>>;
  assignedRoles?: InputMaybe<RoleUserFilterInput>;
  authProvider?: InputMaybe<StringFilterInput>;
  authProviderUid?: InputMaybe<StringFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  fullName?: InputMaybe<StringFilterInput>;
  hasPersonIdentity?: InputMaybe<BooleanFilterInput>;
  hasPin?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  identities?: InputMaybe<UserIdentityFilterInput>;
  includeSystem?: InputMaybe<BooleanFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  isCurrent?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  oldRoles?: InputMaybe<UserRoleFilterInput>;
  or?: InputMaybe<Array<ActAsUserFilterInput>>;
  reviewedSuppliers?: InputMaybe<SupplierFilterInput>;
  timers?: InputMaybe<ProcessTimerFilterInput>;
  username?: InputMaybe<StringFilterInput>;
}

export interface AmendPurchaseOrderInput {
  lines: Array<PurchaseOrderLineInput>;
  purchaseOrderId: Scalars["ID"]["input"];
}

export interface AssetFilterInput {
  and?: InputMaybe<Array<AssetFilterInput>>;
  assetType?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<AssetFilterInput>>;
}

export interface AssignBusinessRolesToBatchScheduleInput {
  batchScheduleId: Scalars["ID"]["input"];
  personBusinessRoleIds: Array<Scalars["String"]["input"]>;
  roleType: Scalars["String"]["input"];
}

export interface AssignBusinessRolesToPersonInput {
  businessRoleIds: Array<Scalars["ID"]["input"]>;
  personId: Scalars["ID"]["input"];
}

export interface AssignInheritanceToRoleInput {
  parentRoleIds: Array<Scalars["String"]["input"]>;
  roleId: Scalars["ID"]["input"];
}

export interface AssignLeadsToSalespersonInput {
  leadIds: Array<Scalars["ID"]["input"]>;
  salespersonId: Scalars["String"]["input"];
}

export interface AssignPermissionsToRoleInput {
  permissions: Array<PermissionInput>;
  roleId: Scalars["ID"]["input"];
}

export interface AssignPermissionsToUserInput {
  permissions: Array<PermissionInput>;
  userId: Scalars["ID"]["input"];
}

export interface AssignRolesToUserInput {
  roleIds: Array<Scalars["String"]["input"]>;
  userId: Scalars["ID"]["input"];
}

export interface AssignScreensToRoleInput {
  roleId: Scalars["ID"]["input"];
  screenIds: Array<Scalars["String"]["input"]>;
}

export interface AssignScreensToUserInput {
  screenIds: Array<Scalars["String"]["input"]>;
  userId: Scalars["ID"]["input"];
}

export interface AssignUsersToRoleInput {
  roleId: Scalars["ID"]["input"];
  userIds: Array<Scalars["String"]["input"]>;
}

export interface AssignedPermissionFilterInput {
  id?: InputMaybe<IDFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  user?: InputMaybe<UserFilterInput>;
}

export interface AsyncTaskFilterInput {
  and?: InputMaybe<Array<AsyncTaskFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<AsyncTaskFilterInput>>;
  payload?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
}

export interface AttachmentTemplateFilterInput {
  and?: InputMaybe<Array<AttachmentTemplateFilterInput>>;
  bodyTemplateId?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  fileName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  notificationTemplate?: InputMaybe<NotificationTemplateFilterInput>;
  or?: InputMaybe<Array<AttachmentTemplateFilterInput>>;
  type?: InputMaybe<StringFilterInput>;
}

export interface AuditLogFilterInput {
  and?: InputMaybe<Array<AuditLogFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  event?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<AuditLogFilterInput>>;
  recordId?: InputMaybe<IDFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userIdentity?: InputMaybe<UserIdentityFilterInput>;
}

export enum AuthProviderType {
  emailPassword = "emailPassword",
  legacy = "legacy",
  microsoft = "microsoft",
}

export interface BatchFilterInput {
  and?: InputMaybe<Array<BatchFilterInput>>;
  batchNumber?: InputMaybe<NumberFilterInput>;
  benchtopSupplier?: InputMaybe<StringFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  cubicMetres?: InputMaybe<NumberFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  installationHours?: InputMaybe<NumberFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItems?: InputMaybe<LineItemFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BatchFilterInput>>;
  schedules?: InputMaybe<BatchScheduleFilterInput>;
  sheets?: InputMaybe<NumberFilterInput>;
}

/** Select exactly one typed Batch report dimension. */
export type BatchReportGroupByInput =
  /** Group by Branch or one of its dimensions. */
  | {
      branch: BranchReportRelationDimensionInput;
      job?: never;
    } /** Group by Job or one of its dimensions. */
  | { branch?: never; job: JobReportRelationDimensionInput };

/** Groups by Batch identity, or traverses to one of its typed dimensions. */
export interface BatchReportRelationDimensionInput {
  filter?: InputMaybe<BatchFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<BatchReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface BatchScheduleFilterInput {
  and?: InputMaybe<Array<BatchScheduleFilterInput>>;
  batch?: InputMaybe<BatchFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  dueDate?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BatchScheduleFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  scheduled?: InputMaybe<DateTimeFilterInput>;
}

/** Select exactly one typed Batch Schedule report dimension. */
export type BatchScheduleReportGroupByInput =
  /** Group by Batch or one of its dimensions. */
  | {
      batch: BatchReportRelationDimensionInput;
      dueDate?: never;
      processType?: never;
      scheduled?: never;
    }
  | {
      batch?: never;
      dueDate: DateTimeReportDimensionInput;
      processType?: never;
      scheduled?: never;
    } /** Group by Process Type or one of its dimensions. */
  | {
      batch?: never;
      dueDate?: never;
      processType: ProcessTypeReportRelationDimensionInput;
      scheduled?: never;
    }
  | {
      batch?: never;
      dueDate?: never;
      processType?: never;
      scheduled: DateTimeReportDimensionInput;
    };

export interface BooleanFilterInput {
  eq?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface BranchFilterInput {
  and?: InputMaybe<Array<BranchFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  colour?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  darkColour?: InputMaybe<StringFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BranchFilterInput>>;
  users?: InputMaybe<UserFilterInput>;
}

/** Groups by Branch identity, or traverses to one of its typed dimensions. */
export interface BranchReportRelationDimensionInput {
  filter?: InputMaybe<BranchFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface BuildTypeFilterInput {
  and?: InputMaybe<Array<BuildTypeFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BuildTypeFilterInput>>;
}

/** Groups by Build Type identity, or traverses to one of its typed dimensions. */
export interface BuildTypeReportRelationDimensionInput {
  filter?: InputMaybe<BuildTypeFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface BuilderFilterInput {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<BuilderFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BuilderFilterInput>>;
}

/** Groups by Builder identity, or traverses to one of its typed dimensions. */
export interface BuilderReportRelationDimensionInput {
  filter?: InputMaybe<BuilderFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface BusinessRoleFilterInput {
  and?: InputMaybe<Array<BusinessRoleFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<BusinessRoleFilterInput>>;
  personBusinessRoles?: InputMaybe<PersonBusinessRoleFilterInput>;
}

/** Groups by Business Role identity, or traverses to one of its typed dimensions. */
export interface BusinessRoleReportRelationDimensionInput {
  filter?: InputMaybe<BusinessRoleFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface CalculateQuoteInput {
  expressions?: Array<ExpressionInput>;
  lineTemplates: Array<QuoteLineTemplateInput>;
  lines: Array<QuoteLineInput>;
}

export interface CancelPurchaseOrdersInput {
  purchaseOrderIds: Array<Scalars["ID"]["input"]>;
}

export interface CancelSalesOrderInput {
  salesOrderId: Scalars["ID"]["input"];
}

export interface CancelSupplierQuoteRequestInput {
  supplierQuoteRequestId: Scalars["ID"]["input"];
}

export interface CandidateFilterInput {
  and?: InputMaybe<Array<CandidateFilterInput>>;
  conversionErrors?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  generatedData?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CandidateFilterInput>>;
  shortSummary?: InputMaybe<StringFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  targetRecordId?: InputMaybe<IDFilterInput>;
  targetRecordType?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
}

export enum CandidateIngestionMode {
  autoConvert = "autoConvert",
  disabled = "disabled",
  manualReview = "manualReview",
}

export interface CandidateIngestionPolicyFilterInput {
  and?: InputMaybe<Array<CandidateIngestionPolicyFilterInput>>;
  candidateType?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  mode?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  or?: InputMaybe<Array<CandidateIngestionPolicyFilterInput>>;
  senderRecordId?: InputMaybe<IDFilterInput>;
  senderRecordType?: InputMaybe<StringFilterInput>;
}

export interface ClientFilterInput {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<ClientFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  faxHome?: InputMaybe<StringFilterInput>;
  faxWork?: InputMaybe<StringFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  fullName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  jobs?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ClientFilterInput>>;
  phoneCell?: InputMaybe<StringFilterInput>;
  phoneHome?: InputMaybe<StringFilterInput>;
  phoneWork?: InputMaybe<StringFilterInput>;
}

/** Groups by Client identity, or traverses to one of its typed dimensions. */
export interface ClientReportRelationDimensionInput {
  filter?: InputMaybe<ClientFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface CommitPendingFilesInput {
  defaultFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  files: Array<FileInput>;
  folderId?: InputMaybe<Scalars["ID"]["input"]>;
  recordId: Scalars["String"]["input"];
  recordType: Scalars["String"]["input"];
  uploadToken?: InputMaybe<Scalars["String"]["input"]>;
}

export interface ConfiguredLinkedActionFilterInput {
  actionId?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<ConfiguredLinkedActionFilterInput>>;
  bindings?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  displayOrder?: InputMaybe<NumberFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isGlobal?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ConfiguredLinkedActionFilterInput>>;
  recordPath?: InputMaybe<StringFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
}

export interface ConfirmSalesOrderInput {
  salesOrderId: Scalars["ID"]["input"];
}

export interface ConvertLeadToJobInput {
  jobId: Scalars["ID"]["input"];
  leadId: Scalars["ID"]["input"];
}

export interface CorrespondenceFilterInput {
  and?: InputMaybe<Array<CorrespondenceFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdBy?: InputMaybe<UserFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<DateTimeFilterInput>;
  or?: InputMaybe<Array<CorrespondenceFilterInput>>;
  recordId?: InputMaybe<IDFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
}

export interface CostingFilterInput {
  and?: InputMaybe<Array<CostingFilterInput>>;
  costTotal?: InputMaybe<StringFilterInput>;
  costingTemplateRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  currentRevision?: InputMaybe<CostingRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  jobComponent?: InputMaybe<JobComponentFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<CostingLineFilterInput>;
  marginPercent?: InputMaybe<StringFilterInput>;
  markupTotal?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingFilterInput>>;
  revisions?: InputMaybe<CostingRevisionFilterInput>;
  sellTotal?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
}

export interface CostingLineFilterInput {
  and?: InputMaybe<Array<CostingLineFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  costing?: InputMaybe<CostingFilterInput>;
  costingRevision?: InputMaybe<CostingRevisionFilterInput>;
  costingTemplateRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  lineTemplateId?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<CostingLineFilterInput>;
  markupAmount?: InputMaybe<StringFilterInput>;
  markupExpression?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingLineFilterInput>>;
  parentLine?: InputMaybe<CostingLineFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<StringFilterInput>;
  quantity?: InputMaybe<StringFilterInput>;
  supplierQuote?: InputMaybe<SupplierQuoteFilterInput>;
  supplierQuoteId?: InputMaybe<IDFilterInput>;
  total?: InputMaybe<StringFilterInput>;
  unitCostPrice?: InputMaybe<StringFilterInput>;
  unitSellPrice?: InputMaybe<StringFilterInput>;
}

export interface CostingLineInput {
  costPrice?: InputMaybe<Scalars["String"]["input"]>;
  costing?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  lineTemplateId?: InputMaybe<Scalars["String"]["input"]>;
  lines?: InputMaybe<Array<CostingLineInput>>;
  markupExpression?: InputMaybe<Scalars["String"]["input"]>;
  product?: InputMaybe<Scalars["String"]["input"]>;
  quantity?: InputMaybe<Scalars["String"]["input"]>;
  supplierQuoteId?: InputMaybe<Scalars["String"]["input"]>;
  type?: CostingLineType;
}

export interface CostingLineTemplateFilterInput {
  and?: InputMaybe<Array<CostingLineTemplateFilterInput>>;
  category?: InputMaybe<StringFilterInput>;
  costingTemplateRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  descriptionEditable?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  markupEditable?: InputMaybe<BooleanFilterInput>;
  markupExpression?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingLineTemplateFilterInput>>;
  quantity?: InputMaybe<StringFilterInput>;
  quantityEditable?: InputMaybe<BooleanFilterInput>;
  unitCostPrice?: InputMaybe<StringFilterInput>;
  unitCostPriceEditable?: InputMaybe<BooleanFilterInput>;
}

export interface CostingLineTemplateInput {
  category?: Scalars["String"]["input"];
  costPriceEditable?: Scalars["Boolean"]["input"];
  description: Scalars["String"]["input"];
  descriptionEditable?: Scalars["Boolean"]["input"];
  id: Scalars["String"]["input"];
  markupEditable?: Scalars["Boolean"]["input"];
  markupExpression?: Scalars["String"]["input"];
  quantity: Scalars["String"]["input"];
  quantityEditable?: Scalars["Boolean"]["input"];
  type?: CostingLineType;
  unitCostPrice?: Scalars["String"]["input"];
  unitCostPriceEditable?: Scalars["Boolean"]["input"];
}

export enum CostingLineType {
  COMPOSITE = "COMPOSITE",
  NORMAL = "NORMAL",
}

export interface CostingRevisionFilterInput {
  and?: InputMaybe<Array<CostingRevisionFilterInput>>;
  costTotal?: InputMaybe<StringFilterInput>;
  costing?: InputMaybe<CostingFilterInput>;
  costingTemplateRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<CostingLineFilterInput>;
  marginPercent?: InputMaybe<StringFilterInput>;
  markupTotal?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingRevisionFilterInput>>;
  sellTotal?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  version?: InputMaybe<NumberFilterInput>;
}

export interface CostingTemplateExpressionFilterInput {
  and?: InputMaybe<Array<CostingTemplateExpressionFilterInput>>;
  costingTemplateRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  costingTemplateRevisionId?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingTemplateExpressionFilterInput>>;
  value?: InputMaybe<StringFilterInput>;
}

export interface CostingTemplateFilterInput {
  and?: InputMaybe<Array<CostingTemplateFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  currentRevision?: InputMaybe<CostingTemplateRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isDefault?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CostingTemplateFilterInput>>;
  version?: InputMaybe<NumberFilterInput>;
}

export interface CostingTemplateRevisionFilterInput {
  and?: InputMaybe<Array<CostingTemplateRevisionFilterInput>>;
  costingTemplate?: InputMaybe<CostingTemplateFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  expressions?: InputMaybe<CostingTemplateExpressionFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineTemplates?: InputMaybe<CostingLineTemplateFilterInput>;
  or?: InputMaybe<Array<CostingTemplateRevisionFilterInput>>;
  status?: InputMaybe<NumberFilterInput>;
  version?: InputMaybe<NumberFilterInput>;
}

/** Costing template revision status. */
export enum CostingTemplateRevisionStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export interface CreateBatchInput {
  jobId: Scalars["ID"]["input"];
}

export interface CreateBranchInput {
  code: Scalars["String"]["input"];
  colour: Scalars["String"]["input"];
  darkColour: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
}

export interface CreateBuilderInput {
  address?: InputMaybe<Scalars["String"]["input"]>;
  code?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
}

export interface CreateBusinessRoleInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
}

export interface CreateCandidateInput {
  files?: Array<Scalars["ID"]["input"]>;
  source: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
}

export interface CreateClientInput {
  address?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  faxHome?: InputMaybe<Scalars["String"]["input"]>;
  faxWork?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  phoneCell?: InputMaybe<Scalars["String"]["input"]>;
  phoneHome?: InputMaybe<Scalars["String"]["input"]>;
  phoneWork?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateCorrespondenceInput {
  date?: InputMaybe<Scalars["DateTime"]["input"]>;
  details: Scalars["String"]["input"];
  recordId: Scalars["String"]["input"];
  recordType: Scalars["String"]["input"];
  type: Scalars["Int"]["input"];
}

export interface CreateCostingInput {
  costingTemplateRevisionId?: InputMaybe<Scalars["ID"]["input"]>;
  jobComponentId?: InputMaybe<Scalars["ID"]["input"]>;
  jobId?: InputMaybe<Scalars["ID"]["input"]>;
  lines?: Array<CostingLineInput>;
  name: Scalars["String"]["input"];
}

export interface CreateCostingTemplateInput {
  isDefault?: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
}

export interface CreateCostingTemplateRevisionInput {
  costingTemplateId: Scalars["String"]["input"];
  costingTemplateRevisionId?: InputMaybe<Scalars["String"]["input"]>;
  defaultLines: Array<CostingLineInput>;
  expressions: Array<ExpressionInput>;
  lineTemplates: Array<CostingLineTemplateInput>;
  publish?: Scalars["Boolean"]["input"];
}

export interface CreateDocumentTemplateInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  recordType: Scalars["String"]["input"];
}

export interface CreateFileInput {
  hash: Scalars["String"]["input"];
  metadata?: InputMaybe<Scalars["String"]["input"]>;
  mimeType?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  persistenceType?: InputMaybe<Scalars["Int"]["input"]>;
  resourceId: Scalars["String"]["input"];
  resourceType: Scalars["String"]["input"];
  size: Scalars["Int"]["input"];
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface CreateFolderInput {
  name: Scalars["String"]["input"];
  parentFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  recordId: Scalars["ID"]["input"];
  recordType: Scalars["String"]["input"];
}

export interface CreateHousingCompanyImageInput {
  hash: Scalars["String"]["input"];
  housingCompanyId: Scalars["ID"]["input"];
  mimeType?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  size: Scalars["Int"]["input"];
  url?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateHousingCompanyInput {
  code?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
}

export interface CreateIssueInput {
  completed?: Scalars["Boolean"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  files?: InputMaybe<Array<Scalars["String"]["input"]>>;
  recordId?: InputMaybe<Scalars["String"]["input"]>;
  recordType?: InputMaybe<Scalars["String"]["input"]>;
  requiredDate?: InputMaybe<Scalars["DateTime"]["input"]>;
}

export interface CreateJobComponentInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  jobId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  partTypeId?: InputMaybe<Scalars["ID"]["input"]>;
}

export interface CreateJobEmailInput {
  body: Scalars["String"]["input"];
  jobId: Scalars["ID"]["input"];
  subject: Scalars["String"]["input"];
  to: Scalars["String"]["input"];
}

export interface CreateJobInput {
  address?: InputMaybe<Scalars["String"]["input"]>;
  benchtopOnly: Scalars["Boolean"]["input"];
  branch: Scalars["ID"]["input"];
  buildType: Scalars["ID"]["input"];
  builder?: InputMaybe<Scalars["ID"]["input"]>;
  builderPhone?: InputMaybe<Scalars["String"]["input"]>;
  client: Scalars["ID"]["input"];
  designer?: InputMaybe<Scalars["ID"]["input"]>;
  difficultAccess: Scalars["Boolean"]["input"];
  estimatedDueDate: Scalars["DateTime"]["input"];
  hcJobNumber?: InputMaybe<Scalars["String"]["input"]>;
  hcPmPhone?: InputMaybe<Scalars["String"]["input"]>;
  hcProjectManager?: InputMaybe<Scalars["String"]["input"]>;
  housingCompany?: InputMaybe<Scalars["ID"]["input"]>;
  jobName?: InputMaybe<Scalars["String"]["input"]>;
  jobQuantity: Scalars["Int"]["input"];
  leadId?: InputMaybe<Scalars["ID"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  project?: InputMaybe<Scalars["String"]["input"]>;
  projectManager?: InputMaybe<Scalars["ID"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
  saleType: Scalars["ID"]["input"];
  showHome: Scalars["Boolean"]["input"];
  siteNotes?: InputMaybe<Scalars["String"]["input"]>;
  sssp: Scalars["Boolean"]["input"];
  tristoneJoin: Scalars["Boolean"]["input"];
  tristoneSpecified: Scalars["Boolean"]["input"];
  unit: Scalars["Boolean"]["input"];
}

export interface CreateLeadInput {
  address?: InputMaybe<Scalars["String"]["input"]>;
  assignedTo?: InputMaybe<Scalars["String"]["input"]>;
  branchId?: InputMaybe<Scalars["String"]["input"]>;
  builderName?: InputMaybe<Scalars["String"]["input"]>;
  builderType?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  client: Scalars["String"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  joineryTypes?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  priceRangeBottom?: InputMaybe<Scalars["Float"]["input"]>;
  priceRangeTop?: InputMaybe<Scalars["Float"]["input"]>;
  priority?: InputMaybe<Scalars["Int"]["input"]>;
  projectType: Scalars["String"]["input"];
  requiredBy?: InputMaybe<Scalars["String"]["input"]>;
  source: Scalars["String"]["input"];
  suburb?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateLineItemInput {
  batchId?: InputMaybe<Scalars["ID"]["input"]>;
  jobId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  partTypeId: Scalars["ID"]["input"];
}

export interface CreateLostReasonInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
}

export interface CreatePanelInput {
  config: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
}

export interface CreatePartTypeInput {
  code: Scalars["String"]["input"];
  colour: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
}

export interface CreatePersonInput {
  branchId?: InputMaybe<Scalars["ID"]["input"]>;
  businessRoleIds?: Array<Scalars["ID"]["input"]>;
  isActive?: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  userId?: InputMaybe<Scalars["ID"]["input"]>;
}

export interface CreateProcessTimerInput {
  processInstanceIds: Array<Scalars["String"]["input"]>;
}

export interface CreateProcessTypeInput {
  code: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
}

export interface CreateProcessTypeNoteInput {
  assignedProcessIds: Array<Scalars["ID"]["input"]>;
  date?: InputMaybe<Scalars["String"]["input"]>;
  note: Scalars["String"]["input"];
}

export interface CreateProcessTypeRoleInput {
  processTypeId: Scalars["ID"]["input"];
  roleType: Scalars["String"]["input"];
}

export interface CreateProductCategoryInput {
  group: Scalars["ID"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  name: Scalars["String"]["input"];
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
}

export interface CreateProductInput {
  category?: InputMaybe<Scalars["ID"]["input"]>;
  code: Scalars["String"]["input"];
  deleted: Scalars["Boolean"]["input"];
  indent: Scalars["Boolean"]["input"];
  leadTime?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  qtyReviewThreshold: Scalars["Int"]["input"];
  safetyStockDays: Scalars["Int"]["input"];
  starred: Scalars["Boolean"]["input"];
  stockItem: Scalars["Boolean"]["input"];
  supplier: Scalars["ID"]["input"];
  tags: Array<Scalars["ID"]["input"]>;
  template: Scalars["Boolean"]["input"];
  unitOfMeasure: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
}

export interface CreateProductPriceInput {
  effectiveDate: Scalars["String"]["input"];
  productId: Scalars["ID"]["input"];
  type: Scalars["String"]["input"];
  unitPrice: Scalars["String"]["input"];
}

export interface CreateProjectInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
}

export interface CreatePurchaseOrderFromSupplierQuoteInput {
  supplierQuoteId: Scalars["ID"]["input"];
}

export interface CreatePurchaseOrderInput {
  category?: InputMaybe<OrderCategory>;
  deliveryAddress?: InputMaybe<Scalars["String"]["input"]>;
  deliveryAddressId?: InputMaybe<Scalars["ID"]["input"]>;
  internalComment?: InputMaybe<Scalars["String"]["input"]>;
  jobId?: InputMaybe<Scalars["ID"]["input"]>;
  lines?: InputMaybe<Array<PurchaseOrderLineInput>>;
  notifySupplierWhenPlaced?: Scalars["Boolean"]["input"];
  reference?: InputMaybe<Scalars["String"]["input"]>;
  required?: InputMaybe<Scalars["String"]["input"]>;
  shippingMethod?: InputMaybe<OrderShippingMethods>;
  shippingTerms?: InputMaybe<OrderShippingTerms>;
  siteVisitRequired?: Scalars["Boolean"]["input"];
  statusWhenPlaced?: InputMaybe<OrderStatus>;
  supplierComment?: InputMaybe<Scalars["String"]["input"]>;
  supplierId?: InputMaybe<Scalars["ID"]["input"]>;
  templateId?: InputMaybe<Scalars["ID"]["input"]>;
  urgent?: Scalars["Boolean"]["input"];
  warehouseId?: InputMaybe<Scalars["ID"]["input"]>;
}

export interface CreatePurchaseOrderReceiptInput {
  notes?: InputMaybe<Scalars["String"]["input"]>;
  orderLines: Array<PurchaseOrderReceiptLineInput>;
  purchaseOrderId: Scalars["ID"]["input"];
  reference?: InputMaybe<Scalars["String"]["input"]>;
  warehouseId: Scalars["ID"]["input"];
}

export interface CreateQuoteApprovalRequestInput {
  quoteId: Scalars["ID"]["input"];
}

export interface CreateQuoteInput {
  clientAddress?: InputMaybe<Scalars["String"]["input"]>;
  clientName: Scalars["String"]["input"];
  contactName?: InputMaybe<Scalars["String"]["input"]>;
  customer?: InputMaybe<Scalars["ID"]["input"]>;
  files?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  jobId?: InputMaybe<Scalars["ID"]["input"]>;
  lineItemId?: InputMaybe<Scalars["ID"]["input"]>;
  lines: Array<QuoteLineInput>;
  quoteRequestId?: InputMaybe<Scalars["ID"]["input"]>;
  quoteTemplateRevisionId?: InputMaybe<Scalars["ID"]["input"]>;
  reference: Scalars["String"]["input"];
}

export interface CreateQuoteTemplateInput {
  isDefault?: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
}

export interface CreateQuoteTemplateRevisionInput {
  defaultLines: Array<QuoteLineInput>;
  expressions: Array<ExpressionInput>;
  lineTemplates: Array<QuoteLineTemplateInput>;
  publish?: Scalars["Boolean"]["input"];
  quoteTemplateId: Scalars["String"]["input"];
  quoteTemplateRevisionId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateRecordFileInput {
  entity: Scalars["String"]["input"];
  fileId: Scalars["String"]["input"];
  metadata?: InputMaybe<Scalars["String"]["input"]>;
  recordId: Scalars["Int"]["input"];
}

export interface CreateRoleInput {
  description: Scalars["String"]["input"];
  inheritFrom?: Array<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
}

export interface CreateSalesOrderInput {
  clientAddress?: InputMaybe<Scalars["String"]["input"]>;
  clientId?: InputMaybe<Scalars["ID"]["input"]>;
  clientName: Scalars["String"]["input"];
  contactName?: InputMaybe<Scalars["String"]["input"]>;
  currency?: Scalars["String"]["input"];
  jobId?: InputMaybe<Scalars["ID"]["input"]>;
  lines: Array<SalesOrderLineInput>;
  reference?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateSchemaInput {
  description: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  recordType: Scalars["String"]["input"];
}

export interface CreateScreenInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  group?: InputMaybe<ScreenGroup>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  recordId?: InputMaybe<Scalars["String"]["input"]>;
  recordType?: InputMaybe<Scalars["String"]["input"]>;
  screenCfg: Scalars["String"]["input"];
}

export interface CreateSignedUploadUrlInput {
  filename: Scalars["String"]["input"];
  mimeType: Scalars["String"]["input"];
}

export interface CreateStorageConnectionInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  deviceAccessEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  dropboxAuthToken?: InputMaybe<Scalars["String"]["input"]>;
  dropboxNamespaceId?: InputMaybe<Scalars["String"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  localRoot?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  root: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
}

export interface CreateStorageResourceMappingInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  externalStorageConnectionId: Scalars["ID"]["input"];
  path?: InputMaybe<Scalars["String"]["input"]>;
  resourceFilter?: InputMaybe<Scalars["String"]["input"]>;
  resourceType: Scalars["String"]["input"];
}

export interface CreateSubscriptionInput {
  enabled?: Scalars["Boolean"]["input"];
  event: Scalars["String"]["input"];
  maxRecipients?: InputMaybe<Scalars["Int"]["input"]>;
  notifications?: Array<NotificationInput>;
  sourceFilter?: InputMaybe<Scalars["String"]["input"]>;
  targetFilter?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateSupplierImageInput {
  hash: Scalars["String"]["input"];
  mimeType?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  size: Scalars["Int"]["input"];
  supplierId: Scalars["ID"]["input"];
  url?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateSupplierInput {
  address: Scalars["String"]["input"];
  categoryId?: InputMaybe<Scalars["ID"]["input"]>;
  cell: Scalars["String"]["input"];
  currency: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  orderEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  quoteEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  url: Scalars["String"]["input"];
}

export interface CreateSupplierQuoteInput {
  files?: Array<Scalars["ID"]["input"]>;
  jobId?: InputMaybe<Scalars["ID"]["input"]>;
  lines?: Array<SupplierQuoteLineInput>;
  quoteRequestId?: InputMaybe<Scalars["ID"]["input"]>;
  reference?: InputMaybe<Scalars["String"]["input"]>;
  salesTax?: Scalars["String"]["input"];
  saveAsDraft?: Scalars["Boolean"]["input"];
  supplierId?: InputMaybe<Scalars["ID"]["input"]>;
  supplierQuoteNumber?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateSupplierQuoteRequestInput {
  files?: Array<Scalars["ID"]["input"]>;
  jobId?: InputMaybe<Scalars["ID"]["input"]>;
  lines: Array<SupplierQuoteRequestLineInput>;
  noteForSupplier: Scalars["String"]["input"];
  place?: InputMaybe<Scalars["Boolean"]["input"]>;
  reference: Scalars["String"]["input"];
  supplierIds: Array<Scalars["ID"]["input"]>;
}

export interface CreateTagInput {
  colour: Scalars["String"]["input"];
  context: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
}

export interface CreateUserIdentityInput {
  entity: Scalars["String"]["input"];
  recordId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
}

export interface CreateUserInput {
  authProvider: AuthProviderType;
  branchId?: InputMaybe<Scalars["String"]["input"]>;
  fullName: Scalars["String"]["input"];
  password?: InputMaybe<Scalars["String"]["input"]>;
  personId?: InputMaybe<Scalars["ID"]["input"]>;
  roles?: InputMaybe<Array<Scalars["String"]["input"]>>;
  username: Scalars["String"]["input"];
}

export interface CreateWarehouseInput {
  address: Scalars["String"]["input"];
  code?: InputMaybe<Scalars["String"]["input"]>;
  color?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
}

export interface CreateWebhookInput {
  authType?: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  enabled: Scalars["Boolean"]["input"];
  event: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  sourceFilter?: InputMaybe<Scalars["String"]["input"]>;
  url: Scalars["String"]["input"];
}

export interface CreateWorkflowTypeInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  master: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
}

export interface CustomDataFilterInput {
  and?: InputMaybe<Array<CustomDataFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  data?: InputMaybe<JsonFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CustomDataFilterInput>>;
  recordId?: InputMaybe<IDFilterInput>;
  schema?: InputMaybe<SchemaFilterInput>;
  schemaId?: InputMaybe<StringFilterInput>;
  schemaVersion?: InputMaybe<SchemaVersionFilterInput>;
}

export interface CustomTemplateFilterInput {
  and?: InputMaybe<Array<CustomTemplateFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  default?: InputMaybe<BooleanFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  entity?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CustomTemplateFilterInput>>;
  query?: InputMaybe<StringFilterInput>;
  sampleDataOverride?: InputMaybe<StringFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  template?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<NumberFilterInput>;
}

export interface DateTimeFilterInput {
  eq?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
}

/** Groups a DateTime field into calendar intervals within a typed date filter. */
export interface DateTimeReportDimensionInput {
  filter: DateTimeFilterInput;
  /** Include interval values for which the aggregate is zero. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
  interval: ReportDateInterval;
  /** Restrict contributing values to the same relative date range within every interval. */
  withinEachInterval?: InputMaybe<DateTimeFilterInput>;
}

export interface DeactivatePersonInput {
  personId: Scalars["ID"]["input"];
  userIds: Array<Scalars["ID"]["input"]>;
}

export interface DefaultFolderFilterInput {
  and?: InputMaybe<Array<DefaultFolderFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<DefaultFolderFilterInput>>;
  recordType?: InputMaybe<StringFilterInput>;
}

export interface DeleteBatchesInput {
  batchIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteBranchesInput {
  branchIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteBuildersInput {
  builderIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteClientsInput {
  clientIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteConfiguredLinkedActionsInput {
  ids: Array<Scalars["ID"]["input"]>;
}

export interface DeleteCorrespondenceInput {
  correspondenceId: Scalars["ID"]["input"];
}

export interface DeleteCostingInput {
  costingId: Scalars["ID"]["input"];
}

export interface DeleteDraftPurchaseOrdersInput {
  purchaseOrderIds: Array<Scalars["String"]["input"]>;
}

export interface DeleteExternalStorageItemsInput {
  paths: Array<Scalars["String"]["input"]>;
}

export interface DeleteHousingCompaniesInput {
  housingCompanyIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteHousingCompanyImageInput {
  housingCompanyId: Scalars["ID"]["input"];
}

export interface DeleteJobComponentInput {
  jobComponentId: Scalars["ID"]["input"];
}

export interface DeleteLeadsInput {
  leadIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteLineItemsInput {
  lineItemIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteLostReasonsInput {
  lostReasonIds: Array<Scalars["ID"]["input"]>;
}

export interface DeletePanelsInput {
  panelIds: Array<Scalars["ID"]["input"]>;
}

export interface DeletePartTypesInput {
  partTypeIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteProcessTypeNoteInput {
  processTypeNoteId: Scalars["ID"]["input"];
}

export interface DeleteProcessTypeRolesInput {
  processTypeRoleIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteProcessTypesInput {
  processTypeIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteProductCategoriesInput {
  cascade: Scalars["Boolean"]["input"];
  productCategoryIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteProductPricesInput {
  productPriceIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteRecordFilesInput {
  ids: Array<Scalars["String"]["input"]>;
}

export interface DeleteSalesOrderInput {
  salesOrderId: Scalars["ID"]["input"];
}

export interface DeleteScreensInput {
  screenIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteSupplierImageInput {
  supplierId: Scalars["ID"]["input"];
}

export interface DeleteSupplierQuoteInput {
  supplierQuoteId: Scalars["ID"]["input"];
}

export interface DeleteSupplierQuoteRequestInput {
  supplierQuoteRequestId: Scalars["ID"]["input"];
}

export interface DeleteSuppliersInput {
  supplierIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteUserIdentitiesInput {
  userIdentityIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteWebhooksInput {
  webhookIds: Array<Scalars["ID"]["input"]>;
}

export interface DeleteWorkflowTypesInput {
  workflowTypeIds: Array<Scalars["ID"]["input"]>;
}

export interface DeliveryAddressFilterInput {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<DeliveryAddressFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  color?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  or?: InputMaybe<Array<DeliveryAddressFilterInput>>;
}

export interface DocumentTemplateFilterInput {
  and?: InputMaybe<Array<DocumentTemplateFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  default?: InputMaybe<BooleanFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  entity?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<DocumentTemplateFilterInput>>;
  query?: InputMaybe<StringFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  sampleDataOverride?: InputMaybe<StringFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  template?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
}

/** All discovered domain event GraphQL type names. */
export enum DomainEventType {
  BatchCreatedEvent = "BatchCreatedEvent",
  BatchDeletedEvent = "BatchDeletedEvent",
  BatchRecalculateDueDateEvent = "BatchRecalculateDueDateEvent",
  BatchStatusCheckEvent = "BatchStatusCheckEvent",
  BatchUpdatedEvent = "BatchUpdatedEvent",
  BranchCreatedEvent = "BranchCreatedEvent",
  BranchDeletedEvent = "BranchDeletedEvent",
  BranchRestoredEvent = "BranchRestoredEvent",
  BranchUpdatedEvent = "BranchUpdatedEvent",
  CandidateCreatedEvent = "CandidateCreatedEvent",
  CustomDataSetEvent = "CustomDataSetEvent",
  EmailCreatedEvent = "EmailCreatedEvent",
  EmailStatusChangedEvent = "EmailStatusChangedEvent",
  FileUploadedEvent = "FileUploadedEvent",
  InternalCommentUpdatedEvent = "InternalCommentUpdatedEvent",
  InvalidateCacheEvent = "InvalidateCacheEvent",
  InvoiceCheckedEvent = "InvoiceCheckedEvent",
  InvoiceUncheckedEvent = "InvoiceUncheckedEvent",
  IssueCreatedEvent = "IssueCreatedEvent",
  IssueUpdatedEvent = "IssueUpdatedEvent",
  JobBuilderUpdatedEvent = "JobBuilderUpdatedEvent",
  JobClientUpdatedEvent = "JobClientUpdatedEvent",
  JobCreatedEvent = "JobCreatedEvent",
  JobDetailsUpdatedEvent = "JobDetailsUpdatedEvent",
  JobPartBatchChangedEvent = "JobPartBatchChangedEvent",
  JobPartConfirmedEvent = "JobPartConfirmedEvent",
  JobPartCreatedEvent = "JobPartCreatedEvent",
  JobPartDeletedEvent = "JobPartDeletedEvent",
  JobPartUpdatedEvent = "JobPartUpdatedEvent",
  JobSiteUpdatedEvent = "JobSiteUpdatedEvent",
  JobStatusChangedEvent = "JobStatusChangedEvent",
  LeadAssignedEvent = "LeadAssignedEvent",
  LeadBranchChangedEvent = "LeadBranchChangedEvent",
  LeadConvertedToJobEvent = "LeadConvertedToJobEvent",
  LeadCreatedEvent = "LeadCreatedEvent",
  LeadDetailsUpdatedEvent = "LeadDetailsUpdatedEvent",
  LeadOverrideStatusEvent = "LeadOverrideStatusEvent",
  LeadStatusChangedEvent = "LeadStatusChangedEvent",
  LineItemMasterWorkflowCompletedEvent = "LineItemMasterWorkflowCompletedEvent",
  OrderEmailStatusUpdatedEvent = "OrderEmailStatusUpdatedEvent",
  OrderOverrideStatusEvent = "OrderOverrideStatusEvent",
  OrderReceiptCreatedEvent = "OrderReceiptCreatedEvent",
  OrderRevisionCreatedEvent = "OrderRevisionCreatedEvent",
  PartTypeCreatedEvent = "PartTypeCreatedEvent",
  PartTypeDeletedEvent = "PartTypeDeletedEvent",
  PartTypeRestoredEvent = "PartTypeRestoredEvent",
  PartTypeUpdatedEvent = "PartTypeUpdatedEvent",
  ProcessTypeCreatedEvent = "ProcessTypeCreatedEvent",
  ProcessTypeDeletedEvent = "ProcessTypeDeletedEvent",
  ProcessTypeRestoredEvent = "ProcessTypeRestoredEvent",
  ProcessTypeUpdatedEvent = "ProcessTypeUpdatedEvent",
  ProductCreatedEvent = "ProductCreatedEvent",
  ProductDetailsUpdatedEvent = "ProductDetailsUpdatedEvent",
  ProductPriceCreatedEvent = "ProductPriceCreatedEvent",
  ProductPriceDeletedEvent = "ProductPriceDeletedEvent",
  PurchaseOrderAmendedEvent = "PurchaseOrderAmendedEvent",
  PurchaseOrderApprovedEvent = "PurchaseOrderApprovedEvent",
  PurchaseOrderCancelledEvent = "PurchaseOrderCancelledEvent",
  PurchaseOrderIncompleteEvent = "PurchaseOrderIncompleteEvent",
  PurchaseOrderPendingReviewEvent = "PurchaseOrderPendingReviewEvent",
  PurchaseOrderPlacedEvent = "PurchaseOrderPlacedEvent",
  PurchaseOrderReceivedEvent = "PurchaseOrderReceivedEvent",
  PurchaseOrderRejectedEvent = "PurchaseOrderRejectedEvent",
  PurchaseOrderReleasedEvent = "PurchaseOrderReleasedEvent",
  PurchaseOrderSupplierNotificationManuallySentEvent = "PurchaseOrderSupplierNotificationManuallySentEvent",
  PurchaseOrderSupplierNotificationSentEvent = "PurchaseOrderSupplierNotificationSentEvent",
  QuoteApprovalRequestedEvent = "QuoteApprovalRequestedEvent",
  QuoteRequestAcceptedEvent = "QuoteRequestAcceptedEvent",
  QuoteRequestPlacedEvent = "QuoteRequestPlacedEvent",
  QuoteRequestQuotedEvent = "QuoteRequestQuotedEvent",
  RecordFileDeletedEvent = "RecordFileDeletedEvent",
  RecordFilesUploadedEvent = "RecordFilesUploadedEvent",
  RoleCreatedEvent = "RoleCreatedEvent",
  RoleDeletedEvent = "RoleDeletedEvent",
  RoleDetailsUpdatedEvent = "RoleDetailsUpdatedEvent",
  RoleInheritanceAssignmentUpdatedEvent = "RoleInheritanceAssignmentUpdatedEvent",
  RolePermissionsAssignmentUpdatedEvent = "RolePermissionsAssignmentUpdatedEvent",
  RoleScreensAssignmentUpdatedEvent = "RoleScreensAssignmentUpdatedEvent",
  RoleUsersAssignmentUpdatedEvent = "RoleUsersAssignmentUpdatedEvent",
  SchemaCreatedEvent = "SchemaCreatedEvent",
  SchemaDeletedEvent = "SchemaDeletedEvent",
  SchemaUpdatedEvent = "SchemaUpdatedEvent",
  SchemaVersionActiveEvent = "SchemaVersionActiveEvent",
  SchemaVersionCreatedEvent = "SchemaVersionCreatedEvent",
  SchemaVersionDeletedEvent = "SchemaVersionDeletedEvent",
  SchemaVersionUpdatedEvent = "SchemaVersionUpdatedEvent",
  ScreenCreatedEvent = "ScreenCreatedEvent",
  ScreenDeletedEvent = "ScreenDeletedEvent",
  ScreenUpdatedEvent = "ScreenUpdatedEvent",
  StatusChangedEvent = "StatusChangedEvent",
  StatusUpdatedEvent = "StatusUpdatedEvent",
  StockTakeCreatedEvent = "StockTakeCreatedEvent",
  StockTransactionCreatedEvent = "StockTransactionCreatedEvent",
  SupplierCreatedEvent = "SupplierCreatedEvent",
  SupplierDeletedEvent = "SupplierDeletedEvent",
  SupplierDetailsUpdatedEvent = "SupplierDetailsUpdatedEvent",
  SupplierReviewersUpdatedEvent = "SupplierReviewersUpdatedEvent",
  SupplierStatusUpdatedEvent = "SupplierStatusUpdatedEvent",
  TemplateCreatedEvent = "TemplateCreatedEvent",
  TemplateDeletedEvent = "TemplateDeletedEvent",
  TemplateUpdatedEvent = "TemplateUpdatedEvent",
  UserCreatedEvent = "UserCreatedEvent",
  UserDeletedEvent = "UserDeletedEvent",
  UserDisabledEvent = "UserDisabledEvent",
  UserEnabledEvent = "UserEnabledEvent",
  UserPermissionsUpdatedEvent = "UserPermissionsUpdatedEvent",
  UserRestoredEvent = "UserRestoredEvent",
  UserRolesUpdatedEvent = "UserRolesUpdatedEvent",
  UserScreensUpdatedEvent = "UserScreensUpdatedEvent",
  UserUpdatedEvent = "UserUpdatedEvent",
  WarehouseCreatedEvent = "WarehouseCreatedEvent",
  WarehouseDeletedEvent = "WarehouseDeletedEvent",
  WarehouseStockReceivedEvent = "WarehouseStockReceivedEvent",
  WarehouseStockTakeEvent = "WarehouseStockTakeEvent",
  WarehouseStockTransferReceivedEvent = "WarehouseStockTransferReceivedEvent",
  WarehouseStockTransferWithdrawnEvent = "WarehouseStockTransferWithdrawnEvent",
  WarehouseStockWithdrawnEvent = "WarehouseStockWithdrawnEvent",
  WarehouseUpdatedEvent = "WarehouseUpdatedEvent",
  WebhookCallFailedEvent = "WebhookCallFailedEvent",
  WebhookCalledEvent = "WebhookCalledEvent",
  WebhookCreatedEvent = "WebhookCreatedEvent",
  WebhookDeletedEvent = "WebhookDeletedEvent",
  WebhookUpdatedEvent = "WebhookUpdatedEvent",
  WorkflowTypeCreatedEvent = "WorkflowTypeCreatedEvent",
  WorkflowTypeDeletedEvent = "WorkflowTypeDeletedEvent",
  WorkflowTypeRestoredEvent = "WorkflowTypeRestoredEvent",
  WorkflowTypeUpdatedEvent = "WorkflowTypeUpdatedEvent",
}

/** Transactional email delivery status. */
export enum EmailDeliveryStatus {
  DELIVERED = "DELIVERED",
  FAILED = "FAILED",
  NOT_SENT = "NOT_SENT",
  PENDING = "PENDING",
}

export interface EmailDeliveryStatusFilterInput {
  eq?: InputMaybe<EmailDeliveryStatus>;
  in?: InputMaybe<Array<EmailDeliveryStatus>>;
}

export interface EmailFilterInput {
  and?: InputMaybe<Array<EmailFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  messageId?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<EmailFilterInput>>;
  purchaseOrder?: InputMaybe<PurchaseOrderFilterInput>;
  recipient?: InputMaybe<StringFilterInput>;
  sender?: InputMaybe<StringFilterInput>;
  sentAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<EmailDeliveryStatusFilterInput>;
  subject?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  typeDisplayName?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
}

export interface ExpressionInput {
  name: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
}

export interface ExternalStorageConnectionFilterInput {
  and?: InputMaybe<Array<ExternalStorageConnectionFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  localRoot?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ExternalStorageConnectionFilterInput>>;
  root?: InputMaybe<StringFilterInput>;
  storageMappings?: InputMaybe<ExternalStorageResourceMappingFilterInput>;
  type?: InputMaybe<StringFilterInput>;
}

export interface ExternalStorageItemFilterInput {
  id?: InputMaybe<IDFilterInput>;
  isFolder?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  mimeType?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  path?: InputMaybe<StringFilterInput>;
  recordFile?: InputMaybe<RecordFileFilterInput>;
  type?: InputMaybe<StringFilterInput>;
}

export interface ExternalStorageResourceMappingFilterInput {
  and?: InputMaybe<Array<ExternalStorageResourceMappingFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  externalStorageConnection?: InputMaybe<ExternalStorageConnectionFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ExternalStorageResourceMappingFilterInput>>;
  path?: InputMaybe<StringFilterInput>;
  resourceFilter?: InputMaybe<StringFilterInput>;
  resourceType?: InputMaybe<StringFilterInput>;
  storageConnection?: InputMaybe<ExternalStorageConnectionFilterInput>;
}

export interface FileFilterInput {
  and?: InputMaybe<Array<FileFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  mimeType?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<FileFilterInput>>;
  size?: InputMaybe<NumberFilterInput>;
  sizeBytes?: InputMaybe<NumberFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UserIdentityFilterInput>;
}

export interface FileInput {
  fileId: Scalars["String"]["input"];
  metadata?: InputMaybe<Scalars["String"]["input"]>;
  primaryImage?: InputMaybe<Scalars["Boolean"]["input"]>;
}

/** Select exactly one typed File report dimension. */
export type FileReportGroupByInput =
  | { created: DateTimeReportDimensionInput; modified?: never; user?: never }
  | {
      created?: never;
      modified: DateTimeReportDimensionInput;
      user?: never;
    } /** Group by User or one of its dimensions. */
  | {
      created?: never;
      modified?: never;
      user: UserReportRelationDimensionInput;
    };

/** Groups by File identity, or traverses to one of its typed dimensions. */
export interface FileReportRelationDimensionInput {
  filter?: InputMaybe<FileFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<FileReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface GetDocumentPreviewInput {
  /** Dummy data returned from query */
  data?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Eith pass id (above) or template (below) */
  template?: InputMaybe<Scalars["String"]["input"]>;
  /** Dummy variables for either record or event */
  variables?: InputMaybe<Scalars["String"]["input"]>;
}

export interface GroupInstanceFilterInput {
  and?: InputMaybe<Array<GroupInstanceFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<GroupInstanceFilterInput>>;
  workflow?: InputMaybe<WorkflowFilterInput>;
}

export interface GroupTemplateFilterInput {
  and?: InputMaybe<Array<GroupTemplateFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<GroupTemplateFilterInput>>;
  placeHolder?: InputMaybe<BooleanFilterInput>;
  workflowTemplate?: InputMaybe<WorkflowTemplateFilterInput>;
}

export interface HousingCompanyFilterInput {
  and?: InputMaybe<Array<HousingCompanyFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  /** Completed-month YTD confirmed sales minus the equivalent period in the previous year. */
  confirmedSalesYtdChange?: InputMaybe<NumberFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  image?: InputMaybe<FileFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  jobs?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<HousingCompanyFilterInput>>;
}

/** Select exactly one typed Housing Company report dimension. */
export type HousingCompanyReportGroupByInput =
  | {
      created: DateTimeReportDimensionInput;
      image?: never;
      modified?: never;
    } /** Group by File or one of its dimensions. */
  | {
      created?: never;
      image: FileReportRelationDimensionInput;
      modified?: never;
    }
  | { created?: never; image?: never; modified: DateTimeReportDimensionInput };

/** Groups by Housing Company identity, or traverses to one of its typed dimensions. */
export interface HousingCompanyReportRelationDimensionInput {
  filter?: InputMaybe<HousingCompanyFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<HousingCompanyReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface IDFilterInput {
  eq?: InputMaybe<Scalars["ID"]["input"]>;
  in?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  notEq?: InputMaybe<Scalars["ID"]["input"]>;
  notIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
}

export interface IssueFilterInput {
  and?: InputMaybe<Array<IssueFilterInput>>;
  completed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  files?: InputMaybe<RecordFileFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modifiedAt?: InputMaybe<DateTimeFilterInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<IssueFilterInput>>;
  recordId?: InputMaybe<IDFilterInput>;
  /** The Job linked through the issue record reference. */
  recordJob?: InputMaybe<JobFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  reportedBy?: InputMaybe<StringFilterInput>;
  requiredDate?: InputMaybe<DateTimeFilterInput>;
  scheduledDate?: InputMaybe<DateTimeFilterInput>;
}

export interface IssueQuoteInput {
  quoteId: Scalars["ID"]["input"];
}

export interface JobComponentFilterInput {
  and?: InputMaybe<Array<JobComponentFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  costings?: InputMaybe<CostingFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  estimatingSellTotal?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<JobComponentFilterInput>>;
  partType?: InputMaybe<PartTypeFilterInput>;
  quoteLines?: InputMaybe<QuoteLineFilterInput>;
  salesOrderLines?: InputMaybe<SalesOrderLineFilterInput>;
}

export interface JobFilterInput {
  and?: InputMaybe<Array<JobFilterInput>>;
  batches?: InputMaybe<BatchFilterInput>;
  benchtopOnly?: InputMaybe<BooleanFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  buildType?: InputMaybe<BuildTypeFilterInput>;
  buildTypeId?: InputMaybe<StringFilterInput>;
  builder?: InputMaybe<BuilderFilterInput>;
  builderId?: InputMaybe<StringFilterInput>;
  builderPhone?: InputMaybe<StringFilterInput>;
  client?: InputMaybe<ClientFilterInput>;
  costings?: InputMaybe<CostingFilterInput>;
  createdDate?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  designer?: InputMaybe<PersonBusinessRoleFilterInput>;
  designerId?: InputMaybe<StringFilterInput>;
  difficultAccess?: InputMaybe<BooleanFilterInput>;
  dueDate?: InputMaybe<DateTimeFilterInput>;
  hasAssociatedLead?: InputMaybe<BooleanFilterInput>;
  hcJobNumber?: InputMaybe<StringFilterInput>;
  hcPmPhone?: InputMaybe<StringFilterInput>;
  hcProjectManager?: InputMaybe<StringFilterInput>;
  housingCompany?: InputMaybe<HousingCompanyFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  issues?: InputMaybe<IssueFilterInput>;
  jobComponents?: InputMaybe<JobComponentFilterInput>;
  jobName?: InputMaybe<StringFilterInput>;
  /** A unique number for this job */
  jobNumber?: InputMaybe<StringFilterInput>;
  jobString?: InputMaybe<StringFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lead?: InputMaybe<LeadFilterInput>;
  lineItems?: InputMaybe<LineItemFilterInput>;
  lostReason?: InputMaybe<LostReasonFilterInput>;
  lostReasonNotes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<JobFilterInput>>;
  projectManager?: InputMaybe<PersonBusinessRoleFilterInput>;
  projectManagerId?: InputMaybe<StringFilterInput>;
  purchaseOrders?: InputMaybe<PurchaseOrderFilterInput>;
  quotes?: InputMaybe<QuoteFilterInput>;
  region?: InputMaybe<RegionFilterInput>;
  regionId?: InputMaybe<StringFilterInput>;
  saleType?: InputMaybe<SaleTypeFilterInput>;
  saleTypeId?: InputMaybe<StringFilterInput>;
  salesOrders?: InputMaybe<SalesOrderFilterInput>;
  showHome?: InputMaybe<BooleanFilterInput>;
  siteAddress?: InputMaybe<StringFilterInput>;
  siteNotes?: InputMaybe<StringFilterInput>;
  sssp?: InputMaybe<BooleanFilterInput>;
  status?: InputMaybe<JobStatusFilterInput>;
  supplierQuoteRequests?: InputMaybe<SupplierQuoteRequestFilterInput>;
  supplierQuotes?: InputMaybe<SupplierQuoteFilterInput>;
  tristoneJoin?: InputMaybe<BooleanFilterInput>;
  tristoneSpecified?: InputMaybe<BooleanFilterInput>;
  unit?: InputMaybe<BooleanFilterInput>;
}

/** Select exactly one typed Job report dimension. */
export type JobReportGroupByInput =
  /** Group by Branch or one of its dimensions. */
  | {
      branch: BranchReportRelationDimensionInput;
      buildType?: never;
      builder?: never;
      client?: never;
      createdDate?: never;
      designer?: never;
      dueDate?: never;
      housingCompany?: never;
      lead?: never;
      lostReason?: never;
      projectManager?: never;
      region?: never;
      saleType?: never;
    } /** Group by Build Type or one of its dimensions. */
  | {
      branch?: never;
      buildType: BuildTypeReportRelationDimensionInput;
      builder?: never;
      client?: never;
      createdDate?: never;
      designer?: never;
      dueDate?: never;
      housingCompany?: never;
      lead?: never;
      lostReason?: never;
      projectManager?: never;
      region?: never;
      saleType?: never;
    } /** Group by Builder or one of its dimensions. */
  | {
      branch?: never;
      buildType?: never;
      builder: BuilderReportRelationDimensionInput;
      client?: never;
      createdDate?: never;
      designer?: never;
      dueDate?: never;
      housingCompany?: never;
      lead?: never;
      lostReason?: never;
      projectManager?: never;
      region?: never;
      saleType?: never;
    } /** Group by Client or one of its dimensions. */
  | {
      branch?: never;
      buildType?: never;
      builder?: never;
      client: ClientReportRelationDimensionInput;
      createdDate?: never;
      designer?: never;
      dueDate?: never;
      housingCompany?: never;
      lead?: never;
      lostReason?: never;
      projectManager?: never;
      region?: never;
      saleType?: never;
    }
  | {
      branch?: never;
      buildType?: never;
      builder?: never;
      client?: never;
      createdDate: DateTimeReportDimensionInput;
      designer?: never;
      dueDate?: never;
      housingCompany?: never;
      lead?: never;
      lostReason?: never;
      projectManager?: never;
      region?: never;
      saleType?: never;
    } /** Group by Person Business Role or one of its dimensions. */
  | {
      branch?: never;
      buildType?: never;
      builder?: never;
      client?: never;
      createdDate?: never;
      designer: PersonBusinessRoleReportRelationDimensionInput;
      dueDate?: never;
      housingCompany?: never;
      lead?: never;
      lostReason?: never;
      projectManager?: never;
      region?: never;
      saleType?: never;
    }
  | {
      branch?: never;
      buildType?: never;
      builder?: never;
      client?: never;
      createdDate?: never;
      designer?: never;
      dueDate: DateTimeReportDimensionInput;
      housingCompany?: never;
      lead?: never;
      lostReason?: never;
      projectManager?: never;
      region?: never;
      saleType?: never;
    } /** Group by Housing Company or one of its dimensions. */
  | {
      branch?: never;
      buildType?: never;
      builder?: never;
      client?: never;
      createdDate?: never;
      designer?: never;
      dueDate?: never;
      housingCompany: HousingCompanyReportRelationDimensionInput;
      lead?: never;
      lostReason?: never;
      projectManager?: never;
      region?: never;
      saleType?: never;
    } /** Group by Lead or one of its dimensions. */
  | {
      branch?: never;
      buildType?: never;
      builder?: never;
      client?: never;
      createdDate?: never;
      designer?: never;
      dueDate?: never;
      housingCompany?: never;
      lead: LeadReportRelationDimensionInput;
      lostReason?: never;
      projectManager?: never;
      region?: never;
      saleType?: never;
    } /** Group by Lost Reason or one of its dimensions. */
  | {
      branch?: never;
      buildType?: never;
      builder?: never;
      client?: never;
      createdDate?: never;
      designer?: never;
      dueDate?: never;
      housingCompany?: never;
      lead?: never;
      lostReason: LostReasonReportRelationDimensionInput;
      projectManager?: never;
      region?: never;
      saleType?: never;
    } /** Group by Person Business Role or one of its dimensions. */
  | {
      branch?: never;
      buildType?: never;
      builder?: never;
      client?: never;
      createdDate?: never;
      designer?: never;
      dueDate?: never;
      housingCompany?: never;
      lead?: never;
      lostReason?: never;
      projectManager: PersonBusinessRoleReportRelationDimensionInput;
      region?: never;
      saleType?: never;
    } /** Group by Region or one of its dimensions. */
  | {
      branch?: never;
      buildType?: never;
      builder?: never;
      client?: never;
      createdDate?: never;
      designer?: never;
      dueDate?: never;
      housingCompany?: never;
      lead?: never;
      lostReason?: never;
      projectManager?: never;
      region: RegionReportRelationDimensionInput;
      saleType?: never;
    } /** Group by Sale Type or one of its dimensions. */
  | {
      branch?: never;
      buildType?: never;
      builder?: never;
      client?: never;
      createdDate?: never;
      designer?: never;
      dueDate?: never;
      housingCompany?: never;
      lead?: never;
      lostReason?: never;
      projectManager?: never;
      region?: never;
      saleType: SaleTypeReportRelationDimensionInput;
    };

/** Groups by Job identity, or traverses to one of its typed dimensions. */
export interface JobReportRelationDimensionInput {
  filter?: InputMaybe<JobFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<JobReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface JobStatusFilterInput {
  id?: InputMaybe<IDFilterInput>;
}

export interface JsonFilterInput {
  eq?: InputMaybe<Scalars["String"]["input"]>;
  field?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  like?: InputMaybe<Scalars["String"]["input"]>;
  neq?: InputMaybe<Scalars["String"]["input"]>;
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface LeadFilterInput {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<LeadFilterInput>>;
  assignedDate?: InputMaybe<DateTimeFilterInput>;
  assignedTo?: InputMaybe<PersonBusinessRoleFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  builderName?: InputMaybe<StringFilterInput>;
  builderType?: InputMaybe<StringFilterInput>;
  city?: InputMaybe<StringFilterInput>;
  client?: InputMaybe<StringFilterInput>;
  correspondence?: InputMaybe<CorrespondenceFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  hasAssociatedJob?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  joineryTypes?: InputMaybe<StringFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lostReason?: InputMaybe<LostReasonFilterInput>;
  lostReasonNotes?: InputMaybe<StringFilterInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LeadFilterInput>>;
  phone?: InputMaybe<StringFilterInput>;
  priceRangeBottom?: InputMaybe<NumberFilterInput>;
  priceRangeTop?: InputMaybe<NumberFilterInput>;
  priority?: InputMaybe<NumberFilterInput>;
  projectType?: InputMaybe<StringFilterInput>;
  requiredBy?: InputMaybe<DateTimeFilterInput>;
  source?: InputMaybe<LeadSourceFilterInput>;
  status?: InputMaybe<LeadStatusFilterInput>;
  suburb?: InputMaybe<StringFilterInput>;
}

/** Select exactly one typed Lead report dimension. */
export type LeadReportGroupByInput =
  | {
      assignedDate: DateTimeReportDimensionInput;
      assignedTo?: never;
      branch?: never;
      createdAt?: never;
      job?: never;
      lostReason?: never;
      requiredBy?: never;
    } /** Group by Person Business Role or one of its dimensions. */
  | {
      assignedDate?: never;
      assignedTo: PersonBusinessRoleReportRelationDimensionInput;
      branch?: never;
      createdAt?: never;
      job?: never;
      lostReason?: never;
      requiredBy?: never;
    } /** Group by Branch or one of its dimensions. */
  | {
      assignedDate?: never;
      assignedTo?: never;
      branch: BranchReportRelationDimensionInput;
      createdAt?: never;
      job?: never;
      lostReason?: never;
      requiredBy?: never;
    }
  | {
      assignedDate?: never;
      assignedTo?: never;
      branch?: never;
      createdAt: DateTimeReportDimensionInput;
      job?: never;
      lostReason?: never;
      requiredBy?: never;
    } /** Group by Job or one of its dimensions. */
  | {
      assignedDate?: never;
      assignedTo?: never;
      branch?: never;
      createdAt?: never;
      job: JobReportRelationDimensionInput;
      lostReason?: never;
      requiredBy?: never;
    } /** Group by Lost Reason or one of its dimensions. */
  | {
      assignedDate?: never;
      assignedTo?: never;
      branch?: never;
      createdAt?: never;
      job?: never;
      lostReason: LostReasonReportRelationDimensionInput;
      requiredBy?: never;
    }
  | {
      assignedDate?: never;
      assignedTo?: never;
      branch?: never;
      createdAt?: never;
      job?: never;
      lostReason?: never;
      requiredBy: DateTimeReportDimensionInput;
    };

/** Groups by Lead identity, or traverses to one of its typed dimensions. */
export interface LeadReportRelationDimensionInput {
  filter?: InputMaybe<LeadFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<LeadReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface LeadSourceFilterInput {
  id?: InputMaybe<IDFilterInput>;
  leads?: InputMaybe<LeadFilterInput>;
}

export enum LeadStatusEnum {
  assigned = "assigned",
  converted = "converted",
  lost = "lost",
  new = "new",
}

export interface LeadStatusFilterInput {
  id?: InputMaybe<IDFilterInput>;
  leads?: InputMaybe<LeadFilterInput>;
}

export interface LineItemFilterInput {
  and?: InputMaybe<Array<LineItemFilterInput>>;
  batch?: InputMaybe<BatchFilterInput>;
  batchId?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  confirmedDate?: InputMaybe<DateTimeFilterInput>;
  confirmedSale?: InputMaybe<NumberFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  masterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LineItemFilterInput>>;
  partNumber?: InputMaybe<StringFilterInput>;
  partType?: InputMaybe<PartTypeFilterInput>;
  salePrice?: InputMaybe<NumberFilterInput>;
}

export interface LineItemMasterWorkflowFilterInput {
  and?: InputMaybe<Array<LineItemMasterWorkflowFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  groupInstances?: InputMaybe<GroupInstanceFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  items?: InputMaybe<WorkflowNodeFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItem?: InputMaybe<LineItemFilterInput>;
  lineItemId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LineItemMasterWorkflowFilterInput>>;
  processAssets?: InputMaybe<ProcessAssetFilterInput>;
  processInstances?: InputMaybe<ProcessInstanceFilterInput>;
}

/** Select exactly one typed Line Item Master Workflow report dimension. */
export interface LineItemMasterWorkflowReportGroupByInput {
  /** Group by Work Order or one of its dimensions. */
  lineItem: LineItemReportRelationDimensionInput;
}

/** Groups by Line Item Master Workflow identity, or traverses to one of its typed dimensions. */
export interface LineItemMasterWorkflowReportRelationDimensionInput {
  filter?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<LineItemMasterWorkflowReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

/** Select exactly one typed Work Order report dimension. */
export type LineItemReportGroupByInput =
  /** Group by Batch or one of its dimensions. */
  | {
      batch: BatchReportRelationDimensionInput;
      confirmedDate?: never;
      job?: never;
      masterWorkflow?: never;
      partType?: never;
    }
  | {
      batch?: never;
      confirmedDate: DateTimeReportDimensionInput;
      job?: never;
      masterWorkflow?: never;
      partType?: never;
    } /** Group by Job or one of its dimensions. */
  | {
      batch?: never;
      confirmedDate?: never;
      job: JobReportRelationDimensionInput;
      masterWorkflow?: never;
      partType?: never;
    } /** Group by Line Item Master Workflow or one of its dimensions. */
  | {
      batch?: never;
      confirmedDate?: never;
      job?: never;
      masterWorkflow: LineItemMasterWorkflowReportRelationDimensionInput;
      partType?: never;
    } /** Group by Part Type or one of its dimensions. */
  | {
      batch?: never;
      confirmedDate?: never;
      job?: never;
      masterWorkflow?: never;
      partType: PartTypeReportRelationDimensionInput;
    };

/** Groups by Work Order identity, or traverses to one of its typed dimensions. */
export interface LineItemReportRelationDimensionInput {
  filter?: InputMaybe<LineItemFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<LineItemReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface LineItemWorkflowPlaceholderInput {
  workflowTemplateId: Scalars["ID"]["input"];
  workflowTypeId: Scalars["ID"]["input"];
}

export interface LinkedActionFilterInput {
  actionId?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<LinkedActionFilterInput>>;
  bindings?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  displayOrder?: InputMaybe<NumberFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LinkedActionFilterInput>>;
  ownerUserId?: InputMaybe<IDFilterInput>;
  recordPath?: InputMaybe<StringFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
}

export interface LostReasonFilterInput {
  and?: InputMaybe<Array<LostReasonFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LostReasonFilterInput>>;
}

/** Groups by Lost Reason identity, or traverses to one of its typed dimensions. */
export interface LostReasonReportRelationDimensionInput {
  filter?: InputMaybe<LostReasonFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface MachineFilterInput {
  id?: InputMaybe<IDFilterInput>;
  machineType?: InputMaybe<MachineTypeFilterInput>;
}

export interface MachineTypeFilterInput {
  id?: InputMaybe<IDFilterInput>;
}

export interface MarkJobLostInput {
  additionalNotes?: InputMaybe<Scalars["String"]["input"]>;
  jobId: Scalars["ID"]["input"];
  lostReasonId: Scalars["ID"]["input"];
}

export interface MarkLeadLostInput {
  additionalNotes?: InputMaybe<Scalars["String"]["input"]>;
  leadId: Scalars["ID"]["input"];
  lostReasonId: Scalars["ID"]["input"];
}

export enum NotificationAction {
  ACKNOWLEDGE = "ACKNOWLEDGE",
  CLEAR = "CLEAR",
  MARK_UNREAD = "MARK_UNREAD",
}

export interface NotificationAttachmentInput {
  bodyTemplateId?: InputMaybe<Scalars["ID"]["input"]>;
  filename: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
}

export interface NotificationInput {
  attachments: Array<NotificationAttachmentInput>;
  bodyTemplateId?: InputMaybe<Scalars["ID"]["input"]>;
  type: Scalars["String"]["input"];
}

export interface NotificationTemplateFilterInput {
  and?: InputMaybe<Array<NotificationTemplateFilterInput>>;
  attachmentTemplates?: InputMaybe<AttachmentTemplateFilterInput>;
  bodyTemplateId?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<NotificationTemplateFilterInput>>;
  subscription?: InputMaybe<SubscriptionRealFilterInput>;
  type?: InputMaybe<StringFilterInput>;
}

export interface NumberFilterInput {
  eq?: InputMaybe<Scalars["Int"]["input"]>;
  gt?: InputMaybe<Scalars["Int"]["input"]>;
  gte?: InputMaybe<Scalars["Int"]["input"]>;
  in?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  lt?: InputMaybe<Scalars["Int"]["input"]>;
  lte?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface OptionsInput {
  groupBy?: InputMaybe<StringFilterInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** TODO: implement frontend ui support for array inputs */
  sort?: InputMaybe<Array<SortInput>>;
}

export enum OrderCategory {
  FACTORY = "FACTORY",
  JOB = "JOB",
  OFFICE = "OFFICE",
  STOCK = "STOCK",
  VEHICLE = "VEHICLE",
}

export enum OrderReviewStatus {
  APPROVED = "APPROVED",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum OrderShippingMethods {
  SeaFreight = "SeaFreight",
}

export enum OrderShippingTerms {
  CFR = "CFR",
  CIF = "CIF",
  CIP = "CIP",
  CPT = "CPT",
  DAP = "DAP",
  DAT = "DAT",
  DDP = "DDP",
  EXW = "EXW",
  FAS = "FAS",
  FCA = "FCA",
  FOB = "FOB",
}

export enum OrderStatus {
  APPROVED = "APPROVED",
  CANCELLED = "CANCELLED",
  DRAFT = "DRAFT",
  INCOMPLETE = "INCOMPLETE",
  ON_HOLD = "ON_HOLD",
  ORDERED = "ORDERED",
  PENDING_REVIEW = "PENDING_REVIEW",
  RECEIVED = "RECEIVED",
  REJECTED = "REJECTED",
  RELEASED = "RELEASED",
}

export interface OverrideLeadStatusInput {
  leadId: Scalars["ID"]["input"];
  status: Scalars["String"]["input"];
}

export interface OverridePurchaseOrderStatusInput {
  purchaseOrderId: Scalars["ID"]["input"];
  status: OrderStatus;
}

export interface PanelFilterInput {
  and?: InputMaybe<Array<PanelFilterInput>>;
  config?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PanelFilterInput>>;
  recordTags?: InputMaybe<RecordTagFilterInput>;
  type?: InputMaybe<StringFilterInput>;
}

export interface PartTypeFilterInput {
  and?: InputMaybe<Array<PartTypeFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  colour?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PartTypeFilterInput>>;
}

/** Select exactly one typed Part Type report dimension. */
export type PartTypeReportGroupByInput =
  | { created: DateTimeReportDimensionInput; modified?: never }
  | { created?: never; modified: DateTimeReportDimensionInput };

/** Groups by Part Type identity, or traverses to one of its typed dimensions. */
export interface PartTypeReportRelationDimensionInput {
  filter?: InputMaybe<PartTypeFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<PartTypeReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface PermissionCheckInput {
  conditions?: InputMaybe<Scalars["String"]["input"]>;
  permission: Scalars["String"]["input"];
}

export interface PermissionFilterInput {
  id?: InputMaybe<IDFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
}

export interface PermissionInput {
  conditions?: InputMaybe<Scalars["String"]["input"]>;
  permissionId: Scalars["String"]["input"];
  policy: Policy;
}

export interface PersonAssignedWorkFilterInput {
  and?: InputMaybe<Array<PersonAssignedWorkFilterInput>>;
  assignmentType?: InputMaybe<StringFilterInput>;
  businessRole?: InputMaybe<BusinessRoleFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PersonAssignedWorkFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  personBusinessRole?: InputMaybe<PersonBusinessRoleFilterInput>;
  recordId?: InputMaybe<IDFilterInput>;
  recordLabel?: InputMaybe<StringFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  statusLabel?: InputMaybe<StringFilterInput>;
}

export interface PersonBusinessRoleFilterInput {
  and?: InputMaybe<Array<PersonBusinessRoleFilterInput>>;
  assignedWork?: InputMaybe<PersonAssignedWorkFilterInput>;
  businessRole?: InputMaybe<BusinessRoleFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PersonBusinessRoleFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  processAssignments?: InputMaybe<ProcessAssignmentFilterInput>;
}

/** Select exactly one typed Person Business Role report dimension. */
export type PersonBusinessRoleReportGroupByInput =
  /** Group by Business Role or one of its dimensions. */
  | {
      businessRole: BusinessRoleReportRelationDimensionInput;
      person?: never;
    } /** Group by Person or one of its dimensions. */
  | { businessRole?: never; person: PersonReportRelationDimensionInput };

/** Groups by Person Business Role identity, or traverses to one of its typed dimensions. */
export interface PersonBusinessRoleReportRelationDimensionInput {
  filter?: InputMaybe<PersonBusinessRoleFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<PersonBusinessRoleReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface PersonFilterInput {
  and?: InputMaybe<Array<PersonFilterInput>>;
  assignedWork?: InputMaybe<PersonAssignedWorkFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  businessRoleLabels?: InputMaybe<StringFilterInput>;
  /** The system user account connected to this person. */
  connectedUser?: InputMaybe<UserFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  /** Filter People by whether they have active system access. */
  hasActiveSystemAccess?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  /** Include inactive people in query results. */
  includeInactive?: InputMaybe<BooleanFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  /** Filter People by whether they are connected to the current user. */
  isCurrentUser?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PersonFilterInput>>;
  personBusinessRoles?: InputMaybe<PersonBusinessRoleFilterInput>;
  /** People assigned as Project Manager to matching jobs. */
  projectManagedJobs?: InputMaybe<JobFilterInput>;
}

/** Select exactly one typed Person report dimension. */
export type PersonReportGroupByInput =
  /** Group by Branch or one of its dimensions. */
  | {
      branch: BranchReportRelationDimensionInput;
      connectedUser?: never;
      created?: never;
    } /** Group by User or one of its dimensions. */
  | {
      branch?: never;
      connectedUser: UserReportRelationDimensionInput;
      created?: never;
    }
  | {
      branch?: never;
      connectedUser?: never;
      created: DateTimeReportDimensionInput;
    };

/** Groups by Person identity, or traverses to one of its typed dimensions. */
export interface PersonReportRelationDimensionInput {
  filter?: InputMaybe<PersonFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<PersonReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export enum Policy {
  Allow = "Allow",
  Conditional = "Conditional",
  Deny = "Deny",
}

export interface ProcessAssetFilterInput {
  and?: InputMaybe<Array<ProcessAssetFilterInput>>;
  asset?: InputMaybe<AssetFilterInput>;
  assetId?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  or?: InputMaybe<Array<ProcessAssetFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  processTypeId?: InputMaybe<StringFilterInput>;
  workflowSubjectId?: InputMaybe<StringFilterInput>;
}

export interface ProcessAssignmentFilterInput {
  and?: InputMaybe<Array<ProcessAssignmentFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  or?: InputMaybe<Array<ProcessAssignmentFilterInput>>;
  personBusinessRoleId?: InputMaybe<IDFilterInput>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  processTypeId?: InputMaybe<StringFilterInput>;
  userRole?: InputMaybe<UserRoleFilterInput>;
  userRoleId?: InputMaybe<StringFilterInput>;
  workflowSubject?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  workflowSubjectId?: InputMaybe<StringFilterInput>;
}

export interface ProcessInstanceFilterInput {
  and?: InputMaybe<Array<ProcessInstanceFilterInput>>;
  assignedHours?: InputMaybe<StringFilterInput>;
  assignedUsers?: InputMaybe<UserFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  dueDate?: InputMaybe<DateTimeFilterInput>;
  elapsedTime?: InputMaybe<NumberFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  leadDays?: InputMaybe<NumberFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  or?: InputMaybe<Array<ProcessInstanceFilterInput>>;
  ordered?: InputMaybe<BooleanFilterInput>;
  processAssignments?: InputMaybe<ProcessAssignmentFilterInput>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  scheduled?: InputMaybe<DateTimeFilterInput>;
  startBy?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<IDFilterInput>;
  workflow?: InputMaybe<WorkflowFilterInput>;
}

export interface ProcessTemplateFilterInput {
  and?: InputMaybe<Array<ProcessTemplateFilterInput>>;
  assignedHours?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  leadDays?: InputMaybe<NumberFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProcessTemplateFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
}

export interface ProcessTimerFilterInput {
  and?: InputMaybe<Array<ProcessTimerFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  elapsedTime?: InputMaybe<NumberFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  items?: InputMaybe<ProcessTimerItemFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProcessTimerFilterInput>>;
  status?: InputMaybe<StringFilterInput>;
  transactions?: InputMaybe<TimerTransactionFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
}

export interface ProcessTimerItemFilterInput {
  and?: InputMaybe<Array<ProcessTimerItemFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  or?: InputMaybe<Array<ProcessTimerItemFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  processTypeId?: InputMaybe<StringFilterInput>;
  timer?: InputMaybe<ProcessTimerFilterInput>;
  timerId?: InputMaybe<StringFilterInput>;
  workflowSubjectId?: InputMaybe<StringFilterInput>;
}

export interface ProcessTypeFilterInput {
  and?: InputMaybe<Array<ProcessTypeFilterInput>>;
  assignments?: InputMaybe<ProcessAssignmentFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProcessTypeFilterInput>>;
  processInstances?: InputMaybe<ProcessInstanceFilterInput>;
  roles?: InputMaybe<ProcessTypeRoleFilterInput>;
}

export interface ProcessTypeNoteFilterInput {
  and?: InputMaybe<Array<ProcessTypeNoteFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  note?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProcessTypeNoteFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
}

/** Select exactly one typed Process Type report dimension. */
export type ProcessTypeReportGroupByInput =
  | { created: DateTimeReportDimensionInput; modified?: never }
  | { created?: never; modified: DateTimeReportDimensionInput };

/** Groups by Process Type identity, or traverses to one of its typed dimensions. */
export interface ProcessTypeReportRelationDimensionInput {
  filter?: InputMaybe<ProcessTypeFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<ProcessTypeReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface ProcessTypeRoleFilterInput {
  and?: InputMaybe<Array<ProcessTypeRoleFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProcessTypeRoleFilterInput>>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
  roleType?: InputMaybe<StringFilterInput>;
}

export interface ProductCategoryFilterInput {
  and?: InputMaybe<Array<ProductCategoryFilterInput>>;
  children?: InputMaybe<ProductCategoryFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  group?: InputMaybe<ProductCategoryGroupFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  includeSubCategories?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProductCategoryFilterInput>>;
  parent?: InputMaybe<ProductCategoryFilterInput>;
  products?: InputMaybe<ProductFilterInput>;
}

export interface ProductCategoryGroupFilterInput {
  and?: InputMaybe<Array<ProductCategoryGroupFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProductCategoryGroupFilterInput>>;
}

export interface ProductFilterInput {
  and?: InputMaybe<Array<ProductFilterInput>>;
  category?: InputMaybe<ProductCategoryFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  currentBuyPrice?: InputMaybe<NumberFilterInput>;
  currentSellPrice?: InputMaybe<NumberFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  indent?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  isStockItem?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  leadTime?: InputMaybe<NumberFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProductFilterInput>>;
  qtyReviewThreshold?: InputMaybe<NumberFilterInput>;
  recordTags?: InputMaybe<RecordTagFilterInput>;
  safetyStockDays?: InputMaybe<NumberFilterInput>;
  starred?: InputMaybe<BooleanFilterInput>;
  stock?: InputMaybe<StockFilterInput>;
  stockByWarehouse?: InputMaybe<StockFilterInput>;
  stockedQty?: InputMaybe<NumberFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  template?: InputMaybe<BooleanFilterInput>;
  type?: InputMaybe<NumberFilterInput>;
  unitOfMeasure?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
}

export interface ProductImportInput {
  buyPrice?: InputMaybe<Scalars["String"]["input"]>;
  buyPriceEffectiveDate?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  code: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  operation: Scalars["String"]["input"];
  productId?: InputMaybe<Scalars["ID"]["input"]>;
  supplier: Scalars["String"]["input"];
}

export enum ProductImportUpdateField {
  BuyPrice = "BuyPrice",
  Description = "Description",
}

export interface ProductPriceFilterInput {
  and?: InputMaybe<Array<ProductPriceFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  effectiveDate?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProductPriceFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  type?: InputMaybe<NumberFilterInput>;
  unitPrice?: InputMaybe<NumberFilterInput>;
}

export interface ProjectFilterInput {
  and?: InputMaybe<Array<ProjectFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
}

export interface PromoteSchemaVersionInput {
  schemaVersionId: Scalars["ID"]["input"];
}

export interface PurchaseOrderEventFilterInput {
  created?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  purchaseOrder?: InputMaybe<PurchaseOrderFilterInput>;
  type?: InputMaybe<NumberFilterInput>;
  user?: InputMaybe<UserFilterInput>;
}

export interface PurchaseOrderFilterInput {
  acknowledgedBy?: InputMaybe<StringFilterInput>;
  amended?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<PurchaseOrderFilterInput>>;
  approved?: InputMaybe<BooleanFilterInput>;
  category?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deliveryAddress?: InputMaybe<StringFilterInput>;
  deliveryAddressEntity?: InputMaybe<DeliveryAddressFilterInput>;
  emails?: InputMaybe<EmailFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  incomplete?: InputMaybe<BooleanFilterInput>;
  internalComment?: InputMaybe<StringFilterInput>;
  invoiceChecked?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<PurchaseOrderLineFilterInput>;
  notificationStatus?: InputMaybe<NumberFilterInput>;
  notifySupplierWhenPlaced?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderFilterInput>>;
  placedBy?: InputMaybe<UserFilterInput>;
  poNumber?: InputMaybe<StringFilterInput>;
  reference?: InputMaybe<StringFilterInput>;
  required?: InputMaybe<DateTimeFilterInput>;
  reviews?: InputMaybe<PurchaseOrderReviewFilterInput>;
  shippingMethod?: InputMaybe<StringFilterInput>;
  shippingTerms?: InputMaybe<StringFilterInput>;
  siteVisitRequired?: InputMaybe<BooleanFilterInput>;
  ssspCompleted?: InputMaybe<BooleanFilterInput>;
  status?: InputMaybe<PurchaseOrderStatusFilterInput>;
  statusWhenPlaced?: InputMaybe<StringFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierComment?: InputMaybe<StringFilterInput>;
  supplierStatus?: InputMaybe<NumberFilterInput>;
  template?: InputMaybe<DocumentTemplateFilterInput>;
  urgent?: InputMaybe<BooleanFilterInput>;
  warehouse?: InputMaybe<WarehouseFilterInput>;
}

export interface PurchaseOrderLineFilterInput {
  and?: InputMaybe<Array<PurchaseOrderLineFilterInput>>;
  buyPrice?: InputMaybe<NumberFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderLineFilterInput>>;
  orderedQty?: InputMaybe<NumberFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  purchaseOrder?: InputMaybe<PurchaseOrderFilterInput>;
  receivedQty?: InputMaybe<NumberFilterInput>;
  unit?: InputMaybe<StringFilterInput>;
}

export interface PurchaseOrderLineInput {
  buyPrice?: InputMaybe<Scalars["String"]["input"]>;
  code?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  product?: InputMaybe<Scalars["ID"]["input"]>;
  quantity?: InputMaybe<Scalars["String"]["input"]>;
  unit?: InputMaybe<Scalars["String"]["input"]>;
}

export interface PurchaseOrderReceiptFilterInput {
  and?: InputMaybe<Array<PurchaseOrderReceiptFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<PurchaseOrderReceiptLineFilterInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderReceiptFilterInput>>;
  purchaseOrder?: InputMaybe<PurchaseOrderFilterInput>;
  reference?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
}

export interface PurchaseOrderReceiptLineFilterInput {
  and?: InputMaybe<Array<PurchaseOrderReceiptLineFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<PurchaseOrderLineFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderReceiptLineFilterInput>>;
  quantity?: InputMaybe<StringFilterInput>;
  receipt?: InputMaybe<PurchaseOrderReceiptFilterInput>;
}

export interface PurchaseOrderReceiptLineInput {
  orderLineId: Scalars["ID"]["input"];
  quantity: Scalars["Float"]["input"];
}

export interface PurchaseOrderReviewFilterInput {
  and?: InputMaybe<Array<PurchaseOrderReviewFilterInput>>;
  comment?: InputMaybe<StringFilterInput>;
  completedAt?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderReviewFilterInput>>;
  purchaseOrder?: InputMaybe<PurchaseOrderFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<StringFilterInput>;
}

export interface PurchaseOrderStatusFilterInput {
  id?: InputMaybe<IDFilterInput>;
  purchaseOrders?: InputMaybe<PurchaseOrderFilterInput>;
}

export interface QuoteFilterInput {
  acceptedAt?: InputMaybe<DateTimeFilterInput>;
  and?: InputMaybe<Array<QuoteFilterInput>>;
  clientAddress?: InputMaybe<StringFilterInput>;
  clientName?: InputMaybe<StringFilterInput>;
  contactName?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  currentRevision?: InputMaybe<QuoteRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  issuedAt?: InputMaybe<DateTimeFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<QuoteFilterInput>>;
  quoteNumber?: InputMaybe<StringFilterInput>;
  quoteTemplateRevision?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  reference?: InputMaybe<StringFilterInput>;
  salesTax?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  subTotal?: InputMaybe<StringFilterInput>;
  total?: InputMaybe<StringFilterInput>;
  version?: InputMaybe<NumberFilterInput>;
}

export interface QuoteLineFilterInput {
  and?: InputMaybe<Array<QuoteLineFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  costingRevision?: InputMaybe<CostingRevisionFilterInput>;
  costingRevisionId?: InputMaybe<IDFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  jobComponent?: InputMaybe<JobComponentFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  lineTemplateId?: InputMaybe<StringFilterInput>;
  markupAmount?: InputMaybe<StringFilterInput>;
  markupExpression?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<QuoteLineFilterInput>>;
  parentLine?: InputMaybe<QuoteLineFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<StringFilterInput>;
  quantity?: InputMaybe<StringFilterInput>;
  quote?: InputMaybe<QuoteFilterInput>;
  quoteRevision?: InputMaybe<QuoteRevisionFilterInput>;
  quoteTemplateRevision?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  total?: InputMaybe<StringFilterInput>;
  unitCostPrice?: InputMaybe<StringFilterInput>;
  unitSellPrice?: InputMaybe<StringFilterInput>;
}

export interface QuoteLineInput {
  costPrice?: InputMaybe<Scalars["String"]["input"]>;
  costing?: InputMaybe<Scalars["String"]["input"]>;
  costingRevisionId?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  jobComponentId?: InputMaybe<Scalars["ID"]["input"]>;
  lineTemplateId?: InputMaybe<Scalars["String"]["input"]>;
  lines?: InputMaybe<Array<QuoteLineInput>>;
  markupExpression?: InputMaybe<Scalars["String"]["input"]>;
  product?: InputMaybe<Scalars["String"]["input"]>;
  quantity?: InputMaybe<Scalars["String"]["input"]>;
  type?: QuoteLineType;
}

export interface QuoteLineTemplateFilterInput {
  and?: InputMaybe<Array<QuoteLineTemplateFilterInput>>;
  category?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  descriptionEditable?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  markupEditable?: InputMaybe<BooleanFilterInput>;
  markupExpression?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<QuoteLineTemplateFilterInput>>;
  quantity?: InputMaybe<StringFilterInput>;
  quantityEditable?: InputMaybe<BooleanFilterInput>;
  quoteTemplateRevision?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  unitCostPrice?: InputMaybe<StringFilterInput>;
  unitCostPriceEditable?: InputMaybe<BooleanFilterInput>;
}

export interface QuoteLineTemplateInput {
  category?: Scalars["String"]["input"];
  costPriceEditable?: Scalars["Boolean"]["input"];
  description: Scalars["String"]["input"];
  descriptionEditable?: Scalars["Boolean"]["input"];
  id: Scalars["String"]["input"];
  markupEditable?: Scalars["Boolean"]["input"];
  markupExpression?: Scalars["String"]["input"];
  quantity: Scalars["String"]["input"];
  quantityEditable?: Scalars["Boolean"]["input"];
  type?: QuoteLineType;
  unitCostPrice?: Scalars["String"]["input"];
  unitCostPriceEditable?: Scalars["Boolean"]["input"];
}

export enum QuoteLineType {
  COMPOSITE = "COMPOSITE",
  NORMAL = "NORMAL",
}

export interface QuoteRevisionFilterInput {
  and?: InputMaybe<Array<QuoteRevisionFilterInput>>;
  clientAddress?: InputMaybe<StringFilterInput>;
  clientName?: InputMaybe<StringFilterInput>;
  contactName?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<QuoteLineFilterInput>;
  or?: InputMaybe<Array<QuoteRevisionFilterInput>>;
  quote?: InputMaybe<QuoteFilterInput>;
  reference?: InputMaybe<StringFilterInput>;
  salesTax?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  subTotal?: InputMaybe<StringFilterInput>;
  total?: InputMaybe<StringFilterInput>;
  version?: InputMaybe<NumberFilterInput>;
}

export interface QuoteTemplateExpressionFilterInput {
  and?: InputMaybe<Array<QuoteTemplateExpressionFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<QuoteTemplateExpressionFilterInput>>;
  quoteTemplateRevision?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  quoteTemplateRevisionId?: InputMaybe<StringFilterInput>;
  value?: InputMaybe<StringFilterInput>;
}

export interface QuoteTemplateFilterInput {
  and?: InputMaybe<Array<QuoteTemplateFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  currentRevision?: InputMaybe<QuoteTemplateRevisionFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isDefault?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<QuoteTemplateFilterInput>>;
  version?: InputMaybe<NumberFilterInput>;
}

export interface QuoteTemplateRevisionFilterInput {
  and?: InputMaybe<Array<QuoteTemplateRevisionFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  expressions?: InputMaybe<QuoteTemplateExpressionFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineTemplates?: InputMaybe<QuoteLineTemplateFilterInput>;
  or?: InputMaybe<Array<QuoteTemplateRevisionFilterInput>>;
  quoteTemplate?: InputMaybe<QuoteTemplateFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  version?: InputMaybe<NumberFilterInput>;
}

/** Quote template revision status. */
export enum QuoteTemplateRevisionStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export interface ReceiveWarehouseStockInput {
  stock: Array<WarehouseStockInput>;
  warehouseId: Scalars["ID"]["input"];
}

export interface RecordFileFilterInput {
  and?: InputMaybe<Array<RecordFileFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  file?: InputMaybe<FileFilterInput>;
  fileId?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<RecordFolderFilterInput>;
  folderId?: InputMaybe<IDFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  isPrimaryImage?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  or?: InputMaybe<Array<RecordFileFilterInput>>;
  path?: InputMaybe<StringFilterInput>;
  primaryImage?: InputMaybe<BooleanFilterInput>;
  resourceId?: InputMaybe<IDFilterInput>;
  resourceType?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
}

export interface RecordFolderFilterInput {
  and?: InputMaybe<Array<RecordFolderFilterInput>>;
  children?: InputMaybe<RecordFolderFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  defaultFolderId?: InputMaybe<IDFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RecordFolderFilterInput>>;
  parentFolder?: InputMaybe<RecordFolderFilterInput>;
  parentFolderId?: InputMaybe<IDFilterInput>;
  resourceId?: InputMaybe<IDFilterInput>;
  resourceType?: InputMaybe<StringFilterInput>;
}

export interface RecordScreenFilterInput {
  and?: InputMaybe<Array<RecordScreenFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RecordScreenFilterInput>>;
  recordId?: InputMaybe<IDFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  screen?: InputMaybe<ScreenFilterInput>;
  user?: InputMaybe<UserFilterInput>;
}

export enum RecordScreenType {
  ROLE = "ROLE",
  USER = "USER",
}

export enum RecordSource {
  SYSTEM = "SYSTEM",
  USER = "USER",
}

export interface RecordTagFilterInput {
  and?: InputMaybe<Array<RecordTagFilterInput>>;
  colour?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RecordTagFilterInput>>;
  recordId?: InputMaybe<IDFilterInput>;
  recordType?: InputMaybe<StringFilterInput>;
  resourceType?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<TagFilterInput>;
}

/** All discoverable record type names. */
export enum RecordType {
  ActAsUser = "ActAsUser",
  Asset = "Asset",
  AssignedPermission = "AssignedPermission",
  AsyncTask = "AsyncTask",
  AttachmentTemplate = "AttachmentTemplate",
  AuditLog = "AuditLog",
  Batch = "Batch",
  BatchSchedule = "BatchSchedule",
  BillOfMaterialsImport = "BillOfMaterialsImport",
  BillOfMaterialsLine = "BillOfMaterialsLine",
  Branch = "Branch",
  BuildType = "BuildType",
  Builder = "Builder",
  BusinessRole = "BusinessRole",
  Candidate = "Candidate",
  CandidateIngestionPolicy = "CandidateIngestionPolicy",
  Client = "Client",
  ComponentAction = "ComponentAction",
  ComponentGridColumn = "ComponentGridColumn",
  ConfiguredLinkedAction = "ConfiguredLinkedAction",
  Correspondence = "Correspondence",
  Costing = "Costing",
  CostingLine = "CostingLine",
  CostingLineTemplate = "CostingLineTemplate",
  CostingRevision = "CostingRevision",
  CostingTemplate = "CostingTemplate",
  CostingTemplateExpression = "CostingTemplateExpression",
  CostingTemplateRevision = "CostingTemplateRevision",
  CustomData = "CustomData",
  CustomTemplate = "CustomTemplate",
  DataStore = "DataStore",
  DataStoreRecord = "DataStoreRecord",
  Day = "Day",
  DefaultFolder = "DefaultFolder",
  DeliveryAddress = "DeliveryAddress",
  Designer = "Designer",
  Document = "Document",
  DocumentPreview = "DocumentPreview",
  DocumentTemplate = "DocumentTemplate",
  EffectivePermission = "EffectivePermission",
  Email = "Email",
  ExternalStorageConnection = "ExternalStorageConnection",
  ExternalStorageItem = "ExternalStorageItem",
  ExternalStorageResourceMapping = "ExternalStorageResourceMapping",
  File = "File",
  GroupInstance = "GroupInstance",
  GroupTemplate = "GroupTemplate",
  HousingCompany = "HousingCompany",
  Issue = "Issue",
  IssueCompletionStatus = "IssueCompletionStatus",
  Job = "Job",
  JobComponent = "JobComponent",
  JobStatus = "JobStatus",
  JobStatusEnum = "JobStatusEnum",
  Lead = "Lead",
  LeadProjectType = "LeadProjectType",
  LeadProjectTypeEnum = "LeadProjectTypeEnum",
  LeadSource = "LeadSource",
  LeadStatus = "LeadStatus",
  LeadStatusEnum = "LeadStatusEnum",
  LineItem = "LineItem",
  LineItemMasterWorkflow = "LineItemMasterWorkflow",
  LinkedAction = "LinkedAction",
  LostReason = "LostReason",
  Machine = "Machine",
  MachineType = "MachineType",
  Money = "Money",
  Month = "Month",
  NZRegion = "NZRegion",
  NotificationAction = "NotificationAction",
  NotificationTemplate = "NotificationTemplate",
  PageInfo = "PageInfo",
  PagedJobs = "PagedJobs",
  PaginatedResult = "PaginatedResult",
  Panel = "Panel",
  PartType = "PartType",
  Permission = "Permission",
  PermissionPolicy = "PermissionPolicy",
  PermissionScope = "PermissionScope",
  Person = "Person",
  PersonAssignedWork = "PersonAssignedWork",
  PersonBusinessRole = "PersonBusinessRole",
  PersonStatus = "PersonStatus",
  ProcessAsset = "ProcessAsset",
  ProcessAssignment = "ProcessAssignment",
  ProcessInstance = "ProcessInstance",
  ProcessTemplate = "ProcessTemplate",
  ProcessTimer = "ProcessTimer",
  ProcessTimerItem = "ProcessTimerItem",
  ProcessType = "ProcessType",
  ProcessTypeNote = "ProcessTypeNote",
  ProcessTypeRole = "ProcessTypeRole",
  Product = "Product",
  ProductCategory = "ProductCategory",
  ProductCategoryGroup = "ProductCategoryGroup",
  ProductImportUpdateField = "ProductImportUpdateField",
  ProductPrice = "ProductPrice",
  Project = "Project",
  ProjectManager = "ProjectManager",
  PurchaseOrder = "PurchaseOrder",
  PurchaseOrderEvent = "PurchaseOrderEvent",
  PurchaseOrderLine = "PurchaseOrderLine",
  PurchaseOrderPreview = "PurchaseOrderPreview",
  PurchaseOrderReceipt = "PurchaseOrderReceipt",
  PurchaseOrderReceiptLine = "PurchaseOrderReceiptLine",
  PurchaseOrderReview = "PurchaseOrderReview",
  PurchaseOrderSavePayload = "PurchaseOrderSavePayload",
  PurchaseOrderStatus = "PurchaseOrderStatus",
  Quote = "Quote",
  QuoteLine = "QuoteLine",
  QuoteLineTemplate = "QuoteLineTemplate",
  QuotePreview = "QuotePreview",
  QuoteRevision = "QuoteRevision",
  QuoteStatus = "QuoteStatus",
  QuoteTemplate = "QuoteTemplate",
  QuoteTemplateExpression = "QuoteTemplateExpression",
  QuoteTemplatePreview = "QuoteTemplatePreview",
  QuoteTemplateRevision = "QuoteTemplateRevision",
  RecordFile = "RecordFile",
  RecordFolder = "RecordFolder",
  RecordNavigationRecord = "RecordNavigationRecord",
  RecordScreen = "RecordScreen",
  RecordTag = "RecordTag",
  Region = "Region",
  Role = "Role",
  RoleInheritance = "RoleInheritance",
  RolePermission = "RolePermission",
  RoleUser = "RoleUser",
  SaleType = "SaleType",
  SalesOrder = "SalesOrder",
  SalesOrderLine = "SalesOrderLine",
  Schema = "Schema",
  SchemaType = "SchemaType",
  SchemaVersion = "SchemaVersion",
  Screen = "Screen",
  SignedUploadUrlPayload = "SignedUploadUrlPayload",
  Specification = "Specification",
  SpecificationLookupOption = "SpecificationLookupOption",
  Stock = "Stock",
  StockTransaction = "StockTransaction",
  StockTransactionLine = "StockTransactionLine",
  SubscriptionReal = "SubscriptionReal",
  Supplier = "Supplier",
  SupplierCategory = "SupplierCategory",
  SupplierQuote = "SupplierQuote",
  SupplierQuoteLine = "SupplierQuoteLine",
  SupplierQuoteRequest = "SupplierQuoteRequest",
  SupplierQuoteRequestLine = "SupplierQuoteRequestLine",
  Tag = "Tag",
  TimerTransaction = "TimerTransaction",
  Unknown = "Unknown",
  UploadRequestUrl = "UploadRequestUrl",
  User = "User",
  UserIdentity = "UserIdentity",
  UserNotification = "UserNotification",
  UserPermission = "UserPermission",
  UserRole = "UserRole",
  Warehouse = "Warehouse",
  Webhook = "Webhook",
  Week = "Week",
  Workflow = "Workflow",
  WorkflowNode = "WorkflowNode",
  WorkflowNote = "WorkflowNote",
  WorkflowTemplate = "WorkflowTemplate",
  WorkflowType = "WorkflowType",
}

export interface RegionFilterInput {
  and?: InputMaybe<Array<RegionFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nzRegion?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RegionFilterInput>>;
}

/** Groups by Region identity, or traverses to one of its typed dimensions. */
export interface RegionReportRelationDimensionInput {
  filter?: InputMaybe<RegionFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface ReleasePurchaseOrdersInput {
  purchaseOrderIds: Array<Scalars["ID"]["input"]>;
}

/** Calendar interval used by a DateTime report dimension. */
export enum ReportDateInterval {
  /** One row per calendar day. */
  DAY = "DAY",
  /** One row per calendar month. */
  MONTH = "MONTH",
  /** One row per calendar quarter. */
  QUARTER = "QUARTER",
  /** One row per ISO week, starting on Monday. */
  WEEK = "WEEK",
  /** One row per calendar year. */
  YEAR = "YEAR",
}

export interface RescheduleBatchesInput {
  batchScheduleIds: Array<Scalars["ID"]["input"]>;
  ignoreRestrictions: Scalars["Boolean"]["input"];
  scheduled: Scalars["String"]["input"];
}

export interface ResetUserPasswordInput {
  password: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
}

export interface ResourceGroupByInput {
  dir?: InputMaybe<ResourceGroupDirection>;
  field: Scalars["String"]["input"];
}

export enum ResourceGroupDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export interface ResourceGroupInput {
  field: Scalars["String"]["input"];
  key: Scalars["String"]["input"];
}

export interface RestorePartTypesInput {
  partTypeIds: Array<Scalars["ID"]["input"]>;
}

export interface RestoreProcessTypesInput {
  processTypeIds: Array<Scalars["ID"]["input"]>;
}

export interface RestoreWorkflowTypesInput {
  workflowTypeIds: Array<Scalars["ID"]["input"]>;
}

export interface ReviseQuoteInput {
  clientAddress?: InputMaybe<Scalars["String"]["input"]>;
  clientName: Scalars["String"]["input"];
  contactName?: InputMaybe<Scalars["String"]["input"]>;
  files?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  lines: Array<QuoteLineInput>;
  quoteId?: InputMaybe<Scalars["ID"]["input"]>;
  reference: Scalars["String"]["input"];
}

export interface RoleFilterInput {
  and?: InputMaybe<Array<RoleFilterInput>>;
  assignedUsers?: InputMaybe<RoleUserFilterInput>;
  childRoles?: InputMaybe<RoleInheritanceFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  inheritances?: InputMaybe<RoleInheritanceFilterInput>;
  inheritedBy?: InputMaybe<RoleInheritanceFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RoleFilterInput>>;
  parentRoles?: InputMaybe<RoleInheritanceFilterInput>;
  roleScreens?: InputMaybe<RecordScreenFilterInput>;
  roleUsers?: InputMaybe<RoleUserFilterInput>;
  source?: InputMaybe<SourceFilterInput>;
}

export interface RoleInheritanceFilterInput {
  and?: InputMaybe<Array<RoleInheritanceFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RoleInheritanceFilterInput>>;
  parent?: InputMaybe<RoleFilterInput>;
  parentId?: InputMaybe<StringFilterInput>;
  parentRole?: InputMaybe<RoleFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<StringFilterInput>;
}

export interface RolePermissionFilterInput {
  and?: InputMaybe<Array<RolePermissionFilterInput>>;
  conditions?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RolePermissionFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
}

export interface RoleUserFilterInput {
  and?: InputMaybe<Array<RoleUserFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<RoleUserFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
  user?: InputMaybe<UserFilterInput>;
}

export interface SaleTypeFilterInput {
  and?: InputMaybe<Array<SaleTypeFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SaleTypeFilterInput>>;
}

/** Groups by Sale Type identity, or traverses to one of its typed dimensions. */
export interface SaleTypeReportRelationDimensionInput {
  filter?: InputMaybe<SaleTypeFilterInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface SalesOrderFilterInput {
  and?: InputMaybe<Array<SalesOrderFilterInput>>;
  client?: InputMaybe<ClientFilterInput>;
  clientAddress?: InputMaybe<StringFilterInput>;
  clientName?: InputMaybe<StringFilterInput>;
  confirmedAt?: InputMaybe<StringFilterInput>;
  contactName?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<SalesOrderLineFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SalesOrderFilterInput>>;
  reference?: InputMaybe<StringFilterInput>;
  salesOrderNumber?: InputMaybe<StringFilterInput>;
  salesTax?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  subTotal?: InputMaybe<StringFilterInput>;
  total?: InputMaybe<StringFilterInput>;
}

export interface SalesOrderLineFilterInput {
  and?: InputMaybe<Array<SalesOrderLineFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  jobComponent?: InputMaybe<JobComponentFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  lineTotal?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SalesOrderLineFilterInput>>;
  quantity?: InputMaybe<StringFilterInput>;
  salesOrder?: InputMaybe<SalesOrderFilterInput>;
  sourceQuote?: InputMaybe<QuoteFilterInput>;
  sourceQuoteLine?: InputMaybe<QuoteLineFilterInput>;
  sourceQuoteRevision?: InputMaybe<QuoteRevisionFilterInput>;
  unit?: InputMaybe<StringFilterInput>;
  unitSellPrice?: InputMaybe<StringFilterInput>;
}

export interface SalesOrderLineInput {
  description: Scalars["String"]["input"];
  jobComponentId?: InputMaybe<Scalars["ID"]["input"]>;
  quantity: Scalars["String"]["input"];
  sourceQuoteId?: InputMaybe<Scalars["ID"]["input"]>;
  sourceQuoteLineId?: InputMaybe<Scalars["ID"]["input"]>;
  sourceQuoteRevisionId?: InputMaybe<Scalars["ID"]["input"]>;
  unit?: InputMaybe<Scalars["String"]["input"]>;
  unitSellPrice: Scalars["String"]["input"];
}

export interface SchemaFilterInput {
  and?: InputMaybe<Array<SchemaFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  latestVersion?: InputMaybe<SchemaVersionFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SchemaFilterInput>>;
  recordType?: InputMaybe<StringFilterInput>;
  versions?: InputMaybe<SchemaVersionFilterInput>;
}

export interface SchemaTypeFilterInput {
  id?: InputMaybe<IDFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
}

export interface SchemaVersionFilterInput {
  and?: InputMaybe<Array<SchemaVersionFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  dataDefinition?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  extra?: InputMaybe<StringFilterInput>;
  formDefinition?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  latestActive?: InputMaybe<BooleanFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SchemaVersionFilterInput>>;
  schema?: InputMaybe<SchemaFilterInput>;
  schemaId?: InputMaybe<IDFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  version?: InputMaybe<StringFilterInput>;
  versionNo?: InputMaybe<StringFilterInput>;
}

export interface SchemaVersionInput {
  dataSchema: Scalars["String"]["input"];
  formSchema: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  schemaId: Scalars["ID"]["input"];
}

export interface ScreenAssignmentInput {
  roleIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  screenId: Scalars["ID"]["input"];
  userIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface ScreenFilterInput {
  and?: InputMaybe<Array<ScreenFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  icon?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ScreenFilterInput>>;
  recordType?: InputMaybe<StringFilterInput>;
  screenCfg?: InputMaybe<StringFilterInput>;
}

export enum ScreenGroup {
  ACCOUNTS = "ACCOUNTS",
  ADMIN = "ADMIN",
  INSTALLATION = "INSTALLATION",
  INVENTORY = "INVENTORY",
  MAINTENANCE = "MAINTENANCE",
  MANUFACTURING = "MANUFACTURING",
  SALES = "SALES",
}

export interface ScreenUnassignmentInput {
  recordScreenIds: Array<Scalars["String"]["input"]>;
  screenId: Scalars["ID"]["input"];
}

export interface SetCandidateIngestionPolicyInput {
  candidateType: Scalars["String"]["input"];
  emailAddresses: Array<Scalars["String"]["input"]>;
  mode: CandidateIngestionMode;
  senderRecordId: Scalars["ID"]["input"];
  senderRecordType: Scalars["String"]["input"];
}

export interface SetConfiguredLinkedActionInput {
  actionId: Scalars["String"]["input"];
  bindings: Scalars["String"]["input"];
  displayOrder: Scalars["Int"]["input"];
  enabled: Scalars["Boolean"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  isGlobal: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  recordPath: Scalars["String"]["input"];
  recordType: Scalars["String"]["input"];
  roleIds: Array<Scalars["ID"]["input"]>;
  userIds: Array<Scalars["ID"]["input"]>;
}

export interface SetCustomDataInput {
  data: Scalars["String"]["input"];
  recordId: Scalars["String"]["input"];
  schemaId: Scalars["String"]["input"];
  upgradeSchema?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface SetDefaultFolderInput {
  allowedMimeTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  enabled?: Scalars["Boolean"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  name: Scalars["String"]["input"];
  recordType: Scalars["String"]["input"];
}

export interface SetFavouriteLinkedActionInput {
  actionId: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  recordPath: Scalars["String"]["input"];
  recordType: Scalars["String"]["input"];
}

export interface SetLinkedActionRecipientInput {
  assigned: Scalars["Boolean"]["input"];
  linkedActionId: Scalars["ID"]["input"];
  roleId?: InputMaybe<Scalars["ID"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
}

export interface SetUserPinInput {
  pin: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
}

export interface SortInput {
  dir?: InputMaybe<Scalars["String"]["input"]>;
  field?: InputMaybe<Scalars["String"]["input"]>;
}

export interface SourceFilterInput {
  eq?: InputMaybe<RecordSource>;
  notEq?: InputMaybe<RecordSource>;
}

export interface StockFilterInput {
  and?: InputMaybe<Array<StockFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<StockFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  quantity?: InputMaybe<NumberFilterInput>;
  warehouse?: InputMaybe<WarehouseFilterInput>;
}

export interface StockTransactionFilterInput {
  and?: InputMaybe<Array<StockTransactionFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<StockTransactionLineFilterInput>;
  or?: InputMaybe<Array<StockTransactionFilterInput>>;
  type?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  warehouse?: InputMaybe<WarehouseFilterInput>;
}

export interface StockTransactionLineFilterInput {
  and?: InputMaybe<Array<StockTransactionLineFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<StockTransactionLineFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  quantity?: InputMaybe<NumberFilterInput>;
  stockTransaction?: InputMaybe<StockTransactionFilterInput>;
}

/** Inventory stock transaction type. */
export enum StockTransactionType {
  Receive = "Receive",
  StockTake = "StockTake",
  Transfer = "Transfer",
  Withdraw = "Withdraw",
}

export interface StringFilterInput {
  endsWith?: InputMaybe<Scalars["String"]["input"]>;
  eq?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<Scalars["String"]["input"]>;
  likeAll?: InputMaybe<Array<Scalars["String"]["input"]>>;
  neq?: InputMaybe<Scalars["String"]["input"]>;
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
}

export interface SubmitPurchaseOrderReviewInput {
  comment: Scalars["String"]["input"];
  purchaseOrderId: Scalars["ID"]["input"];
  review: OrderReviewStatus;
}

export interface SubscriptionRealFilterInput {
  and?: InputMaybe<Array<SubscriptionRealFilterInput>>;
  channels?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  event?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  maxRecipients?: InputMaybe<NumberFilterInput>;
  notificationTemplates?: InputMaybe<NotificationTemplateFilterInput>;
  or?: InputMaybe<Array<SubscriptionRealFilterInput>>;
  sourceFilter?: InputMaybe<StringFilterInput>;
  targetFilter?: InputMaybe<StringFilterInput>;
}

export interface SupplierCategoryFilterInput {
  and?: InputMaybe<Array<SupplierCategoryFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SupplierCategoryFilterInput>>;
}

export interface SupplierFilterInput {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<SupplierFilterInput>>;
  category?: InputMaybe<SupplierCategoryFilterInput>;
  cell?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  image?: InputMaybe<FileFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  numberOfReviews?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SupplierFilterInput>>;
  products?: InputMaybe<ProductFilterInput>;
  quantityThreshold?: InputMaybe<StringFilterInput>;
  reviewType?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
}

export interface SupplierQuoteFilterInput {
  and?: InputMaybe<Array<SupplierQuoteFilterInput>>;
  costingLines?: InputMaybe<CostingLineFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<SupplierQuoteLineFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SupplierQuoteFilterInput>>;
  quoteRequest?: InputMaybe<SupplierQuoteRequestFilterInput>;
  reference?: InputMaybe<StringFilterInput>;
  salesTax?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
  subTotal?: InputMaybe<StringFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierAddress?: InputMaybe<StringFilterInput>;
  supplierName?: InputMaybe<StringFilterInput>;
  supplierQuoteNumber?: InputMaybe<StringFilterInput>;
  total?: InputMaybe<StringFilterInput>;
}

export interface SupplierQuoteLineFilterInput {
  and?: InputMaybe<Array<SupplierQuoteLineFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  or?: InputMaybe<Array<SupplierQuoteLineFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  quantity?: InputMaybe<StringFilterInput>;
  supplierQuote?: InputMaybe<SupplierQuoteFilterInput>;
  total?: InputMaybe<StringFilterInput>;
  unitPrice?: InputMaybe<StringFilterInput>;
}

export interface SupplierQuoteLineInput {
  description: Scalars["String"]["input"];
  productId?: InputMaybe<Scalars["ID"]["input"]>;
  quantity: Scalars["String"]["input"];
  unitPrice: Scalars["String"]["input"];
}

export interface SupplierQuoteRequestFilterInput {
  and?: InputMaybe<Array<SupplierQuoteRequestFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  job?: InputMaybe<JobFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lines?: InputMaybe<SupplierQuoteRequestLineFilterInput>;
  noteForSupplier?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<SupplierQuoteRequestFilterInput>>;
  reference?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
}

export interface SupplierQuoteRequestLineFilterInput {
  and?: InputMaybe<Array<SupplierQuoteRequestLineFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  line?: InputMaybe<NumberFilterInput>;
  or?: InputMaybe<Array<SupplierQuoteRequestLineFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  quantity?: InputMaybe<NumberFilterInput>;
  quoteRequest?: InputMaybe<SupplierQuoteRequestFilterInput>;
  unit?: InputMaybe<StringFilterInput>;
}

export interface SupplierQuoteRequestLineInput {
  code: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  line: Scalars["Int"]["input"];
  quantity: Scalars["String"]["input"];
}

export interface TagFilterInput {
  and?: InputMaybe<Array<TagFilterInput>>;
  colour?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<TagFilterInput>>;
  resourceType?: InputMaybe<StringFilterInput>;
}

export interface TimerTransactionFilterInput {
  and?: InputMaybe<Array<TimerTransactionFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<TimerTransactionFilterInput>>;
  start?: InputMaybe<DateTimeFilterInput>;
  stop?: InputMaybe<DateTimeFilterInput>;
  timer?: InputMaybe<ProcessTimerFilterInput>;
}

export interface TransferWarehouseStockInput {
  destinationWarehouseId: Scalars["ID"]["input"];
  sourceWarehouseId: Scalars["ID"]["input"];
  stock: Array<WarehouseStockInput>;
}

export interface TriggerWebhookInput {
  recordId?: InputMaybe<Scalars["String"]["input"]>;
  webhookId: Scalars["String"]["input"];
}

export interface UnassignBusinessRolesFromPersonInput {
  personBusinessRoleIds: Array<Scalars["ID"]["input"]>;
}

export interface UnassignInheritanceFromRoleInput {
  roleId: Scalars["ID"]["input"];
  roleInheritanceIds: Array<Scalars["String"]["input"]>;
}

export interface UnassignLeadsFromSalespersonInput {
  leadIds: Array<Scalars["ID"]["input"]>;
}

export interface UnassignPermissionsFromRoleInput {
  roleId: Scalars["ID"]["input"];
  rolePermissionIds: Array<Scalars["String"]["input"]>;
}

export interface UnassignPermissionsFromUserInput {
  userId: Scalars["ID"]["input"];
  userPermissionIds: Array<Scalars["String"]["input"]>;
}

export interface UnassignRolesFromUserInput {
  roleIds: Array<Scalars["String"]["input"]>;
  userId: Scalars["ID"]["input"];
}

export interface UnassignScreensFromRoleInput {
  recordScreenIds: Array<Scalars["String"]["input"]>;
  roleId: Scalars["ID"]["input"];
}

export interface UnassignScreensFromUserInput {
  recordScreenIds: Array<Scalars["String"]["input"]>;
  userId: Scalars["ID"]["input"];
}

export interface UnassignUsersFromRoleInput {
  roleId: Scalars["ID"]["input"];
  userIds: Array<Scalars["String"]["input"]>;
}

export interface UnmarkJobLostInput {
  jobId: Scalars["ID"]["input"];
}

export interface UnmarkLeadLostInput {
  leadId: Scalars["ID"]["input"];
}

export interface UpdateBatchDetailsInput {
  batchId: Scalars["ID"]["input"];
  cubicMetres?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  sheets?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface UpdateBranchInput {
  branchId: Scalars["ID"]["input"];
  code: Scalars["String"]["input"];
  colour: Scalars["String"]["input"];
  darkColour: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
}

export interface UpdateBuilderInput {
  address: Scalars["String"]["input"];
  code: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
}

export interface UpdateBusinessRoleInput {
  businessRoleId: Scalars["ID"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
}

export interface UpdateClientInput {
  address?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  faxHome?: InputMaybe<Scalars["String"]["input"]>;
  faxWork?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  lastName: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  phoneCell?: InputMaybe<Scalars["String"]["input"]>;
  phoneHome?: InputMaybe<Scalars["String"]["input"]>;
  phoneWork?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UpdateCorrespondenceInput {
  date?: InputMaybe<Scalars["DateTime"]["input"]>;
  details: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  type: Scalars["Int"]["input"];
}

export interface UpdateCostingInput {
  costingId: Scalars["ID"]["input"];
  jobComponentId?: InputMaybe<Scalars["ID"]["input"]>;
  lines?: Array<CostingLineInput>;
  name: Scalars["String"]["input"];
}

export interface UpdateDocumentTemplateInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  query: Scalars["String"]["input"];
  recordType: Scalars["String"]["input"];
  sampleDataOverride: Scalars["String"]["input"];
  template: Scalars["String"]["input"];
  templateId: Scalars["ID"]["input"];
}

export interface UpdateDraftPurchaseOrderInput {
  category?: InputMaybe<OrderCategory>;
  deliveryAddress?: InputMaybe<Scalars["String"]["input"]>;
  deliveryAddressId?: InputMaybe<Scalars["ID"]["input"]>;
  internalComment?: InputMaybe<Scalars["String"]["input"]>;
  jobId?: InputMaybe<Scalars["ID"]["input"]>;
  lines?: InputMaybe<Array<PurchaseOrderLineInput>>;
  notifySupplierWhenPlaced?: Scalars["Boolean"]["input"];
  reference?: InputMaybe<Scalars["String"]["input"]>;
  required?: InputMaybe<Scalars["String"]["input"]>;
  shippingMethod?: InputMaybe<OrderShippingMethods>;
  shippingTerms?: InputMaybe<OrderShippingTerms>;
  siteVisitRequired?: Scalars["Boolean"]["input"];
  statusWhenPlaced?: InputMaybe<OrderStatus>;
  supplierComment?: InputMaybe<Scalars["String"]["input"]>;
  supplierId?: InputMaybe<Scalars["ID"]["input"]>;
  templateId?: InputMaybe<Scalars["ID"]["input"]>;
  urgent?: Scalars["Boolean"]["input"];
  warehouseId?: InputMaybe<Scalars["ID"]["input"]>;
}

export interface UpdateDraftSchemaVersionInput {
  dataSchema: Scalars["String"]["input"];
  formSchema: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
}

export interface UpdateHousingCompanyInput {
  code?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
}

export interface UpdateIssueInput {
  completed?: Scalars["Boolean"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  requiredDate?: InputMaybe<Scalars["DateTime"]["input"]>;
}

export interface UpdateJobBuilderInput {
  builderId?: InputMaybe<Scalars["ID"]["input"]>;
  builderPhone?: InputMaybe<Scalars["String"]["input"]>;
  hcJobNumber?: InputMaybe<Scalars["String"]["input"]>;
  hcPmPhone?: InputMaybe<Scalars["String"]["input"]>;
  hcProjectManager?: InputMaybe<Scalars["String"]["input"]>;
  housingCompanyId?: InputMaybe<Scalars["ID"]["input"]>;
  id: Scalars["ID"]["input"];
}

export interface UpdateJobClientInput {
  client: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
}

export interface UpdateJobComponentInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  jobComponentId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  partTypeId?: InputMaybe<Scalars["ID"]["input"]>;
}

export interface UpdateJobDetailsInput {
  benchtopOnly: Scalars["Boolean"]["input"];
  branch: Scalars["ID"]["input"];
  buildType: Scalars["ID"]["input"];
  designer?: InputMaybe<Scalars["ID"]["input"]>;
  estimatedDueDate: Scalars["DateTime"]["input"];
  id: Scalars["ID"]["input"];
  jobName?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  projectManager?: InputMaybe<Scalars["ID"]["input"]>;
  saleType: Scalars["ID"]["input"];
  showHome: Scalars["Boolean"]["input"];
  sssp: Scalars["Boolean"]["input"];
  tristoneJoin: Scalars["Boolean"]["input"];
  tristoneSpecified: Scalars["Boolean"]["input"];
}

export interface UpdateJobNoteInput {
  jobId: Scalars["ID"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UpdateJobSiteInput {
  address?: InputMaybe<Scalars["String"]["input"]>;
  difficultAccess: Scalars["Boolean"]["input"];
  id: Scalars["String"]["input"];
  region?: InputMaybe<Scalars["ID"]["input"]>;
  siteNotes?: InputMaybe<Scalars["String"]["input"]>;
  unit: Scalars["Boolean"]["input"];
}

export interface UpdateLeadInput {
  address?: InputMaybe<Scalars["String"]["input"]>;
  assignedTo?: InputMaybe<Scalars["String"]["input"]>;
  branchId?: InputMaybe<Scalars["String"]["input"]>;
  builderName?: InputMaybe<Scalars["String"]["input"]>;
  builderType?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  client: Scalars["String"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  joineryTypes?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  priceRangeBottom?: InputMaybe<Scalars["Float"]["input"]>;
  priceRangeTop?: InputMaybe<Scalars["Float"]["input"]>;
  priority?: Scalars["Int"]["input"];
  projectType: Scalars["String"]["input"];
  requiredBy?: InputMaybe<Scalars["String"]["input"]>;
  source: Scalars["String"]["input"];
  suburb?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UpdateLineItemInput {
  lineItemId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
}

export interface UpdateLineItemWorkflowInput {
  lineItemId: Scalars["ID"]["input"];
  placeholders?: Array<LineItemWorkflowPlaceholderInput>;
  workflowTemplateId: Scalars["ID"]["input"];
}

export interface UpdateLostReasonInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  lostReasonId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
}

export interface UpdatePanelConfigInput {
  config: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  panelId: Scalars["ID"]["input"];
}

export interface UpdatePanelDetailsInput {
  name: Scalars["String"]["input"];
  panelId: Scalars["ID"]["input"];
  tags: Array<Scalars["ID"]["input"]>;
}

export interface UpdatePartTypeInput {
  code: Scalars["String"]["input"];
  colour: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  partTypeId: Scalars["ID"]["input"];
}

export interface UpdatePermissionForRoleInput {
  permission: PermissionInput;
  roleId: Scalars["ID"]["input"];
  rolePermissionId: Scalars["ID"]["input"];
}

export interface UpdatePermissionForUserInput {
  permission: PermissionInput;
  userId: Scalars["ID"]["input"];
  userPermissionId: Scalars["ID"]["input"];
}

export interface UpdatePersonInput {
  isActive: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  personId: Scalars["ID"]["input"];
}

export interface UpdateProcessInstanceDetailsInput {
  assignedHours: Scalars["Float"]["input"];
  leadDays: Scalars["Int"]["input"];
  processInstanceId: Scalars["ID"]["input"];
}

export interface UpdateProcessInstanceStatusInput {
  processInstanceId: Scalars["ID"]["input"];
  status: Scalars["Int"]["input"];
}

export interface UpdateProcessTypeDetailsInput {
  code: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  processTypeId: Scalars["ID"]["input"];
}

export interface UpdateProcessTypeNoteInput {
  assignedProcessIds: Array<Scalars["ID"]["input"]>;
  date?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  processTypeNoteId: Scalars["ID"]["input"];
}

export interface UpdateProcessTypeRoleInput {
  processTypeId: Scalars["ID"]["input"];
  processTypeRoleId: Scalars["ID"]["input"];
  roleType: Scalars["String"]["input"];
}

export interface UpdateProductCategoryInput {
  group: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
}

export interface UpdateProductDetailsInput {
  category?: InputMaybe<Scalars["ID"]["input"]>;
  code?: InputMaybe<Scalars["String"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  indent?: InputMaybe<Scalars["Boolean"]["input"]>;
  leadTime?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  productIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  qtyReviewThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  safetyStockDays?: InputMaybe<Scalars["Int"]["input"]>;
  starred?: InputMaybe<Scalars["Boolean"]["input"]>;
  stockItem?: InputMaybe<Scalars["Boolean"]["input"]>;
  supplier?: InputMaybe<Scalars["ID"]["input"]>;
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  template?: InputMaybe<Scalars["Boolean"]["input"]>;
  unitOfMeasure?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UpdatePurchaseOrderInternalCommentInput {
  internalComment: Scalars["String"]["input"];
  purchaseOrderId: Scalars["ID"]["input"];
}

export interface UpdateQuoteInput {
  clientAddress?: InputMaybe<Scalars["String"]["input"]>;
  clientName: Scalars["String"]["input"];
  contactName?: InputMaybe<Scalars["String"]["input"]>;
  customer?: InputMaybe<Scalars["String"]["input"]>;
  files?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  jobId?: InputMaybe<Scalars["ID"]["input"]>;
  lines: Array<QuoteLineInput>;
  quoteId: Scalars["ID"]["input"];
  reference: Scalars["String"]["input"];
}

export interface UpdateRoleDetailsInput {
  description: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  roleId: Scalars["ID"]["input"];
}

export interface UpdateSalesOrderInput {
  clientAddress?: InputMaybe<Scalars["String"]["input"]>;
  clientId?: InputMaybe<Scalars["ID"]["input"]>;
  clientName: Scalars["String"]["input"];
  contactName?: InputMaybe<Scalars["String"]["input"]>;
  currency?: Scalars["String"]["input"];
  jobId?: InputMaybe<Scalars["ID"]["input"]>;
  lines: Array<SalesOrderLineInput>;
  reference?: InputMaybe<Scalars["String"]["input"]>;
  salesOrderId: Scalars["ID"]["input"];
}

export interface UpdateSchemaDetailsInput {
  description: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  recordType: Scalars["String"]["input"];
}

export interface UpdateScreenConfigInput {
  name: Scalars["String"]["input"];
  screenCfg: Scalars["String"]["input"];
  screenId: Scalars["ID"]["input"];
}

export interface UpdateScreenDetailsInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  recordType?: InputMaybe<Scalars["String"]["input"]>;
  screenGroup?: InputMaybe<ScreenGroup>;
  screenId: Scalars["ID"]["input"];
}

export interface UpdateSettingsInput {
  settings: Scalars["String"]["input"];
}

export interface UpdateStorageConnectionInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  deviceAccessEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  dropboxAuthToken?: InputMaybe<Scalars["String"]["input"]>;
  dropboxNamespaceId?: InputMaybe<Scalars["String"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["ID"]["input"];
  localRoot?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  root: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
}

export interface UpdateStorageResourceMappingInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  enabled: Scalars["Boolean"]["input"];
  externalStorageConnectionId: Scalars["String"]["input"];
  path?: InputMaybe<Scalars["String"]["input"]>;
  resourceFilter?: InputMaybe<Scalars["String"]["input"]>;
  resourceMappingId: Scalars["ID"]["input"];
  resourceType: Scalars["String"]["input"];
}

export interface UpdateSubscriptionInput {
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  event: Scalars["String"]["input"];
  maxRecipients?: InputMaybe<Scalars["Int"]["input"]>;
  notifications?: Array<NotificationInput>;
  sourceFilter?: InputMaybe<Scalars["String"]["input"]>;
  subscriptionId: Scalars["ID"]["input"];
  targetFilter?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UpdateSupplierDetailsInput {
  address: Scalars["String"]["input"];
  categoryId?: InputMaybe<Scalars["ID"]["input"]>;
  cell: Scalars["String"]["input"];
  currency: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  orderEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  quoteEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  supplierId: Scalars["ID"]["input"];
  url: Scalars["String"]["input"];
}

export interface UpdateSupplierQuoteInput {
  files?: Array<Scalars["ID"]["input"]>;
  jobId?: InputMaybe<Scalars["ID"]["input"]>;
  lines?: Array<SupplierQuoteLineInput>;
  quoteRequestId?: InputMaybe<Scalars["ID"]["input"]>;
  reference?: InputMaybe<Scalars["String"]["input"]>;
  salesTax?: Scalars["String"]["input"];
  saveAsDraft?: Scalars["Boolean"]["input"];
  supplierId?: InputMaybe<Scalars["ID"]["input"]>;
  supplierQuoteId: Scalars["ID"]["input"];
  supplierQuoteNumber?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UpdateSupplierQuoteRequestInput {
  files?: Array<Scalars["ID"]["input"]>;
  lines: Array<SupplierQuoteRequestLineInput>;
  noteForSupplier: Scalars["String"]["input"];
  place?: Scalars["Boolean"]["input"];
  reference: Scalars["String"]["input"];
  supplierId?: InputMaybe<Scalars["ID"]["input"]>;
  supplierQuoteRequestId: Scalars["ID"]["input"];
}

export interface UpdateSupplierReviewersInput {
  id: Scalars["ID"]["input"];
  numberOfReviews: Scalars["Int"]["input"];
  quantityThreshold: Scalars["Int"]["input"];
  reviewType: Scalars["Int"]["input"];
  reviewers: Array<Scalars["String"]["input"]>;
}

export interface UpdateTagInput {
  colour: Scalars["String"]["input"];
  context: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
}

export interface UpdateUserDetailsInput {
  authProvider: AuthProviderType;
  branchId?: InputMaybe<Scalars["String"]["input"]>;
  fullName: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
  username: Scalars["String"]["input"];
}

export interface UpdateUserSubscriptionsInput {
  subscriptions: Array<Scalars["String"]["input"]>;
  userId: Scalars["ID"]["input"];
}

export interface UpdateWarehouseInput {
  address: Scalars["String"]["input"];
  code?: InputMaybe<Scalars["String"]["input"]>;
  color?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
}

export interface UpdateWebhookInput {
  authType?: InputMaybe<Scalars["String"]["input"]>;
  description: Scalars["String"]["input"];
  enabled: Scalars["Boolean"]["input"];
  event: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  sourceFilter?: InputMaybe<Scalars["String"]["input"]>;
  url: Scalars["String"]["input"];
}

export interface UpdateWorkflowTypeDetailsInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  master: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  workflowTypeId: Scalars["ID"]["input"];
}

export interface UserFilterInput {
  and?: InputMaybe<Array<UserFilterInput>>;
  assignedRoles?: InputMaybe<RoleUserFilterInput>;
  authProvider?: InputMaybe<StringFilterInput>;
  authProviderUid?: InputMaybe<StringFilterInput>;
  branch?: InputMaybe<BranchFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  fullName?: InputMaybe<StringFilterInput>;
  hasPersonIdentity?: InputMaybe<BooleanFilterInput>;
  hasPin?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  identities?: InputMaybe<UserIdentityFilterInput>;
  includeSystem?: InputMaybe<BooleanFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  isCurrent?: InputMaybe<BooleanFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  oldRoles?: InputMaybe<UserRoleFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  reviewedSuppliers?: InputMaybe<SupplierFilterInput>;
  timers?: InputMaybe<ProcessTimerFilterInput>;
  username?: InputMaybe<StringFilterInput>;
}

export interface UserIdentityFilterInput {
  and?: InputMaybe<Array<UserIdentityFilterInput>>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  /** The schema type of the represented record. */
  entity?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<UserIdentityFilterInput>>;
  /** The person represented by a Person identity. */
  person?: InputMaybe<PersonFilterInput>;
  recordId?: InputMaybe<IDFilterInput>;
  recordLabel?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<StringFilterInput>;
}

export interface UserPermissionFilterInput {
  and?: InputMaybe<Array<UserPermissionFilterInput>>;
  conditions?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<UserPermissionFilterInput>>;
  user?: InputMaybe<UserFilterInput>;
}

/** Select exactly one typed User report dimension. */
export interface UserReportGroupByInput {
  /** Group by Branch or one of its dimensions. */
  branch: BranchReportRelationDimensionInput;
}

/** Groups by User identity, or traverses to one of its typed dimensions. */
export interface UserReportRelationDimensionInput {
  filter?: InputMaybe<UserFilterInput>;
  /** Traverse through this relation and group by a field or relation on the related Resource. */
  groupBy?: InputMaybe<UserReportGroupByInput>;
  /** Include filtered related records that have no contributing resource rows. */
  includeEmpty?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface UserRoleFilterInput {
  and?: InputMaybe<Array<UserRoleFilterInput>>;
  businessRole?: InputMaybe<BusinessRoleFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<UserRoleFilterInput>>;
  processAssignments?: InputMaybe<ProcessAssignmentFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UserFilterInput>;
}

export interface WarehouseFilterInput {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<WarehouseFilterInput>>;
  code?: InputMaybe<StringFilterInput>;
  color?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WarehouseFilterInput>>;
  stock?: InputMaybe<StockFilterInput>;
}

export interface WarehouseStockInput {
  productId: Scalars["ID"]["input"];
  quantity: Scalars["String"]["input"];
}

export interface WarehouseStockTakeInput {
  stock: Array<WarehouseStockInput>;
  warehouseId: Scalars["ID"]["input"];
}

export interface WebhookFilterInput {
  and?: InputMaybe<Array<WebhookFilterInput>>;
  authType?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<StringFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  event?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WebhookFilterInput>>;
  sourceFilter?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
}

export interface WeekFilterInput {
  date?: InputMaybe<DateTimeFilterInput>;
}

export interface WithdrawWarehouseStockInput {
  stock: Array<WarehouseStockInput>;
  warehouseId: Scalars["ID"]["input"];
}

export interface WorkflowFilterInput {
  and?: InputMaybe<Array<WorkflowFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WorkflowFilterInput>>;
  type?: InputMaybe<WorkflowTypeFilterInput>;
}

export interface WorkflowNodeFilterInput {
  and?: InputMaybe<Array<WorkflowNodeFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  lineItemMasterWorkflow?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nodeType?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WorkflowNodeFilterInput>>;
  owner?: InputMaybe<LineItemMasterWorkflowFilterInput>;
  status?: InputMaybe<NumberFilterInput>;
}

export interface WorkflowNoteFilterInput {
  and?: InputMaybe<Array<WorkflowNoteFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdBy?: InputMaybe<UserFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  nodeId?: InputMaybe<IDFilterInput>;
  or?: InputMaybe<Array<WorkflowNoteFilterInput>>;
  processInstance?: InputMaybe<ProcessInstanceFilterInput>;
  processType?: InputMaybe<ProcessTypeFilterInput>;
}

export interface WorkflowTemplateFilterInput {
  and?: InputMaybe<Array<WorkflowTemplateFilterInput>>;
  customData?: InputMaybe<CustomDataFilterInput>;
  display?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WorkflowTemplateFilterInput>>;
  placeHolder?: InputMaybe<BooleanFilterInput>;
  valid?: InputMaybe<BooleanFilterInput>;
  workflowType?: InputMaybe<WorkflowTypeFilterInput>;
}

export interface WorkflowTypeFilterInput {
  and?: InputMaybe<Array<WorkflowTypeFilterInput>>;
  created?: InputMaybe<DateTimeFilterInput>;
  customData?: InputMaybe<CustomDataFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IDFilterInput>;
  isNull?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  master?: InputMaybe<BooleanFilterInput>;
  modified?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<WorkflowTypeFilterInput>>;
}

export const scalarsEnumsHash: ScalarsEnumsHash = {
  AuthProviderType: true,
  Boolean: true,
  CandidateIngestionMode: true,
  CostingLineType: true,
  CostingTemplateRevisionStatus: true,
  DateTime: true,
  DomainEventType: true,
  EmailDeliveryStatus: true,
  Float: true,
  ID: true,
  Int: true,
  LeadStatusEnum: true,
  NotificationAction: true,
  OrderCategory: true,
  OrderReviewStatus: true,
  OrderShippingMethods: true,
  OrderShippingTerms: true,
  OrderStatus: true,
  Policy: true,
  ProductImportUpdateField: true,
  QuoteLineType: true,
  QuoteTemplateRevisionStatus: true,
  RecordScreenType: true,
  RecordSource: true,
  RecordType: true,
  ReportDateInterval: true,
  ResourceGroupDirection: true,
  ScreenGroup: true,
  StockTransactionType: true,
  String: true,
  Void: true,
};
export const generatedSchema = {
  AIGenInput: { data: { __type: "String!" } },
  AcceptQuoteInput: {
    fileIds: { __type: "[ID!]!" },
    quoteId: { __type: "ID!" },
  },
  ActAsUser: {
    __typename: { __type: "String!" },
    allPermissions: {
      __type: "[AssignedPermission!]!",
      __args: { filter: "AssignedPermissionFilterInput" },
    },
    allScreens: { __type: "[Screen!]!" },
    assignedRoles: {
      __type: "[RoleUser!]!",
      __args: { filter: "RoleUserFilterInput" },
    },
    authProvider: { __type: "String!" },
    authProviderUid: { __type: "String!" },
    branch: { __type: "Branch" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deleted: { __type: "Boolean!" },
    email: { __type: "String" },
    firebaseAuthId: { __type: "String" },
    fullName: { __type: "String" },
    hasPin: { __type: "Boolean!" },
    id: { __type: "ID!" },
    identities: {
      __type: "[UserIdentity!]!",
      __args: { filter: "UserIdentityFilterInput" },
    },
    inheritedPermissions: {
      __type: "[AssignedPermission!]!",
      __args: { filter: "AssignedPermissionFilterInput" },
    },
    inheritedScreens: { __type: "[Screen!]!" },
    initials: { __type: "String!" },
    isActive: { __type: "Boolean!" },
    label: { __type: "String!" },
    ownPermissions: {
      __type: "[AssignedPermission!]!",
      __args: { filter: "AssignedPermissionFilterInput" },
    },
    ownScreens: { __type: "[Screen!]!" },
    roles: { __type: "[Role!]!" },
    timers: {
      __type: "[ProcessTimer!]!",
      __args: { filter: "ProcessTimerFilterInput" },
    },
    username: { __type: "String" },
  },
  ActAsUserAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ActAsUserFilterInput: {
    and: { __type: "[ActAsUserFilterInput!]" },
    assignedRoles: { __type: "RoleUserFilterInput" },
    authProvider: { __type: "StringFilterInput" },
    authProviderUid: { __type: "StringFilterInput" },
    branch: { __type: "BranchFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    email: { __type: "StringFilterInput" },
    fullName: { __type: "StringFilterInput" },
    hasPersonIdentity: { __type: "BooleanFilterInput" },
    hasPin: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    identities: { __type: "UserIdentityFilterInput" },
    includeSystem: { __type: "BooleanFilterInput" },
    isActive: { __type: "BooleanFilterInput" },
    isCurrent: { __type: "BooleanFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    oldRoles: { __type: "UserRoleFilterInput" },
    or: { __type: "[ActAsUserFilterInput!]" },
    reviewedSuppliers: { __type: "SupplierFilterInput" },
    timers: { __type: "ProcessTimerFilterInput" },
    username: { __type: "StringFilterInput" },
  },
  AmendPurchaseOrderInput: {
    lines: { __type: "[PurchaseOrderLineInput!]!" },
    purchaseOrderId: { __type: "ID!" },
  },
  Asset: {
    __typename: { __type: "String!" },
    assetType: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  AssetAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  AssetFilterInput: {
    and: { __type: "[AssetFilterInput!]" },
    assetType: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[AssetFilterInput!]" },
  },
  AssignBusinessRolesToBatchScheduleInput: {
    batchScheduleId: { __type: "ID!" },
    personBusinessRoleIds: { __type: "[String!]!" },
    roleType: { __type: "String!" },
  },
  AssignBusinessRolesToPersonInput: {
    businessRoleIds: { __type: "[ID!]!" },
    personId: { __type: "ID!" },
  },
  AssignInheritanceToRoleInput: {
    parentRoleIds: { __type: "[String!]!" },
    roleId: { __type: "ID!" },
  },
  AssignLeadsToSalespersonInput: {
    leadIds: { __type: "[ID!]!" },
    salespersonId: { __type: "String!" },
  },
  AssignPermissionsToRoleInput: {
    permissions: { __type: "[PermissionInput!]!" },
    roleId: { __type: "ID!" },
  },
  AssignPermissionsToUserInput: {
    permissions: { __type: "[PermissionInput!]!" },
    userId: { __type: "ID!" },
  },
  AssignRolesToUserInput: {
    roleIds: { __type: "[String!]!" },
    userId: { __type: "ID!" },
  },
  AssignScreensToRoleInput: {
    roleId: { __type: "ID!" },
    screenIds: { __type: "[String!]!" },
  },
  AssignScreensToUserInput: {
    screenIds: { __type: "[String!]!" },
    userId: { __type: "ID!" },
  },
  AssignUsersToRoleInput: {
    roleId: { __type: "ID!" },
    userIds: { __type: "[String!]!" },
  },
  AssignedPermission: {
    __typename: { __type: "String!" },
    conditions: { __type: "String!" },
    id: { __type: "String!" },
    originalId: { __type: "String!" },
    permission: { __type: "Permission!" },
    policy: { __type: "Policy!" },
    role: { __type: "Role" },
    subjectId: { __type: "String!" },
    subjectName: { __type: "String!" },
    user: { __type: "User" },
  },
  AssignedPermissionFilterInput: {
    id: { __type: "IDFilterInput" },
    label: { __type: "StringFilterInput" },
    role: { __type: "RoleFilterInput" },
    user: { __type: "UserFilterInput" },
  },
  AsyncTask: {
    __typename: { __type: "String!" },
    created: { __type: "DateTime!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    payload: { __type: "String" },
    status: { __type: "String" },
  },
  AsyncTaskAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  AsyncTaskFilterInput: {
    and: { __type: "[AsyncTaskFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[AsyncTaskFilterInput!]" },
    payload: { __type: "StringFilterInput" },
    status: { __type: "StringFilterInput" },
  },
  AttachmentTemplate: {
    __typename: { __type: "String!" },
    bodyTemplateId: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    fileName: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    notificationTemplate: { __type: "NotificationTemplate" },
    type: { __type: "String!" },
  },
  AttachmentTemplateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  AttachmentTemplateFilterInput: {
    and: { __type: "[AttachmentTemplateFilterInput!]" },
    bodyTemplateId: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    fileName: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    notificationTemplate: { __type: "NotificationTemplateFilterInput" },
    or: { __type: "[AttachmentTemplateFilterInput!]" },
    type: { __type: "StringFilterInput" },
  },
  AuditLog: {
    __typename: { __type: "String!" },
    created: { __type: "DateTime!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    event: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    recordId: { __type: "String" },
    recordType: { __type: "String!" },
    user: { __type: "User" },
  },
  AuditLogFilterInput: {
    and: { __type: "[AuditLogFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    event: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[AuditLogFilterInput!]" },
    recordId: { __type: "IDFilterInput" },
    recordType: { __type: "StringFilterInput" },
    user: { __type: "UserFilterInput" },
    userIdentity: { __type: "UserIdentityFilterInput" },
  },
  Batch: {
    __typename: { __type: "String!" },
    batchNumber: { __type: "Int!" },
    benchtopSupplier: { __type: "String" },
    branch: { __type: "Branch!" },
    cubicMetres: { __type: "Float" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    installationHours: { __type: "Float" },
    job: { __type: "Job" },
    label: { __type: "String!" },
    lineItemAggregate: {
      __type: "LineItemAggregate",
      __args: { filter: "LineItemFilterInput" },
    },
    lineItems: {
      __type: "[LineItem!]!",
      __args: { filter: "LineItemFilterInput" },
    },
    name: { __type: "String" },
    schedules: {
      __type: "[BatchSchedule!]!",
      __args: { filter: "BatchScheduleFilterInput" },
    },
    sheets: { __type: "Int" },
  },
  BatchAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    sheetCount: { __type: "Int!" },
  },
  BatchCreatedEvent: {
    __typename: { __type: "String!" },
    batchId: { __type: "String!" },
    batchName: { __type: "String!" },
  },
  BatchDeletedEvent: {
    __typename: { __type: "String!" },
    batchId: { __type: "String!" },
    batchName: { __type: "String!" },
  },
  BatchFilterInput: {
    and: { __type: "[BatchFilterInput!]" },
    batchNumber: { __type: "NumberFilterInput" },
    benchtopSupplier: { __type: "StringFilterInput" },
    branch: { __type: "BranchFilterInput" },
    cubicMetres: { __type: "NumberFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    installationHours: { __type: "NumberFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    job: { __type: "JobFilterInput" },
    label: { __type: "StringFilterInput" },
    lineItems: { __type: "LineItemFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[BatchFilterInput!]" },
    schedules: { __type: "BatchScheduleFilterInput" },
    sheets: { __type: "NumberFilterInput" },
  },
  BatchRecalculateDueDateEvent: {
    __typename: { __type: "String!" },
    batchId: { __type: "String!" },
  },
  BatchReportDimensionValue: {
    __typename: { __type: "String!" },
    branch: { __type: "BranchReportDimensionValue" },
    job: { __type: "JobReportDimensionValue" },
    key: { __type: "String" },
    label: { __type: "String" },
  },
  BatchReportGroupByInput: {
    branch: { __type: "BranchReportRelationDimensionInput" },
    job: { __type: "JobReportRelationDimensionInput" },
  },
  BatchReportRelationDimensionInput: {
    filter: { __type: "BatchFilterInput" },
    groupBy: { __type: "BatchReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  BatchSchedule: {
    __typename: { __type: "String!" },
    batch: { __type: "Batch" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    dueDate: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    processInstances: {
      __type: "[ProcessInstance!]!",
      __args: { filter: "ProcessInstanceFilterInput" },
    },
    processType: { __type: "ProcessType" },
    scheduled: { __type: "String" },
  },
  BatchScheduleAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    sheetCount: { __type: "Int!" },
    totalConfirmedSale: { __type: "Float" },
  },
  BatchScheduleFilterInput: {
    and: { __type: "[BatchScheduleFilterInput!]" },
    batch: { __type: "BatchFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    dueDate: { __type: "DateTimeFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[BatchScheduleFilterInput!]" },
    processType: { __type: "ProcessTypeFilterInput" },
    scheduled: { __type: "DateTimeFilterInput" },
  },
  BatchScheduleReportDimensions: {
    __typename: { __type: "String!" },
    batch: { __type: "BatchReportDimensionValue" },
    dueDate: { __type: "ReportDimensionValue" },
    processType: { __type: "ProcessTypeReportDimensionValue" },
    scheduled: { __type: "ReportDimensionValue" },
  },
  BatchScheduleReportGroupByInput: {
    batch: { __type: "BatchReportRelationDimensionInput" },
    dueDate: { __type: "DateTimeReportDimensionInput" },
    processType: { __type: "ProcessTypeReportRelationDimensionInput" },
    scheduled: { __type: "DateTimeReportDimensionInput" },
  },
  BatchScheduleReportRow: {
    __typename: { __type: "String!" },
    aggregate: {
      __type: "BatchScheduleAggregate!",
      __args: { filter: "BatchScheduleFilterInput" },
    },
    dimensions: { __type: "BatchScheduleReportDimensions!" },
    key: { __type: "String!" },
    label: { __type: "String!" },
  },
  BatchStatusCheckEvent: {
    __typename: { __type: "String!" },
    batchId: { __type: "String!" },
  },
  BatchUpdatedEvent: {
    __typename: { __type: "String!" },
    batchId: { __type: "String!" },
    batchName: { __type: "String!" },
  },
  BillOfMaterialsImport: {
    __typename: { __type: "String!" },
    externalStorageConnection: { __type: "ExternalStorageConnection!" },
    matchedItems: { __type: "[BillOfMaterialsLine!]!" },
    rawItems: { __type: "String!" },
  },
  BillOfMaterialsLine: {
    __typename: { __type: "String!" },
    description: { __type: "String!" },
    group: { __type: "String" },
    price: { __type: "String" },
    product: { __type: "Product" },
    quantity: { __type: "String!" },
    room: { __type: "String" },
  },
  BooleanFilterInput: { eq: { __type: "Boolean" } },
  Branch: {
    __typename: { __type: "String!" },
    code: { __type: "String!" },
    colour: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    darkColour: { __type: "String!" },
    deleted: { __type: "Boolean!" },
    id: { __type: "ID!" },
    jobAggregate: {
      __type: "JobAggregate",
      __args: { filter: "JobFilterInput" },
    },
    label: { __type: "String!" },
    name: { __type: "String!" },
    personAggregate: {
      __type: "PersonAggregate",
      __args: { filter: "PersonFilterInput" },
    },
    users: { __type: "[User!]!", __args: { filter: "UserFilterInput" } },
  },
  BranchAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  BranchCreatedEvent: {
    __typename: { __type: "String!" },
    branchId: { __type: "Int!" },
    branchName: { __type: "String!" },
  },
  BranchDeletedEvent: {
    __typename: { __type: "String!" },
    branchId: { __type: "Int!" },
    branchName: { __type: "String!" },
  },
  BranchFilterInput: {
    and: { __type: "[BranchFilterInput!]" },
    code: { __type: "StringFilterInput" },
    colour: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    darkColour: { __type: "StringFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[BranchFilterInput!]" },
    users: { __type: "UserFilterInput" },
  },
  BranchReportDimensionValue: {
    __typename: { __type: "String!" },
    key: { __type: "String" },
    label: { __type: "String" },
  },
  BranchReportRelationDimensionInput: {
    filter: { __type: "BranchFilterInput" },
    includeEmpty: { __type: "Boolean" },
  },
  BranchRestoredEvent: {
    __typename: { __type: "String!" },
    branchId: { __type: "Int!" },
    branchName: { __type: "String!" },
  },
  BranchUpdatedEvent: {
    __typename: { __type: "String!" },
    branchId: { __type: "Int!" },
    branchName: { __type: "String!" },
  },
  BuildType: {
    __typename: { __type: "String!" },
    code: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  BuildTypeAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  BuildTypeFilterInput: {
    and: { __type: "[BuildTypeFilterInput!]" },
    code: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[BuildTypeFilterInput!]" },
  },
  BuildTypeReportDimensionValue: {
    __typename: { __type: "String!" },
    key: { __type: "String" },
    label: { __type: "String" },
  },
  BuildTypeReportRelationDimensionInput: {
    filter: { __type: "BuildTypeFilterInput" },
    includeEmpty: { __type: "Boolean" },
  },
  Builder: {
    __typename: { __type: "String!" },
    address: { __type: "String!" },
    code: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deleted: { __type: "Boolean!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  BuilderAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  BuilderFilterInput: {
    address: { __type: "StringFilterInput" },
    and: { __type: "[BuilderFilterInput!]" },
    code: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[BuilderFilterInput!]" },
  },
  BuilderReportDimensionValue: {
    __typename: { __type: "String!" },
    key: { __type: "String" },
    label: { __type: "String" },
  },
  BuilderReportRelationDimensionInput: {
    filter: { __type: "BuilderFilterInput" },
    includeEmpty: { __type: "Boolean" },
  },
  BusinessRole: {
    __typename: { __type: "String!" },
    activePersonBusinessRoleCount: { __type: "Int!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    personBusinessRoleAggregate: {
      __type: "PersonBusinessRoleAggregate",
      __args: { filter: "PersonBusinessRoleFilterInput" },
    },
    personBusinessRoles: {
      __type: "[PersonBusinessRole!]!",
      __args: { filter: "PersonBusinessRoleFilterInput" },
    },
  },
  BusinessRoleAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  BusinessRoleFilterInput: {
    and: { __type: "[BusinessRoleFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[BusinessRoleFilterInput!]" },
    personBusinessRoles: { __type: "PersonBusinessRoleFilterInput" },
  },
  BusinessRoleReportDimensionValue: {
    __typename: { __type: "String!" },
    key: { __type: "String" },
    label: { __type: "String" },
  },
  BusinessRoleReportRelationDimensionInput: {
    filter: { __type: "BusinessRoleFilterInput" },
    includeEmpty: { __type: "Boolean" },
  },
  CalculateQuoteInput: {
    expressions: { __type: "[ExpressionInput!]!" },
    lineTemplates: { __type: "[QuoteLineTemplateInput!]!" },
    lines: { __type: "[QuoteLineInput!]!" },
  },
  CancelPurchaseOrdersInput: { purchaseOrderIds: { __type: "[ID!]!" } },
  CancelSalesOrderInput: { salesOrderId: { __type: "ID!" } },
  CancelSupplierQuoteRequestInput: {
    supplierQuoteRequestId: { __type: "ID!" },
  },
  Candidate: {
    __typename: { __type: "String!" },
    candidateTypeName: { __type: "String!" },
    conversionErrors: { __type: "String!" },
    created: { __type: "DateTime" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    generatedData: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    shortSummary: { __type: "String!" },
    source: { __type: "String" },
    status: { __type: "String" },
    targetRecordId: { __type: "ID" },
    targetRecordType: { __type: "String" },
    type: { __type: "String!" },
  },
  CandidateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  CandidateCreatedEvent: {
    __typename: { __type: "String!" },
    candidateId: { __type: "Int!" },
    shortSummary: { __type: "String!" },
    type: { __type: "String!" },
  },
  CandidateFilterInput: {
    and: { __type: "[CandidateFilterInput!]" },
    conversionErrors: { __type: "StringFilterInput" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    generatedData: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[CandidateFilterInput!]" },
    shortSummary: { __type: "StringFilterInput" },
    source: { __type: "StringFilterInput" },
    status: { __type: "StringFilterInput" },
    targetRecordId: { __type: "IDFilterInput" },
    targetRecordType: { __type: "StringFilterInput" },
    type: { __type: "StringFilterInput" },
  },
  CandidateIngestionPolicy: {
    __typename: { __type: "String!" },
    candidateType: { __type: "String!" },
    created: { __type: "DateTime" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    emailAddresses: { __type: "[String!]!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    mode: { __type: "String!" },
    modified: { __type: "DateTime" },
    senderRecordId: { __type: "ID!" },
    senderRecordType: { __type: "String!" },
  },
  CandidateIngestionPolicyAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  CandidateIngestionPolicyFilterInput: {
    and: { __type: "[CandidateIngestionPolicyFilterInput!]" },
    candidateType: { __type: "StringFilterInput" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    mode: { __type: "StringFilterInput" },
    modified: { __type: "DateTimeFilterInput" },
    or: { __type: "[CandidateIngestionPolicyFilterInput!]" },
    senderRecordId: { __type: "IDFilterInput" },
    senderRecordType: { __type: "StringFilterInput" },
  },
  Client: {
    __typename: { __type: "String!" },
    address: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deleted: { __type: "Boolean!" },
    email: { __type: "String" },
    faxHome: { __type: "String" },
    faxWork: { __type: "String" },
    firstName: { __type: "String" },
    fullName: { __type: "String!" },
    id: { __type: "ID!" },
    jobs: { __type: "[Job!]", __args: { filter: "JobFilterInput" } },
    label: { __type: "String!" },
    lastName: { __type: "String" },
    notes: { __type: "String" },
    phoneCell: { __type: "String" },
    phoneHome: { __type: "String" },
    phoneWork: { __type: "String" },
  },
  ClientAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ClientFilterInput: {
    address: { __type: "StringFilterInput" },
    and: { __type: "[ClientFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    email: { __type: "StringFilterInput" },
    faxHome: { __type: "StringFilterInput" },
    faxWork: { __type: "StringFilterInput" },
    firstName: { __type: "StringFilterInput" },
    fullName: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    jobs: { __type: "JobFilterInput" },
    label: { __type: "StringFilterInput" },
    lastName: { __type: "StringFilterInput" },
    notes: { __type: "StringFilterInput" },
    or: { __type: "[ClientFilterInput!]" },
    phoneCell: { __type: "StringFilterInput" },
    phoneHome: { __type: "StringFilterInput" },
    phoneWork: { __type: "StringFilterInput" },
  },
  ClientReportDimensionValue: {
    __typename: { __type: "String!" },
    key: { __type: "String" },
    label: { __type: "String" },
  },
  ClientReportRelationDimensionInput: {
    filter: { __type: "ClientFilterInput" },
    includeEmpty: { __type: "Boolean" },
  },
  CommitPendingFilesInput: {
    defaultFolderId: { __type: "ID" },
    files: { __type: "[FileInput!]!" },
    folderId: { __type: "ID" },
    recordId: { __type: "String!" },
    recordType: { __type: "String!" },
    uploadToken: { __type: "String" },
  },
  ComponentAction: {
    __typename: { __type: "String!" },
    action: { __type: "String!" },
    colour: { __type: "String!" },
    icon: { __type: "String!" },
    id: { __type: "ID!" },
    index: { __type: "Int!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  ComponentGridColumn: {
    __typename: { __type: "String!" },
    field: { __type: "String!" },
    id: { __type: "ID!" },
    index: { __type: "Int!" },
    name: { __type: "String!" },
    sort: { __type: "String!" },
  },
  ConfiguredLinkedAction: {
    __typename: { __type: "String!" },
    actionId: { __type: "String!" },
    bindings: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    displayOrder: { __type: "Int!" },
    enabled: { __type: "Boolean!" },
    id: { __type: "ID!" },
    isGlobal: { __type: "Boolean!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    recordPath: { __type: "String!" },
    recordType: { __type: "String!" },
    roleIds: { __type: "[ID!]!" },
    seedRoleIds: { __type: "[ID!]!" },
    seedUserIds: { __type: "[ID!]!" },
    source: { __type: "String!" },
    userIds: { __type: "[ID!]!" },
  },
  ConfiguredLinkedActionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ConfiguredLinkedActionFilterInput: {
    actionId: { __type: "StringFilterInput" },
    and: { __type: "[ConfiguredLinkedActionFilterInput!]" },
    bindings: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    displayOrder: { __type: "NumberFilterInput" },
    enabled: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    isGlobal: { __type: "BooleanFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[ConfiguredLinkedActionFilterInput!]" },
    recordPath: { __type: "StringFilterInput" },
    recordType: { __type: "StringFilterInput" },
  },
  ConfirmSalesOrderInput: { salesOrderId: { __type: "ID!" } },
  ConvertLeadToJobInput: {
    jobId: { __type: "ID!" },
    leadId: { __type: "ID!" },
  },
  Correspondence: {
    __typename: { __type: "String!" },
    created: { __type: "DateTime" },
    createdBy: { __type: "User" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    date: { __type: "DateTime" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    recordId: { __type: "ID" },
    recordType: { __type: "String" },
    text: { __type: "String!" },
    type: { __type: "String" },
  },
  CorrespondenceAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  CorrespondenceFilterInput: {
    and: { __type: "[CorrespondenceFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    createdBy: { __type: "UserFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    date: { __type: "DateTimeFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "DateTimeFilterInput" },
    or: { __type: "[CorrespondenceFilterInput!]" },
    recordId: { __type: "IDFilterInput" },
    recordType: { __type: "StringFilterInput" },
    text: { __type: "StringFilterInput" },
    type: { __type: "StringFilterInput" },
  },
  Costing: {
    __typename: { __type: "String!" },
    costTotal: { __type: "String!" },
    costingTemplateRevision: { __type: "CostingTemplateRevision" },
    created: { __type: "String!" },
    currentRevision: { __type: "CostingRevision" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    job: { __type: "Job" },
    jobComponent: { __type: "JobComponent" },
    label: { __type: "String!" },
    lines: {
      __type: "[CostingLine!]!",
      __args: { filter: "CostingLineFilterInput" },
    },
    marginPercent: { __type: "String!" },
    markupTotal: { __type: "String!" },
    modified: { __type: "String!" },
    name: { __type: "String!" },
    revisions: {
      __type: "[CostingRevision!]!",
      __args: { filter: "CostingRevisionFilterInput" },
    },
    sellTotal: { __type: "String!" },
    status: { __type: "String!" },
  },
  CostingAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  CostingFilterInput: {
    and: { __type: "[CostingFilterInput!]" },
    costTotal: { __type: "StringFilterInput" },
    costingTemplateRevision: { __type: "CostingTemplateRevisionFilterInput" },
    created: { __type: "StringFilterInput" },
    currentRevision: { __type: "CostingRevisionFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    job: { __type: "JobFilterInput" },
    jobComponent: { __type: "JobComponentFilterInput" },
    label: { __type: "StringFilterInput" },
    lines: { __type: "CostingLineFilterInput" },
    marginPercent: { __type: "StringFilterInput" },
    markupTotal: { __type: "StringFilterInput" },
    modified: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[CostingFilterInput!]" },
    revisions: { __type: "CostingRevisionFilterInput" },
    sellTotal: { __type: "StringFilterInput" },
    status: { __type: "StringFilterInput" },
  },
  CostingLine: {
    __typename: { __type: "String!" },
    code: { __type: "String" },
    costing: { __type: "Costing" },
    costingRevision: { __type: "CostingRevision" },
    costingTemplateRevision: { __type: "CostingTemplateRevision" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    line: { __type: "Int!" },
    lineTemplateId: { __type: "String" },
    lines: {
      __type: "[CostingLine!]!",
      __args: { filter: "CostingLineFilterInput" },
    },
    markupAmount: { __type: "String" },
    markupExpression: { __type: "String!" },
    parentLine: { __type: "CostingLine" },
    product: { __type: "Product" },
    productId: { __type: "String" },
    quantity: { __type: "String!" },
    supplierQuote: { __type: "SupplierQuote" },
    supplierQuoteId: { __type: "ID" },
    total: { __type: "String!" },
    type: { __type: "String!" },
    unitCostPrice: { __type: "String!" },
    unitSellPrice: { __type: "String!" },
  },
  CostingLineAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    quantity: { __type: "Float!" },
  },
  CostingLineFilterInput: {
    and: { __type: "[CostingLineFilterInput!]" },
    code: { __type: "StringFilterInput" },
    costing: { __type: "CostingFilterInput" },
    costingRevision: { __type: "CostingRevisionFilterInput" },
    costingTemplateRevision: { __type: "CostingTemplateRevisionFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    line: { __type: "NumberFilterInput" },
    lineTemplateId: { __type: "StringFilterInput" },
    lines: { __type: "CostingLineFilterInput" },
    markupAmount: { __type: "StringFilterInput" },
    markupExpression: { __type: "StringFilterInput" },
    or: { __type: "[CostingLineFilterInput!]" },
    parentLine: { __type: "CostingLineFilterInput" },
    product: { __type: "ProductFilterInput" },
    productId: { __type: "StringFilterInput" },
    quantity: { __type: "StringFilterInput" },
    supplierQuote: { __type: "SupplierQuoteFilterInput" },
    supplierQuoteId: { __type: "IDFilterInput" },
    total: { __type: "StringFilterInput" },
    unitCostPrice: { __type: "StringFilterInput" },
    unitSellPrice: { __type: "StringFilterInput" },
  },
  CostingLineInput: {
    costPrice: { __type: "String" },
    costing: { __type: "String" },
    description: { __type: "String" },
    lineTemplateId: { __type: "String" },
    lines: { __type: "[CostingLineInput!]" },
    markupExpression: { __type: "String" },
    product: { __type: "String" },
    quantity: { __type: "String" },
    supplierQuoteId: { __type: "String" },
    type: { __type: "CostingLineType!" },
  },
  CostingLineTemplate: {
    __typename: { __type: "String!" },
    category: { __type: "String!" },
    costingTemplateRevision: { __type: "CostingTemplateRevision" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String!" },
    descriptionEditable: { __type: "Boolean!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    markupEditable: { __type: "Boolean!" },
    markupExpression: { __type: "String!" },
    quantity: { __type: "String!" },
    quantityEditable: { __type: "Boolean!" },
    unitCostPrice: { __type: "String!" },
    unitCostPriceEditable: { __type: "Boolean!" },
  },
  CostingLineTemplateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  CostingLineTemplateFilterInput: {
    and: { __type: "[CostingLineTemplateFilterInput!]" },
    category: { __type: "StringFilterInput" },
    costingTemplateRevision: { __type: "CostingTemplateRevisionFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    descriptionEditable: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    markupEditable: { __type: "BooleanFilterInput" },
    markupExpression: { __type: "StringFilterInput" },
    or: { __type: "[CostingLineTemplateFilterInput!]" },
    quantity: { __type: "StringFilterInput" },
    quantityEditable: { __type: "BooleanFilterInput" },
    unitCostPrice: { __type: "StringFilterInput" },
    unitCostPriceEditable: { __type: "BooleanFilterInput" },
  },
  CostingLineTemplateInput: {
    category: { __type: "String!" },
    costPriceEditable: { __type: "Boolean!" },
    description: { __type: "String!" },
    descriptionEditable: { __type: "Boolean!" },
    id: { __type: "String!" },
    markupEditable: { __type: "Boolean!" },
    markupExpression: { __type: "String!" },
    quantity: { __type: "String!" },
    quantityEditable: { __type: "Boolean!" },
    type: { __type: "CostingLineType!" },
    unitCostPrice: { __type: "String!" },
    unitCostPriceEditable: { __type: "Boolean!" },
  },
  CostingRevision: {
    __typename: { __type: "String!" },
    costTotal: { __type: "String!" },
    costing: { __type: "Costing!" },
    costingTemplateRevision: { __type: "CostingTemplateRevision" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    lines: {
      __type: "[CostingLine!]!",
      __args: { filter: "CostingLineFilterInput" },
    },
    marginPercent: { __type: "String!" },
    markupTotal: { __type: "String!" },
    modified: { __type: "String!" },
    sellTotal: { __type: "String!" },
    status: { __type: "String!" },
    version: { __type: "Int!" },
  },
  CostingRevisionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  CostingRevisionFilterInput: {
    and: { __type: "[CostingRevisionFilterInput!]" },
    costTotal: { __type: "StringFilterInput" },
    costing: { __type: "CostingFilterInput" },
    costingTemplateRevision: { __type: "CostingTemplateRevisionFilterInput" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    lines: { __type: "CostingLineFilterInput" },
    marginPercent: { __type: "StringFilterInput" },
    markupTotal: { __type: "StringFilterInput" },
    modified: { __type: "StringFilterInput" },
    or: { __type: "[CostingRevisionFilterInput!]" },
    sellTotal: { __type: "StringFilterInput" },
    status: { __type: "StringFilterInput" },
    version: { __type: "NumberFilterInput" },
  },
  CostingTemplate: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    currentRevision: { __type: "CostingTemplateRevision" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    draftRevision: { __type: "CostingTemplateRevision" },
    id: { __type: "ID!" },
    isDefault: { __type: "Boolean!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    version: { __type: "Int!" },
  },
  CostingTemplateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  CostingTemplateExpression: {
    __typename: { __type: "String!" },
    costingTemplateRevision: { __type: "CostingTemplateRevision" },
    costingTemplateRevisionId: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    value: { __type: "String!" },
  },
  CostingTemplateExpressionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  CostingTemplateExpressionFilterInput: {
    and: { __type: "[CostingTemplateExpressionFilterInput!]" },
    costingTemplateRevision: { __type: "CostingTemplateRevisionFilterInput" },
    costingTemplateRevisionId: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[CostingTemplateExpressionFilterInput!]" },
    value: { __type: "StringFilterInput" },
  },
  CostingTemplateFilterInput: {
    and: { __type: "[CostingTemplateFilterInput!]" },
    created: { __type: "StringFilterInput" },
    currentRevision: { __type: "CostingTemplateRevisionFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isDefault: { __type: "BooleanFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[CostingTemplateFilterInput!]" },
    version: { __type: "NumberFilterInput" },
  },
  CostingTemplateRevision: {
    __typename: { __type: "String!" },
    costingTemplate: { __type: "CostingTemplate!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    defaultLines: { __type: "[CostingLine!]!" },
    expressions: {
      __type: "[CostingTemplateExpression!]!",
      __args: { filter: "CostingTemplateExpressionFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    lineTemplates: {
      __type: "[CostingLineTemplate!]!",
      __args: { filter: "CostingLineTemplateFilterInput" },
    },
    status: { __type: "CostingTemplateRevisionStatus!" },
    version: { __type: "Int!" },
  },
  CostingTemplateRevisionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  CostingTemplateRevisionFilterInput: {
    and: { __type: "[CostingTemplateRevisionFilterInput!]" },
    costingTemplate: { __type: "CostingTemplateFilterInput" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    expressions: { __type: "CostingTemplateExpressionFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    lineTemplates: { __type: "CostingLineTemplateFilterInput" },
    or: { __type: "[CostingTemplateRevisionFilterInput!]" },
    status: { __type: "NumberFilterInput" },
    version: { __type: "NumberFilterInput" },
  },
  CreateBatchInput: { jobId: { __type: "ID!" } },
  CreateBranchInput: {
    code: { __type: "String!" },
    colour: { __type: "String!" },
    darkColour: { __type: "String!" },
    name: { __type: "String!" },
  },
  CreateBuilderInput: {
    address: { __type: "String" },
    code: { __type: "String" },
    name: { __type: "String!" },
  },
  CreateBusinessRoleInput: {
    description: { __type: "String" },
    name: { __type: "String!" },
  },
  CreateCandidateInput: {
    files: { __type: "[ID!]!" },
    source: { __type: "String!" },
    type: { __type: "String!" },
  },
  CreateClientInput: {
    address: { __type: "String" },
    email: { __type: "String" },
    faxHome: { __type: "String" },
    faxWork: { __type: "String" },
    firstName: { __type: "String" },
    lastName: { __type: "String!" },
    notes: { __type: "String" },
    phoneCell: { __type: "String" },
    phoneHome: { __type: "String" },
    phoneWork: { __type: "String" },
    title: { __type: "String" },
  },
  CreateCorrespondenceInput: {
    date: { __type: "DateTime" },
    details: { __type: "String!" },
    recordId: { __type: "String!" },
    recordType: { __type: "String!" },
    type: { __type: "Int!" },
  },
  CreateCostingInput: {
    costingTemplateRevisionId: { __type: "ID" },
    jobComponentId: { __type: "ID" },
    jobId: { __type: "ID" },
    lines: { __type: "[CostingLineInput!]!" },
    name: { __type: "String!" },
  },
  CreateCostingTemplateInput: {
    isDefault: { __type: "Boolean!" },
    name: { __type: "String!" },
  },
  CreateCostingTemplateRevisionInput: {
    costingTemplateId: { __type: "String!" },
    costingTemplateRevisionId: { __type: "String" },
    defaultLines: { __type: "[CostingLineInput!]!" },
    expressions: { __type: "[ExpressionInput!]!" },
    lineTemplates: { __type: "[CostingLineTemplateInput!]!" },
    publish: { __type: "Boolean!" },
  },
  CreateDocumentTemplateInput: {
    description: { __type: "String" },
    name: { __type: "String!" },
    recordType: { __type: "String!" },
  },
  CreateFileInput: {
    hash: { __type: "String!" },
    metadata: { __type: "String" },
    mimeType: { __type: "String" },
    name: { __type: "String!" },
    persistenceType: { __type: "Int" },
    resourceId: { __type: "String!" },
    resourceType: { __type: "String!" },
    size: { __type: "Int!" },
    tags: { __type: "[String!]" },
    url: { __type: "String" },
    userId: { __type: "Int" },
  },
  CreateFolderInput: {
    name: { __type: "String!" },
    parentFolderId: { __type: "ID" },
    recordId: { __type: "ID!" },
    recordType: { __type: "String!" },
  },
  CreateHousingCompanyImageInput: {
    hash: { __type: "String!" },
    housingCompanyId: { __type: "ID!" },
    mimeType: { __type: "String" },
    name: { __type: "String" },
    size: { __type: "Int!" },
    url: { __type: "String" },
  },
  CreateHousingCompanyInput: {
    code: { __type: "String" },
    name: { __type: "String!" },
  },
  CreateIssueInput: {
    completed: { __type: "Boolean!" },
    description: { __type: "String" },
    files: { __type: "[String!]" },
    recordId: { __type: "String" },
    recordType: { __type: "String" },
    requiredDate: { __type: "DateTime" },
  },
  CreateJobComponentInput: {
    description: { __type: "String" },
    jobId: { __type: "ID!" },
    name: { __type: "String!" },
    partTypeId: { __type: "ID" },
  },
  CreateJobEmailInput: {
    body: { __type: "String!" },
    jobId: { __type: "ID!" },
    subject: { __type: "String!" },
    to: { __type: "String!" },
  },
  CreateJobInput: {
    address: { __type: "String" },
    benchtopOnly: { __type: "Boolean!" },
    branch: { __type: "ID!" },
    buildType: { __type: "ID!" },
    builder: { __type: "ID" },
    builderPhone: { __type: "String" },
    client: { __type: "ID!" },
    designer: { __type: "ID" },
    difficultAccess: { __type: "Boolean!" },
    estimatedDueDate: { __type: "DateTime!" },
    hcJobNumber: { __type: "String" },
    hcPmPhone: { __type: "String" },
    hcProjectManager: { __type: "String" },
    housingCompany: { __type: "ID" },
    jobName: { __type: "String" },
    jobQuantity: { __type: "Int!" },
    leadId: { __type: "ID" },
    notes: { __type: "String" },
    project: { __type: "String" },
    projectManager: { __type: "ID" },
    region: { __type: "ID" },
    saleType: { __type: "ID!" },
    showHome: { __type: "Boolean!" },
    siteNotes: { __type: "String" },
    sssp: { __type: "Boolean!" },
    tristoneJoin: { __type: "Boolean!" },
    tristoneSpecified: { __type: "Boolean!" },
    unit: { __type: "Boolean!" },
  },
  CreateLeadInput: {
    address: { __type: "String" },
    assignedTo: { __type: "String" },
    branchId: { __type: "String" },
    builderName: { __type: "String" },
    builderType: { __type: "String" },
    city: { __type: "String" },
    client: { __type: "String!" },
    email: { __type: "String" },
    joineryTypes: { __type: "String" },
    notes: { __type: "String" },
    phone: { __type: "String" },
    priceRangeBottom: { __type: "Float" },
    priceRangeTop: { __type: "Float" },
    priority: { __type: "Int" },
    projectType: { __type: "String!" },
    requiredBy: { __type: "String" },
    source: { __type: "String!" },
    suburb: { __type: "String" },
  },
  CreateLineItemInput: {
    batchId: { __type: "ID" },
    jobId: { __type: "ID!" },
    name: { __type: "String!" },
    partTypeId: { __type: "ID!" },
  },
  CreateLostReasonInput: {
    description: { __type: "String" },
    name: { __type: "String!" },
  },
  CreatePanelInput: {
    config: { __type: "String!" },
    name: { __type: "String!" },
    type: { __type: "String!" },
  },
  CreatePartTypeInput: {
    code: { __type: "String!" },
    colour: { __type: "String!" },
    name: { __type: "String!" },
  },
  CreatePersonInput: {
    branchId: { __type: "ID" },
    businessRoleIds: { __type: "[ID!]!" },
    isActive: { __type: "Boolean!" },
    name: { __type: "String!" },
    userId: { __type: "ID" },
  },
  CreateProcessTimerInput: { processInstanceIds: { __type: "[String!]!" } },
  CreateProcessTypeInput: {
    code: { __type: "String!" },
    description: { __type: "String" },
    name: { __type: "String!" },
  },
  CreateProcessTypeNoteInput: {
    assignedProcessIds: { __type: "[ID!]!" },
    date: { __type: "String" },
    note: { __type: "String!" },
  },
  CreateProcessTypeRoleInput: {
    processTypeId: { __type: "ID!" },
    roleType: { __type: "String!" },
  },
  CreateProductCategoryInput: {
    group: { __type: "ID!" },
    id: { __type: "ID" },
    name: { __type: "String!" },
    parentId: { __type: "ID" },
  },
  CreateProductInput: {
    category: { __type: "ID" },
    code: { __type: "String!" },
    deleted: { __type: "Boolean!" },
    indent: { __type: "Boolean!" },
    leadTime: { __type: "Int" },
    name: { __type: "String!" },
    qtyReviewThreshold: { __type: "Int!" },
    safetyStockDays: { __type: "Int!" },
    starred: { __type: "Boolean!" },
    stockItem: { __type: "Boolean!" },
    supplier: { __type: "ID!" },
    tags: { __type: "[ID!]!" },
    template: { __type: "Boolean!" },
    unitOfMeasure: { __type: "String!" },
    url: { __type: "String!" },
  },
  CreateProductPriceInput: {
    effectiveDate: { __type: "String!" },
    productId: { __type: "ID!" },
    type: { __type: "String!" },
    unitPrice: { __type: "String!" },
  },
  CreateProjectInput: {
    description: { __type: "String" },
    name: { __type: "String!" },
  },
  CreatePurchaseOrderFromSupplierQuoteInput: {
    supplierQuoteId: { __type: "ID!" },
  },
  CreatePurchaseOrderInput: {
    category: { __type: "OrderCategory" },
    deliveryAddress: { __type: "String" },
    deliveryAddressId: { __type: "ID" },
    internalComment: { __type: "String" },
    jobId: { __type: "ID" },
    lines: { __type: "[PurchaseOrderLineInput!]" },
    notifySupplierWhenPlaced: { __type: "Boolean!" },
    reference: { __type: "String" },
    required: { __type: "String" },
    shippingMethod: { __type: "OrderShippingMethods" },
    shippingTerms: { __type: "OrderShippingTerms" },
    siteVisitRequired: { __type: "Boolean!" },
    statusWhenPlaced: { __type: "OrderStatus" },
    supplierComment: { __type: "String" },
    supplierId: { __type: "ID" },
    templateId: { __type: "ID" },
    urgent: { __type: "Boolean!" },
    warehouseId: { __type: "ID" },
  },
  CreatePurchaseOrderReceiptInput: {
    notes: { __type: "String" },
    orderLines: { __type: "[PurchaseOrderReceiptLineInput!]!" },
    purchaseOrderId: { __type: "ID!" },
    reference: { __type: "String" },
    warehouseId: { __type: "ID!" },
  },
  CreateQuoteApprovalRequestInput: { quoteId: { __type: "ID!" } },
  CreateQuoteInput: {
    clientAddress: { __type: "String" },
    clientName: { __type: "String!" },
    contactName: { __type: "String" },
    customer: { __type: "ID" },
    files: { __type: "[ID!]" },
    jobId: { __type: "ID" },
    lineItemId: { __type: "ID" },
    lines: { __type: "[QuoteLineInput!]!" },
    quoteRequestId: { __type: "ID" },
    quoteTemplateRevisionId: { __type: "ID" },
    reference: { __type: "String!" },
  },
  CreateQuoteTemplateInput: {
    isDefault: { __type: "Boolean!" },
    name: { __type: "String!" },
  },
  CreateQuoteTemplateRevisionInput: {
    defaultLines: { __type: "[QuoteLineInput!]!" },
    expressions: { __type: "[ExpressionInput!]!" },
    lineTemplates: { __type: "[QuoteLineTemplateInput!]!" },
    publish: { __type: "Boolean!" },
    quoteTemplateId: { __type: "String!" },
    quoteTemplateRevisionId: { __type: "String" },
  },
  CreateRecordFileInput: {
    entity: { __type: "String!" },
    fileId: { __type: "String!" },
    metadata: { __type: "String" },
    recordId: { __type: "Int!" },
  },
  CreateRoleInput: {
    description: { __type: "String!" },
    inheritFrom: { __type: "[String!]!" },
    name: { __type: "String!" },
  },
  CreateSalesOrderInput: {
    clientAddress: { __type: "String" },
    clientId: { __type: "ID" },
    clientName: { __type: "String!" },
    contactName: { __type: "String" },
    currency: { __type: "String!" },
    jobId: { __type: "ID" },
    lines: { __type: "[SalesOrderLineInput!]!" },
    reference: { __type: "String" },
  },
  CreateSchemaInput: {
    description: { __type: "String!" },
    name: { __type: "String!" },
    recordType: { __type: "String!" },
  },
  CreateScreenInput: {
    description: { __type: "String" },
    group: { __type: "ScreenGroup" },
    icon: { __type: "String" },
    name: { __type: "String!" },
    recordId: { __type: "String" },
    recordType: { __type: "String" },
    screenCfg: { __type: "String!" },
  },
  CreateSignedUploadUrlInput: {
    filename: { __type: "String!" },
    mimeType: { __type: "String!" },
  },
  CreateStorageConnectionInput: {
    description: { __type: "String" },
    deviceAccessEnabled: { __type: "Boolean" },
    dropboxAuthToken: { __type: "String" },
    dropboxNamespaceId: { __type: "String" },
    enabled: { __type: "Boolean" },
    localRoot: { __type: "String" },
    name: { __type: "String!" },
    root: { __type: "String!" },
    type: { __type: "String!" },
  },
  CreateStorageResourceMappingInput: {
    description: { __type: "String" },
    enabled: { __type: "Boolean" },
    externalStorageConnectionId: { __type: "ID!" },
    path: { __type: "String" },
    resourceFilter: { __type: "String" },
    resourceType: { __type: "String!" },
  },
  CreateSubscriptionInput: {
    enabled: { __type: "Boolean!" },
    event: { __type: "String!" },
    maxRecipients: { __type: "Int" },
    notifications: { __type: "[NotificationInput!]!" },
    sourceFilter: { __type: "String" },
    targetFilter: { __type: "String" },
  },
  CreateSupplierImageInput: {
    hash: { __type: "String!" },
    mimeType: { __type: "String" },
    name: { __type: "String" },
    size: { __type: "Int!" },
    supplierId: { __type: "ID!" },
    url: { __type: "String" },
  },
  CreateSupplierInput: {
    address: { __type: "String!" },
    categoryId: { __type: "ID" },
    cell: { __type: "String!" },
    currency: { __type: "String!" },
    email: { __type: "String!" },
    name: { __type: "String!" },
    orderEmails: { __type: "[String!]" },
    quoteEmails: { __type: "[String!]" },
    url: { __type: "String!" },
  },
  CreateSupplierQuoteInput: {
    files: { __type: "[ID!]!" },
    jobId: { __type: "ID" },
    lines: { __type: "[SupplierQuoteLineInput!]!" },
    quoteRequestId: { __type: "ID" },
    reference: { __type: "String" },
    salesTax: { __type: "String!" },
    saveAsDraft: { __type: "Boolean!" },
    supplierId: { __type: "ID" },
    supplierQuoteNumber: { __type: "String" },
  },
  CreateSupplierQuoteRequestInput: {
    files: { __type: "[ID!]!" },
    jobId: { __type: "ID" },
    lines: { __type: "[SupplierQuoteRequestLineInput!]!" },
    noteForSupplier: { __type: "String!" },
    place: { __type: "Boolean" },
    reference: { __type: "String!" },
    supplierIds: { __type: "[ID!]!" },
  },
  CreateTagInput: {
    colour: { __type: "String!" },
    context: { __type: "String!" },
    description: { __type: "String!" },
    name: { __type: "String!" },
  },
  CreateUserIdentityInput: {
    entity: { __type: "String!" },
    recordId: { __type: "ID!" },
    userId: { __type: "ID!" },
  },
  CreateUserInput: {
    authProvider: { __type: "AuthProviderType!" },
    branchId: { __type: "String" },
    fullName: { __type: "String!" },
    password: { __type: "String" },
    personId: { __type: "ID" },
    roles: { __type: "[String!]" },
    username: { __type: "String!" },
  },
  CreateWarehouseInput: {
    address: { __type: "String!" },
    code: { __type: "String" },
    color: { __type: "String" },
    description: { __type: "String" },
    name: { __type: "String!" },
  },
  CreateWebhookInput: {
    authType: { __type: "String!" },
    description: { __type: "String!" },
    enabled: { __type: "Boolean!" },
    event: { __type: "String!" },
    name: { __type: "String!" },
    sourceFilter: { __type: "String" },
    url: { __type: "String!" },
  },
  CreateWorkflowTypeInput: {
    description: { __type: "String" },
    master: { __type: "Boolean!" },
    name: { __type: "String!" },
  },
  CustomData: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    data: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    modified: { __type: "String!" },
    recordId: { __type: "String" },
    schema: { __type: "Schema!" },
    schemaId: { __type: "String!" },
    schemaVersion: { __type: "SchemaVersion" },
  },
  CustomDataAggregate: {
    __typename: { __type: "String!" },
    average: { __type: "Float", __args: { path: "String!" } },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    max: { __type: "Float", __args: { path: "String!" } },
    min: { __type: "Float", __args: { path: "String!" } },
    sum: { __type: "Float!", __args: { path: "String!" } },
  },
  CustomDataFilterInput: {
    and: { __type: "[CustomDataFilterInput!]" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    data: { __type: "JsonFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "StringFilterInput" },
    or: { __type: "[CustomDataFilterInput!]" },
    recordId: { __type: "IDFilterInput" },
    schema: { __type: "SchemaFilterInput" },
    schemaId: { __type: "StringFilterInput" },
    schemaVersion: { __type: "SchemaVersionFilterInput" },
  },
  CustomDataSetEvent: {
    __typename: { __type: "String!" },
    customDataId: { __type: "String!" },
    data: { __type: "String!" },
    description: { __type: "String!" },
    recordId: { __type: "String!" },
    recordType: { __type: "String!" },
    schemaId: { __type: "String!" },
    schemaVersionId: { __type: "String!" },
  },
  CustomTemplate: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    default: { __type: "Boolean!" },
    deleted: { __type: "Boolean!" },
    description: { __type: "String" },
    entity: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    modified: { __type: "String!" },
    name: { __type: "String!" },
    query: { __type: "String" },
    sampleDataOverride: { __type: "String" },
    source: { __type: "String!" },
    template: { __type: "String!" },
    type: { __type: "Int!" },
  },
  CustomTemplateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  CustomTemplateFilterInput: {
    and: { __type: "[CustomTemplateFilterInput!]" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    default: { __type: "BooleanFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    description: { __type: "StringFilterInput" },
    entity: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[CustomTemplateFilterInput!]" },
    query: { __type: "StringFilterInput" },
    sampleDataOverride: { __type: "StringFilterInput" },
    source: { __type: "StringFilterInput" },
    template: { __type: "StringFilterInput" },
    type: { __type: "NumberFilterInput" },
  },
  DataStore: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    name: { __type: "String" },
  },
  DataStoreRecord: {
    __typename: { __type: "String!" },
    data: { __type: "String" },
    id: { __type: "ID!" },
  },
  DateTimeFilterInput: {
    eq: { __type: "String" },
    gte: { __type: "String" },
    isNull: { __type: "Boolean" },
    like: { __type: "String" },
    lte: { __type: "String" },
  },
  DateTimeReportDimensionInput: {
    filter: { __type: "DateTimeFilterInput!" },
    includeEmpty: { __type: "Boolean" },
    interval: { __type: "ReportDateInterval!" },
    withinEachInterval: { __type: "DateTimeFilterInput" },
  },
  Day: {
    __typename: { __type: "String!" },
    createdLeadAggregate: {
      __type: "LeadAggregate",
      __args: { filter: "LeadFilterInput" },
    },
    createdPurchaseOrderAggregate: {
      __type: "PurchaseOrderAggregate",
      __args: { filter: "PurchaseOrderFilterInput" },
    },
    createdPurchaseOrderLineAggregate: {
      __type: "PurchaseOrderLineAggregate",
      __args: { filter: "PurchaseOrderLineFilterInput" },
    },
    date: { __type: "String!" },
  },
  DeactivatePersonInput: {
    personId: { __type: "ID!" },
    userIds: { __type: "[ID!]!" },
  },
  DefaultFolder: {
    __typename: { __type: "String!" },
    allowedMimeTypes: { __type: "[String!]" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    enabled: { __type: "Boolean!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    recordType: { __type: "String!" },
  },
  DefaultFolderAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  DefaultFolderFilterInput: {
    and: { __type: "[DefaultFolderFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    enabled: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[DefaultFolderFilterInput!]" },
    recordType: { __type: "StringFilterInput" },
  },
  DeleteBatchesInput: { batchIds: { __type: "[ID!]!" } },
  DeleteBranchesInput: { branchIds: { __type: "[ID!]!" } },
  DeleteBuildersInput: { builderIds: { __type: "[ID!]!" } },
  DeleteClientsInput: { clientIds: { __type: "[ID!]!" } },
  DeleteConfiguredLinkedActionsInput: { ids: { __type: "[ID!]!" } },
  DeleteCorrespondenceInput: { correspondenceId: { __type: "ID!" } },
  DeleteCostingInput: { costingId: { __type: "ID!" } },
  DeleteDraftPurchaseOrdersInput: {
    purchaseOrderIds: { __type: "[String!]!" },
  },
  DeleteExternalStorageItemsInput: { paths: { __type: "[String!]!" } },
  DeleteHousingCompaniesInput: { housingCompanyIds: { __type: "[ID!]!" } },
  DeleteHousingCompanyImageInput: { housingCompanyId: { __type: "ID!" } },
  DeleteJobComponentInput: { jobComponentId: { __type: "ID!" } },
  DeleteLeadsInput: { leadIds: { __type: "[ID!]!" } },
  DeleteLineItemsInput: { lineItemIds: { __type: "[ID!]!" } },
  DeleteLostReasonsInput: { lostReasonIds: { __type: "[ID!]!" } },
  DeletePanelsInput: { panelIds: { __type: "[ID!]!" } },
  DeletePartTypesInput: { partTypeIds: { __type: "[ID!]!" } },
  DeleteProcessTypeNoteInput: { processTypeNoteId: { __type: "ID!" } },
  DeleteProcessTypeRolesInput: { processTypeRoleIds: { __type: "[ID!]!" } },
  DeleteProcessTypesInput: { processTypeIds: { __type: "[ID!]!" } },
  DeleteProductCategoriesInput: {
    cascade: { __type: "Boolean!" },
    productCategoryIds: { __type: "[ID!]!" },
  },
  DeleteProductPricesInput: { productPriceIds: { __type: "[ID!]!" } },
  DeleteRecordFilesInput: { ids: { __type: "[String!]!" } },
  DeleteSalesOrderInput: { salesOrderId: { __type: "ID!" } },
  DeleteScreensInput: { screenIds: { __type: "[ID!]!" } },
  DeleteSupplierImageInput: { supplierId: { __type: "ID!" } },
  DeleteSupplierQuoteInput: { supplierQuoteId: { __type: "ID!" } },
  DeleteSupplierQuoteRequestInput: {
    supplierQuoteRequestId: { __type: "ID!" },
  },
  DeleteSuppliersInput: { supplierIds: { __type: "[ID!]!" } },
  DeleteUserIdentitiesInput: { userIdentityIds: { __type: "[ID!]!" } },
  DeleteWebhooksInput: { webhookIds: { __type: "[ID!]!" } },
  DeleteWorkflowTypesInput: { workflowTypeIds: { __type: "[ID!]!" } },
  DeliveryAddress: {
    __typename: { __type: "String!" },
    address: { __type: "String" },
    code: { __type: "String" },
    color: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String" },
  },
  DeliveryAddressAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  DeliveryAddressFilterInput: {
    address: { __type: "StringFilterInput" },
    and: { __type: "[DeliveryAddressFilterInput!]" },
    code: { __type: "StringFilterInput" },
    color: { __type: "StringFilterInput" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "DateTimeFilterInput" },
    or: { __type: "[DeliveryAddressFilterInput!]" },
  },
  Document: {
    __typename: { __type: "String!" },
    html: { __type: "String!" },
    id: { __type: "ID!" },
    pdfBase64: { __type: "String!" },
    template: { __type: "DocumentTemplate!" },
  },
  DocumentPreview: {
    __typename: { __type: "String!" },
    html: { __type: "String!" },
    pdfBase64: { __type: "String!" },
  },
  DocumentTemplate: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    default: { __type: "Boolean!" },
    deleted: { __type: "Boolean!" },
    description: { __type: "String!" },
    entity: { __type: "String!" },
    html: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    modified: { __type: "String!" },
    name: { __type: "String!" },
    query: { __type: "String" },
    sampleDataOverride: { __type: "String" },
    source: { __type: "String!" },
    template: { __type: "String!" },
    type: { __type: "String!" },
  },
  DocumentTemplateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  DocumentTemplateFilterInput: {
    and: { __type: "[DocumentTemplateFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    default: { __type: "BooleanFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    description: { __type: "StringFilterInput" },
    entity: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "DateTimeFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[DocumentTemplateFilterInput!]" },
    query: { __type: "StringFilterInput" },
    recordType: { __type: "StringFilterInput" },
    sampleDataOverride: { __type: "StringFilterInput" },
    source: { __type: "StringFilterInput" },
    template: { __type: "StringFilterInput" },
    type: { __type: "StringFilterInput" },
  },
  EffectivePermission: {
    __typename: { __type: "String!" },
    assigned: { __type: "Boolean!" },
    conditions: { __type: "String" },
    permission: { __type: "Permission!" },
    policy: { __type: "Policy!" },
  },
  Email: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    messageId: { __type: "String" },
    purchaseOrder: { __type: "PurchaseOrder" },
    recipient: { __type: "String" },
    sender: { __type: "String" },
    sentAt: { __type: "DateTime" },
    status: { __type: "EmailDeliveryStatus" },
    subject: { __type: "String" },
    type: { __type: "String" },
    typeDisplayName: { __type: "String" },
    updatedAt: { __type: "DateTime" },
  },
  EmailAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  EmailCreatedEvent: {
    __typename: { __type: "String!" },
    entity: { __type: "String!" },
  },
  EmailDeliveryStatusFilterInput: {
    eq: { __type: "EmailDeliveryStatus" },
    in: { __type: "[EmailDeliveryStatus!]" },
  },
  EmailFilterInput: {
    and: { __type: "[EmailFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    messageId: { __type: "StringFilterInput" },
    or: { __type: "[EmailFilterInput!]" },
    purchaseOrder: { __type: "PurchaseOrderFilterInput" },
    recipient: { __type: "StringFilterInput" },
    sender: { __type: "StringFilterInput" },
    sentAt: { __type: "DateTimeFilterInput" },
    status: { __type: "EmailDeliveryStatusFilterInput" },
    subject: { __type: "StringFilterInput" },
    type: { __type: "StringFilterInput" },
    typeDisplayName: { __type: "StringFilterInput" },
    updatedAt: { __type: "DateTimeFilterInput" },
  },
  EmailStatusChangedEvent: {
    __typename: { __type: "String!" },
    description: { __type: "String" },
    emailId: { __type: "String!" },
    previousStatus: { __type: "Int" },
    recipient: { __type: "String" },
    status: { __type: "Int!" },
    subject: { __type: "String" },
  },
  ExpressionInput: {
    name: { __type: "String!" },
    value: { __type: "String!" },
  },
  ExternalStorageConnection: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    deviceAccessEnabled: { __type: "Boolean!" },
    dropboxAuthToken: { __type: "String" },
    dropboxNamespaceId: { __type: "String" },
    enabled: { __type: "Boolean!" },
    id: { __type: "ID!" },
    item: { __type: "ExternalStorageItem!", __args: { path: "String!" } },
    items: {
      __type: "[ExternalStorageItem!]!",
      __args: { path: "String!", pathPrefix: "String!" },
    },
    label: { __type: "String!" },
    localPathSeparator: { __type: "String!" },
    localRoot: { __type: "String" },
    name: { __type: "String!" },
    root: { __type: "String!" },
    storageMappings: {
      __type: "[ExternalStorageResourceMapping!]!",
      __args: { filter: "ExternalStorageResourceMappingFilterInput" },
    },
    type: { __type: "String!" },
  },
  ExternalStorageConnectionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ExternalStorageConnectionFilterInput: {
    and: { __type: "[ExternalStorageConnectionFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    localRoot: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[ExternalStorageConnectionFilterInput!]" },
    root: { __type: "StringFilterInput" },
    storageMappings: { __type: "ExternalStorageResourceMappingFilterInput" },
    type: { __type: "StringFilterInput" },
  },
  ExternalStorageItem: {
    __typename: { __type: "String!" },
    canOpen: { __type: "Boolean" },
    fileId: { __type: "String" },
    folderBadgeIconColour: { __type: "String" },
    folderBadgeIconName: { __type: "String" },
    id: { __type: "String!" },
    isFolder: { __type: "Boolean!" },
    label: { __type: "String!" },
    largeThumbnailUrl: { __type: "String" },
    localPath: { __type: "String" },
    localUrl: { __type: "String" },
    mediumThumbnailUrl: { __type: "String" },
    metadata: { __type: "String" },
    mimeType: { __type: "String" },
    modified: { __type: "DateTime" },
    name: { __type: "String!" },
    path: { __type: "String!" },
    previewUrl: { __type: "String" },
    recordFileId: { __type: "String" },
    size: { __type: "Int" },
    smallThumbnailUrl: { __type: "String" },
    temporaryUrl: { __type: "String" },
    type: { __type: "String!" },
    uploadMimeTypes: { __type: "[String!]" },
  },
  ExternalStorageItemFilterInput: {
    id: { __type: "IDFilterInput" },
    isFolder: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    mimeType: { __type: "StringFilterInput" },
    modified: { __type: "DateTimeFilterInput" },
    name: { __type: "StringFilterInput" },
    path: { __type: "StringFilterInput" },
    recordFile: { __type: "RecordFileFilterInput" },
    type: { __type: "StringFilterInput" },
  },
  ExternalStorageResourceMapping: {
    __typename: { __type: "String!" },
    created: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    enabled: { __type: "Boolean!" },
    externalStorageConnection: { __type: "ExternalStorageConnection!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    path: { __type: "String" },
    resourceFilter: { __type: "String" },
    resourceType: { __type: "String" },
  },
  ExternalStorageResourceMappingAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ExternalStorageResourceMappingFilterInput: {
    and: { __type: "[ExternalStorageResourceMappingFilterInput!]" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    enabled: { __type: "BooleanFilterInput" },
    externalStorageConnection: {
      __type: "ExternalStorageConnectionFilterInput",
    },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[ExternalStorageResourceMappingFilterInput!]" },
    path: { __type: "StringFilterInput" },
    resourceFilter: { __type: "StringFilterInput" },
    resourceType: { __type: "StringFilterInput" },
    storageConnection: { __type: "ExternalStorageConnectionFilterInput" },
  },
  File: {
    __typename: { __type: "String!" },
    created: { __type: "DateTime!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    hash: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    largeThumbnailUrl: { __type: "String" },
    mediumThumbnailUrl: { __type: "String" },
    mimeType: { __type: "String" },
    modified: { __type: "DateTime!" },
    name: { __type: "String!" },
    sizeBytes: { __type: "Int!" },
    smallThumbnailUrl: { __type: "String" },
    temporaryUrl: { __type: "String" },
    user: { __type: "User" },
  },
  FileAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  FileFilterInput: {
    and: { __type: "[FileFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    hash: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    mimeType: { __type: "StringFilterInput" },
    modified: { __type: "DateTimeFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[FileFilterInput!]" },
    size: { __type: "NumberFilterInput" },
    sizeBytes: { __type: "NumberFilterInput" },
    user: { __type: "UserFilterInput" },
    userId: { __type: "UserIdentityFilterInput" },
  },
  FileInput: {
    fileId: { __type: "String!" },
    metadata: { __type: "String" },
    primaryImage: { __type: "Boolean" },
  },
  FileReportDimensionValue: {
    __typename: { __type: "String!" },
    created: { __type: "ReportDimensionValue" },
    key: { __type: "String" },
    label: { __type: "String" },
    modified: { __type: "ReportDimensionValue" },
    user: { __type: "UserReportDimensionValue" },
  },
  FileReportGroupByInput: {
    created: { __type: "DateTimeReportDimensionInput" },
    modified: { __type: "DateTimeReportDimensionInput" },
    user: { __type: "UserReportRelationDimensionInput" },
  },
  FileReportRelationDimensionInput: {
    filter: { __type: "FileFilterInput" },
    groupBy: { __type: "FileReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  FileUploadedEvent: {
    __typename: { __type: "String!" },
    file: { __type: "String!" },
  },
  GetDocumentPreviewInput: {
    data: { __type: "String" },
    id: { __type: "ID" },
    query: { __type: "String" },
    template: { __type: "String" },
    variables: { __type: "String" },
  },
  GroupInstance: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    lineItemMasterWorkflow: { __type: "LineItemMasterWorkflow" },
    name: { __type: "String!" },
    workflow: { __type: "Workflow!" },
  },
  GroupInstanceFilterInput: {
    and: { __type: "[GroupInstanceFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    lineItemMasterWorkflow: { __type: "LineItemMasterWorkflowFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[GroupInstanceFilterInput!]" },
    workflow: { __type: "WorkflowFilterInput" },
  },
  GroupTemplate: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    placeHolder: { __type: "Boolean!" },
    workflowTemplate: { __type: "WorkflowTemplate" },
  },
  GroupTemplateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  GroupTemplateFilterInput: {
    and: { __type: "[GroupTemplateFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[GroupTemplateFilterInput!]" },
    placeHolder: { __type: "BooleanFilterInput" },
    workflowTemplate: { __type: "WorkflowTemplateFilterInput" },
  },
  HousingCompany: {
    __typename: { __type: "String!" },
    code: { __type: "String" },
    confirmedSalesYtdChange: { __type: "Float" },
    created: { __type: "DateTime" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deleted: { __type: "Boolean!" },
    id: { __type: "ID!" },
    image: { __type: "File" },
    jobAggregate: {
      __type: "JobAggregate",
      __args: { filter: "JobFilterInput" },
    },
    jobs: { __type: "[Job!]!", __args: { filter: "JobFilterInput" } },
    label: { __type: "String!" },
    modified: { __type: "DateTime" },
    name: { __type: "String" },
  },
  HousingCompanyAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  HousingCompanyFilterInput: {
    and: { __type: "[HousingCompanyFilterInput!]" },
    code: { __type: "StringFilterInput" },
    confirmedSalesYtdChange: { __type: "NumberFilterInput" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    image: { __type: "FileFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    jobs: { __type: "JobFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "DateTimeFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[HousingCompanyFilterInput!]" },
  },
  HousingCompanyReportDimensionValue: {
    __typename: { __type: "String!" },
    created: { __type: "ReportDimensionValue" },
    image: { __type: "FileReportDimensionValue" },
    key: { __type: "String" },
    label: { __type: "String" },
    modified: { __type: "ReportDimensionValue" },
  },
  HousingCompanyReportGroupByInput: {
    created: { __type: "DateTimeReportDimensionInput" },
    image: { __type: "FileReportRelationDimensionInput" },
    modified: { __type: "DateTimeReportDimensionInput" },
  },
  HousingCompanyReportRelationDimensionInput: {
    filter: { __type: "HousingCompanyFilterInput" },
    groupBy: { __type: "HousingCompanyReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  IDFilterInput: {
    eq: { __type: "ID" },
    in: { __type: "[ID!]" },
    isNull: { __type: "Boolean" },
    notEq: { __type: "ID" },
    notIn: { __type: "[ID!]" },
  },
  InternalCommentUpdatedEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  InvalidateCacheEvent: {
    __typename: { __type: "String!" },
    shutdown: { __type: "String!" },
  },
  InvoiceCheckedEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  InvoiceUncheckedEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  Issue: {
    __typename: { __type: "String!" },
    completed: { __type: "Boolean!" },
    createdAt: { __type: "DateTime" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    files: {
      __type: "[RecordFile!]!",
      __args: { filter: "RecordFileFilterInput" },
    },
    id: { __type: "ID!" },
    job: { __type: "Job" },
    label: { __type: "String!" },
    modifiedAt: { __type: "DateTime" },
    notes: { __type: "String" },
    recordId: { __type: "ID" },
    recordJob: { __type: "Job" },
    recordType: { __type: "String" },
    reportedBy: { __type: "String" },
    requiredDate: { __type: "DateTime" },
    scheduledDate: { __type: "DateTime" },
  },
  IssueAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  IssueCompletionStatus: {
    __typename: { __type: "String!" },
    completed: { __type: "Boolean!" },
    id: { __type: "ID!" },
    issueAggregate: {
      __type: "IssueAggregate",
      __args: { filter: "IssueFilterInput" },
    },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  IssueCreatedEvent: {
    __typename: { __type: "String!" },
    description: { __type: "String" },
    issueId: { __type: "Int!" },
  },
  IssueFilterInput: {
    and: { __type: "[IssueFilterInput!]" },
    completed: { __type: "BooleanFilterInput" },
    createdAt: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    files: { __type: "RecordFileFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    job: { __type: "JobFilterInput" },
    label: { __type: "StringFilterInput" },
    modifiedAt: { __type: "DateTimeFilterInput" },
    notes: { __type: "StringFilterInput" },
    or: { __type: "[IssueFilterInput!]" },
    recordId: { __type: "IDFilterInput" },
    recordJob: { __type: "JobFilterInput" },
    recordType: { __type: "StringFilterInput" },
    reportedBy: { __type: "StringFilterInput" },
    requiredDate: { __type: "DateTimeFilterInput" },
    scheduledDate: { __type: "DateTimeFilterInput" },
  },
  IssueQuoteInput: { quoteId: { __type: "ID!" } },
  IssueUpdatedEvent: {
    __typename: { __type: "String!" },
    description: { __type: "String" },
    issueId: { __type: "Int!" },
  },
  Job: {
    __typename: { __type: "String!" },
    batches: { __type: "[Batch!]!", __args: { filter: "BatchFilterInput" } },
    benchtopOnly: { __type: "Boolean!" },
    branch: { __type: "Branch" },
    buildType: { __type: "BuildType" },
    buildTypeId: { __type: "String" },
    builder: { __type: "Builder" },
    builderId: { __type: "String" },
    builderPhone: { __type: "String" },
    client: { __type: "Client" },
    costings: {
      __type: "[Costing!]!",
      __args: { filter: "CostingFilterInput" },
    },
    createdDate: { __type: "DateTime" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    designer: { __type: "PersonBusinessRole" },
    designerId: { __type: "String" },
    difficultAccess: { __type: "Boolean!" },
    dueDate: { __type: "DateTime" },
    externalStorageConnection: { __type: "ExternalStorageConnection" },
    externalStorageItems: {
      __type: "[ExternalStorageItem!]",
      __args: { path: "String" },
    },
    externalStoragePath: { __type: "String" },
    hcJobNumber: { __type: "String" },
    hcPmPhone: { __type: "String" },
    hcProjectManager: { __type: "String" },
    housingCompany: { __type: "HousingCompany" },
    id: { __type: "ID!" },
    issues: { __type: "[Issue!]!", __args: { filter: "IssueFilterInput" } },
    jobComponents: {
      __type: "[JobComponent!]!",
      __args: { filter: "JobComponentFilterInput" },
    },
    jobFolderLink: { __type: "String" },
    jobName: { __type: "String" },
    jobNumber: { __type: "String" },
    label: { __type: "String!" },
    lead: { __type: "Lead" },
    lineItemAggregate: {
      __type: "LineItemAggregate",
      __args: { filter: "LineItemFilterInput" },
    },
    lineItems: {
      __type: "[LineItem!]!",
      __args: { filter: "LineItemFilterInput" },
    },
    lostReason: { __type: "LostReason" },
    lostReasonNotes: { __type: "String" },
    note: { __type: "String" },
    projectManager: { __type: "PersonBusinessRole" },
    projectManagerId: { __type: "String" },
    purchaseOrderAggregate: { __type: "PurchaseOrderAggregate" },
    purchaseOrders: {
      __type: "[PurchaseOrder!]!",
      __args: { filter: "PurchaseOrderFilterInput" },
    },
    quotes: { __type: "[Quote!]!", __args: { filter: "QuoteFilterInput" } },
    region: { __type: "Region" },
    regionId: { __type: "String" },
    saleType: { __type: "SaleType" },
    saleTypeId: { __type: "String" },
    salesOrders: {
      __type: "[SalesOrder!]!",
      __args: { filter: "SalesOrderFilterInput" },
    },
    showHome: { __type: "Boolean!" },
    siteAddress: { __type: "String" },
    siteNotes: { __type: "String" },
    sssp: { __type: "Boolean!" },
    status: { __type: "Int!" },
    supplierQuoteRequests: {
      __type: "[SupplierQuoteRequest!]!",
      __args: { filter: "SupplierQuoteRequestFilterInput" },
    },
    supplierQuotes: {
      __type: "[SupplierQuote!]!",
      __args: { filter: "SupplierQuoteFilterInput" },
    },
    tristoneJoin: { __type: "Boolean!" },
    tristoneSpecified: { __type: "Boolean!" },
    unit: { __type: "Boolean!" },
  },
  JobAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    estimatedSheets: { __type: "Float!" },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    totalConfirmedSale: {
      __type: "Float",
      __args: { confirmedDate: "DateTimeFilterInput" },
    },
  },
  JobBuilderUpdatedEvent: {
    __typename: { __type: "String!" },
    jobId: { __type: "String!" },
    jobNumber: { __type: "String!" },
  },
  JobClientUpdatedEvent: {
    __typename: { __type: "String!" },
    clientName: { __type: "String!" },
    jobId: { __type: "String!" },
    jobNumber: { __type: "String!" },
  },
  JobComponent: {
    __typename: { __type: "String!" },
    code: { __type: "String!" },
    costings: {
      __type: "[Costing!]!",
      __args: { filter: "CostingFilterInput" },
    },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    estimatingSellTotal: { __type: "String!" },
    id: { __type: "ID!" },
    job: { __type: "Job!" },
    label: { __type: "String!" },
    modified: { __type: "String!" },
    name: { __type: "String!" },
    partType: { __type: "PartType" },
    quoteLines: {
      __type: "[QuoteLine!]!",
      __args: { filter: "QuoteLineFilterInput" },
    },
    salesOrderLines: {
      __type: "[SalesOrderLine!]!",
      __args: { filter: "SalesOrderLineFilterInput" },
    },
  },
  JobComponentAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  JobComponentFilterInput: {
    and: { __type: "[JobComponentFilterInput!]" },
    code: { __type: "StringFilterInput" },
    costings: { __type: "CostingFilterInput" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    estimatingSellTotal: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    job: { __type: "JobFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[JobComponentFilterInput!]" },
    partType: { __type: "PartTypeFilterInput" },
    quoteLines: { __type: "QuoteLineFilterInput" },
    salesOrderLines: { __type: "SalesOrderLineFilterInput" },
  },
  JobCreatedEvent: {
    __typename: { __type: "String!" },
    jobId: { __type: "String!" },
    jobNumber: { __type: "String!" },
    leadId: { __type: "String" },
  },
  JobDetailsUpdatedEvent: {
    __typename: { __type: "String!" },
    jobId: { __type: "String!" },
    jobNumber: { __type: "String!" },
  },
  JobFilterInput: {
    and: { __type: "[JobFilterInput!]" },
    batches: { __type: "BatchFilterInput" },
    benchtopOnly: { __type: "BooleanFilterInput" },
    branch: { __type: "BranchFilterInput" },
    buildType: { __type: "BuildTypeFilterInput" },
    buildTypeId: { __type: "StringFilterInput" },
    builder: { __type: "BuilderFilterInput" },
    builderId: { __type: "StringFilterInput" },
    builderPhone: { __type: "StringFilterInput" },
    client: { __type: "ClientFilterInput" },
    costings: { __type: "CostingFilterInput" },
    createdDate: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    designer: { __type: "PersonBusinessRoleFilterInput" },
    designerId: { __type: "StringFilterInput" },
    difficultAccess: { __type: "BooleanFilterInput" },
    dueDate: { __type: "DateTimeFilterInput" },
    hasAssociatedLead: { __type: "BooleanFilterInput" },
    hcJobNumber: { __type: "StringFilterInput" },
    hcPmPhone: { __type: "StringFilterInput" },
    hcProjectManager: { __type: "StringFilterInput" },
    housingCompany: { __type: "HousingCompanyFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    issues: { __type: "IssueFilterInput" },
    jobComponents: { __type: "JobComponentFilterInput" },
    jobName: { __type: "StringFilterInput" },
    jobNumber: { __type: "StringFilterInput" },
    jobString: { __type: "StringFilterInput" },
    label: { __type: "StringFilterInput" },
    lead: { __type: "LeadFilterInput" },
    lineItems: { __type: "LineItemFilterInput" },
    lostReason: { __type: "LostReasonFilterInput" },
    lostReasonNotes: { __type: "StringFilterInput" },
    or: { __type: "[JobFilterInput!]" },
    projectManager: { __type: "PersonBusinessRoleFilterInput" },
    projectManagerId: { __type: "StringFilterInput" },
    purchaseOrders: { __type: "PurchaseOrderFilterInput" },
    quotes: { __type: "QuoteFilterInput" },
    region: { __type: "RegionFilterInput" },
    regionId: { __type: "StringFilterInput" },
    saleType: { __type: "SaleTypeFilterInput" },
    saleTypeId: { __type: "StringFilterInput" },
    salesOrders: { __type: "SalesOrderFilterInput" },
    showHome: { __type: "BooleanFilterInput" },
    siteAddress: { __type: "StringFilterInput" },
    siteNotes: { __type: "StringFilterInput" },
    sssp: { __type: "BooleanFilterInput" },
    status: { __type: "JobStatusFilterInput" },
    supplierQuoteRequests: { __type: "SupplierQuoteRequestFilterInput" },
    supplierQuotes: { __type: "SupplierQuoteFilterInput" },
    tristoneJoin: { __type: "BooleanFilterInput" },
    tristoneSpecified: { __type: "BooleanFilterInput" },
    unit: { __type: "BooleanFilterInput" },
  },
  JobPartBatchChangedEvent: {
    __typename: { __type: "String!" },
    lineItemId: { __type: "String!" },
    lineItemName: { __type: "String!" },
    newBatchId: { __type: "String!" },
    newBatchName: { __type: "String!" },
    oldBatchId: { __type: "String" },
  },
  JobPartConfirmedEvent: {
    __typename: { __type: "String!" },
    lineItemId: { __type: "String!" },
    lineItemName: { __type: "String!" },
  },
  JobPartCreatedEvent: {
    __typename: { __type: "String!" },
    jobNumber: { __type: "String!" },
    lineItemId: { __type: "String!" },
    lineItemName: { __type: "String!" },
  },
  JobPartDeletedEvent: {
    __typename: { __type: "String!" },
    batchId: { __type: "String" },
    lineItemId: { __type: "String!" },
    lineItemName: { __type: "String!" },
  },
  JobPartUpdatedEvent: {
    __typename: { __type: "String!" },
    lineItemId: { __type: "String!" },
    lineItemName: { __type: "String!" },
  },
  JobReportDimensionValue: {
    __typename: { __type: "String!" },
    branch: { __type: "BranchReportDimensionValue" },
    buildType: { __type: "BuildTypeReportDimensionValue" },
    builder: { __type: "BuilderReportDimensionValue" },
    client: { __type: "ClientReportDimensionValue" },
    createdDate: { __type: "ReportDimensionValue" },
    designer: { __type: "PersonBusinessRoleReportDimensionValue" },
    dueDate: { __type: "ReportDimensionValue" },
    housingCompany: { __type: "HousingCompanyReportDimensionValue" },
    key: { __type: "String" },
    label: { __type: "String" },
    lead: { __type: "LeadReportDimensionValue" },
    lostReason: { __type: "LostReasonReportDimensionValue" },
    projectManager: { __type: "PersonBusinessRoleReportDimensionValue" },
    region: { __type: "RegionReportDimensionValue" },
    saleType: { __type: "SaleTypeReportDimensionValue" },
  },
  JobReportDimensions: {
    __typename: { __type: "String!" },
    branch: { __type: "BranchReportDimensionValue" },
    buildType: { __type: "BuildTypeReportDimensionValue" },
    builder: { __type: "BuilderReportDimensionValue" },
    client: { __type: "ClientReportDimensionValue" },
    createdDate: { __type: "ReportDimensionValue" },
    designer: { __type: "PersonBusinessRoleReportDimensionValue" },
    dueDate: { __type: "ReportDimensionValue" },
    housingCompany: { __type: "HousingCompanyReportDimensionValue" },
    lead: { __type: "LeadReportDimensionValue" },
    lostReason: { __type: "LostReasonReportDimensionValue" },
    projectManager: { __type: "PersonBusinessRoleReportDimensionValue" },
    region: { __type: "RegionReportDimensionValue" },
    saleType: { __type: "SaleTypeReportDimensionValue" },
  },
  JobReportGroupByInput: {
    branch: { __type: "BranchReportRelationDimensionInput" },
    buildType: { __type: "BuildTypeReportRelationDimensionInput" },
    builder: { __type: "BuilderReportRelationDimensionInput" },
    client: { __type: "ClientReportRelationDimensionInput" },
    createdDate: { __type: "DateTimeReportDimensionInput" },
    designer: { __type: "PersonBusinessRoleReportRelationDimensionInput" },
    dueDate: { __type: "DateTimeReportDimensionInput" },
    housingCompany: { __type: "HousingCompanyReportRelationDimensionInput" },
    lead: { __type: "LeadReportRelationDimensionInput" },
    lostReason: { __type: "LostReasonReportRelationDimensionInput" },
    projectManager: {
      __type: "PersonBusinessRoleReportRelationDimensionInput",
    },
    region: { __type: "RegionReportRelationDimensionInput" },
    saleType: { __type: "SaleTypeReportRelationDimensionInput" },
  },
  JobReportRelationDimensionInput: {
    filter: { __type: "JobFilterInput" },
    groupBy: { __type: "JobReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  JobReportRow: {
    __typename: { __type: "String!" },
    aggregate: {
      __type: "JobAggregate!",
      __args: { filter: "JobFilterInput" },
    },
    dimensions: { __type: "JobReportDimensions!" },
    key: { __type: "String!" },
    label: { __type: "String!" },
  },
  JobSiteUpdatedEvent: {
    __typename: { __type: "String!" },
    jobId: { __type: "String!" },
    jobNumber: { __type: "String!" },
  },
  JobStatus: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    intent: { __type: "String!" },
    jobAggregate: {
      __type: "JobAggregate",
      __args: { filter: "JobFilterInput" },
    },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  JobStatusChangedEvent: {
    __typename: { __type: "String!" },
    jobId: { __type: "String!" },
    jobNumber: { __type: "String" },
    newStatus: { __type: "String!" },
    oldStatus: { __type: "String" },
  },
  JobStatusFilterInput: { id: { __type: "IDFilterInput" } },
  JsonFilterInput: {
    eq: { __type: "String" },
    field: { __type: "String" },
    in: { __type: "[String!]" },
    like: { __type: "String" },
    neq: { __type: "String" },
    notIn: { __type: "[String!]" },
  },
  Lead: {
    __typename: { __type: "String!" },
    address: { __type: "String" },
    assignedDate: { __type: "DateTime" },
    assignedTo: { __type: "PersonBusinessRole" },
    branch: { __type: "Branch" },
    builderName: { __type: "String" },
    builderType: { __type: "String" },
    city: { __type: "String" },
    client: { __type: "String!" },
    correspondence: {
      __type: "[Correspondence!]!",
      __args: { filter: "CorrespondenceFilterInput" },
    },
    createdAt: { __type: "DateTime" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    email: { __type: "String" },
    id: { __type: "ID!" },
    job: { __type: "Job" },
    joineryTypes: { __type: "String" },
    label: { __type: "String!" },
    latestCorrespondence: { __type: "Correspondence" },
    lostReason: { __type: "LostReason" },
    lostReasonNotes: { __type: "String" },
    notes: { __type: "String" },
    phone: { __type: "String" },
    priceRangeBottom: { __type: "Float" },
    priceRangeTop: { __type: "Float" },
    priority: { __type: "Int!" },
    projectType: { __type: "String!" },
    requiredBy: { __type: "DateTime" },
    source: { __type: "String!" },
    status: { __type: "LeadStatus!" },
    suburb: { __type: "String" },
  },
  LeadAggregate: {
    __typename: { __type: "String!" },
    avgAssignTimeDays: { __type: "Int" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    ids: { __type: "[String!]!" },
    newStatusCount: { __type: "Int!" },
  },
  LeadAssignedEvent: {
    __typename: { __type: "String!" },
    assignedToId: { __type: "Int!" },
    assignedToName: { __type: "String!" },
    clientName: { __type: "String!" },
    leadId: { __type: "Int!" },
  },
  LeadBranchChangedEvent: {
    __typename: { __type: "String!" },
    clientName: { __type: "String!" },
    leadId: { __type: "Int!" },
    newBranchId: { __type: "String" },
    newBranchName: { __type: "String" },
    oldBranchId: { __type: "String" },
    oldBranchName: { __type: "String" },
  },
  LeadConvertedToJobEvent: {
    __typename: { __type: "String!" },
    jobNumber: { __type: "String!" },
    leadId: { __type: "String!" },
    leadLabel: { __type: "String!" },
  },
  LeadCreatedEvent: {
    __typename: { __type: "String!" },
    clientName: { __type: "String!" },
    leadId: { __type: "Int!" },
  },
  LeadDetailsUpdatedEvent: {
    __typename: { __type: "String!" },
    clientName: { __type: "String!" },
    leadId: { __type: "Int!" },
  },
  LeadFilterInput: {
    address: { __type: "StringFilterInput" },
    and: { __type: "[LeadFilterInput!]" },
    assignedDate: { __type: "DateTimeFilterInput" },
    assignedTo: { __type: "PersonBusinessRoleFilterInput" },
    branch: { __type: "BranchFilterInput" },
    builderName: { __type: "StringFilterInput" },
    builderType: { __type: "StringFilterInput" },
    city: { __type: "StringFilterInput" },
    client: { __type: "StringFilterInput" },
    correspondence: { __type: "CorrespondenceFilterInput" },
    created: { __type: "DateTimeFilterInput" },
    createdAt: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    email: { __type: "StringFilterInput" },
    hasAssociatedJob: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    job: { __type: "JobFilterInput" },
    joineryTypes: { __type: "StringFilterInput" },
    label: { __type: "StringFilterInput" },
    lostReason: { __type: "LostReasonFilterInput" },
    lostReasonNotes: { __type: "StringFilterInput" },
    notes: { __type: "StringFilterInput" },
    or: { __type: "[LeadFilterInput!]" },
    phone: { __type: "StringFilterInput" },
    priceRangeBottom: { __type: "NumberFilterInput" },
    priceRangeTop: { __type: "NumberFilterInput" },
    priority: { __type: "NumberFilterInput" },
    projectType: { __type: "StringFilterInput" },
    requiredBy: { __type: "DateTimeFilterInput" },
    source: { __type: "LeadSourceFilterInput" },
    status: { __type: "LeadStatusFilterInput" },
    suburb: { __type: "StringFilterInput" },
  },
  LeadOverrideStatusEvent: {
    __typename: { __type: "String!" },
    clientName: { __type: "String!" },
    leadId: { __type: "Int!" },
    newStatus: { __type: "String!" },
    oldStatus: { __type: "String!" },
  },
  LeadProjectType: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    leadAggregate: {
      __type: "LeadAggregate",
      __args: { filter: "LeadFilterInput" },
    },
    name: { __type: "String!" },
  },
  LeadReportDimensionValue: {
    __typename: { __type: "String!" },
    assignedDate: { __type: "ReportDimensionValue" },
    assignedTo: { __type: "PersonBusinessRoleReportDimensionValue" },
    branch: { __type: "BranchReportDimensionValue" },
    createdAt: { __type: "ReportDimensionValue" },
    job: { __type: "JobReportDimensionValue" },
    key: { __type: "String" },
    label: { __type: "String" },
    lostReason: { __type: "LostReasonReportDimensionValue" },
    requiredBy: { __type: "ReportDimensionValue" },
  },
  LeadReportDimensions: {
    __typename: { __type: "String!" },
    assignedDate: { __type: "ReportDimensionValue" },
    assignedTo: { __type: "PersonBusinessRoleReportDimensionValue" },
    branch: { __type: "BranchReportDimensionValue" },
    createdAt: { __type: "ReportDimensionValue" },
    job: { __type: "JobReportDimensionValue" },
    lostReason: { __type: "LostReasonReportDimensionValue" },
    requiredBy: { __type: "ReportDimensionValue" },
  },
  LeadReportGroupByInput: {
    assignedDate: { __type: "DateTimeReportDimensionInput" },
    assignedTo: { __type: "PersonBusinessRoleReportRelationDimensionInput" },
    branch: { __type: "BranchReportRelationDimensionInput" },
    createdAt: { __type: "DateTimeReportDimensionInput" },
    job: { __type: "JobReportRelationDimensionInput" },
    lostReason: { __type: "LostReasonReportRelationDimensionInput" },
    requiredBy: { __type: "DateTimeReportDimensionInput" },
  },
  LeadReportRelationDimensionInput: {
    filter: { __type: "LeadFilterInput" },
    groupBy: { __type: "LeadReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  LeadReportRow: {
    __typename: { __type: "String!" },
    aggregate: {
      __type: "LeadAggregate!",
      __args: { filter: "LeadFilterInput" },
    },
    dimensions: { __type: "LeadReportDimensions!" },
    key: { __type: "String!" },
    label: { __type: "String!" },
  },
  LeadSource: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    leadAggregate: {
      __type: "LeadAggregate",
      __args: { filter: "LeadFilterInput" },
    },
    name: { __type: "String!" },
  },
  LeadSourceFilterInput: {
    id: { __type: "IDFilterInput" },
    leads: { __type: "LeadFilterInput" },
  },
  LeadStatus: {
    __typename: { __type: "String!" },
    id: { __type: "LeadStatusEnum!" },
    intent: { __type: "String!" },
    label: { __type: "String!" },
    leadAggregate: {
      __type: "LeadAggregate",
      __args: { filter: "LeadFilterInput" },
    },
    name: { __type: "String!" },
  },
  LeadStatusChangedEvent: {
    __typename: { __type: "String!" },
    clientName: { __type: "String!" },
    leadId: { __type: "Int!" },
    newStatus: { __type: "String!" },
    oldStatus: { __type: "String!" },
  },
  LeadStatusFilterInput: {
    id: { __type: "IDFilterInput" },
    leads: { __type: "LeadFilterInput" },
  },
  LineItem: {
    __typename: { __type: "String!" },
    batch: { __type: "Batch" },
    batchId: { __type: "String" },
    confirmed: { __type: "Boolean!" },
    confirmedDate: { __type: "String" },
    confirmedSale: { __type: "Float" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    job: { __type: "Job" },
    label: { __type: "String!" },
    masterWorkflow: { __type: "LineItemMasterWorkflow" },
    name: { __type: "String" },
    oldSpecification: { __type: "Specification" },
    partNumber: { __type: "String" },
    partType: { __type: "PartType" },
    salePrice: { __type: "Float" },
  },
  LineItemAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    totalConfirmedSale: { __type: "Float" },
  },
  LineItemFilterInput: {
    and: { __type: "[LineItemFilterInput!]" },
    batch: { __type: "BatchFilterInput" },
    batchId: { __type: "StringFilterInput" },
    confirmed: { __type: "BooleanFilterInput" },
    confirmedDate: { __type: "DateTimeFilterInput" },
    confirmedSale: { __type: "NumberFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    job: { __type: "JobFilterInput" },
    label: { __type: "StringFilterInput" },
    masterWorkflow: { __type: "LineItemMasterWorkflowFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[LineItemFilterInput!]" },
    partNumber: { __type: "StringFilterInput" },
    partType: { __type: "PartTypeFilterInput" },
    salePrice: { __type: "NumberFilterInput" },
  },
  LineItemMasterWorkflow: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    groupInstances: {
      __type: "[GroupInstance!]!",
      __args: { filter: "GroupInstanceFilterInput" },
    },
    id: { __type: "ID!" },
    items: {
      __type: "[WorkflowNode!]!",
      __args: { filter: "WorkflowNodeFilterInput" },
    },
    label: { __type: "String!" },
    lineItem: { __type: "LineItem" },
    lineItemId: { __type: "String!" },
    name: { __type: "String!" },
    orderedItems: { __type: "[WorkflowNode!]!" },
    orderedProcessInstances: { __type: "[ProcessInstance!]!" },
    processAssets: {
      __type: "[ProcessAsset!]!",
      __args: { filter: "ProcessAssetFilterInput" },
    },
    processInstanceAggregate: {
      __type: "ProcessInstanceAggregate",
      __args: { filter: "ProcessInstanceFilterInput" },
    },
    processInstances: {
      __type: "[ProcessInstance!]!",
      __args: { filter: "ProcessInstanceFilterInput" },
    },
  },
  LineItemMasterWorkflowAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  LineItemMasterWorkflowCompletedEvent: {
    __typename: { __type: "String!" },
    lineItemMasterWorkflowId: { __type: "String!" },
  },
  LineItemMasterWorkflowFilterInput: {
    and: { __type: "[LineItemMasterWorkflowFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    groupInstances: { __type: "GroupInstanceFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    items: { __type: "WorkflowNodeFilterInput" },
    label: { __type: "StringFilterInput" },
    lineItem: { __type: "LineItemFilterInput" },
    lineItemId: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[LineItemMasterWorkflowFilterInput!]" },
    processAssets: { __type: "ProcessAssetFilterInput" },
    processInstances: { __type: "ProcessInstanceFilterInput" },
  },
  LineItemMasterWorkflowReportDimensionValue: {
    __typename: { __type: "String!" },
    key: { __type: "String" },
    label: { __type: "String" },
    lineItem: { __type: "LineItemReportDimensionValue" },
  },
  LineItemMasterWorkflowReportGroupByInput: {
    lineItem: { __type: "LineItemReportRelationDimensionInput" },
  },
  LineItemMasterWorkflowReportRelationDimensionInput: {
    filter: { __type: "LineItemMasterWorkflowFilterInput" },
    groupBy: { __type: "LineItemMasterWorkflowReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  LineItemReportDimensionValue: {
    __typename: { __type: "String!" },
    batch: { __type: "BatchReportDimensionValue" },
    confirmedDate: { __type: "ReportDimensionValue" },
    job: { __type: "JobReportDimensionValue" },
    key: { __type: "String" },
    label: { __type: "String" },
    masterWorkflow: { __type: "LineItemMasterWorkflowReportDimensionValue" },
    partType: { __type: "PartTypeReportDimensionValue" },
  },
  LineItemReportDimensions: {
    __typename: { __type: "String!" },
    batch: { __type: "BatchReportDimensionValue" },
    confirmedDate: { __type: "ReportDimensionValue" },
    job: { __type: "JobReportDimensionValue" },
    masterWorkflow: { __type: "LineItemMasterWorkflowReportDimensionValue" },
    partType: { __type: "PartTypeReportDimensionValue" },
  },
  LineItemReportGroupByInput: {
    batch: { __type: "BatchReportRelationDimensionInput" },
    confirmedDate: { __type: "DateTimeReportDimensionInput" },
    job: { __type: "JobReportRelationDimensionInput" },
    masterWorkflow: {
      __type: "LineItemMasterWorkflowReportRelationDimensionInput",
    },
    partType: { __type: "PartTypeReportRelationDimensionInput" },
  },
  LineItemReportRelationDimensionInput: {
    filter: { __type: "LineItemFilterInput" },
    groupBy: { __type: "LineItemReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  LineItemReportRow: {
    __typename: { __type: "String!" },
    aggregate: {
      __type: "LineItemAggregate!",
      __args: { filter: "LineItemFilterInput" },
    },
    dimensions: { __type: "LineItemReportDimensions!" },
    key: { __type: "String!" },
    label: { __type: "String!" },
  },
  LineItemWorkflowPlaceholderInput: {
    workflowTemplateId: { __type: "ID!" },
    workflowTypeId: { __type: "ID!" },
  },
  LinkedAction: {
    __typename: { __type: "String!" },
    actionId: { __type: "String!" },
    bindings: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    displayOrder: { __type: "Int!" },
    enabled: { __type: "Boolean!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    ownerUserId: { __type: "ID" },
    recordPath: { __type: "String!" },
    recordType: { __type: "String!" },
  },
  LinkedActionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  LinkedActionFilterInput: {
    actionId: { __type: "StringFilterInput" },
    and: { __type: "[LinkedActionFilterInput!]" },
    bindings: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    displayOrder: { __type: "NumberFilterInput" },
    enabled: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[LinkedActionFilterInput!]" },
    ownerUserId: { __type: "IDFilterInput" },
    recordPath: { __type: "StringFilterInput" },
    recordType: { __type: "StringFilterInput" },
  },
  LostReason: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  LostReasonAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  LostReasonFilterInput: {
    and: { __type: "[LostReasonFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[LostReasonFilterInput!]" },
  },
  LostReasonReportDimensionValue: {
    __typename: { __type: "String!" },
    key: { __type: "String" },
    label: { __type: "String" },
  },
  LostReasonReportRelationDimensionInput: {
    filter: { __type: "LostReasonFilterInput" },
    includeEmpty: { __type: "Boolean" },
  },
  Machine: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    machineTypeId: { __type: "String!" },
    name: { __type: "String!" },
  },
  MachineFilterInput: {
    id: { __type: "IDFilterInput" },
    machineType: { __type: "MachineTypeFilterInput" },
  },
  MachineType: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    machines: {
      __type: "[Machine!]!",
      __args: { filter: "MachineFilterInput" },
    },
    name: { __type: "String!" },
  },
  MachineTypeFilterInput: { id: { __type: "IDFilterInput" } },
  MarkJobLostInput: {
    additionalNotes: { __type: "String" },
    jobId: { __type: "ID!" },
    lostReasonId: { __type: "ID!" },
  },
  MarkLeadLostInput: {
    additionalNotes: { __type: "String" },
    leadId: { __type: "ID!" },
    lostReasonId: { __type: "ID!" },
  },
  Money: {
    __typename: { __type: "String!" },
    amount: { __type: "String!" },
    currency: { __type: "String!" },
  },
  Month: {
    __typename: { __type: "String!" },
    createdLeadAggregate: {
      __type: "LeadAggregate",
      __args: { filter: "LeadFilterInput" },
    },
    createdPurchaseOrderAggregate: {
      __type: "PurchaseOrderAggregate",
      __args: { filter: "PurchaseOrderFilterInput" },
    },
    createdPurchaseOrderLineAggregate: {
      __type: "PurchaseOrderLineAggregate",
      __args: { filter: "PurchaseOrderLineFilterInput" },
    },
    monthNumber: { __type: "String!" },
    monthNumberAndYear: { __type: "String!" },
    quoteLineAggregateByJobEstDue: {
      __type: "QuoteLineAggregate",
      __args: { filter: "QuoteLineFilterInput" },
    },
    year: { __type: "String!" },
  },
  NZRegion: {
    __typename: { __type: "String!" },
    id: { __type: "String!" },
    jobAggregate: {
      __type: "JobAggregate",
      __args: { filter: "JobFilterInput" },
    },
    name: { __type: "String!" },
  },
  NotificationAttachmentInput: {
    bodyTemplateId: { __type: "ID" },
    filename: { __type: "String!" },
    type: { __type: "String!" },
  },
  NotificationInput: {
    attachments: { __type: "[NotificationAttachmentInput!]!" },
    bodyTemplateId: { __type: "ID" },
    type: { __type: "String!" },
  },
  NotificationTemplate: {
    __typename: { __type: "String!" },
    attachmentTemplates: {
      __type: "[AttachmentTemplate!]!",
      __args: { filter: "AttachmentTemplateFilterInput" },
    },
    bodyTemplateId: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    subscription: { __type: "SubscriptionReal" },
    type: { __type: "String!" },
  },
  NotificationTemplateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  NotificationTemplateFilterInput: {
    and: { __type: "[NotificationTemplateFilterInput!]" },
    attachmentTemplates: { __type: "AttachmentTemplateFilterInput" },
    bodyTemplateId: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[NotificationTemplateFilterInput!]" },
    subscription: { __type: "SubscriptionRealFilterInput" },
    type: { __type: "StringFilterInput" },
  },
  NumberFilterInput: {
    eq: { __type: "Int" },
    gt: { __type: "Int" },
    gte: { __type: "Int" },
    in: { __type: "[Int!]" },
    lt: { __type: "Int" },
    lte: { __type: "Int" },
  },
  OptionsInput: {
    groupBy: { __type: "StringFilterInput" },
    limit: { __type: "Int" },
    offset: { __type: "Int" },
    sort: { __type: "[SortInput!]" },
  },
  OrderEmailStatusUpdatedEvent: {
    __typename: { __type: "String!" },
    orderEmail: { __type: "String!" },
  },
  OrderOverrideStatusEvent: {
    __typename: { __type: "String!" },
    newStatus: { __type: "String!" },
    oldStatus: { __type: "String" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  OrderReceiptCreatedEvent: {
    __typename: { __type: "String!" },
    lineData: { __type: "[String]!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
    receiptId: { __type: "Int!" },
    warehouseId: { __type: "Int!" },
  },
  OrderRevisionCreatedEvent: {
    __typename: { __type: "String!" },
    orderRevision: { __type: "String!" },
  },
  OverrideLeadStatusInput: {
    leadId: { __type: "ID!" },
    status: { __type: "String!" },
  },
  OverridePurchaseOrderStatusInput: {
    purchaseOrderId: { __type: "ID!" },
    status: { __type: "OrderStatus!" },
  },
  PageInfo: {
    __typename: { __type: "String!" },
    limit: { __type: "Int!" },
    offset: { __type: "Int!" },
    totalCount: { __type: "Int!" },
  },
  PagedJobs: {
    __typename: { __type: "String!" },
    items: { __type: "[Job!]!" },
    pageInfo: { __type: "PageInfo!" },
  },
  PaginatedResult: {
    __typename: { __type: "String!" },
    pageInfo: { __type: "PageInfo!" },
  },
  PaginatedResultInterface: {
    __typename: { __type: "String!" },
    pageInfo: { __type: "PageInfo!" },
    $on: { __type: "$PaginatedResultInterface!" },
  },
  Panel: {
    __typename: { __type: "String!" },
    compatibleRecordTypes: { __type: "[String!]" },
    config: { __type: "String!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    modified: { __type: "String!" },
    name: { __type: "String!" },
    recordTags: {
      __type: "[RecordTag!]!",
      __args: { filter: "RecordTagFilterInput" },
    },
    source: { __type: "String!" },
    type: { __type: "String!" },
  },
  PanelAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  PanelFilterInput: {
    and: { __type: "[PanelFilterInput!]" },
    config: { __type: "StringFilterInput" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[PanelFilterInput!]" },
    recordTags: { __type: "RecordTagFilterInput" },
    type: { __type: "StringFilterInput" },
  },
  PartType: {
    __typename: { __type: "String!" },
    code: { __type: "String!" },
    colour: { __type: "String!" },
    created: { __type: "DateTime" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deleted: { __type: "Boolean!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    modified: { __type: "DateTime" },
    name: { __type: "String!" },
  },
  PartTypeAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  PartTypeCreatedEvent: {
    __typename: { __type: "String!" },
    partTypeId: { __type: "String!" },
    partTypeName: { __type: "String!" },
  },
  PartTypeDeletedEvent: {
    __typename: { __type: "String!" },
    partTypeId: { __type: "String!" },
    partTypeName: { __type: "String!" },
  },
  PartTypeFilterInput: {
    and: { __type: "[PartTypeFilterInput!]" },
    code: { __type: "StringFilterInput" },
    colour: { __type: "StringFilterInput" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "DateTimeFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[PartTypeFilterInput!]" },
  },
  PartTypeReportDimensionValue: {
    __typename: { __type: "String!" },
    created: { __type: "ReportDimensionValue" },
    key: { __type: "String" },
    label: { __type: "String" },
    modified: { __type: "ReportDimensionValue" },
  },
  PartTypeReportGroupByInput: {
    created: { __type: "DateTimeReportDimensionInput" },
    modified: { __type: "DateTimeReportDimensionInput" },
  },
  PartTypeReportRelationDimensionInput: {
    filter: { __type: "PartTypeFilterInput" },
    groupBy: { __type: "PartTypeReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  PartTypeRestoredEvent: {
    __typename: { __type: "String!" },
    partTypeId: { __type: "String!" },
    partTypeName: { __type: "String!" },
  },
  PartTypeUpdatedEvent: {
    __typename: { __type: "String!" },
    partTypeId: { __type: "String!" },
    partTypeName: { __type: "String!" },
  },
  Permission: {
    __typename: { __type: "String!" },
    category: { __type: "String!" },
    categoryGroup: { __type: "String!" },
    conditionalPolicyInputType: { __type: "String" },
    description: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  PermissionCheckInput: {
    conditions: { __type: "String" },
    permission: { __type: "String!" },
  },
  PermissionFilterInput: {
    id: { __type: "IDFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
  },
  PermissionInput: {
    conditions: { __type: "String" },
    permissionId: { __type: "String!" },
    policy: { __type: "Policy!" },
  },
  PermissionPolicy: {
    __typename: { __type: "String!" },
    conditions: { __type: "String" },
    permission: { __type: "Permission!" },
    policy: { __type: "Policy!" },
    role: { __type: "Role" },
  },
  PermissionScope: {
    __typename: { __type: "String!" },
    description: { __type: "String!" },
    id: { __type: "String!" },
    name: { __type: "String!" },
  },
  Person: {
    __typename: { __type: "String!" },
    assignedDesignerLeadCount: { __type: "Int!" },
    assignedWork: {
      __type: "[PersonAssignedWork!]!",
      __args: { filter: "PersonAssignedWorkFilterInput" },
    },
    branch: { __type: "Branch" },
    businessRoleLabels: { __type: "String!" },
    confirmedDesignerJobCount: { __type: "Int!" },
    connectedUser: { __type: "User" },
    created: { __type: "DateTime!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    designerPreviousYtdSales: { __type: "Float" },
    designerSalesYtd: { __type: "Float" },
    id: { __type: "ID!" },
    isActive: { __type: "Boolean!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    outstandingDesignerQuoteCount: { __type: "Int!" },
    personBusinessRoles: {
      __type: "[PersonBusinessRole!]!",
      __args: { filter: "PersonBusinessRoleFilterInput" },
    },
    processTimeTodaySeconds: { __type: "Int!" },
    unconfirmedDesignerJobCount: { __type: "Int!" },
  },
  PersonAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  PersonAssignedWork: {
    __typename: { __type: "String!" },
    assignmentType: { __type: "String!" },
    businessRole: { __type: "BusinessRole" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    person: { __type: "Person!" },
    personBusinessRole: { __type: "PersonBusinessRole" },
    record: { __type: "PersonAssignedWorkRecordReference!" },
    recordId: { __type: "ID!" },
    recordLabel: { __type: "String!" },
    recordType: { __type: "String!" },
    status: { __type: "String" },
    statusLabel: { __type: "String!" },
  },
  PersonAssignedWorkAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  PersonAssignedWorkFilterInput: {
    and: { __type: "[PersonAssignedWorkFilterInput!]" },
    assignmentType: { __type: "StringFilterInput" },
    businessRole: { __type: "BusinessRoleFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[PersonAssignedWorkFilterInput!]" },
    person: { __type: "PersonFilterInput" },
    personBusinessRole: { __type: "PersonBusinessRoleFilterInput" },
    recordId: { __type: "IDFilterInput" },
    recordLabel: { __type: "StringFilterInput" },
    recordType: { __type: "StringFilterInput" },
    status: { __type: "StringFilterInput" },
    statusLabel: { __type: "StringFilterInput" },
  },
  PersonAssignedWorkRecordReference: {
    __typename: { __type: "String!" },
    recordId: { __type: "ID!" },
    recordType: { __type: "String!" },
  },
  PersonBusinessRole: {
    __typename: { __type: "String!" },
    assignedWork: {
      __type: "[PersonAssignedWork!]!",
      __args: { filter: "PersonAssignedWorkFilterInput" },
    },
    businessRole: { __type: "BusinessRole!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    isActive: { __type: "Boolean!" },
    jobs: {
      __type: "[Job!]!",
      __args: { filter: "JobFilterInput", options: "OptionsInput" },
    },
    label: { __type: "String!" },
    person: { __type: "Person!" },
    processAssignments: {
      __type: "[ProcessAssignment!]!",
      __args: { filter: "ProcessAssignmentFilterInput" },
    },
  },
  PersonBusinessRoleAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  PersonBusinessRoleFilterInput: {
    and: { __type: "[PersonBusinessRoleFilterInput!]" },
    assignedWork: { __type: "PersonAssignedWorkFilterInput" },
    businessRole: { __type: "BusinessRoleFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isActive: { __type: "BooleanFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[PersonBusinessRoleFilterInput!]" },
    person: { __type: "PersonFilterInput" },
    processAssignments: { __type: "ProcessAssignmentFilterInput" },
  },
  PersonBusinessRoleReportDimensionValue: {
    __typename: { __type: "String!" },
    businessRole: { __type: "BusinessRoleReportDimensionValue" },
    key: { __type: "String" },
    label: { __type: "String" },
    person: { __type: "PersonReportDimensionValue" },
  },
  PersonBusinessRoleReportGroupByInput: {
    businessRole: { __type: "BusinessRoleReportRelationDimensionInput" },
    person: { __type: "PersonReportRelationDimensionInput" },
  },
  PersonBusinessRoleReportRelationDimensionInput: {
    filter: { __type: "PersonBusinessRoleFilterInput" },
    groupBy: { __type: "PersonBusinessRoleReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  PersonFilterInput: {
    and: { __type: "[PersonFilterInput!]" },
    assignedWork: { __type: "PersonAssignedWorkFilterInput" },
    branch: { __type: "BranchFilterInput" },
    businessRoleLabels: { __type: "StringFilterInput" },
    connectedUser: { __type: "UserFilterInput" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    hasActiveSystemAccess: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    includeInactive: { __type: "BooleanFilterInput" },
    isActive: { __type: "BooleanFilterInput" },
    isCurrentUser: { __type: "BooleanFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[PersonFilterInput!]" },
    personBusinessRoles: { __type: "PersonBusinessRoleFilterInput" },
    projectManagedJobs: { __type: "JobFilterInput" },
  },
  PersonReportDimensionValue: {
    __typename: { __type: "String!" },
    branch: { __type: "BranchReportDimensionValue" },
    connectedUser: { __type: "UserReportDimensionValue" },
    created: { __type: "ReportDimensionValue" },
    key: { __type: "String" },
    label: { __type: "String" },
  },
  PersonReportGroupByInput: {
    branch: { __type: "BranchReportRelationDimensionInput" },
    connectedUser: { __type: "UserReportRelationDimensionInput" },
    created: { __type: "DateTimeReportDimensionInput" },
  },
  PersonReportRelationDimensionInput: {
    filter: { __type: "PersonFilterInput" },
    groupBy: { __type: "PersonReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  PersonStatus: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    name: { __type: "String!" },
    peopleAggregate: {
      __type: "PersonAggregate",
      __args: { filter: "PersonFilterInput" },
    },
  },
  ProcessAsset: {
    __typename: { __type: "String!" },
    asset: { __type: "Asset" },
    assetId: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "String!" },
    label: { __type: "String!" },
    lineItemMasterWorkflow: { __type: "LineItemMasterWorkflow" },
    processType: { __type: "ProcessType" },
    processTypeId: { __type: "String!" },
    workflowSubjectId: { __type: "String!" },
  },
  ProcessAssetAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProcessAssetFilterInput: {
    and: { __type: "[ProcessAssetFilterInput!]" },
    asset: { __type: "AssetFilterInput" },
    assetId: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "StringFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    lineItemMasterWorkflow: { __type: "LineItemMasterWorkflowFilterInput" },
    or: { __type: "[ProcessAssetFilterInput!]" },
    processType: { __type: "ProcessTypeFilterInput" },
    processTypeId: { __type: "StringFilterInput" },
    workflowSubjectId: { __type: "StringFilterInput" },
  },
  ProcessAssignment: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "String!" },
    label: { __type: "String!" },
    personBusinessRoleId: { __type: "ID" },
    processType: { __type: "ProcessType!" },
    processTypeId: { __type: "String!" },
    userRole: { __type: "UserRole" },
    userRoleId: { __type: "String!" },
    workflowSubject: { __type: "LineItemMasterWorkflow!" },
    workflowSubjectId: { __type: "String!" },
  },
  ProcessAssignmentAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProcessAssignmentFilterInput: {
    and: { __type: "[ProcessAssignmentFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "StringFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    lineItemMasterWorkflow: { __type: "LineItemMasterWorkflowFilterInput" },
    or: { __type: "[ProcessAssignmentFilterInput!]" },
    personBusinessRoleId: { __type: "IDFilterInput" },
    processType: { __type: "ProcessTypeFilterInput" },
    processTypeId: { __type: "StringFilterInput" },
    userRole: { __type: "UserRoleFilterInput" },
    userRoleId: { __type: "StringFilterInput" },
    workflowSubject: { __type: "LineItemMasterWorkflowFilterInput" },
    workflowSubjectId: { __type: "StringFilterInput" },
  },
  ProcessInstance: {
    __typename: { __type: "String!" },
    assignableUserRoles: { __type: "[UserRole!]!" },
    assignedHours: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    dueDate: { __type: "String" },
    elapsedTime: { __type: "Int" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    leadDays: { __type: "Int" },
    lineItemMasterWorkflow: { __type: "LineItemMasterWorkflow" },
    processAssets: { __type: "[ProcessAsset!]!" },
    processAssignments: { __type: "[ProcessAssignment!]!" },
    processType: { __type: "ProcessType" },
    scheduled: { __type: "String" },
    startBy: { __type: "String" },
    status: { __type: "Int" },
    workflow: { __type: "Workflow" },
  },
  ProcessInstanceAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProcessInstanceFilterInput: {
    and: { __type: "[ProcessInstanceFilterInput!]" },
    assignedHours: { __type: "StringFilterInput" },
    assignedUsers: { __type: "UserFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    dueDate: { __type: "DateTimeFilterInput" },
    elapsedTime: { __type: "NumberFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    leadDays: { __type: "NumberFilterInput" },
    lineItemMasterWorkflow: { __type: "LineItemMasterWorkflowFilterInput" },
    or: { __type: "[ProcessInstanceFilterInput!]" },
    ordered: { __type: "BooleanFilterInput" },
    processAssignments: { __type: "ProcessAssignmentFilterInput" },
    processType: { __type: "ProcessTypeFilterInput" },
    scheduled: { __type: "DateTimeFilterInput" },
    startBy: { __type: "DateTimeFilterInput" },
    status: { __type: "IDFilterInput" },
    workflow: { __type: "WorkflowFilterInput" },
  },
  ProcessTemplate: {
    __typename: { __type: "String!" },
    assignedHours: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    leadDays: { __type: "Int" },
    name: { __type: "String!" },
    processType: { __type: "ProcessType" },
  },
  ProcessTemplateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProcessTemplateFilterInput: {
    and: { __type: "[ProcessTemplateFilterInput!]" },
    assignedHours: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    leadDays: { __type: "NumberFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[ProcessTemplateFilterInput!]" },
    processType: { __type: "ProcessTypeFilterInput" },
  },
  ProcessTimer: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    elapsedTime: { __type: "Int" },
    id: { __type: "ID!" },
    itemAggregate: {
      __type: "ProcessTimerItemAggregate",
      __args: { filter: "ProcessTimerItemFilterInput" },
    },
    items: {
      __type: "[ProcessTimerItem!]!",
      __args: { filter: "ProcessTimerItemFilterInput" },
    },
    label: { __type: "String!" },
    status: { __type: "String" },
    transactions: {
      __type: "[TimerTransaction!]!",
      __args: { filter: "TimerTransactionFilterInput" },
    },
    type: { __type: "String" },
    user: { __type: "User!" },
  },
  ProcessTimerAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProcessTimerFilterInput: {
    and: { __type: "[ProcessTimerFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    elapsedTime: { __type: "NumberFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    items: { __type: "ProcessTimerItemFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[ProcessTimerFilterInput!]" },
    status: { __type: "StringFilterInput" },
    transactions: { __type: "TimerTransactionFilterInput" },
    type: { __type: "StringFilterInput" },
    user: { __type: "UserFilterInput" },
  },
  ProcessTimerItem: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    lineItemMasterWorkflow: { __type: "LineItemMasterWorkflow!" },
    processType: { __type: "ProcessType!" },
    processTypeId: { __type: "String!" },
    timer: { __type: "ProcessTimer!" },
    timerId: { __type: "String!" },
    workflowSubjectId: { __type: "String!" },
  },
  ProcessTimerItemAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProcessTimerItemFilterInput: {
    and: { __type: "[ProcessTimerItemFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    lineItemMasterWorkflow: { __type: "LineItemMasterWorkflowFilterInput" },
    or: { __type: "[ProcessTimerItemFilterInput!]" },
    processType: { __type: "ProcessTypeFilterInput" },
    processTypeId: { __type: "StringFilterInput" },
    timer: { __type: "ProcessTimerFilterInput" },
    timerId: { __type: "StringFilterInput" },
    workflowSubjectId: { __type: "StringFilterInput" },
  },
  ProcessType: {
    __typename: { __type: "String!" },
    assignments: {
      __type: "[ProcessAssignment!]!",
      __args: { filter: "ProcessAssignmentFilterInput" },
    },
    code: { __type: "String!" },
    created: { __type: "DateTime!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deleted: { __type: "Boolean!" },
    description: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    modified: { __type: "DateTime!" },
    name: { __type: "String!" },
    roles: {
      __type: "[ProcessTypeRole!]!",
      __args: { filter: "ProcessTypeRoleFilterInput" },
    },
  },
  ProcessTypeAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProcessTypeCreatedEvent: {
    __typename: { __type: "String!" },
    processTypeId: { __type: "String!" },
    processTypeName: { __type: "String!" },
  },
  ProcessTypeDeletedEvent: {
    __typename: { __type: "String!" },
    processTypeId: { __type: "String!" },
    processTypeName: { __type: "String!" },
  },
  ProcessTypeFilterInput: {
    and: { __type: "[ProcessTypeFilterInput!]" },
    assignments: { __type: "ProcessAssignmentFilterInput" },
    code: { __type: "StringFilterInput" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "DateTimeFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[ProcessTypeFilterInput!]" },
    processInstances: { __type: "ProcessInstanceFilterInput" },
    roles: { __type: "ProcessTypeRoleFilterInput" },
  },
  ProcessTypeNote: {
    __typename: { __type: "String!" },
    assignedProcessTypes: { __type: "[ProcessType!]!" },
    created: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    date: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    note: { __type: "String" },
  },
  ProcessTypeNoteAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProcessTypeNoteFilterInput: {
    and: { __type: "[ProcessTypeNoteFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    date: { __type: "DateTimeFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    note: { __type: "StringFilterInput" },
    or: { __type: "[ProcessTypeNoteFilterInput!]" },
    processType: { __type: "ProcessTypeFilterInput" },
  },
  ProcessTypeReportDimensionValue: {
    __typename: { __type: "String!" },
    created: { __type: "ReportDimensionValue" },
    key: { __type: "String" },
    label: { __type: "String" },
    modified: { __type: "ReportDimensionValue" },
  },
  ProcessTypeReportGroupByInput: {
    created: { __type: "DateTimeReportDimensionInput" },
    modified: { __type: "DateTimeReportDimensionInput" },
  },
  ProcessTypeReportRelationDimensionInput: {
    filter: { __type: "ProcessTypeFilterInput" },
    groupBy: { __type: "ProcessTypeReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  ProcessTypeRestoredEvent: {
    __typename: { __type: "String!" },
    processTypeId: { __type: "String!" },
    processTypeName: { __type: "String!" },
  },
  ProcessTypeRole: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    processType: { __type: "ProcessType!" },
    roleType: { __type: "String!" },
  },
  ProcessTypeRoleAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProcessTypeRoleFilterInput: {
    and: { __type: "[ProcessTypeRoleFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[ProcessTypeRoleFilterInput!]" },
    processType: { __type: "ProcessTypeFilterInput" },
    roleType: { __type: "StringFilterInput" },
  },
  ProcessTypeUpdatedEvent: {
    __typename: { __type: "String!" },
    processTypeId: { __type: "String!" },
    processTypeName: { __type: "String!" },
  },
  Product: {
    __typename: { __type: "String!" },
    availableStock: { __type: "Float" },
    category: { __type: "ProductCategory" },
    code: { __type: "String" },
    currentBuyPrice: { __type: "Float" },
    currentSellPrice: { __type: "Float" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    daysStockLeft: { __type: "Int" },
    deleted: { __type: "Boolean!" },
    forecastedDemandQty: { __type: "Float!" },
    forecastedReorderUrgencyQty: { __type: "Float!" },
    forecastedStockRemainingQty: { __type: "Float!" },
    id: { __type: "ID!" },
    image: { __type: "ExternalStorageItem" },
    indent: { __type: "Boolean!" },
    isStockItem: { __type: "Boolean!" },
    label: { __type: "String!" },
    leadTime: { __type: "Int" },
    name: { __type: "String!" },
    purchaseOrderLineAggregate: {
      __type: "PurchaseOrderLineAggregate",
      __args: { filter: "PurchaseOrderLineFilterInput" },
    },
    qtyReviewThreshold: { __type: "Int" },
    quoteLineAggregate: {
      __type: "QuoteLineAggregate",
      __args: { filter: "QuoteLineFilterInput" },
    },
    recordTags: {
      __type: "[RecordTag!]!",
      __args: { filter: "RecordTagFilterInput" },
    },
    reorderLevel: { __type: "Float" },
    safetyStockDays: { __type: "Float!" },
    safetyStockQty: { __type: "Float!" },
    starred: { __type: "Boolean!" },
    stock: { __type: "[Stock]", __args: { filter: "StockFilterInput" } },
    stockByWarehouse: {
      __type: "[Stock!]!",
      __args: { filter: "StockFilterInput" },
    },
    stockGapDays: { __type: "Int" },
    stockedQty: { __type: "Float" },
    supplier: { __type: "Supplier" },
    template: { __type: "Boolean!" },
    type: { __type: "Int" },
    unitOfMeasure: { __type: "String" },
    url: { __type: "String" },
  },
  ProductAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProductCategory: {
    __typename: { __type: "String!" },
    childProductCategoriesAggregate: {
      __type: "ProductCategoryAggregate",
      __args: { filter: "ProductCategoryFilterInput" },
    },
    children: {
      __type: "[ProductCategory!]!",
      __args: { filter: "ProductCategoryFilterInput" },
    },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    group: { __type: "ProductCategoryGroup!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    parent: { __type: "ProductCategory" },
    products: { __type: "[Product]", __args: { filter: "ProductFilterInput" } },
  },
  ProductCategoryAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProductCategoryFilterInput: {
    and: { __type: "[ProductCategoryFilterInput!]" },
    children: { __type: "ProductCategoryFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    group: { __type: "ProductCategoryGroupFilterInput" },
    id: { __type: "IDFilterInput" },
    includeSubCategories: { __type: "BooleanFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[ProductCategoryFilterInput!]" },
    parent: { __type: "ProductCategoryFilterInput" },
    products: { __type: "ProductFilterInput" },
  },
  ProductCategoryGroup: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  ProductCategoryGroupAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProductCategoryGroupFilterInput: {
    and: { __type: "[ProductCategoryGroupFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[ProductCategoryGroupFilterInput!]" },
  },
  ProductCreatedEvent: {
    __typename: { __type: "String!" },
    productId: { __type: "String!" },
    productName: { __type: "String!" },
  },
  ProductDetailsUpdatedEvent: {
    __typename: { __type: "String!" },
    productId: { __type: "String!" },
    productName: { __type: "String!" },
  },
  ProductFilterInput: {
    and: { __type: "[ProductFilterInput!]" },
    category: { __type: "ProductCategoryFilterInput" },
    code: { __type: "StringFilterInput" },
    currentBuyPrice: { __type: "NumberFilterInput" },
    currentSellPrice: { __type: "NumberFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    indent: { __type: "BooleanFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    isStockItem: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    leadTime: { __type: "NumberFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[ProductFilterInput!]" },
    qtyReviewThreshold: { __type: "NumberFilterInput" },
    recordTags: { __type: "RecordTagFilterInput" },
    safetyStockDays: { __type: "NumberFilterInput" },
    starred: { __type: "BooleanFilterInput" },
    stock: { __type: "StockFilterInput" },
    stockByWarehouse: { __type: "StockFilterInput" },
    stockedQty: { __type: "NumberFilterInput" },
    supplier: { __type: "SupplierFilterInput" },
    template: { __type: "BooleanFilterInput" },
    type: { __type: "NumberFilterInput" },
    unitOfMeasure: { __type: "StringFilterInput" },
    url: { __type: "StringFilterInput" },
  },
  ProductImportInput: {
    buyPrice: { __type: "String" },
    buyPriceEffectiveDate: { __type: "String" },
    category: { __type: "String" },
    code: { __type: "String!" },
    description: { __type: "String!" },
    id: { __type: "ID!" },
    operation: { __type: "String!" },
    productId: { __type: "ID" },
    supplier: { __type: "String!" },
  },
  ProductPrice: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deleted: { __type: "Boolean!" },
    effectiveDate: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    product: { __type: "Product!" },
    type: { __type: "Int!" },
    unitPrice: { __type: "Float" },
  },
  ProductPriceAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProductPriceCreatedEvent: {
    __typename: { __type: "String!" },
    entity: { __type: "String!" },
  },
  ProductPriceDeletedEvent: {
    __typename: { __type: "String!" },
    entity: { __type: "String!" },
  },
  ProductPriceFilterInput: {
    and: { __type: "[ProductPriceFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    effectiveDate: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[ProductPriceFilterInput!]" },
    product: { __type: "ProductFilterInput" },
    type: { __type: "NumberFilterInput" },
    unitPrice: { __type: "NumberFilterInput" },
  },
  Project: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    modified: { __type: "String!" },
    name: { __type: "String!" },
  },
  ProjectAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ProjectFilterInput: {
    and: { __type: "[ProjectFilterInput!]" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[ProjectFilterInput!]" },
  },
  PromoteSchemaVersionInput: { schemaVersionId: { __type: "ID!" } },
  PurchaseOrder: {
    __typename: { __type: "String!" },
    acknowledgedBy: { __type: "String" },
    amended: { __type: "Boolean!" },
    approved: { __type: "Boolean!" },
    category: { __type: "String" },
    created: { __type: "DateTime" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deliveryAddress: { __type: "String" },
    deliveryAddressEntity: { __type: "DeliveryAddress" },
    documents: {
      __type: "[Document!]!",
      __args: { filter: "DocumentTemplateFilterInput" },
    },
    emails: { __type: "[Email!]!", __args: { filter: "EmailFilterInput" } },
    id: { __type: "ID!" },
    incomplete: { __type: "Boolean!" },
    internalComment: { __type: "String" },
    invoiceChecked: { __type: "Boolean!" },
    job: { __type: "Job" },
    label: { __type: "String!" },
    lines: {
      __type: "[PurchaseOrderLine!]!",
      __args: { filter: "PurchaseOrderLineFilterInput" },
    },
    notificationStatus: { __type: "Int" },
    notifySupplierWhenPlaced: { __type: "Boolean!" },
    placedBy: { __type: "User" },
    poNumber: { __type: "String" },
    purchaseOrderLineAggregate: {
      __type: "PurchaseOrderLineAggregate",
      __args: { filter: "PurchaseOrderLineFilterInput" },
    },
    reference: { __type: "String!" },
    required: { __type: "DateTime" },
    reviews: {
      __type: "[PurchaseOrderReview!]!",
      __args: { filter: "PurchaseOrderReviewFilterInput" },
    },
    shippingMethod: { __type: "String" },
    shippingTerms: { __type: "String" },
    siteVisitRequired: { __type: "Boolean!" },
    ssspCompleted: { __type: "Boolean!" },
    status: { __type: "Int" },
    statusWhenPlaced: { __type: "String" },
    supplier: { __type: "Supplier" },
    supplierComment: { __type: "String" },
    supplierStatus: { __type: "Int" },
    template: { __type: "DocumentTemplate" },
    urgent: { __type: "Boolean!" },
    warehouse: { __type: "Warehouse" },
  },
  PurchaseOrderAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    incompleteSupplierSssp: { __type: "Boolean!" },
  },
  PurchaseOrderAmendedEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  PurchaseOrderApprovedEvent: {
    __typename: { __type: "String!" },
    comment: { __type: "String" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
    placedByUserId: { __type: "String!" },
  },
  PurchaseOrderCancelledEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  PurchaseOrderEvent: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    id: { __type: "ID!" },
    payload: { __type: "String" },
    purchaseOrder: { __type: "PurchaseOrder" },
    type: { __type: "Int!" },
    userId: { __type: "String!" },
  },
  PurchaseOrderEventFilterInput: {
    created: { __type: "DateTimeFilterInput" },
    id: { __type: "IDFilterInput" },
    purchaseOrder: { __type: "PurchaseOrderFilterInput" },
    type: { __type: "NumberFilterInput" },
    user: { __type: "UserFilterInput" },
  },
  PurchaseOrderFilterInput: {
    acknowledgedBy: { __type: "StringFilterInput" },
    amended: { __type: "BooleanFilterInput" },
    and: { __type: "[PurchaseOrderFilterInput!]" },
    approved: { __type: "BooleanFilterInput" },
    category: { __type: "StringFilterInput" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deliveryAddress: { __type: "StringFilterInput" },
    deliveryAddressEntity: { __type: "DeliveryAddressFilterInput" },
    emails: { __type: "EmailFilterInput" },
    id: { __type: "IDFilterInput" },
    incomplete: { __type: "BooleanFilterInput" },
    internalComment: { __type: "StringFilterInput" },
    invoiceChecked: { __type: "BooleanFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    job: { __type: "JobFilterInput" },
    label: { __type: "StringFilterInput" },
    lines: { __type: "PurchaseOrderLineFilterInput" },
    notificationStatus: { __type: "NumberFilterInput" },
    notifySupplierWhenPlaced: { __type: "BooleanFilterInput" },
    or: { __type: "[PurchaseOrderFilterInput!]" },
    placedBy: { __type: "UserFilterInput" },
    poNumber: { __type: "StringFilterInput" },
    reference: { __type: "StringFilterInput" },
    required: { __type: "DateTimeFilterInput" },
    reviews: { __type: "PurchaseOrderReviewFilterInput" },
    shippingMethod: { __type: "StringFilterInput" },
    shippingTerms: { __type: "StringFilterInput" },
    siteVisitRequired: { __type: "BooleanFilterInput" },
    ssspCompleted: { __type: "BooleanFilterInput" },
    status: { __type: "PurchaseOrderStatusFilterInput" },
    statusWhenPlaced: { __type: "StringFilterInput" },
    supplier: { __type: "SupplierFilterInput" },
    supplierComment: { __type: "StringFilterInput" },
    supplierStatus: { __type: "NumberFilterInput" },
    template: { __type: "DocumentTemplateFilterInput" },
    urgent: { __type: "BooleanFilterInput" },
    warehouse: { __type: "WarehouseFilterInput" },
  },
  PurchaseOrderIncompleteEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  PurchaseOrderLine: {
    __typename: { __type: "String!" },
    buyPrice: { __type: "Float" },
    code: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    line: { __type: "Int!" },
    orderedQty: { __type: "Float" },
    product: { __type: "Product" },
    purchaseOrder: { __type: "PurchaseOrder" },
    receivedQty: { __type: "Float" },
    totalPrice: { __type: "String" },
    unit: { __type: "String" },
  },
  PurchaseOrderLineAggregate: {
    __typename: { __type: "String!" },
    averageDailyQuantity: { __type: "Float!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    id: { __type: "ID!" },
    quantity: { __type: "Float!" },
  },
  PurchaseOrderLineFilterInput: {
    and: { __type: "[PurchaseOrderLineFilterInput!]" },
    buyPrice: { __type: "NumberFilterInput" },
    code: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    line: { __type: "NumberFilterInput" },
    or: { __type: "[PurchaseOrderLineFilterInput!]" },
    orderedQty: { __type: "NumberFilterInput" },
    product: { __type: "ProductFilterInput" },
    purchaseOrder: { __type: "PurchaseOrderFilterInput" },
    receivedQty: { __type: "NumberFilterInput" },
    unit: { __type: "StringFilterInput" },
  },
  PurchaseOrderLineInput: {
    buyPrice: { __type: "String" },
    code: { __type: "String" },
    description: { __type: "String" },
    product: { __type: "ID" },
    quantity: { __type: "String" },
    unit: { __type: "String" },
  },
  PurchaseOrderPendingReviewEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  PurchaseOrderPlacedEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  PurchaseOrderPreview: {
    __typename: { __type: "String!" },
    html: { __type: "String!" },
  },
  PurchaseOrderReceipt: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "String!" },
    label: { __type: "String!" },
    lines: {
      __type: "[PurchaseOrderReceiptLine!]!",
      __args: { filter: "PurchaseOrderReceiptLineFilterInput" },
    },
    notes: { __type: "String" },
    purchaseOrder: { __type: "PurchaseOrder" },
    reference: { __type: "String" },
    user: { __type: "User" },
  },
  PurchaseOrderReceiptAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  PurchaseOrderReceiptFilterInput: {
    and: { __type: "[PurchaseOrderReceiptFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    lines: { __type: "PurchaseOrderReceiptLineFilterInput" },
    notes: { __type: "StringFilterInput" },
    or: { __type: "[PurchaseOrderReceiptFilterInput!]" },
    purchaseOrder: { __type: "PurchaseOrderFilterInput" },
    reference: { __type: "StringFilterInput" },
    user: { __type: "UserFilterInput" },
  },
  PurchaseOrderReceiptLine: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "String" },
    label: { __type: "String!" },
    line: { __type: "PurchaseOrderLine" },
    quantity: { __type: "Float" },
    receipt: { __type: "PurchaseOrderReceipt" },
  },
  PurchaseOrderReceiptLineAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  PurchaseOrderReceiptLineFilterInput: {
    and: { __type: "[PurchaseOrderReceiptLineFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    line: { __type: "PurchaseOrderLineFilterInput" },
    or: { __type: "[PurchaseOrderReceiptLineFilterInput!]" },
    quantity: { __type: "StringFilterInput" },
    receipt: { __type: "PurchaseOrderReceiptFilterInput" },
  },
  PurchaseOrderReceiptLineInput: {
    orderLineId: { __type: "ID!" },
    quantity: { __type: "Float!" },
  },
  PurchaseOrderReceivedEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  PurchaseOrderRejectedEvent: {
    __typename: { __type: "String!" },
    comment: { __type: "String" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
    placedByUserId: { __type: "String!" },
  },
  PurchaseOrderReleasedEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  PurchaseOrderReview: {
    __typename: { __type: "String!" },
    comment: { __type: "String" },
    completedAt: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    purchaseOrder: { __type: "PurchaseOrder" },
    status: { __type: "Int" },
    user: { __type: "User" },
    userId: { __type: "String" },
  },
  PurchaseOrderReviewAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  PurchaseOrderReviewFilterInput: {
    and: { __type: "[PurchaseOrderReviewFilterInput!]" },
    comment: { __type: "StringFilterInput" },
    completedAt: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[PurchaseOrderReviewFilterInput!]" },
    purchaseOrder: { __type: "PurchaseOrderFilterInput" },
    status: { __type: "NumberFilterInput" },
    user: { __type: "UserFilterInput" },
    userId: { __type: "StringFilterInput" },
  },
  PurchaseOrderSavePayload: {
    __typename: { __type: "String!" },
    purchaseOrderId: { __type: "ID!" },
    status: { __type: "OrderStatus!" },
  },
  PurchaseOrderStatus: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    purchaseOrderAggregate: {
      __type: "PurchaseOrderAggregate",
      __args: { filter: "PurchaseOrderFilterInput" },
    },
  },
  PurchaseOrderStatusFilterInput: {
    id: { __type: "IDFilterInput" },
    purchaseOrders: { __type: "PurchaseOrderFilterInput" },
  },
  PurchaseOrderSupplierNotificationManuallySentEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderReference: { __type: "String" },
  },
  PurchaseOrderSupplierNotificationSentEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderReference: { __type: "String" },
  },
  Quote: {
    __typename: { __type: "String!" },
    acceptedAt: { __type: "DateTime" },
    clientAddress: { __type: "String!" },
    clientName: { __type: "String!" },
    contactName: { __type: "String!" },
    created: { __type: "String!" },
    currentRevision: { __type: "QuoteRevision" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    issuedAt: { __type: "DateTime" },
    job: { __type: "Job" },
    label: { __type: "String!" },
    lineItem: { __type: "LineItem" },
    lines: { __type: "[QuoteLine!]!" },
    quoteNumber: { __type: "String" },
    quoteTemplateRevision: { __type: "QuoteTemplateRevision" },
    reference: { __type: "String!" },
    salesTax: { __type: "String!" },
    status: { __type: "Int!" },
    subTotal: { __type: "String!" },
    total: { __type: "String!" },
    version: { __type: "Int!" },
  },
  QuoteAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    total: { __type: "Float!" },
  },
  QuoteApprovalRequestedEvent: {
    __typename: { __type: "String!" },
    quote: { __type: "String!" },
    user: { __type: "String!" },
  },
  QuoteFilterInput: {
    acceptedAt: { __type: "DateTimeFilterInput" },
    and: { __type: "[QuoteFilterInput!]" },
    clientAddress: { __type: "StringFilterInput" },
    clientName: { __type: "StringFilterInput" },
    contactName: { __type: "StringFilterInput" },
    created: { __type: "StringFilterInput" },
    currentRevision: { __type: "QuoteRevisionFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    issuedAt: { __type: "DateTimeFilterInput" },
    job: { __type: "JobFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[QuoteFilterInput!]" },
    quoteNumber: { __type: "StringFilterInput" },
    quoteTemplateRevision: { __type: "QuoteTemplateRevisionFilterInput" },
    reference: { __type: "StringFilterInput" },
    salesTax: { __type: "StringFilterInput" },
    status: { __type: "NumberFilterInput" },
    subTotal: { __type: "StringFilterInput" },
    total: { __type: "StringFilterInput" },
    version: { __type: "NumberFilterInput" },
  },
  QuoteLine: {
    __typename: { __type: "String!" },
    code: { __type: "String" },
    costingRevision: { __type: "CostingRevision" },
    costingRevisionId: { __type: "ID" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String!" },
    id: { __type: "ID!" },
    jobComponent: { __type: "JobComponent" },
    label: { __type: "String!" },
    line: { __type: "Int!" },
    lineTemplateId: { __type: "String" },
    lines: { __type: "[QuoteLine!]!" },
    markupAmount: { __type: "String" },
    markupExpression: { __type: "String!" },
    parentLine: { __type: "QuoteLine" },
    product: { __type: "Product" },
    productId: { __type: "String" },
    quantity: { __type: "String!" },
    quote: { __type: "Quote" },
    quoteRevision: { __type: "QuoteRevision" },
    quoteTemplateRevision: { __type: "QuoteTemplateRevision" },
    total: { __type: "String!" },
    type: { __type: "String!" },
    unitCostPrice: { __type: "String!" },
    unitSellPrice: { __type: "String!" },
  },
  QuoteLineAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    quantity: { __type: "Float!" },
  },
  QuoteLineFilterInput: {
    and: { __type: "[QuoteLineFilterInput!]" },
    code: { __type: "StringFilterInput" },
    costingRevision: { __type: "CostingRevisionFilterInput" },
    costingRevisionId: { __type: "IDFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    jobComponent: { __type: "JobComponentFilterInput" },
    label: { __type: "StringFilterInput" },
    line: { __type: "NumberFilterInput" },
    lineTemplateId: { __type: "StringFilterInput" },
    markupAmount: { __type: "StringFilterInput" },
    markupExpression: { __type: "StringFilterInput" },
    or: { __type: "[QuoteLineFilterInput!]" },
    parentLine: { __type: "QuoteLineFilterInput" },
    product: { __type: "ProductFilterInput" },
    productId: { __type: "StringFilterInput" },
    quantity: { __type: "StringFilterInput" },
    quote: { __type: "QuoteFilterInput" },
    quoteRevision: { __type: "QuoteRevisionFilterInput" },
    quoteTemplateRevision: { __type: "QuoteTemplateRevisionFilterInput" },
    total: { __type: "StringFilterInput" },
    unitCostPrice: { __type: "StringFilterInput" },
    unitSellPrice: { __type: "StringFilterInput" },
  },
  QuoteLineInput: {
    costPrice: { __type: "String" },
    costing: { __type: "String" },
    costingRevisionId: { __type: "String" },
    description: { __type: "String" },
    jobComponentId: { __type: "ID" },
    lineTemplateId: { __type: "String" },
    lines: { __type: "[QuoteLineInput!]" },
    markupExpression: { __type: "String" },
    product: { __type: "String" },
    quantity: { __type: "String" },
    type: { __type: "QuoteLineType!" },
  },
  QuoteLineTemplate: {
    __typename: { __type: "String!" },
    category: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String!" },
    descriptionEditable: { __type: "Boolean!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    markupEditable: { __type: "Boolean!" },
    markupExpression: { __type: "String!" },
    quantity: { __type: "String!" },
    quantityEditable: { __type: "Boolean!" },
    quoteTemplateRevision: { __type: "QuoteTemplateRevision" },
    unitCostPrice: { __type: "String!" },
    unitCostPriceEditable: { __type: "Boolean!" },
  },
  QuoteLineTemplateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  QuoteLineTemplateFilterInput: {
    and: { __type: "[QuoteLineTemplateFilterInput!]" },
    category: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    descriptionEditable: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    markupEditable: { __type: "BooleanFilterInput" },
    markupExpression: { __type: "StringFilterInput" },
    or: { __type: "[QuoteLineTemplateFilterInput!]" },
    quantity: { __type: "StringFilterInput" },
    quantityEditable: { __type: "BooleanFilterInput" },
    quoteTemplateRevision: { __type: "QuoteTemplateRevisionFilterInput" },
    unitCostPrice: { __type: "StringFilterInput" },
    unitCostPriceEditable: { __type: "BooleanFilterInput" },
  },
  QuoteLineTemplateInput: {
    category: { __type: "String!" },
    costPriceEditable: { __type: "Boolean!" },
    description: { __type: "String!" },
    descriptionEditable: { __type: "Boolean!" },
    id: { __type: "String!" },
    markupEditable: { __type: "Boolean!" },
    markupExpression: { __type: "String!" },
    quantity: { __type: "String!" },
    quantityEditable: { __type: "Boolean!" },
    type: { __type: "QuoteLineType!" },
    unitCostPrice: { __type: "String!" },
    unitCostPriceEditable: { __type: "Boolean!" },
  },
  QuotePreview: {
    __typename: { __type: "String!" },
    html: { __type: "String!" },
  },
  QuoteRequestAcceptedEvent: {
    __typename: { __type: "String!" },
    quoteRequest: { __type: "String!" },
    user: { __type: "String!" },
  },
  QuoteRequestPlacedEvent: {
    __typename: { __type: "String!" },
    quoteRequest: { __type: "String!" },
    user: { __type: "String!" },
  },
  QuoteRequestQuotedEvent: {
    __typename: { __type: "String!" },
    quoteRequest: { __type: "String!" },
    user: { __type: "String!" },
  },
  QuoteRevision: {
    __typename: { __type: "String!" },
    clientAddress: { __type: "String!" },
    clientName: { __type: "String!" },
    contactName: { __type: "String!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    lines: {
      __type: "[QuoteLine!]!",
      __args: { filter: "QuoteLineFilterInput" },
    },
    quote: { __type: "Quote!" },
    reference: { __type: "String" },
    salesTax: { __type: "String!" },
    status: { __type: "Int!" },
    subTotal: { __type: "String!" },
    total: { __type: "String!" },
    version: { __type: "Int!" },
  },
  QuoteRevisionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  QuoteRevisionFilterInput: {
    and: { __type: "[QuoteRevisionFilterInput!]" },
    clientAddress: { __type: "StringFilterInput" },
    clientName: { __type: "StringFilterInput" },
    contactName: { __type: "StringFilterInput" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    lines: { __type: "QuoteLineFilterInput" },
    or: { __type: "[QuoteRevisionFilterInput!]" },
    quote: { __type: "QuoteFilterInput" },
    reference: { __type: "StringFilterInput" },
    salesTax: { __type: "StringFilterInput" },
    status: { __type: "NumberFilterInput" },
    subTotal: { __type: "StringFilterInput" },
    total: { __type: "StringFilterInput" },
    version: { __type: "NumberFilterInput" },
  },
  QuoteStatus: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    name: { __type: "String!" },
    quoteAggregate: {
      __type: "QuoteAggregate",
      __args: { filter: "QuoteFilterInput" },
    },
  },
  QuoteTemplate: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    currentRevision: { __type: "QuoteTemplateRevision" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    draftRevision: { __type: "QuoteTemplateRevision" },
    id: { __type: "ID!" },
    isDefault: { __type: "Boolean!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    version: { __type: "Int!" },
  },
  QuoteTemplateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  QuoteTemplateExpression: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    quoteTemplateRevision: { __type: "QuoteTemplateRevision" },
    quoteTemplateRevisionId: { __type: "String!" },
    value: { __type: "String!" },
  },
  QuoteTemplateExpressionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  QuoteTemplateExpressionFilterInput: {
    and: { __type: "[QuoteTemplateExpressionFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[QuoteTemplateExpressionFilterInput!]" },
    quoteTemplateRevision: { __type: "QuoteTemplateRevisionFilterInput" },
    quoteTemplateRevisionId: { __type: "StringFilterInput" },
    value: { __type: "StringFilterInput" },
  },
  QuoteTemplateFilterInput: {
    and: { __type: "[QuoteTemplateFilterInput!]" },
    created: { __type: "StringFilterInput" },
    currentRevision: { __type: "QuoteTemplateRevisionFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isDefault: { __type: "BooleanFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[QuoteTemplateFilterInput!]" },
    version: { __type: "NumberFilterInput" },
  },
  QuoteTemplatePreview: {
    __typename: { __type: "String!" },
    html: { __type: "String!" },
  },
  QuoteTemplateRevision: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    defaultLines: { __type: "[QuoteLine!]!" },
    expressions: {
      __type: "[QuoteTemplateExpression!]!",
      __args: { filter: "QuoteTemplateExpressionFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    lineTemplates: {
      __type: "[QuoteLineTemplate!]!",
      __args: { filter: "QuoteLineTemplateFilterInput" },
    },
    quoteTemplate: { __type: "QuoteTemplate!" },
    status: { __type: "QuoteTemplateRevisionStatus!" },
    version: { __type: "Int!" },
  },
  QuoteTemplateRevisionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  QuoteTemplateRevisionFilterInput: {
    and: { __type: "[QuoteTemplateRevisionFilterInput!]" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    expressions: { __type: "QuoteTemplateExpressionFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    lineTemplates: { __type: "QuoteLineTemplateFilterInput" },
    or: { __type: "[QuoteTemplateRevisionFilterInput!]" },
    quoteTemplate: { __type: "QuoteTemplateFilterInput" },
    status: { __type: "NumberFilterInput" },
    version: { __type: "NumberFilterInput" },
  },
  ReceiveWarehouseStockInput: {
    stock: { __type: "[WarehouseStockInput!]!" },
    warehouseId: { __type: "ID!" },
  },
  RecordFile: {
    __typename: { __type: "String!" },
    created: { __type: "DateTime" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    file: { __type: "File" },
    fileId: { __type: "String" },
    folder: { __type: "RecordFolder" },
    folderId: { __type: "ID" },
    id: { __type: "ID!" },
    isPrimaryImage: { __type: "Boolean!" },
    label: { __type: "String!" },
    metadata: { __type: "String" },
    path: { __type: "String!" },
    resourceId: { __type: "String" },
    resourceType: { __type: "String" },
    user: { __type: "User" },
  },
  RecordFileAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  RecordFileDeletedEvent: {
    __typename: { __type: "String!" },
    fileId: { __type: "String!" },
    id: { __type: "String!" },
  },
  RecordFileFilterInput: {
    and: { __type: "[RecordFileFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    file: { __type: "FileFilterInput" },
    fileId: { __type: "StringFilterInput" },
    folder: { __type: "RecordFolderFilterInput" },
    folderId: { __type: "IDFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    isPrimaryImage: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    metadata: { __type: "JsonFilterInput" },
    or: { __type: "[RecordFileFilterInput!]" },
    path: { __type: "StringFilterInput" },
    primaryImage: { __type: "BooleanFilterInput" },
    resourceId: { __type: "IDFilterInput" },
    resourceType: { __type: "StringFilterInput" },
    user: { __type: "UserFilterInput" },
  },
  RecordFilesUploadedEvent: {
    __typename: { __type: "String!" },
    fileCount: { __type: "Int!" },
    folderId: { __type: "String" },
    folderName: { __type: "String" },
    recordFileIds: { __type: "[String]!" },
    recordId: { __type: "String!" },
    recordType: { __type: "String!" },
  },
  RecordFolder: {
    __typename: { __type: "String!" },
    children: {
      __type: "[RecordFolder!]!",
      __args: { filter: "RecordFolderFilterInput" },
    },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    defaultFolderId: { __type: "ID" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    parentFolder: { __type: "RecordFolder" },
    parentFolderId: { __type: "ID" },
    resourceId: { __type: "ID!" },
    resourceType: { __type: "String!" },
  },
  RecordFolderAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  RecordFolderFilterInput: {
    and: { __type: "[RecordFolderFilterInput!]" },
    children: { __type: "RecordFolderFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    defaultFolderId: { __type: "IDFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[RecordFolderFilterInput!]" },
    parentFolder: { __type: "RecordFolderFilterInput" },
    parentFolderId: { __type: "IDFilterInput" },
    resourceId: { __type: "IDFilterInput" },
    resourceType: { __type: "StringFilterInput" },
  },
  RecordNavigationRecord: {
    __typename: { __type: "String!" },
    groupLabel: { __type: "String" },
    label: { __type: "String!" },
    recordId: { __type: "String!" },
    recordType: { __type: "RecordType!" },
    relation: { __type: "String" },
  },
  RecordScreen: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    inheritedFrom: { __type: "String" },
    label: { __type: "String!" },
    record: { __type: "RecordScreenRecordReference!" },
    recordId: { __type: "String!" },
    recordType: { __type: "RecordScreenType!" },
    role: { __type: "Role" },
    screen: { __type: "Screen!" },
    source: { __type: "RecordSource" },
    user: { __type: "User" },
  },
  RecordScreenAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  RecordScreenFilterInput: {
    and: { __type: "[RecordScreenFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[RecordScreenFilterInput!]" },
    recordId: { __type: "IDFilterInput" },
    recordType: { __type: "StringFilterInput" },
    role: { __type: "RoleFilterInput" },
    screen: { __type: "ScreenFilterInput" },
    user: { __type: "UserFilterInput" },
  },
  RecordScreenRecordReference: {
    __typename: { __type: "String!" },
    recordId: { __type: "ID!" },
    recordType: { __type: "String!" },
  },
  RecordTag: {
    __typename: { __type: "String!" },
    colour: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String" },
    name: { __type: "String!" },
    resourceType: { __type: "String" },
    tag: { __type: "Tag!" },
  },
  RecordTagAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  RecordTagFilterInput: {
    and: { __type: "[RecordTagFilterInput!]" },
    colour: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[RecordTagFilterInput!]" },
    recordId: { __type: "IDFilterInput" },
    recordType: { __type: "StringFilterInput" },
    resourceType: { __type: "StringFilterInput" },
    tag: { __type: "TagFilterInput" },
  },
  Region: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    nzRegion: { __type: "String!" },
  },
  RegionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  RegionFilterInput: {
    and: { __type: "[RegionFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    nzRegion: { __type: "StringFilterInput" },
    or: { __type: "[RegionFilterInput!]" },
  },
  RegionReportDimensionValue: {
    __typename: { __type: "String!" },
    key: { __type: "String" },
    label: { __type: "String" },
  },
  RegionReportRelationDimensionInput: {
    filter: { __type: "RegionFilterInput" },
    includeEmpty: { __type: "Boolean" },
  },
  ReleasePurchaseOrdersInput: { purchaseOrderIds: { __type: "[ID!]!" } },
  ReportDimensionValue: {
    __typename: { __type: "String!" },
    key: { __type: "String!" },
    label: { __type: "String!" },
  },
  RescheduleBatchesInput: {
    batchScheduleIds: { __type: "[ID!]!" },
    ignoreRestrictions: { __type: "Boolean!" },
    scheduled: { __type: "String!" },
  },
  ResetUserPasswordInput: {
    password: { __type: "String!" },
    userId: { __type: "ID!" },
  },
  ResourceAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ResourceGroup: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    key: { __type: "String!" },
    label: { __type: "String!" },
  },
  ResourceGroupByInput: {
    dir: { __type: "ResourceGroupDirection" },
    field: { __type: "String!" },
  },
  ResourceGroupInput: {
    field: { __type: "String!" },
    key: { __type: "String!" },
  },
  ResourceGroupPage: {
    __typename: { __type: "String!" },
    items: { __type: "[ResourceGroup!]!" },
    totalCount: { __type: "Int!" },
  },
  RestorePartTypesInput: { partTypeIds: { __type: "[ID!]!" } },
  RestoreProcessTypesInput: { processTypeIds: { __type: "[ID!]!" } },
  RestoreWorkflowTypesInput: { workflowTypeIds: { __type: "[ID!]!" } },
  ReviseQuoteInput: {
    clientAddress: { __type: "String" },
    clientName: { __type: "String!" },
    contactName: { __type: "String" },
    files: { __type: "[ID!]" },
    lines: { __type: "[QuoteLineInput!]!" },
    quoteId: { __type: "ID" },
    reference: { __type: "String!" },
  },
  Role: {
    __typename: { __type: "String!" },
    allPermissions: {
      __type: "[AssignedPermission!]!",
      __args: { filter: "AssignedPermissionFilterInput" },
    },
    allScreens: { __type: "[Screen!]!" },
    assignedUsers: {
      __type: "[RoleUser!]!",
      __args: { filter: "RoleUserFilterInput" },
    },
    childRoles: { __type: "[Role!]!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String!" },
    id: { __type: "ID!" },
    inheritFrom: { __type: "[Role!]!" },
    inheritances: {
      __type: "[RoleInheritance!]!",
      __args: { filter: "RoleInheritanceFilterInput" },
    },
    inheritedBy: {
      __type: "[RoleInheritance!]!",
      __args: { filter: "RoleInheritanceFilterInput" },
    },
    inheritedFromName: { __type: "String" },
    inheritedPermissions: {
      __type: "[AssignedPermission!]!",
      __args: { filter: "AssignedPermissionFilterInput" },
    },
    inheritedScreens: { __type: "[Screen!]!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    ownPermissions: {
      __type: "[AssignedPermission!]!",
      __args: { filter: "AssignedPermissionFilterInput" },
    },
    ownScreens: { __type: "[Screen!]!" },
    parentRoles: { __type: "[Role!]!" },
    screenAggregate: {
      __type: "RecordScreenAggregate",
      __args: { filter: "RecordScreenFilterInput" },
    },
    source: { __type: "RecordSource!" },
    userAggregate: {
      __type: "RoleUserAggregate",
      __args: { filter: "RoleUserFilterInput" },
    },
    users: { __type: "[User!]!" },
  },
  RoleAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  RoleCreatedEvent: {
    __typename: { __type: "String!" },
    description: { __type: "String!" },
    inheritedFrom: { __type: "[String]!" },
    roleId: { __type: "String!" },
    roleName: { __type: "String!" },
  },
  RoleDeletedEvent: {
    __typename: { __type: "String!" },
    roleId: { __type: "String!" },
    roleName: { __type: "String!" },
  },
  RoleDetailsUpdatedEvent: {
    __typename: { __type: "String!" },
    description: { __type: "String" },
    roleId: { __type: "String!" },
    roleName: { __type: "String!" },
  },
  RoleFilterInput: {
    and: { __type: "[RoleFilterInput!]" },
    assignedUsers: { __type: "RoleUserFilterInput" },
    childRoles: { __type: "RoleInheritanceFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    inheritances: { __type: "RoleInheritanceFilterInput" },
    inheritedBy: { __type: "RoleInheritanceFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[RoleFilterInput!]" },
    parentRoles: { __type: "RoleInheritanceFilterInput" },
    roleScreens: { __type: "RecordScreenFilterInput" },
    roleUsers: { __type: "RoleUserFilterInput" },
    source: { __type: "SourceFilterInput" },
  },
  RoleInheritance: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    parentId: { __type: "String!" },
    parentRole: { __type: "Role!" },
    role: { __type: "Role!" },
    roleId: { __type: "String!" },
  },
  RoleInheritanceAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  RoleInheritanceAssignmentUpdatedEvent: {
    __typename: { __type: "String!" },
    assignedInheritance: { __type: "[String]" },
    roleId: { __type: "String!" },
    roleName: { __type: "String!" },
    unassignedInheritance: { __type: "[String]" },
  },
  RoleInheritanceFilterInput: {
    and: { __type: "[RoleInheritanceFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[RoleInheritanceFilterInput!]" },
    parent: { __type: "RoleFilterInput" },
    parentId: { __type: "StringFilterInput" },
    parentRole: { __type: "RoleFilterInput" },
    role: { __type: "RoleFilterInput" },
    roleId: { __type: "StringFilterInput" },
  },
  RolePermission: {
    __typename: { __type: "String!" },
    conditions: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    permission: { __type: "Permission!" },
    policy: { __type: "Policy!" },
    role: { __type: "Role!" },
  },
  RolePermissionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  RolePermissionFilterInput: {
    and: { __type: "[RolePermissionFilterInput!]" },
    conditions: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[RolePermissionFilterInput!]" },
    role: { __type: "RoleFilterInput" },
  },
  RolePermissionsAssignmentUpdatedEvent: {
    __typename: { __type: "String!" },
    assignedPermissions: { __type: "[String]" },
    roleId: { __type: "String!" },
    roleName: { __type: "String!" },
    unassignedPermissions: { __type: "[String]" },
  },
  RoleScreensAssignmentUpdatedEvent: {
    __typename: { __type: "String!" },
    assignedScreens: { __type: "[String]" },
    roleId: { __type: "String!" },
    roleName: { __type: "String!" },
    unassignedScreens: { __type: "[String]" },
  },
  RoleUser: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    role: { __type: "Role!" },
    user: { __type: "User!" },
  },
  RoleUserAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  RoleUserFilterInput: {
    and: { __type: "[RoleUserFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[RoleUserFilterInput!]" },
    role: { __type: "RoleFilterInput" },
    user: { __type: "UserFilterInput" },
  },
  RoleUsersAssignmentUpdatedEvent: {
    __typename: { __type: "String!" },
    assignedUserIds: { __type: "[String]" },
    roleId: { __type: "String!" },
    roleName: { __type: "String!" },
    unassignedUserIds: { __type: "[String]" },
  },
  SaleType: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  SaleTypeAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  SaleTypeFilterInput: {
    and: { __type: "[SaleTypeFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[SaleTypeFilterInput!]" },
  },
  SaleTypeReportDimensionValue: {
    __typename: { __type: "String!" },
    key: { __type: "String" },
    label: { __type: "String" },
  },
  SaleTypeReportRelationDimensionInput: {
    filter: { __type: "SaleTypeFilterInput" },
    includeEmpty: { __type: "Boolean" },
  },
  SalesOrder: {
    __typename: { __type: "String!" },
    client: { __type: "Client" },
    clientAddress: { __type: "String" },
    clientName: { __type: "String!" },
    confirmedAt: { __type: "String" },
    contactName: { __type: "String" },
    created: { __type: "String!" },
    currency: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    job: { __type: "Job" },
    label: { __type: "String!" },
    lines: {
      __type: "[SalesOrderLine!]!",
      __args: { filter: "SalesOrderLineFilterInput" },
    },
    modified: { __type: "String!" },
    reference: { __type: "String" },
    salesOrderNumber: { __type: "String" },
    salesTax: { __type: "String!" },
    status: { __type: "String!" },
    subTotal: { __type: "String!" },
    total: { __type: "String!" },
  },
  SalesOrderAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  SalesOrderFilterInput: {
    and: { __type: "[SalesOrderFilterInput!]" },
    client: { __type: "ClientFilterInput" },
    clientAddress: { __type: "StringFilterInput" },
    clientName: { __type: "StringFilterInput" },
    confirmedAt: { __type: "StringFilterInput" },
    contactName: { __type: "StringFilterInput" },
    created: { __type: "StringFilterInput" },
    currency: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    job: { __type: "JobFilterInput" },
    label: { __type: "StringFilterInput" },
    lines: { __type: "SalesOrderLineFilterInput" },
    modified: { __type: "StringFilterInput" },
    or: { __type: "[SalesOrderFilterInput!]" },
    reference: { __type: "StringFilterInput" },
    salesOrderNumber: { __type: "StringFilterInput" },
    salesTax: { __type: "StringFilterInput" },
    status: { __type: "StringFilterInput" },
    subTotal: { __type: "StringFilterInput" },
    total: { __type: "StringFilterInput" },
  },
  SalesOrderLine: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String!" },
    id: { __type: "ID!" },
    jobComponent: { __type: "JobComponent" },
    label: { __type: "String!" },
    line: { __type: "Int!" },
    lineTotal: { __type: "String!" },
    quantity: { __type: "String!" },
    salesOrder: { __type: "SalesOrder!" },
    sourceQuote: { __type: "Quote" },
    sourceQuoteLine: { __type: "QuoteLine" },
    sourceQuoteRevision: { __type: "QuoteRevision" },
    unit: { __type: "String" },
    unitSellPrice: { __type: "String!" },
  },
  SalesOrderLineFilterInput: {
    and: { __type: "[SalesOrderLineFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    jobComponent: { __type: "JobComponentFilterInput" },
    label: { __type: "StringFilterInput" },
    line: { __type: "NumberFilterInput" },
    lineTotal: { __type: "StringFilterInput" },
    or: { __type: "[SalesOrderLineFilterInput!]" },
    quantity: { __type: "StringFilterInput" },
    salesOrder: { __type: "SalesOrderFilterInput" },
    sourceQuote: { __type: "QuoteFilterInput" },
    sourceQuoteLine: { __type: "QuoteLineFilterInput" },
    sourceQuoteRevision: { __type: "QuoteRevisionFilterInput" },
    unit: { __type: "StringFilterInput" },
    unitSellPrice: { __type: "StringFilterInput" },
  },
  SalesOrderLineInput: {
    description: { __type: "String!" },
    jobComponentId: { __type: "ID" },
    quantity: { __type: "String!" },
    sourceQuoteId: { __type: "ID" },
    sourceQuoteLineId: { __type: "ID" },
    sourceQuoteRevisionId: { __type: "ID" },
    unit: { __type: "String" },
    unitSellPrice: { __type: "String!" },
  },
  Schema: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    latestVersion: { __type: "SchemaVersion" },
    name: { __type: "String!" },
    recordType: { __type: "String!" },
    versions: {
      __type: "[SchemaVersion!]!",
      __args: { filter: "SchemaVersionFilterInput" },
    },
  },
  SchemaAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  SchemaCreatedEvent: {
    __typename: { __type: "String!" },
    schema: { __type: "String!" },
  },
  SchemaDeletedEvent: {
    __typename: { __type: "String!" },
    schema: { __type: "String!" },
  },
  SchemaFilterInput: {
    and: { __type: "[SchemaFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    latestVersion: { __type: "SchemaVersionFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[SchemaFilterInput!]" },
    recordType: { __type: "StringFilterInput" },
    versions: { __type: "SchemaVersionFilterInput" },
  },
  SchemaType: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  SchemaTypeFilterInput: {
    id: { __type: "IDFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
  },
  SchemaUpdatedEvent: {
    __typename: { __type: "String!" },
    schema: { __type: "String!" },
  },
  SchemaVersion: {
    __typename: { __type: "String!" },
    created: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    dataDefinition: { __type: "String" },
    description: { __type: "String" },
    extra: { __type: "String" },
    formDefinition: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    latestActive: { __type: "Boolean!" },
    modified: { __type: "String" },
    schema: { __type: "Schema" },
    schemaId: { __type: "ID" },
    status: { __type: "Int" },
    version: { __type: "String" },
    versionNo: { __type: "String" },
  },
  SchemaVersionActiveEvent: {
    __typename: { __type: "String!" },
    schemaVersion: { __type: "String!" },
  },
  SchemaVersionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  SchemaVersionCreatedEvent: {
    __typename: { __type: "String!" },
    schemaVersion: { __type: "String!" },
  },
  SchemaVersionDeletedEvent: {
    __typename: { __type: "String!" },
    schemaVersion: { __type: "String!" },
  },
  SchemaVersionFilterInput: {
    and: { __type: "[SchemaVersionFilterInput!]" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    dataDefinition: { __type: "StringFilterInput" },
    description: { __type: "StringFilterInput" },
    extra: { __type: "StringFilterInput" },
    formDefinition: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    latestActive: { __type: "BooleanFilterInput" },
    modified: { __type: "StringFilterInput" },
    or: { __type: "[SchemaVersionFilterInput!]" },
    schema: { __type: "SchemaFilterInput" },
    schemaId: { __type: "IDFilterInput" },
    status: { __type: "NumberFilterInput" },
    version: { __type: "StringFilterInput" },
    versionNo: { __type: "StringFilterInput" },
  },
  SchemaVersionInput: {
    dataSchema: { __type: "String!" },
    formSchema: { __type: "String!" },
    id: { __type: "ID" },
    schemaId: { __type: "ID!" },
  },
  SchemaVersionUpdatedEvent: {
    __typename: { __type: "String!" },
    schemaVersion: { __type: "String!" },
  },
  Screen: {
    __typename: { __type: "String!" },
    assignmentAggregate: {
      __type: "RecordScreenAggregate",
      __args: { filter: "RecordScreenFilterInput" },
    },
    created: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    group: { __type: "String" },
    icon: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    recordType: { __type: "String" },
    resolvedScreenCfg: {
      __type: "String",
      __args: { recordId: "ID", recordType: "String" },
    },
    roles: { __type: "[Role!]" },
    screenCfg: { __type: "String" },
    source: { __type: "String!" },
  },
  ScreenAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  ScreenAssignmentInput: {
    roleIds: { __type: "[String!]" },
    screenId: { __type: "ID!" },
    userIds: { __type: "[String!]" },
  },
  ScreenCreatedEvent: {
    __typename: { __type: "String!" },
    screenCfg: { __type: "String!" },
    screenId: { __type: "String!" },
    screenName: { __type: "String!" },
  },
  ScreenDeletedEvent: {
    __typename: { __type: "String!" },
    screenId: { __type: "String!" },
    screenName: { __type: "String!" },
  },
  ScreenFilterInput: {
    and: { __type: "[ScreenFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    icon: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[ScreenFilterInput!]" },
    recordType: { __type: "StringFilterInput" },
    screenCfg: { __type: "StringFilterInput" },
  },
  ScreenUnassignmentInput: {
    recordScreenIds: { __type: "[String!]!" },
    screenId: { __type: "ID!" },
  },
  ScreenUpdatedEvent: {
    __typename: { __type: "String!" },
    screenCfg: { __type: "String" },
    screenGroup: { __type: "String" },
    screenId: { __type: "String!" },
    screenName: { __type: "String!" },
  },
  SetCandidateIngestionPolicyInput: {
    candidateType: { __type: "String!" },
    emailAddresses: { __type: "[String!]!" },
    mode: { __type: "CandidateIngestionMode!" },
    senderRecordId: { __type: "ID!" },
    senderRecordType: { __type: "String!" },
  },
  SetConfiguredLinkedActionInput: {
    actionId: { __type: "String!" },
    bindings: { __type: "String!" },
    displayOrder: { __type: "Int!" },
    enabled: { __type: "Boolean!" },
    id: { __type: "ID" },
    isGlobal: { __type: "Boolean!" },
    name: { __type: "String!" },
    recordPath: { __type: "String!" },
    recordType: { __type: "String!" },
    roleIds: { __type: "[ID!]!" },
    userIds: { __type: "[ID!]!" },
  },
  SetCustomDataInput: {
    data: { __type: "String!" },
    recordId: { __type: "String!" },
    schemaId: { __type: "String!" },
    upgradeSchema: { __type: "Boolean" },
  },
  SetDefaultFolderInput: {
    allowedMimeTypes: { __type: "[String!]" },
    enabled: { __type: "Boolean!" },
    id: { __type: "ID" },
    name: { __type: "String!" },
    recordType: { __type: "String!" },
  },
  SetFavouriteLinkedActionInput: {
    actionId: { __type: "String!" },
    name: { __type: "String!" },
    recordPath: { __type: "String!" },
    recordType: { __type: "String!" },
  },
  SetLinkedActionRecipientInput: {
    assigned: { __type: "Boolean!" },
    linkedActionId: { __type: "ID!" },
    roleId: { __type: "ID" },
    userId: { __type: "ID" },
  },
  SetUserPinInput: { pin: { __type: "String!" }, userId: { __type: "ID!" } },
  SignedUploadUrlPayload: {
    __typename: { __type: "String!" },
    fileId: { __type: "String!" },
    uploadToken: { __type: "String!" },
    uploadUrl: { __type: "String!" },
  },
  SortInput: { dir: { __type: "String" }, field: { __type: "String" } },
  SourceFilterInput: {
    eq: { __type: "RecordSource" },
    notEq: { __type: "RecordSource" },
  },
  Specification: { __typename: { __type: "String!" }, id: { __type: "ID!" } },
  SpecificationLookupOption: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    name: { __type: "String!" },
    type: { __type: "String!" },
    value: { __type: "String!" },
  },
  StatusChangedEvent: {
    __typename: { __type: "String!" },
    comment: { __type: "String" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
    orderReviewId: { __type: "String!" },
    review: { __type: "String!" },
    reviewerUserName: { __type: "String!" },
  },
  StatusUpdatedEvent: {
    __typename: { __type: "String!" },
    quoteRequestEmail: { __type: "String!" },
  },
  Stock: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    product: { __type: "Product" },
    quantity: { __type: "String" },
    totalCostPrice: { __type: "Money" },
    warehouse: { __type: "Warehouse" },
  },
  StockAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    totalCostPrice: { __type: "Money!" },
    totalQuantity: { __type: "Float!" },
  },
  StockFilterInput: {
    and: { __type: "[StockFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[StockFilterInput!]" },
    product: { __type: "ProductFilterInput" },
    quantity: { __type: "NumberFilterInput" },
    warehouse: { __type: "WarehouseFilterInput" },
  },
  StockTakeCreatedEvent: {
    __typename: { __type: "String!" },
    stockTakeId: { __type: "String!" },
  },
  StockTransaction: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    lines: {
      __type: "[StockTransactionLine!]!",
      __args: { filter: "StockTransactionLineFilterInput" },
    },
    type: { __type: "StockTransactionType!" },
    user: { __type: "User!" },
    warehouse: { __type: "Warehouse!" },
  },
  StockTransactionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
    totalCostPrice: { __type: "Float!" },
    totalQuantity: { __type: "Float!" },
  },
  StockTransactionCreatedEvent: {
    __typename: { __type: "String!" },
    stockTransactionId: { __type: "Int!" },
    type: { __type: "String!" },
  },
  StockTransactionFilterInput: {
    and: { __type: "[StockTransactionFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    lines: { __type: "StockTransactionLineFilterInput" },
    or: { __type: "[StockTransactionFilterInput!]" },
    type: { __type: "StringFilterInput" },
    user: { __type: "UserFilterInput" },
    warehouse: { __type: "WarehouseFilterInput" },
  },
  StockTransactionLine: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    product: { __type: "Product" },
    quantity: { __type: "Float!" },
    stockTransaction: { __type: "StockTransaction!" },
  },
  StockTransactionLineAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  StockTransactionLineFilterInput: {
    and: { __type: "[StockTransactionLineFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[StockTransactionLineFilterInput!]" },
    product: { __type: "ProductFilterInput" },
    quantity: { __type: "NumberFilterInput" },
    stockTransaction: { __type: "StockTransactionFilterInput" },
  },
  StringFilterInput: {
    endsWith: { __type: "String" },
    eq: { __type: "String" },
    in: { __type: "[String!]" },
    isNull: { __type: "Boolean" },
    like: { __type: "String" },
    likeAll: { __type: "[String!]" },
    neq: { __type: "String" },
    notIn: { __type: "[String!]" },
    startsWith: { __type: "String" },
  },
  SubmitPurchaseOrderReviewInput: {
    comment: { __type: "String!" },
    purchaseOrderId: { __type: "ID!" },
    review: { __type: "OrderReviewStatus!" },
  },
  SubscriptionReal: {
    __typename: { __type: "String!" },
    channels: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    enabled: { __type: "Boolean!" },
    event: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    maxRecipients: { __type: "Int" },
    notificationTemplates: {
      __type: "[NotificationTemplate!]!",
      __args: { filter: "NotificationTemplateFilterInput" },
    },
    sourceFilter: { __type: "String" },
    targetFilter: { __type: "String" },
  },
  SubscriptionRealAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  SubscriptionRealFilterInput: {
    and: { __type: "[SubscriptionRealFilterInput!]" },
    channels: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    enabled: { __type: "BooleanFilterInput" },
    event: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    maxRecipients: { __type: "NumberFilterInput" },
    notificationTemplates: { __type: "NotificationTemplateFilterInput" },
    or: { __type: "[SubscriptionRealFilterInput!]" },
    sourceFilter: { __type: "StringFilterInput" },
    targetFilter: { __type: "StringFilterInput" },
  },
  Supplier: {
    __typename: { __type: "String!" },
    address: { __type: "String" },
    category: { __type: "SupplierCategory" },
    cell: { __type: "String" },
    created: { __type: "String!" },
    currency: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deleted: { __type: "Boolean!" },
    email: { __type: "String" },
    id: { __type: "ID!" },
    image: { __type: "File" },
    label: { __type: "String!" },
    modified: { __type: "String!" },
    name: { __type: "String!" },
    numberOfReviews: { __type: "String!" },
    orderEmails: { __type: "[String!]!" },
    productAggregate: {
      __type: "ProductAggregate",
      __args: { filter: "ProductFilterInput" },
    },
    products: { __type: "[Product]", __args: { filter: "ProductFilterInput" } },
    quantityThreshold: { __type: "String!" },
    quoteEmails: { __type: "[String!]!" },
    reviewType: { __type: "String!" },
    reviewers: { __type: "[User!]!" },
    url: { __type: "String" },
  },
  SupplierAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  SupplierCategory: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
  },
  SupplierCategoryAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  SupplierCategoryFilterInput: {
    and: { __type: "[SupplierCategoryFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[SupplierCategoryFilterInput!]" },
  },
  SupplierCreatedEvent: {
    __typename: { __type: "String!" },
    supplierId: { __type: "Int!" },
    supplierName: { __type: "String!" },
  },
  SupplierDeletedEvent: {
    __typename: { __type: "String!" },
    supplierId: { __type: "Int!" },
    supplierName: { __type: "String!" },
  },
  SupplierDetailsUpdatedEvent: {
    __typename: { __type: "String!" },
    address: { __type: "String!" },
    category: { __type: "String" },
    cell: { __type: "String!" },
    currency: { __type: "String!" },
    email: { __type: "String!" },
    orderEmails: { __type: "[String]" },
    quoteEmails: { __type: "[String]" },
    supplierId: { __type: "Int!" },
    supplierName: { __type: "String!" },
    url: { __type: "String!" },
  },
  SupplierFilterInput: {
    address: { __type: "StringFilterInput" },
    and: { __type: "[SupplierFilterInput!]" },
    category: { __type: "SupplierCategoryFilterInput" },
    cell: { __type: "StringFilterInput" },
    created: { __type: "StringFilterInput" },
    currency: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    email: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    image: { __type: "FileFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    numberOfReviews: { __type: "StringFilterInput" },
    or: { __type: "[SupplierFilterInput!]" },
    products: { __type: "ProductFilterInput" },
    quantityThreshold: { __type: "StringFilterInput" },
    reviewType: { __type: "StringFilterInput" },
    url: { __type: "StringFilterInput" },
  },
  SupplierQuote: {
    __typename: { __type: "String!" },
    costingLines: {
      __type: "[CostingLine!]!",
      __args: { filter: "CostingLineFilterInput" },
    },
    created: { __type: "String!" },
    currency: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    job: { __type: "Job" },
    label: { __type: "String!" },
    lines: {
      __type: "[SupplierQuoteLine!]!",
      __args: { filter: "SupplierQuoteLineFilterInput" },
    },
    modified: { __type: "String!" },
    quoteRequest: { __type: "SupplierQuoteRequest" },
    reference: { __type: "String" },
    salesTax: { __type: "String!" },
    status: { __type: "Int!" },
    subTotal: { __type: "String!" },
    supplier: { __type: "Supplier" },
    supplierAddress: { __type: "String!" },
    supplierName: { __type: "String!" },
    supplierQuoteNumber: { __type: "String" },
    total: { __type: "String!" },
  },
  SupplierQuoteAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  SupplierQuoteFilterInput: {
    and: { __type: "[SupplierQuoteFilterInput!]" },
    costingLines: { __type: "CostingLineFilterInput" },
    created: { __type: "StringFilterInput" },
    currency: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    job: { __type: "JobFilterInput" },
    label: { __type: "StringFilterInput" },
    lines: { __type: "SupplierQuoteLineFilterInput" },
    modified: { __type: "StringFilterInput" },
    or: { __type: "[SupplierQuoteFilterInput!]" },
    quoteRequest: { __type: "SupplierQuoteRequestFilterInput" },
    reference: { __type: "StringFilterInput" },
    salesTax: { __type: "StringFilterInput" },
    status: { __type: "NumberFilterInput" },
    subTotal: { __type: "StringFilterInput" },
    supplier: { __type: "SupplierFilterInput" },
    supplierAddress: { __type: "StringFilterInput" },
    supplierName: { __type: "StringFilterInput" },
    supplierQuoteNumber: { __type: "StringFilterInput" },
    total: { __type: "StringFilterInput" },
  },
  SupplierQuoteLine: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    line: { __type: "Int!" },
    product: { __type: "Product" },
    quantity: { __type: "String!" },
    supplierQuote: { __type: "SupplierQuote" },
    total: { __type: "String!" },
    unitPrice: { __type: "String!" },
  },
  SupplierQuoteLineFilterInput: {
    and: { __type: "[SupplierQuoteLineFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    line: { __type: "NumberFilterInput" },
    or: { __type: "[SupplierQuoteLineFilterInput!]" },
    product: { __type: "ProductFilterInput" },
    quantity: { __type: "StringFilterInput" },
    supplierQuote: { __type: "SupplierQuoteFilterInput" },
    total: { __type: "StringFilterInput" },
    unitPrice: { __type: "StringFilterInput" },
  },
  SupplierQuoteLineInput: {
    description: { __type: "String!" },
    productId: { __type: "ID" },
    quantity: { __type: "String!" },
    unitPrice: { __type: "String!" },
  },
  SupplierQuoteRequest: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    job: { __type: "Job" },
    label: { __type: "String!" },
    lines: {
      __type: "[SupplierQuoteRequestLine!]!",
      __args: { filter: "SupplierQuoteRequestLineFilterInput" },
    },
    noteForSupplier: { __type: "String!" },
    reference: { __type: "String!" },
    status: { __type: "Int!" },
    supplier: { __type: "Supplier" },
  },
  SupplierQuoteRequestAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  SupplierQuoteRequestFilterInput: {
    and: { __type: "[SupplierQuoteRequestFilterInput!]" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    job: { __type: "JobFilterInput" },
    label: { __type: "StringFilterInput" },
    lines: { __type: "SupplierQuoteRequestLineFilterInput" },
    noteForSupplier: { __type: "StringFilterInput" },
    or: { __type: "[SupplierQuoteRequestFilterInput!]" },
    reference: { __type: "StringFilterInput" },
    status: { __type: "StringFilterInput" },
    supplier: { __type: "SupplierFilterInput" },
  },
  SupplierQuoteRequestLine: {
    __typename: { __type: "String!" },
    code: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    line: { __type: "Int!" },
    product: { __type: "Product" },
    quantity: { __type: "Float" },
    quoteRequest: { __type: "SupplierQuoteRequest!" },
    unit: { __type: "String" },
  },
  SupplierQuoteRequestLineAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  SupplierQuoteRequestLineFilterInput: {
    and: { __type: "[SupplierQuoteRequestLineFilterInput!]" },
    code: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    line: { __type: "NumberFilterInput" },
    or: { __type: "[SupplierQuoteRequestLineFilterInput!]" },
    product: { __type: "ProductFilterInput" },
    quantity: { __type: "NumberFilterInput" },
    quoteRequest: { __type: "SupplierQuoteRequestFilterInput" },
    unit: { __type: "StringFilterInput" },
  },
  SupplierQuoteRequestLineInput: {
    code: { __type: "String!" },
    description: { __type: "String!" },
    line: { __type: "Int!" },
    quantity: { __type: "String!" },
  },
  SupplierReviewersUpdatedEvent: {
    __typename: { __type: "String!" },
    numberOfReviews: { __type: "Int!" },
    quantityThreshold: { __type: "Int" },
    reviewType: { __type: "String!" },
    supplierId: { __type: "Int!" },
    supplierName: { __type: "String!" },
  },
  SupplierStatusUpdatedEvent: {
    __typename: { __type: "String!" },
    orderId: { __type: "Int!" },
    orderNumber: { __type: "String!" },
  },
  Tag: {
    __typename: { __type: "String!" },
    colour: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String" },
    name: { __type: "String!" },
    resourceType: { __type: "String" },
  },
  TagAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  TagFilterInput: {
    and: { __type: "[TagFilterInput!]" },
    colour: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[TagFilterInput!]" },
    resourceType: { __type: "StringFilterInput" },
  },
  TemplateCreatedEvent: {
    __typename: { __type: "String!" },
    templateId: { __type: "String!" },
    templateName: { __type: "String!" },
  },
  TemplateDeletedEvent: {
    __typename: { __type: "String!" },
    templateId: { __type: "String!" },
    templateName: { __type: "String!" },
  },
  TemplateUpdatedEvent: {
    __typename: { __type: "String!" },
    templateId: { __type: "String!" },
    templateName: { __type: "String!" },
  },
  TimerTransaction: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    start: { __type: "String" },
    stop: { __type: "String" },
    timer: { __type: "ProcessTimer" },
  },
  TimerTransactionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  TimerTransactionFilterInput: {
    and: { __type: "[TimerTransactionFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[TimerTransactionFilterInput!]" },
    start: { __type: "DateTimeFilterInput" },
    stop: { __type: "DateTimeFilterInput" },
    timer: { __type: "ProcessTimerFilterInput" },
  },
  TransferWarehouseStockInput: {
    destinationWarehouseId: { __type: "ID!" },
    sourceWarehouseId: { __type: "ID!" },
    stock: { __type: "[WarehouseStockInput!]!" },
  },
  TriggerWebhookInput: {
    recordId: { __type: "String" },
    webhookId: { __type: "String!" },
  },
  UnassignBusinessRolesFromPersonInput: {
    personBusinessRoleIds: { __type: "[ID!]!" },
  },
  UnassignInheritanceFromRoleInput: {
    roleId: { __type: "ID!" },
    roleInheritanceIds: { __type: "[String!]!" },
  },
  UnassignLeadsFromSalespersonInput: { leadIds: { __type: "[ID!]!" } },
  UnassignPermissionsFromRoleInput: {
    roleId: { __type: "ID!" },
    rolePermissionIds: { __type: "[String!]!" },
  },
  UnassignPermissionsFromUserInput: {
    userId: { __type: "ID!" },
    userPermissionIds: { __type: "[String!]!" },
  },
  UnassignRolesFromUserInput: {
    roleIds: { __type: "[String!]!" },
    userId: { __type: "ID!" },
  },
  UnassignScreensFromRoleInput: {
    recordScreenIds: { __type: "[String!]!" },
    roleId: { __type: "ID!" },
  },
  UnassignScreensFromUserInput: {
    recordScreenIds: { __type: "[String!]!" },
    userId: { __type: "ID!" },
  },
  UnassignUsersFromRoleInput: {
    roleId: { __type: "ID!" },
    userIds: { __type: "[String!]!" },
  },
  UnmarkJobLostInput: { jobId: { __type: "ID!" } },
  UnmarkLeadLostInput: { leadId: { __type: "ID!" } },
  UpdateBatchDetailsInput: {
    batchId: { __type: "ID!" },
    cubicMetres: { __type: "Int" },
    name: { __type: "String!" },
    sheets: { __type: "Int" },
  },
  UpdateBranchInput: {
    branchId: { __type: "ID!" },
    code: { __type: "String!" },
    colour: { __type: "String!" },
    darkColour: { __type: "String!" },
    name: { __type: "String!" },
  },
  UpdateBuilderInput: {
    address: { __type: "String!" },
    code: { __type: "String!" },
    id: { __type: "ID!" },
    name: { __type: "String!" },
  },
  UpdateBusinessRoleInput: {
    businessRoleId: { __type: "ID!" },
    description: { __type: "String" },
    name: { __type: "String!" },
  },
  UpdateClientInput: {
    address: { __type: "String" },
    email: { __type: "String" },
    faxHome: { __type: "String" },
    faxWork: { __type: "String" },
    firstName: { __type: "String" },
    id: { __type: "ID!" },
    lastName: { __type: "String!" },
    notes: { __type: "String" },
    phoneCell: { __type: "String" },
    phoneHome: { __type: "String" },
    phoneWork: { __type: "String" },
    title: { __type: "String" },
  },
  UpdateCorrespondenceInput: {
    date: { __type: "DateTime" },
    details: { __type: "String!" },
    id: { __type: "ID!" },
    type: { __type: "Int!" },
  },
  UpdateCostingInput: {
    costingId: { __type: "ID!" },
    jobComponentId: { __type: "ID" },
    lines: { __type: "[CostingLineInput!]!" },
    name: { __type: "String!" },
  },
  UpdateDocumentTemplateInput: {
    description: { __type: "String" },
    name: { __type: "String!" },
    query: { __type: "String!" },
    recordType: { __type: "String!" },
    sampleDataOverride: { __type: "String!" },
    template: { __type: "String!" },
    templateId: { __type: "ID!" },
  },
  UpdateDraftPurchaseOrderInput: {
    category: { __type: "OrderCategory" },
    deliveryAddress: { __type: "String" },
    deliveryAddressId: { __type: "ID" },
    internalComment: { __type: "String" },
    jobId: { __type: "ID" },
    lines: { __type: "[PurchaseOrderLineInput!]" },
    notifySupplierWhenPlaced: { __type: "Boolean!" },
    reference: { __type: "String" },
    required: { __type: "String" },
    shippingMethod: { __type: "OrderShippingMethods" },
    shippingTerms: { __type: "OrderShippingTerms" },
    siteVisitRequired: { __type: "Boolean!" },
    statusWhenPlaced: { __type: "OrderStatus" },
    supplierComment: { __type: "String" },
    supplierId: { __type: "ID" },
    templateId: { __type: "ID" },
    urgent: { __type: "Boolean!" },
    warehouseId: { __type: "ID" },
  },
  UpdateDraftSchemaVersionInput: {
    dataSchema: { __type: "String!" },
    formSchema: { __type: "String!" },
    id: { __type: "ID!" },
  },
  UpdateHousingCompanyInput: {
    code: { __type: "String" },
    id: { __type: "ID!" },
    name: { __type: "String!" },
  },
  UpdateIssueInput: {
    completed: { __type: "Boolean!" },
    description: { __type: "String" },
    id: { __type: "ID!" },
    requiredDate: { __type: "DateTime" },
  },
  UpdateJobBuilderInput: {
    builderId: { __type: "ID" },
    builderPhone: { __type: "String" },
    hcJobNumber: { __type: "String" },
    hcPmPhone: { __type: "String" },
    hcProjectManager: { __type: "String" },
    housingCompanyId: { __type: "ID" },
    id: { __type: "ID!" },
  },
  UpdateJobClientInput: { client: { __type: "ID!" }, id: { __type: "ID!" } },
  UpdateJobComponentInput: {
    description: { __type: "String" },
    jobComponentId: { __type: "ID!" },
    name: { __type: "String!" },
    partTypeId: { __type: "ID" },
  },
  UpdateJobDetailsInput: {
    benchtopOnly: { __type: "Boolean!" },
    branch: { __type: "ID!" },
    buildType: { __type: "ID!" },
    designer: { __type: "ID" },
    estimatedDueDate: { __type: "DateTime!" },
    id: { __type: "ID!" },
    jobName: { __type: "String" },
    notes: { __type: "String" },
    projectManager: { __type: "ID" },
    saleType: { __type: "ID!" },
    showHome: { __type: "Boolean!" },
    sssp: { __type: "Boolean!" },
    tristoneJoin: { __type: "Boolean!" },
    tristoneSpecified: { __type: "Boolean!" },
  },
  UpdateJobNoteInput: { jobId: { __type: "ID!" }, notes: { __type: "String" } },
  UpdateJobSiteInput: {
    address: { __type: "String" },
    difficultAccess: { __type: "Boolean!" },
    id: { __type: "String!" },
    region: { __type: "ID" },
    siteNotes: { __type: "String" },
    unit: { __type: "Boolean!" },
  },
  UpdateLeadInput: {
    address: { __type: "String" },
    assignedTo: { __type: "String" },
    branchId: { __type: "String" },
    builderName: { __type: "String" },
    builderType: { __type: "String" },
    city: { __type: "String" },
    client: { __type: "String!" },
    email: { __type: "String" },
    id: { __type: "ID!" },
    joineryTypes: { __type: "String" },
    notes: { __type: "String" },
    phone: { __type: "String" },
    priceRangeBottom: { __type: "Float" },
    priceRangeTop: { __type: "Float" },
    priority: { __type: "Int!" },
    projectType: { __type: "String!" },
    requiredBy: { __type: "String" },
    source: { __type: "String!" },
    suburb: { __type: "String" },
  },
  UpdateLineItemInput: {
    lineItemId: { __type: "ID!" },
    name: { __type: "String!" },
  },
  UpdateLineItemWorkflowInput: {
    lineItemId: { __type: "ID!" },
    placeholders: { __type: "[LineItemWorkflowPlaceholderInput!]!" },
    workflowTemplateId: { __type: "ID!" },
  },
  UpdateLostReasonInput: {
    description: { __type: "String" },
    lostReasonId: { __type: "ID!" },
    name: { __type: "String!" },
  },
  UpdatePanelConfigInput: {
    config: { __type: "String!" },
    name: { __type: "String!" },
    panelId: { __type: "ID!" },
  },
  UpdatePanelDetailsInput: {
    name: { __type: "String!" },
    panelId: { __type: "ID!" },
    tags: { __type: "[ID!]!" },
  },
  UpdatePartTypeInput: {
    code: { __type: "String!" },
    colour: { __type: "String!" },
    name: { __type: "String!" },
    partTypeId: { __type: "ID!" },
  },
  UpdatePermissionForRoleInput: {
    permission: { __type: "PermissionInput!" },
    roleId: { __type: "ID!" },
    rolePermissionId: { __type: "ID!" },
  },
  UpdatePermissionForUserInput: {
    permission: { __type: "PermissionInput!" },
    userId: { __type: "ID!" },
    userPermissionId: { __type: "ID!" },
  },
  UpdatePersonInput: {
    isActive: { __type: "Boolean!" },
    name: { __type: "String!" },
    personId: { __type: "ID!" },
  },
  UpdateProcessInstanceDetailsInput: {
    assignedHours: { __type: "Float!" },
    leadDays: { __type: "Int!" },
    processInstanceId: { __type: "ID!" },
  },
  UpdateProcessInstanceStatusInput: {
    processInstanceId: { __type: "ID!" },
    status: { __type: "Int!" },
  },
  UpdateProcessTypeDetailsInput: {
    code: { __type: "String!" },
    description: { __type: "String" },
    name: { __type: "String!" },
    processTypeId: { __type: "ID!" },
  },
  UpdateProcessTypeNoteInput: {
    assignedProcessIds: { __type: "[ID!]!" },
    date: { __type: "String" },
    note: { __type: "String" },
    processTypeNoteId: { __type: "ID!" },
  },
  UpdateProcessTypeRoleInput: {
    processTypeId: { __type: "ID!" },
    processTypeRoleId: { __type: "ID!" },
    roleType: { __type: "String!" },
  },
  UpdateProductCategoryInput: {
    group: { __type: "ID!" },
    id: { __type: "ID!" },
    name: { __type: "String!" },
    parentId: { __type: "ID" },
  },
  UpdateProductDetailsInput: {
    category: { __type: "ID" },
    code: { __type: "String" },
    deleted: { __type: "Boolean" },
    indent: { __type: "Boolean" },
    leadTime: { __type: "Int" },
    name: { __type: "String" },
    productIds: { __type: "[ID!]" },
    qtyReviewThreshold: { __type: "Int" },
    safetyStockDays: { __type: "Int" },
    starred: { __type: "Boolean" },
    stockItem: { __type: "Boolean" },
    supplier: { __type: "ID" },
    tags: { __type: "[String!]" },
    template: { __type: "Boolean" },
    unitOfMeasure: { __type: "String" },
    url: { __type: "String" },
  },
  UpdatePurchaseOrderInternalCommentInput: {
    internalComment: { __type: "String!" },
    purchaseOrderId: { __type: "ID!" },
  },
  UpdateQuoteInput: {
    clientAddress: { __type: "String" },
    clientName: { __type: "String!" },
    contactName: { __type: "String" },
    customer: { __type: "String" },
    files: { __type: "[ID!]" },
    jobId: { __type: "ID" },
    lines: { __type: "[QuoteLineInput!]!" },
    quoteId: { __type: "ID!" },
    reference: { __type: "String!" },
  },
  UpdateRoleDetailsInput: {
    description: { __type: "String!" },
    name: { __type: "String!" },
    roleId: { __type: "ID!" },
  },
  UpdateSalesOrderInput: {
    clientAddress: { __type: "String" },
    clientId: { __type: "ID" },
    clientName: { __type: "String!" },
    contactName: { __type: "String" },
    currency: { __type: "String!" },
    jobId: { __type: "ID" },
    lines: { __type: "[SalesOrderLineInput!]!" },
    reference: { __type: "String" },
    salesOrderId: { __type: "ID!" },
  },
  UpdateSchemaDetailsInput: {
    description: { __type: "String!" },
    id: { __type: "ID!" },
    name: { __type: "String!" },
    recordType: { __type: "String!" },
  },
  UpdateScreenConfigInput: {
    name: { __type: "String!" },
    screenCfg: { __type: "String!" },
    screenId: { __type: "ID!" },
  },
  UpdateScreenDetailsInput: {
    description: { __type: "String" },
    icon: { __type: "String" },
    name: { __type: "String!" },
    recordType: { __type: "String" },
    screenGroup: { __type: "ScreenGroup" },
    screenId: { __type: "ID!" },
  },
  UpdateSettingsInput: { settings: { __type: "String!" } },
  UpdateStorageConnectionInput: {
    description: { __type: "String" },
    deviceAccessEnabled: { __type: "Boolean" },
    dropboxAuthToken: { __type: "String" },
    dropboxNamespaceId: { __type: "String" },
    enabled: { __type: "Boolean" },
    id: { __type: "ID!" },
    localRoot: { __type: "String" },
    name: { __type: "String!" },
    root: { __type: "String!" },
    type: { __type: "String!" },
  },
  UpdateStorageResourceMappingInput: {
    description: { __type: "String" },
    enabled: { __type: "Boolean!" },
    externalStorageConnectionId: { __type: "String!" },
    path: { __type: "String" },
    resourceFilter: { __type: "String" },
    resourceMappingId: { __type: "ID!" },
    resourceType: { __type: "String!" },
  },
  UpdateSubscriptionInput: {
    enabled: { __type: "Boolean" },
    event: { __type: "String!" },
    maxRecipients: { __type: "Int" },
    notifications: { __type: "[NotificationInput!]!" },
    sourceFilter: { __type: "String" },
    subscriptionId: { __type: "ID!" },
    targetFilter: { __type: "String" },
  },
  UpdateSupplierDetailsInput: {
    address: { __type: "String!" },
    categoryId: { __type: "ID" },
    cell: { __type: "String!" },
    currency: { __type: "String!" },
    email: { __type: "String!" },
    name: { __type: "String!" },
    orderEmails: { __type: "[String!]" },
    quoteEmails: { __type: "[String!]" },
    supplierId: { __type: "ID!" },
    url: { __type: "String!" },
  },
  UpdateSupplierQuoteInput: {
    files: { __type: "[ID!]!" },
    jobId: { __type: "ID" },
    lines: { __type: "[SupplierQuoteLineInput!]!" },
    quoteRequestId: { __type: "ID" },
    reference: { __type: "String" },
    salesTax: { __type: "String!" },
    saveAsDraft: { __type: "Boolean!" },
    supplierId: { __type: "ID" },
    supplierQuoteId: { __type: "ID!" },
    supplierQuoteNumber: { __type: "String" },
  },
  UpdateSupplierQuoteRequestInput: {
    files: { __type: "[ID!]!" },
    lines: { __type: "[SupplierQuoteRequestLineInput!]!" },
    noteForSupplier: { __type: "String!" },
    place: { __type: "Boolean!" },
    reference: { __type: "String!" },
    supplierId: { __type: "ID" },
    supplierQuoteRequestId: { __type: "ID!" },
  },
  UpdateSupplierReviewersInput: {
    id: { __type: "ID!" },
    numberOfReviews: { __type: "Int!" },
    quantityThreshold: { __type: "Int!" },
    reviewType: { __type: "Int!" },
    reviewers: { __type: "[String!]!" },
  },
  UpdateTagInput: {
    colour: { __type: "String!" },
    context: { __type: "String!" },
    description: { __type: "String!" },
    id: { __type: "String!" },
    name: { __type: "String!" },
  },
  UpdateUserDetailsInput: {
    authProvider: { __type: "AuthProviderType!" },
    branchId: { __type: "String" },
    fullName: { __type: "String!" },
    userId: { __type: "ID!" },
    username: { __type: "String!" },
  },
  UpdateUserSubscriptionsInput: {
    subscriptions: { __type: "[String!]!" },
    userId: { __type: "ID!" },
  },
  UpdateWarehouseInput: {
    address: { __type: "String!" },
    code: { __type: "String" },
    color: { __type: "String" },
    description: { __type: "String" },
    id: { __type: "ID!" },
    name: { __type: "String!" },
  },
  UpdateWebhookInput: {
    authType: { __type: "String" },
    description: { __type: "String!" },
    enabled: { __type: "Boolean!" },
    event: { __type: "String!" },
    id: { __type: "ID!" },
    name: { __type: "String!" },
    sourceFilter: { __type: "String" },
    url: { __type: "String!" },
  },
  UpdateWorkflowTypeDetailsInput: {
    description: { __type: "String" },
    master: { __type: "Boolean!" },
    name: { __type: "String!" },
    workflowTypeId: { __type: "ID!" },
  },
  UploadRequestUrl: {
    __typename: { __type: "String!" },
    headers: { __type: "String!" },
    method: { __type: "String!" },
    url: { __type: "String!" },
  },
  User: {
    __typename: { __type: "String!" },
    allPermissions: {
      __type: "[AssignedPermission!]!",
      __args: { filter: "AssignedPermissionFilterInput" },
    },
    allScreens: { __type: "[Screen!]!" },
    assignedRoles: {
      __type: "[RoleUser!]!",
      __args: { filter: "RoleUserFilterInput" },
    },
    authProvider: { __type: "String!" },
    authProviderUid: { __type: "String!" },
    branch: { __type: "Branch" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deleted: { __type: "Boolean!" },
    email: { __type: "String" },
    firebaseAuthId: { __type: "String" },
    fullName: { __type: "String" },
    hasPin: { __type: "Boolean!" },
    id: { __type: "ID!" },
    identities: {
      __type: "[UserIdentity!]!",
      __args: { filter: "UserIdentityFilterInput" },
    },
    inheritedPermissions: {
      __type: "[AssignedPermission!]!",
      __args: { filter: "AssignedPermissionFilterInput" },
    },
    inheritedScreens: { __type: "[Screen!]!" },
    initials: { __type: "String!" },
    isActive: { __type: "Boolean!" },
    label: { __type: "String!" },
    ownPermissions: {
      __type: "[AssignedPermission!]!",
      __args: { filter: "AssignedPermissionFilterInput" },
    },
    ownScreens: { __type: "[Screen!]!" },
    roles: { __type: "[Role!]!" },
    timers: {
      __type: "[ProcessTimer!]!",
      __args: { filter: "ProcessTimerFilterInput" },
    },
    username: { __type: "String" },
  },
  UserAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  UserCreatedEvent: {
    __typename: { __type: "String!" },
    userId: { __type: "Int!" },
    userName: { __type: "String!" },
  },
  UserDeletedEvent: {
    __typename: { __type: "String!" },
    userId: { __type: "Int!" },
    userName: { __type: "String!" },
  },
  UserDisabledEvent: {
    __typename: { __type: "String!" },
    userId: { __type: "Int!" },
    userName: { __type: "String!" },
  },
  UserEnabledEvent: {
    __typename: { __type: "String!" },
    userId: { __type: "Int!" },
    userName: { __type: "String!" },
  },
  UserFilterInput: {
    and: { __type: "[UserFilterInput!]" },
    assignedRoles: { __type: "RoleUserFilterInput" },
    authProvider: { __type: "StringFilterInput" },
    authProviderUid: { __type: "StringFilterInput" },
    branch: { __type: "BranchFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    email: { __type: "StringFilterInput" },
    fullName: { __type: "StringFilterInput" },
    hasPersonIdentity: { __type: "BooleanFilterInput" },
    hasPin: { __type: "BooleanFilterInput" },
    id: { __type: "IDFilterInput" },
    identities: { __type: "UserIdentityFilterInput" },
    includeSystem: { __type: "BooleanFilterInput" },
    isActive: { __type: "BooleanFilterInput" },
    isCurrent: { __type: "BooleanFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    oldRoles: { __type: "UserRoleFilterInput" },
    or: { __type: "[UserFilterInput!]" },
    reviewedSuppliers: { __type: "SupplierFilterInput" },
    timers: { __type: "ProcessTimerFilterInput" },
    username: { __type: "StringFilterInput" },
  },
  UserIdentity: {
    __typename: { __type: "String!" },
    created: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    entity: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    person: { __type: "Person" },
    recordId: { __type: "ID" },
    recordLabel: { __type: "String" },
    user: { __type: "User" },
    userId: { __type: "String" },
  },
  UserIdentityAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  UserIdentityFilterInput: {
    and: { __type: "[UserIdentityFilterInput!]" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    entity: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[UserIdentityFilterInput!]" },
    person: { __type: "PersonFilterInput" },
    recordId: { __type: "IDFilterInput" },
    recordLabel: { __type: "StringFilterInput" },
    user: { __type: "UserFilterInput" },
    userId: { __type: "StringFilterInput" },
  },
  UserNotification: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    initialPath: { __type: "[String!]!" },
    initialTab: { __type: "String" },
    recordId: { __type: "ID" },
    recordType: { __type: "String" },
    text: { __type: "String!" },
    timestamp: { __type: "Int!" },
    title: { __type: "String!" },
    unread: { __type: "Boolean!" },
  },
  UserPermission: {
    __typename: { __type: "String!" },
    conditions: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    permission: { __type: "Permission!" },
    policy: { __type: "Policy!" },
    user: { __type: "User!" },
  },
  UserPermissionAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  UserPermissionFilterInput: {
    and: { __type: "[UserPermissionFilterInput!]" },
    conditions: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[UserPermissionFilterInput!]" },
    user: { __type: "UserFilterInput" },
  },
  UserPermissionsUpdatedEvent: {
    __typename: { __type: "String!" },
    assignedPermissions: { __type: "[String]" },
    unassignedPermissions: { __type: "[String]" },
    userId: { __type: "Int!" },
    userName: { __type: "String!" },
  },
  UserReportDimensionValue: {
    __typename: { __type: "String!" },
    branch: { __type: "BranchReportDimensionValue" },
    key: { __type: "String" },
    label: { __type: "String" },
  },
  UserReportGroupByInput: {
    branch: { __type: "BranchReportRelationDimensionInput" },
  },
  UserReportRelationDimensionInput: {
    filter: { __type: "UserFilterInput" },
    groupBy: { __type: "UserReportGroupByInput" },
    includeEmpty: { __type: "Boolean" },
  },
  UserRestoredEvent: {
    __typename: { __type: "String!" },
    userId: { __type: "Int!" },
    userName: { __type: "String!" },
  },
  UserRole: {
    __typename: { __type: "String!" },
    businessRole: { __type: "BusinessRole" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    processAssignments: {
      __type: "[ProcessAssignment!]!",
      __args: { filter: "ProcessAssignmentFilterInput" },
    },
    type: { __type: "String" },
    user: { __type: "User" },
  },
  UserRoleAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  UserRoleFilterInput: {
    and: { __type: "[UserRoleFilterInput!]" },
    businessRole: { __type: "BusinessRoleFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    or: { __type: "[UserRoleFilterInput!]" },
    processAssignments: { __type: "ProcessAssignmentFilterInput" },
    type: { __type: "StringFilterInput" },
    user: { __type: "UserFilterInput" },
  },
  UserRolesUpdatedEvent: {
    __typename: { __type: "String!" },
    assignedRoles: { __type: "[String]" },
    unassignedRoles: { __type: "[String]" },
    userId: { __type: "Int!" },
    userName: { __type: "String!" },
  },
  UserScreensUpdatedEvent: {
    __typename: { __type: "String!" },
    assignedScreens: { __type: "[String]" },
    unassignedScreens: { __type: "[String]" },
    userId: { __type: "Int!" },
    userName: { __type: "String!" },
  },
  UserUpdatedEvent: {
    __typename: { __type: "String!" },
    authProvider: { __type: "String!" },
    branch: { __type: "String" },
    fullName: { __type: "String!" },
    userId: { __type: "Int!" },
    userName: { __type: "String!" },
  },
  Warehouse: {
    __typename: { __type: "String!" },
    address: { __type: "String!" },
    code: { __type: "String" },
    color: { __type: "String" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deleted: { __type: "Boolean!" },
    description: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    stock: { __type: "[Stock!]!", __args: { filter: "StockFilterInput" } },
    stockAggregate: {
      __type: "StockAggregate",
      __args: { filter: "StockFilterInput" },
    },
  },
  WarehouseAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  WarehouseCreatedEvent: {
    __typename: { __type: "String!" },
    warehouseId: { __type: "Int!" },
    warehouseName: { __type: "String!" },
  },
  WarehouseDeletedEvent: {
    __typename: { __type: "String!" },
    warehouseId: { __type: "Int!" },
    warehouseName: { __type: "String!" },
  },
  WarehouseFilterInput: {
    address: { __type: "StringFilterInput" },
    and: { __type: "[WarehouseFilterInput!]" },
    code: { __type: "StringFilterInput" },
    color: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[WarehouseFilterInput!]" },
    stock: { __type: "StockFilterInput" },
  },
  WarehouseStockInput: {
    productId: { __type: "ID!" },
    quantity: { __type: "String!" },
  },
  WarehouseStockReceivedEvent: {
    __typename: { __type: "String!" },
    stock: { __type: "[String]!" },
    warehouseId: { __type: "Int!" },
    warehouseName: { __type: "String!" },
  },
  WarehouseStockTakeEvent: {
    __typename: { __type: "String!" },
    countedStock: { __type: "[String]!" },
    stockDelta: { __type: "[String]!" },
    warehouseId: { __type: "Int!" },
    warehouseName: { __type: "String!" },
  },
  WarehouseStockTakeInput: {
    stock: { __type: "[WarehouseStockInput!]!" },
    warehouseId: { __type: "ID!" },
  },
  WarehouseStockTransferReceivedEvent: {
    __typename: { __type: "String!" },
    receivedWarehouseId: { __type: "Int!" },
    receivedWarehouseName: { __type: "String!" },
    stock: { __type: "[String]!" },
    withdrawnWarehouseId: { __type: "Int!" },
    withdrawnWarehouseName: { __type: "String!" },
  },
  WarehouseStockTransferWithdrawnEvent: {
    __typename: { __type: "String!" },
    receivedWarehouseId: { __type: "Int!" },
    receivedWarehouseName: { __type: "String!" },
    stock: { __type: "[String]!" },
    withdrawnWarehouseId: { __type: "Int!" },
    withdrawnWarehouseName: { __type: "String!" },
  },
  WarehouseStockWithdrawnEvent: {
    __typename: { __type: "String!" },
    stock: { __type: "[String]!" },
    warehouseId: { __type: "Int!" },
    warehouseName: { __type: "String!" },
  },
  WarehouseUpdatedEvent: {
    __typename: { __type: "String!" },
    warehouseId: { __type: "Int!" },
    warehouseName: { __type: "String!" },
  },
  Webhook: {
    __typename: { __type: "String!" },
    authType: { __type: "String!" },
    created: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String!" },
    enabled: { __type: "Boolean!" },
    event: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    modified: { __type: "String!" },
    name: { __type: "String!" },
    recordType: { __type: "String!" },
    sourceFilter: { __type: "String" },
    url: { __type: "String!" },
  },
  WebhookAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  WebhookCallFailedEvent: {
    __typename: { __type: "String!" },
    error: { __type: "String!" },
    statusCode: { __type: "Int" },
    url: { __type: "String!" },
    webhookId: { __type: "String!" },
  },
  WebhookCalledEvent: {
    __typename: { __type: "String!" },
    response: { __type: "String!" },
    url: { __type: "String!" },
    webhookId: { __type: "String!" },
  },
  WebhookCreatedEvent: {
    __typename: { __type: "String!" },
    webhook: { __type: "String!" },
  },
  WebhookDeletedEvent: {
    __typename: { __type: "String!" },
    webhook: { __type: "String!" },
  },
  WebhookFilterInput: {
    and: { __type: "[WebhookFilterInput!]" },
    authType: { __type: "StringFilterInput" },
    created: { __type: "StringFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    enabled: { __type: "BooleanFilterInput" },
    event: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[WebhookFilterInput!]" },
    sourceFilter: { __type: "StringFilterInput" },
    url: { __type: "StringFilterInput" },
  },
  WebhookUpdatedEvent: {
    __typename: { __type: "String!" },
    webhook: { __type: "String!" },
  },
  Week: {
    __typename: { __type: "String!" },
    createdLeadAggregate: {
      __type: "LeadAggregate",
      __args: { filter: "LeadFilterInput" },
    },
    createdPurchaseOrderAggregate: {
      __type: "PurchaseOrderAggregate",
      __args: { filter: "PurchaseOrderFilterInput" },
    },
    createdPurchaseOrderLineAggregate: {
      __type: "PurchaseOrderLineAggregate",
      __args: { filter: "PurchaseOrderLineFilterInput" },
    },
    stockTransactionAggregate: {
      __type: "StockTransactionAggregate",
      __args: { filter: "StockTransactionFilterInput" },
    },
    weekNumber: { __type: "String!" },
    weekNumberAndYear: { __type: "String!" },
    year: { __type: "String!" },
  },
  WeekFilterInput: { date: { __type: "DateTimeFilterInput" } },
  WithdrawWarehouseStockInput: {
    stock: { __type: "[WarehouseStockInput!]!" },
    warehouseId: { __type: "ID!" },
  },
  Workflow: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    type: { __type: "WorkflowType" },
  },
  WorkflowFilterInput: {
    and: { __type: "[WorkflowFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[WorkflowFilterInput!]" },
    type: { __type: "WorkflowTypeFilterInput" },
  },
  WorkflowNode: {
    __typename: { __type: "String!" },
    children: { __type: "[String!]!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    lineItemMasterWorkflow: { __type: "LineItemMasterWorkflow" },
    name: { __type: "String!" },
    nodeType: { __type: "String!" },
    owner: { __type: "String" },
    parents: { __type: "[String!]!" },
    status: { __type: "Int!" },
  },
  WorkflowNodeFilterInput: {
    and: { __type: "[WorkflowNodeFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    lineItemMasterWorkflow: { __type: "LineItemMasterWorkflowFilterInput" },
    name: { __type: "StringFilterInput" },
    nodeType: { __type: "StringFilterInput" },
    or: { __type: "[WorkflowNodeFilterInput!]" },
    owner: { __type: "LineItemMasterWorkflowFilterInput" },
    status: { __type: "NumberFilterInput" },
  },
  WorkflowNote: {
    __typename: { __type: "String!" },
    created: { __type: "String!" },
    createdBy: { __type: "User" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    description: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    modified: { __type: "String!" },
    nodeId: { __type: "ID!" },
    processInstance: { __type: "ProcessInstance" },
    processType: { __type: "ProcessType!" },
  },
  WorkflowNoteAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  WorkflowNoteFilterInput: {
    and: { __type: "[WorkflowNoteFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    createdBy: { __type: "UserFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    modified: { __type: "DateTimeFilterInput" },
    nodeId: { __type: "IDFilterInput" },
    or: { __type: "[WorkflowNoteFilterInput!]" },
    processInstance: { __type: "ProcessInstanceFilterInput" },
    processType: { __type: "ProcessTypeFilterInput" },
  },
  WorkflowTemplate: {
    __typename: { __type: "String!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    display: { __type: "String!" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    name: { __type: "String!" },
    placeHolder: { __type: "Boolean!" },
    placeholders: { __type: "[WorkflowTemplatePlaceholder!]!" },
    previewGroupInstances: {
      __type: "[WorkflowTemplatePreviewGroupInstance!]!",
    },
    previewItems: { __type: "[WorkflowTemplatePreviewItem!]!" },
    valid: { __type: "Boolean!" },
    workflowType: { __type: "WorkflowType" },
  },
  WorkflowTemplateAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  WorkflowTemplateFilterInput: {
    and: { __type: "[WorkflowTemplateFilterInput!]" },
    customData: { __type: "CustomDataFilterInput" },
    display: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[WorkflowTemplateFilterInput!]" },
    placeHolder: { __type: "BooleanFilterInput" },
    valid: { __type: "BooleanFilterInput" },
    workflowType: { __type: "WorkflowTypeFilterInput" },
  },
  WorkflowTemplatePlaceholder: {
    __typename: { __type: "String!" },
    description: { __type: "String" },
    display: { __type: "String!" },
    id: { __type: "ID!" },
    options: { __type: "[WorkflowTemplatePlaceholderOption!]!" },
  },
  WorkflowTemplatePlaceholderOption: {
    __typename: { __type: "String!" },
    description: { __type: "String" },
    display: { __type: "String!" },
    id: { __type: "ID!" },
    placeholders: { __type: "[WorkflowTemplatePlaceholder!]!" },
    previewGroupInstances: {
      __type: "[WorkflowTemplatePreviewGroupInstance!]!",
    },
    previewItems: { __type: "[WorkflowTemplatePreviewItem!]!" },
  },
  WorkflowTemplatePreviewGroupInstance: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    name: { __type: "String!" },
    workflow: { __type: "WorkflowTemplatePreviewGroupWorkflow!" },
  },
  WorkflowTemplatePreviewGroupWorkflow: {
    __typename: { __type: "String!" },
    id: { __type: "ID!" },
    type: { __type: "WorkflowTemplatePreviewWorkflowType" },
  },
  WorkflowTemplatePreviewItem: {
    __typename: { __type: "String!" },
    children: { __type: "[String!]!" },
    id: { __type: "ID!" },
    name: { __type: "String!" },
    nodeType: { __type: "String!" },
    owner: { __type: "String" },
    parents: { __type: "[String!]!" },
    processTypeId: { __type: "String" },
    status: { __type: "Int!" },
  },
  WorkflowTemplatePreviewWorkflowType: {
    __typename: { __type: "String!" },
    id: { __type: "ID" },
    name: { __type: "String" },
  },
  WorkflowType: {
    __typename: { __type: "String!" },
    created: { __type: "DateTime!" },
    customData: {
      __type: "[CustomData]",
      __args: { filter: "CustomDataFilterInput" },
    },
    deleted: { __type: "Boolean!" },
    description: { __type: "String" },
    id: { __type: "ID!" },
    label: { __type: "String!" },
    master: { __type: "Boolean!" },
    modified: { __type: "DateTime!" },
    name: { __type: "String!" },
  },
  WorkflowTypeAggregate: {
    __typename: { __type: "String!" },
    count: { __type: "Int!" },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput" },
    },
    groups: {
      __type: "ResourceGroupPage!",
      __args: { by: "ResourceGroupByInput!", limit: "Int", offset: "Int" },
    },
  },
  WorkflowTypeCreatedEvent: {
    __typename: { __type: "String!" },
    workflowTypeId: { __type: "String!" },
    workflowTypeName: { __type: "String!" },
  },
  WorkflowTypeDeletedEvent: {
    __typename: { __type: "String!" },
    workflowTypeId: { __type: "String!" },
    workflowTypeName: { __type: "String!" },
  },
  WorkflowTypeFilterInput: {
    and: { __type: "[WorkflowTypeFilterInput!]" },
    created: { __type: "DateTimeFilterInput" },
    customData: { __type: "CustomDataFilterInput" },
    deleted: { __type: "BooleanFilterInput" },
    description: { __type: "StringFilterInput" },
    id: { __type: "IDFilterInput" },
    isNull: { __type: "BooleanFilterInput" },
    label: { __type: "StringFilterInput" },
    master: { __type: "BooleanFilterInput" },
    modified: { __type: "DateTimeFilterInput" },
    name: { __type: "StringFilterInput" },
    or: { __type: "[WorkflowTypeFilterInput!]" },
  },
  WorkflowTypeRestoredEvent: {
    __typename: { __type: "String!" },
    workflowTypeId: { __type: "String!" },
    workflowTypeName: { __type: "String!" },
  },
  WorkflowTypeUpdatedEvent: {
    __typename: { __type: "String!" },
    workflowTypeId: { __type: "String!" },
    workflowTypeName: { __type: "String!" },
  },
  mutation: {
    __typename: { __type: "String!" },
    acceptQuote: { __type: "ID", __args: { input: "AcceptQuoteInput!" } },
    activatePerson: { __type: "ID", __args: { personId: "ID!" } },
    amendPurchaseOrder: {
      __type: "ID",
      __args: { input: "AmendPurchaseOrderInput!" },
    },
    assignBusinessRolesToBatchSchedule: {
      __type: "ID",
      __args: { input: "AssignBusinessRolesToBatchScheduleInput!" },
    },
    assignBusinessRolesToPerson: {
      __type: "ID",
      __args: { input: "AssignBusinessRolesToPersonInput!" },
    },
    assignInheritanceToRole: {
      __type: "ID",
      __args: { input: "AssignInheritanceToRoleInput!" },
    },
    assignLeadsToSalesperson: {
      __type: "[ID!]",
      __args: { input: "AssignLeadsToSalespersonInput!" },
    },
    assignPermissionsToRole: {
      __type: "ID",
      __args: { input: "AssignPermissionsToRoleInput!" },
    },
    assignPermissionsToUser: {
      __type: "ID",
      __args: { input: "AssignPermissionsToUserInput!" },
    },
    assignRolesToUser: {
      __type: "ID",
      __args: { input: "AssignRolesToUserInput!" },
    },
    assignScreensToRole: {
      __type: "ID",
      __args: { input: "AssignScreensToRoleInput!" },
    },
    assignScreensToUser: {
      __type: "ID",
      __args: { input: "AssignScreensToUserInput!" },
    },
    assignUsersToProcessInstance: {
      __type: "String!",
      __args: { processInstanceId: "ID!", userRoles: "[ID!]!" },
    },
    assignUsersToRole: {
      __type: "ID",
      __args: { input: "AssignUsersToRoleInput!" },
    },
    bulkCreatePurchaseOrder: {
      __type: "[ID!]!",
      __args: { orders: "[CreatePurchaseOrderInput!]!", place: "Boolean" },
    },
    bulkProductImport: {
      __type: "String",
      __args: {
        productsToImport: "[ProductImportInput!]!",
        updateFields: "[ProductImportUpdateField!]!",
      },
    },
    bulkProductPriceAdjustment: {
      __type: "ID!",
      __args: { productIds: "[ID!]!" },
    },
    cancelPurchaseOrders: {
      __type: "[ID!]",
      __args: { input: "CancelPurchaseOrdersInput!" },
    },
    cancelSalesOrder: {
      __type: "ID",
      __args: { input: "CancelSalesOrderInput!" },
    },
    cancelSupplierQuoteRequest: {
      __type: "ID",
      __args: { input: "CancelSupplierQuoteRequestInput!" },
    },
    cleanupFiles: { __type: "Void" },
    clearPermissionCache: { __type: "Boolean" },
    commitPendingFiles: {
      __type: "String",
      __args: { input: "CommitPendingFilesInput!" },
    },
    completeTimers: { __type: "ID", __args: { timerIds: "[ID!]!" } },
    confirmSalesOrder: {
      __type: "ID",
      __args: { input: "ConfirmSalesOrderInput!" },
    },
    convertCandidate: { __type: "ID", __args: { id: "ID!" } },
    convertLeadToJob: {
      __type: "ID",
      __args: { input: "ConvertLeadToJobInput!" },
    },
    createAuthToken: { __type: "String!", __args: { userId: "String!" } },
    createBatch: { __type: "ID", __args: { input: "CreateBatchInput!" } },
    createBranch: { __type: "ID", __args: { input: "CreateBranchInput!" } },
    createBuilder: { __type: "ID!", __args: { input: "CreateBuilderInput!" } },
    createBusinessRole: {
      __type: "ID",
      __args: { input: "CreateBusinessRoleInput!" },
    },
    createCandidate: {
      __type: "AsyncTask",
      __args: { input: "CreateCandidateInput!" },
    },
    createClient: { __type: "ID", __args: { input: "CreateClientInput!" } },
    createCorrespondence: {
      __type: "ID!",
      __args: { input: "CreateCorrespondenceInput!" },
    },
    createCosting: { __type: "ID", __args: { input: "CreateCostingInput!" } },
    createCostingTemplate: {
      __type: "ID",
      __args: { input: "CreateCostingTemplateInput!" },
    },
    createCostingTemplateRevision: {
      __type: "ID",
      __args: { input: "CreateCostingTemplateRevisionInput!" },
    },
    createDocumentTemplate: {
      __type: "ID",
      __args: { input: "CreateDocumentTemplateInput!" },
    },
    createFiles: { __type: "[ID!]", __args: { files: "[CreateFileInput!]!" } },
    createFirebaseAuthToken: { __type: "String", __args: { userId: "ID!" } },
    createFolder: { __type: "ID", __args: { input: "CreateFolderInput!" } },
    createHousingCompany: {
      __type: "ID",
      __args: { input: "CreateHousingCompanyInput!" },
    },
    createHousingCompanyImage: {
      __type: "ID",
      __args: { input: "CreateHousingCompanyImageInput!" },
    },
    createIssue: { __type: "ID", __args: { input: "CreateIssueInput!" } },
    createJob: { __type: "[ID!]", __args: { input: "CreateJobInput!" } },
    createJobComponent: {
      __type: "ID",
      __args: { input: "CreateJobComponentInput!" },
    },
    createJobEmail: {
      __type: "ID!",
      __args: { input: "CreateJobEmailInput!" },
    },
    createJobFileUrl: { __type: "String!", __args: { jobId: "ID!" } },
    createLead: { __type: "ID", __args: { input: "CreateLeadInput!" } },
    createLineItem: { __type: "ID", __args: { input: "CreateLineItemInput!" } },
    createLostReason: {
      __type: "ID",
      __args: { input: "CreateLostReasonInput!" },
    },
    createPanel: { __type: "ID", __args: { input: "CreatePanelInput!" } },
    createPartType: { __type: "ID", __args: { input: "CreatePartTypeInput!" } },
    createPerson: { __type: "ID", __args: { input: "CreatePersonInput!" } },
    createProcessAsset: {
      __type: "String!",
      __args: { assetId: "ID!", processInstanceId: "ID!" },
    },
    createProcessTimer: {
      __type: "ID",
      __args: { input: "CreateProcessTimerInput!" },
    },
    createProcessType: {
      __type: "ID",
      __args: { input: "CreateProcessTypeInput!" },
    },
    createProcessTypeNote: {
      __type: "ID",
      __args: { input: "CreateProcessTypeNoteInput!" },
    },
    createProcessTypeRole: {
      __type: "ID",
      __args: { input: "CreateProcessTypeRoleInput!" },
    },
    createProduct: { __type: "ID", __args: { input: "CreateProductInput!" } },
    createProductCategory: {
      __type: "ID",
      __args: { input: "CreateProductCategoryInput!" },
    },
    createProductPrice: {
      __type: "ID",
      __args: { input: "CreateProductPriceInput!" },
    },
    createProject: { __type: "ID!", __args: { input: "CreateProjectInput!" } },
    createPurchaseOrder: {
      __type: "PurchaseOrderSavePayload",
      __args: { place: "Boolean", purchaseOrder: "CreatePurchaseOrderInput!" },
    },
    createPurchaseOrderFromSupplierQuote: {
      __type: "ID",
      __args: { input: "CreatePurchaseOrderFromSupplierQuoteInput!" },
    },
    createPurchaseOrderReceipt: {
      __type: "ID",
      __args: { input: "CreatePurchaseOrderReceiptInput!" },
    },
    createQuote: { __type: "ID", __args: { input: "CreateQuoteInput!" } },
    createQuoteApprovalRequest: {
      __type: "ID!",
      __args: { input: "CreateQuoteApprovalRequestInput!" },
    },
    createQuoteTemplate: {
      __type: "ID",
      __args: { input: "CreateQuoteTemplateInput!" },
    },
    createQuoteTemplateRevision: {
      __type: "ID",
      __args: { input: "CreateQuoteTemplateRevisionInput!" },
    },
    createRecordFile: {
      __type: "ID!",
      __args: { input: "CreateRecordFileInput!" },
    },
    createRole: { __type: "ID", __args: { input: "CreateRoleInput!" } },
    createSalesOrder: {
      __type: "ID",
      __args: { input: "CreateSalesOrderInput!" },
    },
    createSchema: { __type: "ID!", __args: { input: "CreateSchemaInput!" } },
    createSchemaVersion: {
      __type: "ID!",
      __args: { input: "SchemaVersionInput!" },
    },
    createScreen: { __type: "ID", __args: { input: "CreateScreenInput!" } },
    createSignedUploadUrl: {
      __type: "SignedUploadUrlPayload",
      __args: { input: "CreateSignedUploadUrlInput!" },
    },
    createSpecification: { __type: "ID!", __args: { lineItemId: "ID!" } },
    createStorageConnection: {
      __type: "ID",
      __args: { input: "CreateStorageConnectionInput!" },
    },
    createStorageResourceMapping: {
      __type: "ID",
      __args: { input: "CreateStorageResourceMappingInput!" },
    },
    createSubscription: {
      __type: "ID",
      __args: { input: "CreateSubscriptionInput!" },
    },
    createSupplier: { __type: "ID", __args: { input: "CreateSupplierInput!" } },
    createSupplierImage: {
      __type: "ID",
      __args: { input: "CreateSupplierImageInput!" },
    },
    createSupplierQuote: {
      __type: "ID",
      __args: { input: "CreateSupplierQuoteInput!" },
    },
    createSupplierQuoteRequest: {
      __type: "[ID!]",
      __args: { input: "CreateSupplierQuoteRequestInput!" },
    },
    createTag: { __type: "ID", __args: { input: "CreateTagInput!" } },
    createUser: { __type: "ID", __args: { input: "CreateUserInput!" } },
    createUserIdentity: {
      __type: "ID",
      __args: { input: "CreateUserIdentityInput!" },
    },
    createWarehouse: {
      __type: "ID",
      __args: { input: "CreateWarehouseInput!" },
    },
    createWebhook: { __type: "ID", __args: { input: "CreateWebhookInput!" } },
    createWorkflowType: {
      __type: "ID",
      __args: { input: "CreateWorkflowTypeInput!" },
    },
    deactivatePerson: {
      __type: "ID",
      __args: { input: "DeactivatePersonInput!" },
    },
    deleteBatches: {
      __type: "[ID!]",
      __args: { input: "DeleteBatchesInput!" },
    },
    deleteBranches: {
      __type: "[ID!]",
      __args: { input: "DeleteBranchesInput!" },
    },
    deleteBuilders: {
      __type: "[ID!]",
      __args: { input: "DeleteBuildersInput!" },
    },
    deleteBusinessRole: { __type: "ID", __args: { businessRoleId: "ID!" } },
    deleteCandidate: { __type: "ID!", __args: { id: "ID!" } },
    deleteClients: {
      __type: "[ID!]",
      __args: { input: "DeleteClientsInput!" },
    },
    deleteConfiguredLinkedActions: {
      __type: "[ID!]",
      __args: { input: "DeleteConfiguredLinkedActionsInput!" },
    },
    deleteCorrespondence: {
      __type: "ID",
      __args: { input: "DeleteCorrespondenceInput!" },
    },
    deleteCosting: { __type: "ID", __args: { input: "DeleteCostingInput!" } },
    deleteCustomData: { __type: "ID!", __args: { id: "ID!" } },
    deleteDocumentTemplate: {
      __type: "ID",
      __args: { documentTemplateId: "ID!" },
    },
    deleteDraftPurchaseOrders: {
      __type: "[ID!]",
      __args: { input: "DeleteDraftPurchaseOrdersInput!" },
    },
    deleteExternalStorageItems: {
      __type: "Boolean",
      __args: { input: "DeleteExternalStorageItemsInput!" },
    },
    deleteFavouriteLinkedAction: { __type: "ID", __args: { id: "ID!" } },
    deleteHousingCompanies: {
      __type: "[ID!]",
      __args: { input: "DeleteHousingCompaniesInput!" },
    },
    deleteHousingCompanyImage: {
      __type: "ID",
      __args: { input: "DeleteHousingCompanyImageInput!" },
    },
    deleteJobComponent: {
      __type: "ID",
      __args: { input: "DeleteJobComponentInput!" },
    },
    deleteLeads: { __type: "[ID!]", __args: { input: "DeleteLeadsInput!" } },
    deleteLineItems: {
      __type: "[ID!]",
      __args: { input: "DeleteLineItemsInput!" },
    },
    deleteLostReasons: {
      __type: "[ID!]",
      __args: { input: "DeleteLostReasonsInput!" },
    },
    deletePanels: { __type: "[ID!]", __args: { input: "DeletePanelsInput!" } },
    deletePartTypes: {
      __type: "[ID!]",
      __args: { input: "DeletePartTypesInput!" },
    },
    deleteProcessTypeNote: {
      __type: "ID",
      __args: { input: "DeleteProcessTypeNoteInput!" },
    },
    deleteProcessTypeRoles: {
      __type: "[ID!]",
      __args: { input: "DeleteProcessTypeRolesInput!" },
    },
    deleteProcessTypes: {
      __type: "[ID!]",
      __args: { input: "DeleteProcessTypesInput!" },
    },
    deleteProductCategories: {
      __type: "[ID!]",
      __args: { input: "DeleteProductCategoriesInput!" },
    },
    deleteProductPrices: {
      __type: "[ID!]",
      __args: { input: "DeleteProductPricesInput!" },
    },
    deleteQuote: { __type: "ID", __args: { id: "ID!" } },
    deleteRecordFiles: {
      __type: "Void",
      __args: { input: "DeleteRecordFilesInput!" },
    },
    deleteRole: { __type: "ID", __args: { id: "ID!" } },
    deleteSalesOrder: {
      __type: "ID",
      __args: { input: "DeleteSalesOrderInput!" },
    },
    deleteSchema: { __type: "ID!", __args: { id: "ID!" } },
    deleteSchemaVersion: { __type: "ID!", __args: { id: "ID!" } },
    deleteScreens: {
      __type: "[ID!]",
      __args: { input: "DeleteScreensInput!" },
    },
    deleteStorageConnection: { __type: "ID!", __args: { id: "ID!" } },
    deleteStorageResourceMapping: { __type: "ID!", __args: { id: "ID!" } },
    deleteSubscription: { __type: "ID", __args: { subscriptionId: "ID!" } },
    deleteSupplierImage: {
      __type: "ID",
      __args: { input: "DeleteSupplierImageInput!" },
    },
    deleteSupplierQuote: {
      __type: "ID",
      __args: { input: "DeleteSupplierQuoteInput!" },
    },
    deleteSupplierQuoteRequest: {
      __type: "ID",
      __args: { input: "DeleteSupplierQuoteRequestInput!" },
    },
    deleteSuppliers: {
      __type: "[ID!]",
      __args: { input: "DeleteSuppliersInput!" },
    },
    deleteTag: { __type: "ID", __args: { id: "ID!" } },
    deleteUser: { __type: "ID", __args: { userId: "ID!" } },
    deleteUserIdentities: {
      __type: "[ID!]",
      __args: { input: "DeleteUserIdentitiesInput!" },
    },
    deleteWarehouse: { __type: "ID", __args: { id: "ID!" } },
    deleteWebhooks: {
      __type: "[ID!]",
      __args: { input: "DeleteWebhooksInput!" },
    },
    deleteWorkflowTypes: {
      __type: "[ID!]",
      __args: { input: "DeleteWorkflowTypesInput!" },
    },
    disableUser: { __type: "ID", __args: { userId: "ID!" } },
    enableUser: { __type: "ID", __args: { userId: "ID!" } },
    generateCurrentProductPricing: { __type: "Boolean" },
    issueQuote: { __type: "ID", __args: { input: "IssueQuoteInput!" } },
    markJobLost: { __type: "ID", __args: { input: "MarkJobLostInput!" } },
    markLeadLost: { __type: "ID", __args: { input: "MarkLeadLostInput!" } },
    markPurchaseOrderInvoiceAsChecked: {
      __type: "ID",
      __args: { purchaseOrderId: "ID!" },
    },
    markPurchaseOrderInvoiceAsUnchecked: {
      __type: "ID",
      __args: { purchaseOrderId: "ID!" },
    },
    notifyJobPhotoRecipients: {
      __type: "Boolean!",
      __args: { area: "String!", jobNumber: "String!", notes: "String" },
    },
    overrideLeadStatus: {
      __type: "ID",
      __args: { input: "OverrideLeadStatusInput!" },
    },
    overridePurchaseOrderStatus: {
      __type: "ID",
      __args: { input: "OverridePurchaseOrderStatusInput!" },
    },
    pauseTimers: { __type: "ID", __args: { timerIds: "[ID!]!" } },
    promoteSchemaVersion: {
      __type: "ID",
      __args: { input: "PromoteSchemaVersionInput!" },
    },
    publishDraftCostingRevision: { __type: "ID", __args: { costingId: "ID!" } },
    publishDraftCostingTemplate: {
      __type: "ID",
      __args: { costingTemplateId: "ID!" },
    },
    publishDraftQuoteTemplate: {
      __type: "ID",
      __args: { quoteTemplateId: "ID!" },
    },
    receiveWarehouseStock: {
      __type: "ID",
      __args: { input: "ReceiveWarehouseStockInput!" },
    },
    releasePurchaseOrders: {
      __type: "[ID!]",
      __args: { input: "ReleasePurchaseOrdersInput!" },
    },
    removeProcessAsset: {
      __type: "String!",
      __args: { assetId: "ID!", processInstanceId: "ID!" },
    },
    rescheduleBatches: {
      __type: "[ID!]",
      __args: { input: "RescheduleBatchesInput!" },
    },
    rescheduleProcessTypeNote: {
      __type: "ID",
      __args: { date: "String!", processTypeNoteId: "ID!" },
    },
    resendPurchaseOrderSupplierNotification: {
      __type: "AsyncTask",
      __args: { id: "ID!" },
    },
    resetUserPassword: {
      __type: "ID",
      __args: { input: "ResetUserPasswordInput!" },
    },
    restorePartTypes: {
      __type: "[ID!]",
      __args: { input: "RestorePartTypesInput!" },
    },
    restoreProcessTypes: {
      __type: "[ID!]",
      __args: { input: "RestoreProcessTypesInput!" },
    },
    restoreWorkflowTypes: {
      __type: "[ID!]",
      __args: { input: "RestoreWorkflowTypesInput!" },
    },
    resumeTimers: { __type: "ID", __args: { timerIds: "[ID!]!" } },
    reviseQuote: { __type: "ID", __args: { input: "ReviseQuoteInput!" } },
    screenAssignment: {
      __type: "ID",
      __args: { input: "ScreenAssignmentInput!" },
    },
    screenUnassignment: {
      __type: "ID",
      __args: { input: "ScreenUnassignmentInput!" },
    },
    setCandidateIngestionPolicy: {
      __type: "ID",
      __args: { input: "SetCandidateIngestionPolicyInput!" },
    },
    setConfiguredLinkedAction: {
      __type: "ID",
      __args: { input: "SetConfiguredLinkedActionInput!" },
    },
    setCustomData: { __type: "ID!", __args: { input: "SetCustomDataInput!" } },
    setDefaultCostingTemplate: {
      __type: "ID",
      __args: { costingTemplateId: "ID!" },
    },
    setDefaultDocumentTemplate: {
      __type: "ID",
      __args: { documentTemplateId: "ID!" },
    },
    setDefaultFolder: {
      __type: "ID",
      __args: { input: "SetDefaultFolderInput!" },
    },
    setDefaultQuoteTemplate: {
      __type: "ID",
      __args: { quoteTemplateId: "ID!" },
    },
    setFavouriteLinkedAction: {
      __type: "ID",
      __args: { input: "SetFavouriteLinkedActionInput!" },
    },
    setLinkedActionRecipient: {
      __type: "ID",
      __args: { input: "SetLinkedActionRecipientInput!" },
    },
    setUserPin: { __type: "ID", __args: { input: "SetUserPinInput!" } },
    submitPurchaseOrderReview: {
      __type: "ID!",
      __args: { input: "SubmitPurchaseOrderReviewInput!" },
    },
    submitQuoteForApproval: { __type: "ID!", __args: { id: "ID!" } },
    transferWarehouseStock: {
      __type: "ID",
      __args: { input: "TransferWarehouseStockInput!" },
    },
    triggerWebhook: { __type: "ID", __args: { input: "TriggerWebhookInput!" } },
    unassignBusinessRolesFromPerson: {
      __type: "[ID!]",
      __args: { input: "UnassignBusinessRolesFromPersonInput!" },
    },
    unassignInheritanceFromRole: {
      __type: "ID",
      __args: { input: "UnassignInheritanceFromRoleInput!" },
    },
    unassignLeadsFromSalesperson: {
      __type: "[ID!]",
      __args: { input: "UnassignLeadsFromSalespersonInput!" },
    },
    unassignPermissionsFromRole: {
      __type: "ID",
      __args: { input: "UnassignPermissionsFromRoleInput!" },
    },
    unassignPermissionsFromUser: {
      __type: "ID",
      __args: { input: "UnassignPermissionsFromUserInput!" },
    },
    unassignRolesFromUser: {
      __type: "ID",
      __args: { input: "UnassignRolesFromUserInput!" },
    },
    unassignScreensFromRole: {
      __type: "ID",
      __args: { input: "UnassignScreensFromRoleInput!" },
    },
    unassignScreensFromUser: {
      __type: "ID",
      __args: { input: "UnassignScreensFromUserInput!" },
    },
    unassignUsersFromRole: {
      __type: "ID",
      __args: { input: "UnassignUsersFromRoleInput!" },
    },
    unmarkJobLost: { __type: "ID", __args: { input: "UnmarkJobLostInput!" } },
    unmarkLeadLost: { __type: "ID", __args: { input: "UnmarkLeadLostInput!" } },
    unsetUserPin: { __type: "ID", __args: { userId: "ID!" } },
    updateBatchDetails: {
      __type: "ID",
      __args: { input: "UpdateBatchDetailsInput!" },
    },
    updateBranch: { __type: "ID", __args: { input: "UpdateBranchInput!" } },
    updateBuilder: { __type: "ID", __args: { input: "UpdateBuilderInput!" } },
    updateBusinessRole: {
      __type: "ID",
      __args: { input: "UpdateBusinessRoleInput!" },
    },
    updateClient: { __type: "ID", __args: { input: "UpdateClientInput!" } },
    updateCorrespondence: {
      __type: "ID!",
      __args: { input: "UpdateCorrespondenceInput!" },
    },
    updateCosting: { __type: "ID", __args: { input: "UpdateCostingInput!" } },
    updateCurrentUserNotifications: {
      __type: "Boolean!",
      __args: { action: "NotificationAction!", ids: "[ID!]!" },
    },
    updateDocumentTemplate: {
      __type: "ID",
      __args: { input: "UpdateDocumentTemplateInput!" },
    },
    updateDraftCostingTemplateRevision: {
      __type: "ID",
      __args: { input: "CreateCostingTemplateRevisionInput!" },
    },
    updateDraftPurchaseOrder: {
      __type: "PurchaseOrderSavePayload",
      __args: {
        place: "Boolean",
        purchaseOrder: "UpdateDraftPurchaseOrderInput!",
        purchaseOrderId: "ID!",
      },
    },
    updateDraftQuoteTemplateRevision: {
      __type: "ID",
      __args: { input: "CreateQuoteTemplateRevisionInput!" },
    },
    updateDraftSchemaVersion: {
      __type: "ID",
      __args: { input: "UpdateDraftSchemaVersionInput!" },
    },
    updateHousingCompany: {
      __type: "ID",
      __args: { input: "UpdateHousingCompanyInput!" },
    },
    updateIssue: { __type: "ID", __args: { input: "UpdateIssueInput!" } },
    updateJobBuilder: {
      __type: "ID",
      __args: { input: "UpdateJobBuilderInput!" },
    },
    updateJobClient: {
      __type: "ID",
      __args: { input: "UpdateJobClientInput!" },
    },
    updateJobComponent: {
      __type: "ID",
      __args: { input: "UpdateJobComponentInput!" },
    },
    updateJobDetails: {
      __type: "ID",
      __args: { input: "UpdateJobDetailsInput!" },
    },
    updateJobNote: { __type: "ID", __args: { input: "UpdateJobNoteInput!" } },
    updateJobSite: { __type: "ID", __args: { input: "UpdateJobSiteInput!" } },
    updateLead: { __type: "ID", __args: { input: "UpdateLeadInput!" } },
    updateLineItem: { __type: "ID", __args: { input: "UpdateLineItemInput!" } },
    updateLineItemWorkflow: {
      __type: "ID",
      __args: { input: "UpdateLineItemWorkflowInput!" },
    },
    updateLostReason: {
      __type: "ID",
      __args: { input: "UpdateLostReasonInput!" },
    },
    updatePanelConfig: {
      __type: "ID",
      __args: { input: "UpdatePanelConfigInput!" },
    },
    updatePanelDetails: {
      __type: "ID",
      __args: { input: "UpdatePanelDetailsInput!" },
    },
    updatePartType: { __type: "ID", __args: { input: "UpdatePartTypeInput!" } },
    updatePermissionForRole: {
      __type: "ID",
      __args: { input: "UpdatePermissionForRoleInput!" },
    },
    updatePermissionForUser: {
      __type: "ID",
      __args: { input: "UpdatePermissionForUserInput!" },
    },
    updatePerson: { __type: "ID", __args: { input: "UpdatePersonInput!" } },
    updateProcessInstanceDetails: {
      __type: "ID",
      __args: { input: "UpdateProcessInstanceDetailsInput!" },
    },
    updateProcessInstanceStatus: {
      __type: "ID",
      __args: { input: "UpdateProcessInstanceStatusInput!" },
    },
    updateProcessTypeDetails: {
      __type: "ID",
      __args: { input: "UpdateProcessTypeDetailsInput!" },
    },
    updateProcessTypeNote: {
      __type: "ID",
      __args: { input: "UpdateProcessTypeNoteInput!" },
    },
    updateProcessTypeRole: {
      __type: "ID",
      __args: { input: "UpdateProcessTypeRoleInput!" },
    },
    updateProductCategory: {
      __type: "ID",
      __args: { input: "UpdateProductCategoryInput!" },
    },
    updateProductDetails: {
      __type: "[ID!]",
      __args: { input: "UpdateProductDetailsInput!" },
    },
    updatePurchaseOrderInternalComment: {
      __type: "ID!",
      __args: { input: "UpdatePurchaseOrderInternalCommentInput!" },
    },
    updateQuote: { __type: "ID", __args: { input: "UpdateQuoteInput!" } },
    updateRoleDetails: {
      __type: "ID",
      __args: { input: "UpdateRoleDetailsInput!" },
    },
    updateSalesOrder: {
      __type: "ID",
      __args: { input: "UpdateSalesOrderInput!" },
    },
    updateSchemaDetails: {
      __type: "ID",
      __args: { input: "UpdateSchemaDetailsInput!" },
    },
    updateScreenConfig: {
      __type: "ID",
      __args: { input: "UpdateScreenConfigInput!" },
    },
    updateScreenDetails: {
      __type: "ID",
      __args: { input: "UpdateScreenDetailsInput!" },
    },
    updateSettings: {
      __type: "ID!",
      __args: { input: "UpdateSettingsInput!" },
    },
    updateStorageConnection: {
      __type: "ID",
      __args: { input: "UpdateStorageConnectionInput!" },
    },
    updateStorageResourceMapping: {
      __type: "ID",
      __args: { input: "UpdateStorageResourceMappingInput!" },
    },
    updateSubscription: {
      __type: "Boolean!",
      __args: { input: "UpdateSubscriptionInput!" },
    },
    updateSupplierDetails: {
      __type: "ID",
      __args: { input: "UpdateSupplierDetailsInput!" },
    },
    updateSupplierQuote: {
      __type: "ID",
      __args: { input: "UpdateSupplierQuoteInput!" },
    },
    updateSupplierQuoteRequest: {
      __type: "ID",
      __args: { input: "UpdateSupplierQuoteRequestInput!" },
    },
    updateSupplierReviewers: {
      __type: "ID",
      __args: { input: "UpdateSupplierReviewersInput!" },
    },
    updateTag: { __type: "ID", __args: { input: "UpdateTagInput!" } },
    updateUserDetails: {
      __type: "ID",
      __args: { input: "UpdateUserDetailsInput!" },
    },
    updateUserSubscriptions: {
      __type: "Boolean!",
      __args: { input: "UpdateUserSubscriptionsInput!" },
    },
    updateWarehouse: {
      __type: "ID",
      __args: { input: "UpdateWarehouseInput!" },
    },
    updateWebhook: { __type: "ID", __args: { input: "UpdateWebhookInput!" } },
    updateWorkflowTypeDetails: {
      __type: "ID",
      __args: { input: "UpdateWorkflowTypeDetailsInput!" },
    },
    warehouseStockTake: {
      __type: "ID",
      __args: { input: "WarehouseStockTakeInput!" },
    },
    withdrawWarehouseStock: {
      __type: "ID",
      __args: { input: "WithdrawWarehouseStockInput!" },
    },
  },
  query: {
    __typename: { __type: "String!" },
    actAsUser: { __type: "ActAsUser", __args: { id: "ID" } },
    actAsUsers: {
      __type: "[ActAsUser!]",
      __args: {
        filter: "ActAsUserFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    actAsUsersAggregate: {
      __type: "ActAsUserAggregate",
      __args: { filter: "ActAsUserFilterInput", group: "ResourceGroupInput" },
    },
    asset: { __type: "Asset", __args: { id: "ID" } },
    assets: {
      __type: "[Asset!]",
      __args: {
        filter: "AssetFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    assetsAggregate: {
      __type: "AssetAggregate",
      __args: { filter: "AssetFilterInput", group: "ResourceGroupInput" },
    },
    assignedPermissions: {
      __type: "[AssignedPermission!]",
      __args: {
        assignedId: "ID!",
        assignedType: "String!",
        filter: "AssignedPermissionFilterInput",
        options: "OptionsInput",
      },
    },
    asyncTask: { __type: "AsyncTask", __args: { id: "ID" } },
    asyncTasks: {
      __type: "[AsyncTask!]",
      __args: {
        filter: "AsyncTaskFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    asyncTasksAggregate: {
      __type: "AsyncTaskAggregate",
      __args: { filter: "AsyncTaskFilterInput", group: "ResourceGroupInput" },
    },
    attachmentTemplate: { __type: "AttachmentTemplate", __args: { id: "ID" } },
    attachmentTemplates: {
      __type: "[AttachmentTemplate!]",
      __args: {
        filter: "AttachmentTemplateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    attachmentTemplatesAggregate: {
      __type: "AttachmentTemplateAggregate",
      __args: {
        filter: "AttachmentTemplateFilterInput",
        group: "ResourceGroupInput",
      },
    },
    auditLog: { __type: "AuditLog", __args: { id: "ID" } },
    auditLogs: {
      __type: "[AuditLog!]",
      __args: {
        filter: "AuditLogFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    auditLogsAggregate: {
      __type: "ResourceAggregate",
      __args: { filter: "AuditLogFilterInput", group: "ResourceGroupInput" },
    },
    batch: { __type: "Batch", __args: { id: "ID" } },
    batchSchedule: { __type: "BatchSchedule", __args: { id: "ID" } },
    batchScheduleReport: {
      __type: "[BatchScheduleReportRow!]",
      __args: { groupBy: "[BatchScheduleReportGroupByInput!]!" },
    },
    batchSchedules: {
      __type: "[BatchSchedule!]",
      __args: {
        filter: "BatchScheduleFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    batchSchedulesAggregate: {
      __type: "BatchScheduleAggregate",
      __args: {
        filter: "BatchScheduleFilterInput",
        group: "ResourceGroupInput",
      },
    },
    batches: {
      __type: "[Batch!]",
      __args: {
        filter: "BatchFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    batchesAggregate: {
      __type: "BatchAggregate",
      __args: { filter: "BatchFilterInput", group: "ResourceGroupInput" },
    },
    billOfMaterialsImport: {
      __type: "BillOfMaterialsImport",
      __args: { jobId: "ID!", loader: "ID!", path: "String!" },
    },
    branch: { __type: "Branch", __args: { id: "ID" } },
    branches: {
      __type: "[Branch!]",
      __args: {
        filter: "BranchFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    branchesAggregate: {
      __type: "BranchAggregate",
      __args: { filter: "BranchFilterInput", group: "ResourceGroupInput" },
    },
    buildType: { __type: "BuildType", __args: { id: "ID" } },
    buildTypes: {
      __type: "[BuildType!]",
      __args: {
        filter: "BuildTypeFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    buildTypesAggregate: {
      __type: "BuildTypeAggregate",
      __args: { filter: "BuildTypeFilterInput", group: "ResourceGroupInput" },
    },
    builder: { __type: "Builder", __args: { id: "ID" } },
    builders: {
      __type: "[Builder!]",
      __args: {
        filter: "BuilderFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    buildersAggregate: {
      __type: "BuilderAggregate",
      __args: { filter: "BuilderFilterInput", group: "ResourceGroupInput" },
    },
    businessRole: { __type: "BusinessRole", __args: { id: "ID" } },
    businessRoles: {
      __type: "[BusinessRole!]",
      __args: {
        filter: "BusinessRoleFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    businessRolesAggregate: {
      __type: "BusinessRoleAggregate",
      __args: {
        filter: "BusinessRoleFilterInput",
        group: "ResourceGroupInput",
      },
    },
    calculateQuote: {
      __type: "Quote",
      __args: { input: "CalculateQuoteInput!" },
    },
    candidate: { __type: "Candidate", __args: { id: "ID" } },
    candidateIngestionPolicies: {
      __type: "[CandidateIngestionPolicy!]",
      __args: {
        filter: "CandidateIngestionPolicyFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    candidateIngestionPoliciesAggregate: {
      __type: "CandidateIngestionPolicyAggregate",
      __args: {
        filter: "CandidateIngestionPolicyFilterInput",
        group: "ResourceGroupInput",
      },
    },
    candidateIngestionPolicy: {
      __type: "CandidateIngestionPolicy",
      __args: { id: "ID" },
    },
    candidates: {
      __type: "[Candidate!]",
      __args: {
        filter: "CandidateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    candidatesAggregate: {
      __type: "CandidateAggregate",
      __args: { filter: "CandidateFilterInput", group: "ResourceGroupInput" },
    },
    client: { __type: "Client", __args: { id: "ID" } },
    clients: {
      __type: "[Client!]",
      __args: {
        filter: "ClientFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    clientsAggregate: {
      __type: "ClientAggregate",
      __args: { filter: "ClientFilterInput", group: "ResourceGroupInput" },
    },
    configuredLinkedAction: {
      __type: "ConfiguredLinkedAction",
      __args: { id: "ID" },
    },
    configuredLinkedActions: {
      __type: "[ConfiguredLinkedAction!]",
      __args: {
        filter: "ConfiguredLinkedActionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    configuredLinkedActionsAggregate: {
      __type: "ConfiguredLinkedActionAggregate",
      __args: {
        filter: "ConfiguredLinkedActionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    correspondence: {
      __type: "[Correspondence!]",
      __args: {
        filter: "CorrespondenceFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    correspondenceAggregate: {
      __type: "CorrespondenceAggregate",
      __args: {
        filter: "CorrespondenceFilterInput",
        group: "ResourceGroupInput",
      },
    },
    correspondenceRecord: { __type: "Correspondence", __args: { id: "ID" } },
    costing: { __type: "Costing", __args: { id: "ID" } },
    costingLine: { __type: "CostingLine", __args: { id: "ID" } },
    costingLineTemplate: {
      __type: "CostingLineTemplate",
      __args: { id: "ID" },
    },
    costingLineTemplates: {
      __type: "[CostingLineTemplate!]",
      __args: {
        filter: "CostingLineTemplateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    costingLineTemplatesAggregate: {
      __type: "CostingLineTemplateAggregate",
      __args: {
        filter: "CostingLineTemplateFilterInput",
        group: "ResourceGroupInput",
      },
    },
    costingLines: {
      __type: "[CostingLine!]",
      __args: {
        filter: "CostingLineFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    costingLinesAggregate: {
      __type: "CostingLineAggregate",
      __args: { filter: "CostingLineFilterInput", group: "ResourceGroupInput" },
    },
    costingRevision: { __type: "CostingRevision", __args: { id: "ID" } },
    costingRevisions: {
      __type: "[CostingRevision!]",
      __args: {
        filter: "CostingRevisionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    costingRevisionsAggregate: {
      __type: "CostingRevisionAggregate",
      __args: {
        filter: "CostingRevisionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    costingTemplate: { __type: "CostingTemplate", __args: { id: "ID" } },
    costingTemplateExpression: {
      __type: "CostingTemplateExpression",
      __args: { id: "ID" },
    },
    costingTemplateExpressions: {
      __type: "[CostingTemplateExpression!]",
      __args: {
        filter: "CostingTemplateExpressionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    costingTemplateExpressionsAggregate: {
      __type: "CostingTemplateExpressionAggregate",
      __args: {
        filter: "CostingTemplateExpressionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    costingTemplateRevision: {
      __type: "CostingTemplateRevision",
      __args: { id: "ID" },
    },
    costingTemplateRevisions: {
      __type: "[CostingTemplateRevision!]",
      __args: {
        filter: "CostingTemplateRevisionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    costingTemplateRevisionsAggregate: {
      __type: "CostingTemplateRevisionAggregate",
      __args: {
        filter: "CostingTemplateRevisionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    costingTemplates: {
      __type: "[CostingTemplate!]",
      __args: {
        filter: "CostingTemplateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    costingTemplatesAggregate: {
      __type: "CostingTemplateAggregate",
      __args: {
        filter: "CostingTemplateFilterInput",
        group: "ResourceGroupInput",
      },
    },
    costings: {
      __type: "[Costing!]",
      __args: {
        filter: "CostingFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    costingsAggregate: {
      __type: "CostingAggregate",
      __args: { filter: "CostingFilterInput", group: "ResourceGroupInput" },
    },
    currentUser: { __type: "User" },
    currentUserNotifications: { __type: "[UserNotification!]" },
    customData: {
      __type: "[CustomData!]",
      __args: {
        filter: "CustomDataFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    customDataAggregate: {
      __type: "CustomDataAggregate",
      __args: { filter: "CustomDataFilterInput", group: "ResourceGroupInput" },
    },
    customDataById: { __type: "CustomData", __args: { id: "ID" } },
    customTemplate: { __type: "CustomTemplate", __args: { id: "ID" } },
    customTemplates: {
      __type: "[CustomTemplate!]",
      __args: {
        filter: "CustomTemplateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    customTemplatesAggregate: {
      __type: "CustomTemplateAggregate",
      __args: {
        filter: "CustomTemplateFilterInput",
        group: "ResourceGroupInput",
      },
    },
    days: { __type: "[Day!]", __args: { filter: "DateTimeFilterInput" } },
    defaultFolder: { __type: "DefaultFolder", __args: { id: "ID" } },
    defaultFolders: {
      __type: "[DefaultFolder!]",
      __args: {
        filter: "DefaultFolderFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    defaultFoldersAggregate: {
      __type: "DefaultFolderAggregate",
      __args: {
        filter: "DefaultFolderFilterInput",
        group: "ResourceGroupInput",
      },
    },
    deliveryAddress: { __type: "DeliveryAddress", __args: { id: "ID" } },
    deliveryAddresses: {
      __type: "[DeliveryAddress!]",
      __args: {
        filter: "DeliveryAddressFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    deliveryAddressesAggregate: {
      __type: "DeliveryAddressAggregate",
      __args: {
        filter: "DeliveryAddressFilterInput",
        group: "ResourceGroupInput",
      },
    },
    documentNavigationRecords: {
      __type: "[RecordNavigationRecord!]",
      __args: { recordId: "String!", recordType: "String!" },
    },
    documentPreview: {
      __type: "DocumentPreview",
      __args: { input: "GetDocumentPreviewInput!" },
    },
    documentTemplate: { __type: "DocumentTemplate", __args: { id: "ID" } },
    documentTemplates: {
      __type: "[DocumentTemplate!]",
      __args: {
        filter: "DocumentTemplateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    documentTemplatesAggregate: {
      __type: "DocumentTemplateAggregate",
      __args: {
        filter: "DocumentTemplateFilterInput",
        group: "ResourceGroupInput",
      },
    },
    domainEventTypes: { __type: "[DomainEventType!]" },
    effectiveUserPermissions: {
      __type: "[EffectivePermission!]",
      __args: { userId: "ID!" },
    },
    email: { __type: "Email", __args: { id: "ID" } },
    emails: {
      __type: "[Email!]",
      __args: {
        filter: "EmailFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    emailsAggregate: {
      __type: "EmailAggregate",
      __args: { filter: "EmailFilterInput", group: "ResourceGroupInput" },
    },
    eventDescriptionPreview: {
      __type: "String",
      __args: { eventName: "String!" },
    },
    externalStorageConnection: {
      __type: "ExternalStorageConnection",
      __args: { id: "ID" },
    },
    externalStorageConnections: {
      __type: "[ExternalStorageConnection!]",
      __args: {
        filter: "ExternalStorageConnectionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    externalStorageConnectionsAggregate: {
      __type: "ExternalStorageConnectionAggregate",
      __args: {
        filter: "ExternalStorageConnectionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    externalStorageItem: {
      __type: "ExternalStorageItem",
      __args: { id: "String!" },
    },
    externalStorageItems: {
      __type: "[ExternalStorageItem!]",
      __args: {
        filter: "ExternalStorageItemFilterInput",
        group: "ResourceGroupInput",
        id: "String",
        options: "OptionsInput",
      },
    },
    externalStorageItemsAggregate: {
      __type: "ResourceAggregate",
      __args: {
        filter: "ExternalStorageItemFilterInput",
        group: "ResourceGroupInput",
        id: "String",
      },
    },
    externalStorageResourceMapping: {
      __type: "ExternalStorageResourceMapping",
      __args: { id: "ID" },
    },
    externalStorageResourceMappings: {
      __type: "[ExternalStorageResourceMapping!]",
      __args: {
        filter: "ExternalStorageResourceMappingFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    externalStorageResourceMappingsAggregate: {
      __type: "ExternalStorageResourceMappingAggregate",
      __args: {
        filter: "ExternalStorageResourceMappingFilterInput",
        group: "ResourceGroupInput",
      },
    },
    file: { __type: "File", __args: { id: "ID" } },
    fileAggregates: {
      __type: "FileAggregate",
      __args: { filter: "FileFilterInput", group: "ResourceGroupInput" },
    },
    fileChangeset: {
      __type: "[ExternalStorageItem!]",
      __args: {
        filter: "ExternalStorageItemFilterInput",
        id: "ID!",
        targetPath: "String!",
      },
    },
    files: {
      __type: "[File!]",
      __args: {
        filter: "FileFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    formNavigationRecords: {
      __type: "[RecordNavigationRecord!]",
      __args: { recordId: "String!", recordType: "String!" },
    },
    googleDownloadFilesRequestUrl: {
      __type: "String",
      __args: {
        fileHashes: "[String!]!",
        firebaseTenantId: "String!",
        firebaseUserId: "String!",
      },
    },
    googleUploadRequestUrl: { __type: "String", __args: { object: "String!" } },
    graphqlQueryGen: { __type: "String", __args: { input: "AIGenInput!" } },
    groupTemplate: { __type: "GroupTemplate", __args: { id: "ID" } },
    groupTemplates: {
      __type: "[GroupTemplate!]",
      __args: {
        filter: "GroupTemplateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    groupTemplatesAggregate: {
      __type: "GroupTemplateAggregate",
      __args: {
        filter: "GroupTemplateFilterInput",
        group: "ResourceGroupInput",
      },
    },
    housingCompanies: {
      __type: "[HousingCompany!]",
      __args: {
        filter: "HousingCompanyFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    housingCompaniesAggregate: {
      __type: "HousingCompanyAggregate",
      __args: {
        filter: "HousingCompanyFilterInput",
        group: "ResourceGroupInput",
      },
    },
    housingCompany: { __type: "HousingCompany", __args: { id: "ID" } },
    isPermitted: {
      __type: "Boolean",
      __args: { permissions: "[PermissionCheckInput!]!", userId: "ID" },
    },
    issue: { __type: "Issue", __args: { id: "ID" } },
    issueCompletionStatuses: {
      __type: "[IssueCompletionStatus!]",
      __args: { filter: "IssueFilterInput" },
    },
    issues: {
      __type: "[Issue!]",
      __args: {
        filter: "IssueFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    issuesAggregate: {
      __type: "IssueAggregate",
      __args: { filter: "IssueFilterInput", group: "ResourceGroupInput" },
    },
    job: { __type: "Job", __args: { id: "ID" } },
    jobComponent: { __type: "JobComponent", __args: { id: "ID" } },
    jobComponents: {
      __type: "[JobComponent!]",
      __args: {
        filter: "JobComponentFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    jobComponentsAggregate: {
      __type: "JobComponentAggregate",
      __args: {
        filter: "JobComponentFilterInput",
        group: "ResourceGroupInput",
      },
    },
    jobReport: {
      __type: "[JobReportRow!]",
      __args: { groupBy: "[JobReportGroupByInput!]!" },
    },
    jobStatuses: {
      __type: "[JobStatus!]",
      __args: { filter: "JobStatusFilterInput" },
    },
    jobs: {
      __type: "[Job!]",
      __args: {
        filter: "JobFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    jobsAggregate: {
      __type: "JobAggregate",
      __args: { filter: "JobFilterInput", group: "ResourceGroupInput" },
    },
    lead: { __type: "Lead", __args: { id: "ID" } },
    leadCandidateGen: { __type: "String", __args: { input: "AIGenInput!" } },
    leadProjectTypes: {
      __type: "[LeadProjectType!]",
      __args: { filter: "LeadFilterInput" },
    },
    leadReport: {
      __type: "[LeadReportRow!]",
      __args: { groupBy: "[LeadReportGroupByInput!]!" },
    },
    leadSources: {
      __type: "[LeadSource!]",
      __args: { filter: "LeadSourceFilterInput" },
    },
    leadStatuses: {
      __type: "[LeadStatus!]",
      __args: { filter: "LeadStatusFilterInput" },
    },
    leads: {
      __type: "[Lead!]",
      __args: {
        filter: "LeadFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    leadsAggregate: {
      __type: "LeadAggregate",
      __args: { filter: "LeadFilterInput", group: "ResourceGroupInput" },
    },
    legacyUserRole: { __type: "UserRole", __args: { id: "ID" } },
    legacyUserRoles: {
      __type: "[UserRole!]",
      __args: {
        filter: "UserRoleFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    legacyUserRolesAggregate: {
      __type: "UserRoleAggregate",
      __args: { filter: "UserRoleFilterInput", group: "ResourceGroupInput" },
    },
    lineItem: { __type: "LineItem", __args: { id: "ID" } },
    lineItemMasterWorkflow: {
      __type: "LineItemMasterWorkflow",
      __args: { id: "ID" },
    },
    lineItemMasterWorkflows: {
      __type: "[LineItemMasterWorkflow!]",
      __args: {
        filter: "LineItemMasterWorkflowFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    lineItemMasterWorkflowsAggregate: {
      __type: "LineItemMasterWorkflowAggregate",
      __args: {
        filter: "LineItemMasterWorkflowFilterInput",
        group: "ResourceGroupInput",
      },
    },
    lineItemReport: {
      __type: "[LineItemReportRow!]",
      __args: { groupBy: "[LineItemReportGroupByInput!]!" },
    },
    lineItems: {
      __type: "[LineItem!]",
      __args: {
        filter: "LineItemFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    lineItemsAggregate: {
      __type: "LineItemAggregate",
      __args: { filter: "LineItemFilterInput", group: "ResourceGroupInput" },
    },
    linkedAction: { __type: "LinkedAction", __args: { id: "ID" } },
    linkedActions: {
      __type: "[LinkedAction!]",
      __args: {
        filter: "LinkedActionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    linkedActionsAggregate: {
      __type: "LinkedActionAggregate",
      __args: {
        filter: "LinkedActionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    lostReason: { __type: "LostReason", __args: { id: "ID" } },
    lostReasons: {
      __type: "[LostReason!]",
      __args: {
        filter: "LostReasonFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    lostReasonsAggregate: {
      __type: "LostReasonAggregate",
      __args: { filter: "LostReasonFilterInput", group: "ResourceGroupInput" },
    },
    months: { __type: "[Month!]", __args: { filter: "DateTimeFilterInput" } },
    notificationTemplate: {
      __type: "NotificationTemplate",
      __args: { id: "ID" },
    },
    notificationTemplates: {
      __type: "[NotificationTemplate!]",
      __args: {
        filter: "NotificationTemplateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    notificationTemplatesAggregate: {
      __type: "NotificationTemplateAggregate",
      __args: {
        filter: "NotificationTemplateFilterInput",
        group: "ResourceGroupInput",
      },
    },
    nzRegions: {
      __type: "[NZRegion!]",
      __args: { filter: "DateTimeFilterInput" },
    },
    panel: { __type: "Panel", __args: { id: "ID" } },
    panels: {
      __type: "[Panel!]",
      __args: {
        filter: "PanelFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    panelsAggregate: {
      __type: "PanelAggregate",
      __args: { filter: "PanelFilterInput", group: "ResourceGroupInput" },
    },
    partType: { __type: "PartType", __args: { id: "ID" } },
    partTypes: {
      __type: "[PartType!]",
      __args: {
        filter: "PartTypeFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    partTypesAggregate: {
      __type: "PartTypeAggregate",
      __args: { filter: "PartTypeFilterInput", group: "ResourceGroupInput" },
    },
    people: {
      __type: "[Person!]",
      __args: {
        filter: "PersonFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    peopleAggregate: {
      __type: "PersonAggregate",
      __args: { filter: "PersonFilterInput", group: "ResourceGroupInput" },
    },
    permissions: {
      __type: "[Permission!]",
      __args: { filter: "PermissionFilterInput", options: "OptionsInput" },
    },
    permitted: { __type: "Boolean", __args: { permission: "String!" } },
    person: { __type: "Person", __args: { id: "ID" } },
    personAssignedWork: {
      __type: "[PersonAssignedWork!]",
      __args: {
        filter: "PersonAssignedWorkFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    personAssignedWorkAggregate: {
      __type: "PersonAssignedWorkAggregate",
      __args: {
        filter: "PersonAssignedWorkFilterInput",
        group: "ResourceGroupInput",
      },
    },
    personAssignedWorkById: {
      __type: "PersonAssignedWork",
      __args: { id: "ID" },
    },
    personBusinessRole: { __type: "PersonBusinessRole", __args: { id: "ID" } },
    personBusinessRoles: {
      __type: "[PersonBusinessRole!]",
      __args: {
        filter: "PersonBusinessRoleFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    personBusinessRolesAggregate: {
      __type: "PersonBusinessRoleAggregate",
      __args: {
        filter: "PersonBusinessRoleFilterInput",
        group: "ResourceGroupInput",
      },
    },
    personStatuses: { __type: "[PersonStatus!]" },
    processAsset: { __type: "ProcessAsset", __args: { id: "ID" } },
    processAssets: {
      __type: "[ProcessAsset!]",
      __args: {
        filter: "ProcessAssetFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    processAssetsAggregate: {
      __type: "ProcessAssetAggregate",
      __args: {
        filter: "ProcessAssetFilterInput",
        group: "ResourceGroupInput",
      },
    },
    processAssignment: { __type: "ProcessAssignment", __args: { id: "ID" } },
    processAssignments: {
      __type: "[ProcessAssignment!]",
      __args: {
        filter: "ProcessAssignmentFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    processAssignmentsAggregate: {
      __type: "ProcessAssignmentAggregate",
      __args: {
        filter: "ProcessAssignmentFilterInput",
        group: "ResourceGroupInput",
      },
    },
    processInstance: { __type: "ProcessInstance", __args: { id: "ID" } },
    processInstances: {
      __type: "[ProcessInstance!]",
      __args: {
        filter: "ProcessInstanceFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    processInstancesAggregate: {
      __type: "ProcessInstanceAggregate",
      __args: {
        filter: "ProcessInstanceFilterInput",
        group: "ResourceGroupInput",
      },
    },
    processTemplate: { __type: "ProcessTemplate", __args: { id: "ID" } },
    processTemplates: {
      __type: "[ProcessTemplate!]",
      __args: {
        filter: "ProcessTemplateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    processTemplatesAggregate: {
      __type: "ProcessTemplateAggregate",
      __args: {
        filter: "ProcessTemplateFilterInput",
        group: "ResourceGroupInput",
      },
    },
    processTimer: { __type: "ProcessTimer", __args: { id: "ID" } },
    processTimerItem: { __type: "ProcessTimerItem", __args: { id: "ID" } },
    processTimerItems: {
      __type: "[ProcessTimerItem!]",
      __args: {
        filter: "ProcessTimerItemFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    processTimerItemsAggregate: {
      __type: "ProcessTimerItemAggregate",
      __args: {
        filter: "ProcessTimerItemFilterInput",
        group: "ResourceGroupInput",
      },
    },
    processType: { __type: "ProcessType", __args: { id: "ID" } },
    processTypeNote: { __type: "ProcessTypeNote", __args: { id: "ID" } },
    processTypeNotes: {
      __type: "[ProcessTypeNote!]",
      __args: {
        filter: "ProcessTypeNoteFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    processTypeNotesAggregate: {
      __type: "ProcessTypeNoteAggregate",
      __args: {
        filter: "ProcessTypeNoteFilterInput",
        group: "ResourceGroupInput",
      },
    },
    processTypeRole: { __type: "ProcessTypeRole", __args: { id: "ID" } },
    processTypeRoles: {
      __type: "[ProcessTypeRole!]",
      __args: {
        filter: "ProcessTypeRoleFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    processTypeRolesAggregate: {
      __type: "ProcessTypeRoleAggregate",
      __args: {
        filter: "ProcessTypeRoleFilterInput",
        group: "ResourceGroupInput",
      },
    },
    processTypes: {
      __type: "[ProcessType!]",
      __args: {
        filter: "ProcessTypeFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    processTypesAggregate: {
      __type: "ProcessTypeAggregate",
      __args: { filter: "ProcessTypeFilterInput", group: "ResourceGroupInput" },
    },
    product: { __type: "Product", __args: { id: "ID" } },
    productCategories: {
      __type: "[ProductCategory!]",
      __args: {
        filter: "ProductCategoryFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    productCategoriesAggregate: {
      __type: "ProductCategoryAggregate",
      __args: {
        filter: "ProductCategoryFilterInput",
        group: "ResourceGroupInput",
      },
    },
    productCategory: { __type: "ProductCategory", __args: { id: "ID" } },
    productCategoryGroup: {
      __type: "ProductCategoryGroup",
      __args: { id: "ID" },
    },
    productCategoryGroups: {
      __type: "[ProductCategoryGroup!]",
      __args: {
        filter: "ProductCategoryGroupFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    productCategoryGroupsAggregate: {
      __type: "ProductCategoryGroupAggregate",
      __args: {
        filter: "ProductCategoryGroupFilterInput",
        group: "ResourceGroupInput",
      },
    },
    productPrice: { __type: "ProductPrice", __args: { id: "ID" } },
    productPrices: {
      __type: "[ProductPrice!]",
      __args: {
        filter: "ProductPriceFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    productPricesAggregate: {
      __type: "ProductPriceAggregate",
      __args: {
        filter: "ProductPriceFilterInput",
        group: "ResourceGroupInput",
      },
    },
    products: {
      __type: "[Product!]",
      __args: {
        filter: "ProductFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    productsAggregate: {
      __type: "ProductAggregate",
      __args: { filter: "ProductFilterInput", group: "ResourceGroupInput" },
    },
    project: { __type: "Project", __args: { id: "ID" } },
    projects: {
      __type: "[Project!]",
      __args: {
        filter: "ProjectFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    projectsAggregate: {
      __type: "ProjectAggregate",
      __args: { filter: "ProjectFilterInput", group: "ResourceGroupInput" },
    },
    purchaseOrder: { __type: "PurchaseOrder", __args: { id: "ID" } },
    purchaseOrderEvents: {
      __type: "[PurchaseOrderEvent!]",
      __args: {
        filter: "PurchaseOrderEventFilterInput",
        options: "OptionsInput",
      },
    },
    purchaseOrderLine: { __type: "PurchaseOrderLine", __args: { id: "ID" } },
    purchaseOrderLines: {
      __type: "[PurchaseOrderLine!]",
      __args: {
        filter: "PurchaseOrderLineFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    purchaseOrderLinesAggregate: {
      __type: "PurchaseOrderLineAggregate",
      __args: {
        filter: "PurchaseOrderLineFilterInput",
        group: "ResourceGroupInput",
      },
    },
    purchaseOrderPreview: {
      __type: "PurchaseOrderPreview",
      __args: { purchaseOrderId: "ID!" },
    },
    purchaseOrderReceipt: {
      __type: "PurchaseOrderReceipt",
      __args: { id: "ID" },
    },
    purchaseOrderReceiptLine: {
      __type: "PurchaseOrderReceiptLine",
      __args: { id: "ID" },
    },
    purchaseOrderReceiptLines: {
      __type: "[PurchaseOrderReceiptLine!]",
      __args: {
        filter: "PurchaseOrderReceiptLineFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    purchaseOrderReceiptLinesAggregate: {
      __type: "PurchaseOrderReceiptLineAggregate",
      __args: {
        filter: "PurchaseOrderReceiptLineFilterInput",
        group: "ResourceGroupInput",
      },
    },
    purchaseOrderReceipts: {
      __type: "[PurchaseOrderReceipt!]",
      __args: {
        filter: "PurchaseOrderReceiptFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    purchaseOrderReceiptsAggregate: {
      __type: "PurchaseOrderReceiptAggregate",
      __args: {
        filter: "PurchaseOrderReceiptFilterInput",
        group: "ResourceGroupInput",
      },
    },
    purchaseOrderReview: {
      __type: "PurchaseOrderReview",
      __args: { id: "ID" },
    },
    purchaseOrderReviews: {
      __type: "[PurchaseOrderReview!]",
      __args: {
        filter: "PurchaseOrderReviewFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    purchaseOrderReviewsAggregate: {
      __type: "PurchaseOrderReviewAggregate",
      __args: {
        filter: "PurchaseOrderReviewFilterInput",
        group: "ResourceGroupInput",
      },
    },
    purchaseOrderStatuses: {
      __type: "[PurchaseOrderStatus!]",
      __args: { filter: "PurchaseOrderStatusFilterInput" },
    },
    purchaseOrders: {
      __type: "[PurchaseOrder!]",
      __args: {
        filter: "PurchaseOrderFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    purchaseOrdersAggregate: {
      __type: "PurchaseOrderAggregate",
      __args: {
        filter: "PurchaseOrderFilterInput",
        group: "ResourceGroupInput",
      },
    },
    quote: { __type: "Quote", __args: { id: "ID" } },
    quoteLine: { __type: "QuoteLine", __args: { id: "ID" } },
    quoteLineTemplate: { __type: "QuoteLineTemplate", __args: { id: "ID" } },
    quoteLineTemplates: {
      __type: "[QuoteLineTemplate!]",
      __args: {
        filter: "QuoteLineTemplateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    quoteLineTemplatesAggregate: {
      __type: "QuoteLineTemplateAggregate",
      __args: {
        filter: "QuoteLineTemplateFilterInput",
        group: "ResourceGroupInput",
      },
    },
    quoteLines: {
      __type: "[QuoteLine!]",
      __args: {
        filter: "QuoteLineFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    quoteLinesAggregate: {
      __type: "QuoteLineAggregate",
      __args: { filter: "QuoteLineFilterInput", group: "ResourceGroupInput" },
    },
    quotePreview: {
      __type: "QuotePreview",
      __args: { quote: "CreateQuoteInput!" },
    },
    quoteRevision: { __type: "QuoteRevision", __args: { id: "ID" } },
    quoteRevisions: {
      __type: "[QuoteRevision!]",
      __args: {
        filter: "QuoteRevisionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    quoteRevisionsAggregate: {
      __type: "QuoteRevisionAggregate",
      __args: {
        filter: "QuoteRevisionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    quoteStatuses: {
      __type: "[QuoteStatus!]",
      __args: { filter: "QuoteFilterInput" },
    },
    quoteTemplate: { __type: "QuoteTemplate", __args: { id: "ID" } },
    quoteTemplateExpression: {
      __type: "QuoteTemplateExpression",
      __args: { id: "ID" },
    },
    quoteTemplateExpressions: {
      __type: "[QuoteTemplateExpression!]",
      __args: {
        filter: "QuoteTemplateExpressionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    quoteTemplateExpressionsAggregate: {
      __type: "QuoteTemplateExpressionAggregate",
      __args: {
        filter: "QuoteTemplateExpressionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    quoteTemplatePreview: {
      __type: "QuoteTemplatePreview",
      __args: { costings: "String!", twigTemplate: "String!" },
    },
    quoteTemplateRevision: {
      __type: "QuoteTemplateRevision",
      __args: { id: "ID" },
    },
    quoteTemplateRevisions: {
      __type: "[QuoteTemplateRevision!]",
      __args: {
        filter: "QuoteTemplateRevisionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    quoteTemplateRevisionsAggregate: {
      __type: "QuoteTemplateRevisionAggregate",
      __args: {
        filter: "QuoteTemplateRevisionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    quoteTemplates: {
      __type: "[QuoteTemplate!]",
      __args: {
        filter: "QuoteTemplateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    quoteTemplatesAggregate: {
      __type: "QuoteTemplateAggregate",
      __args: {
        filter: "QuoteTemplateFilterInput",
        group: "ResourceGroupInput",
      },
    },
    quotes: {
      __type: "[Quote!]",
      __args: {
        filter: "QuoteFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    quotesAggregate: {
      __type: "QuoteAggregate",
      __args: { filter: "QuoteFilterInput", group: "ResourceGroupInput" },
    },
    recordDocuments: {
      __type: "[Document!]",
      __args: {
        documentTemplateId: "ID",
        recordId: "ID!",
        recordType: "String!",
      },
    },
    recordFile: { __type: "RecordFile", __args: { id: "ID" } },
    recordFileAggregates: {
      __type: "RecordFileAggregate",
      __args: { filter: "RecordFileFilterInput", group: "ResourceGroupInput" },
    },
    recordFiles: {
      __type: "[RecordFile!]",
      __args: {
        filter: "RecordFileFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    recordFolder: { __type: "RecordFolder", __args: { id: "ID" } },
    recordFolders: {
      __type: "[RecordFolder!]",
      __args: {
        filter: "RecordFolderFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    recordFoldersAggregate: {
      __type: "RecordFolderAggregate",
      __args: {
        filter: "RecordFolderFilterInput",
        group: "ResourceGroupInput",
      },
    },
    recordScreen: { __type: "RecordScreen", __args: { id: "ID" } },
    recordScreens: {
      __type: "[RecordScreen!]",
      __args: {
        filter: "RecordScreenFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    recordScreensAggregate: {
      __type: "RecordScreenAggregate",
      __args: {
        filter: "RecordScreenFilterInput",
        group: "ResourceGroupInput",
      },
    },
    recordTag: { __type: "RecordTag", __args: { id: "ID" } },
    recordTags: {
      __type: "[RecordTag!]",
      __args: {
        filter: "RecordTagFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    recordTagsAggregate: {
      __type: "RecordTagAggregate",
      __args: { filter: "RecordTagFilterInput", group: "ResourceGroupInput" },
    },
    recordTypes: { __type: "[RecordType!]" },
    region: { __type: "Region", __args: { id: "ID" } },
    regions: {
      __type: "[Region!]",
      __args: {
        filter: "RegionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    regionsAggregate: {
      __type: "RegionAggregate",
      __args: { filter: "RegionFilterInput", group: "ResourceGroupInput" },
    },
    resolvedRecordScreen: {
      __type: "Screen",
      __args: { recordType: "String!" },
    },
    role: { __type: "Role", __args: { id: "ID" } },
    roleInheritance: { __type: "RoleInheritance", __args: { id: "ID" } },
    roleInheritances: {
      __type: "[RoleInheritance!]",
      __args: {
        filter: "RoleInheritanceFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    roleInheritancesAggregate: {
      __type: "RoleInheritanceAggregate",
      __args: {
        filter: "RoleInheritanceFilterInput",
        group: "ResourceGroupInput",
      },
    },
    rolePermission: { __type: "RolePermission", __args: { id: "ID" } },
    rolePermissions: {
      __type: "[RolePermission!]",
      __args: {
        filter: "RolePermissionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    rolePermissionsAggregate: {
      __type: "RolePermissionAggregate",
      __args: {
        filter: "RolePermissionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    roleUser: { __type: "RoleUser", __args: { id: "ID" } },
    roleUsers: {
      __type: "[RoleUser!]",
      __args: {
        filter: "RoleUserFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    roleUsersAggregate: {
      __type: "RoleUserAggregate",
      __args: { filter: "RoleUserFilterInput", group: "ResourceGroupInput" },
    },
    roles: {
      __type: "[Role!]",
      __args: {
        filter: "RoleFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    rolesAggregate: {
      __type: "RoleAggregate",
      __args: { filter: "RoleFilterInput", group: "ResourceGroupInput" },
    },
    saleType: { __type: "SaleType", __args: { id: "ID" } },
    saleTypes: {
      __type: "[SaleType!]",
      __args: {
        filter: "SaleTypeFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    saleTypesAggregate: {
      __type: "SaleTypeAggregate",
      __args: { filter: "SaleTypeFilterInput", group: "ResourceGroupInput" },
    },
    salesOrder: { __type: "SalesOrder", __args: { id: "ID" } },
    salesOrderLine: { __type: "SalesOrderLine", __args: { id: "ID" } },
    salesOrderLines: {
      __type: "[SalesOrderLine!]",
      __args: {
        filter: "SalesOrderLineFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    salesOrderLinesAggregate: {
      __type: "ResourceAggregate",
      __args: {
        filter: "SalesOrderLineFilterInput",
        group: "ResourceGroupInput",
      },
    },
    salesOrders: {
      __type: "[SalesOrder!]",
      __args: {
        filter: "SalesOrderFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    salesOrdersAggregate: {
      __type: "SalesOrderAggregate",
      __args: { filter: "SalesOrderFilterInput", group: "ResourceGroupInput" },
    },
    schema: { __type: "Schema", __args: { id: "ID" } },
    schemaTypes: {
      __type: "[SchemaType!]",
      __args: { filter: "SchemaTypeFilterInput", options: "OptionsInput" },
    },
    schemaVersion: { __type: "SchemaVersion", __args: { id: "ID" } },
    schemaVersions: {
      __type: "[SchemaVersion!]",
      __args: {
        filter: "SchemaVersionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    schemaVersionsAggregate: {
      __type: "SchemaVersionAggregate",
      __args: {
        filter: "SchemaVersionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    schemas: {
      __type: "[Schema!]",
      __args: {
        filter: "SchemaFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    schemasAggregate: {
      __type: "SchemaAggregate",
      __args: { filter: "SchemaFilterInput", group: "ResourceGroupInput" },
    },
    screen: { __type: "Screen", __args: { id: "ID" } },
    screenAssignments: {
      __type: "[RecordScreen!]",
      __args: { filter: "RecordScreenFilterInput", options: "OptionsInput" },
    },
    screens: {
      __type: "[Screen!]",
      __args: {
        filter: "ScreenFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    screensAggregate: {
      __type: "ScreenAggregate",
      __args: { filter: "ScreenFilterInput", group: "ResourceGroupInput" },
    },
    specification: { __type: "Specification", __args: { id: "ID!" } },
    specificationLookupOptions: {
      __type: "[SpecificationLookupOption!]",
      __args: { limit: "Int", search: "String", type: "String!" },
    },
    stock: {
      __type: "[Stock!]",
      __args: {
        filter: "StockFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    stockAggregate: {
      __type: "StockAggregate",
      __args: { filter: "StockFilterInput", group: "ResourceGroupInput" },
    },
    stockRecord: { __type: "Stock", __args: { id: "ID" } },
    stockTransaction: { __type: "StockTransaction", __args: { id: "ID" } },
    stockTransactionLine: {
      __type: "StockTransactionLine",
      __args: { id: "ID" },
    },
    stockTransactionLines: {
      __type: "[StockTransactionLine!]",
      __args: {
        filter: "StockTransactionLineFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    stockTransactionLinesAggregate: {
      __type: "StockTransactionLineAggregate",
      __args: {
        filter: "StockTransactionLineFilterInput",
        group: "ResourceGroupInput",
      },
    },
    stockTransactions: {
      __type: "[StockTransaction!]",
      __args: {
        filter: "StockTransactionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    stockTransactionsAggregate: {
      __type: "StockTransactionAggregate",
      __args: {
        filter: "StockTransactionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    subscriptionReal: { __type: "SubscriptionReal", __args: { id: "ID" } },
    subscriptions: {
      __type: "[SubscriptionReal!]",
      __args: {
        filter: "SubscriptionRealFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    subscriptionsAggregate: {
      __type: "SubscriptionRealAggregate",
      __args: {
        filter: "SubscriptionRealFilterInput",
        group: "ResourceGroupInput",
      },
    },
    supplier: { __type: "Supplier", __args: { id: "ID" } },
    supplierCategories: {
      __type: "[SupplierCategory!]",
      __args: {
        filter: "SupplierCategoryFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    supplierCategoriesAggregate: {
      __type: "SupplierCategoryAggregate",
      __args: {
        filter: "SupplierCategoryFilterInput",
        group: "ResourceGroupInput",
      },
    },
    supplierCategory: { __type: "SupplierCategory", __args: { id: "ID" } },
    supplierQuote: { __type: "SupplierQuote", __args: { id: "ID" } },
    supplierQuoteLine: { __type: "SupplierQuoteLine", __args: { id: "ID" } },
    supplierQuoteLines: {
      __type: "[SupplierQuoteLine!]",
      __args: {
        filter: "SupplierQuoteLineFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    supplierQuoteLinesAggregate: {
      __type: "ResourceAggregate",
      __args: {
        filter: "SupplierQuoteLineFilterInput",
        group: "ResourceGroupInput",
      },
    },
    supplierQuoteRequest: {
      __type: "SupplierQuoteRequest",
      __args: { id: "ID" },
    },
    supplierQuoteRequestLine: {
      __type: "SupplierQuoteRequestLine",
      __args: { id: "ID" },
    },
    supplierQuoteRequestLines: {
      __type: "[SupplierQuoteRequestLine!]",
      __args: {
        filter: "SupplierQuoteRequestLineFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    supplierQuoteRequestLinesAggregate: {
      __type: "SupplierQuoteRequestLineAggregate",
      __args: {
        filter: "SupplierQuoteRequestLineFilterInput",
        group: "ResourceGroupInput",
      },
    },
    supplierQuoteRequests: {
      __type: "[SupplierQuoteRequest!]",
      __args: {
        filter: "SupplierQuoteRequestFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    supplierQuoteRequestsAggregate: {
      __type: "SupplierQuoteRequestAggregate",
      __args: {
        filter: "SupplierQuoteRequestFilterInput",
        group: "ResourceGroupInput",
      },
    },
    supplierQuotes: {
      __type: "[SupplierQuote!]",
      __args: {
        filter: "SupplierQuoteFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    supplierQuotesAggregate: {
      __type: "SupplierQuoteAggregate",
      __args: {
        filter: "SupplierQuoteFilterInput",
        group: "ResourceGroupInput",
      },
    },
    suppliers: {
      __type: "[Supplier!]",
      __args: {
        filter: "SupplierFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    suppliersAggregate: {
      __type: "SupplierAggregate",
      __args: { filter: "SupplierFilterInput", group: "ResourceGroupInput" },
    },
    systemSettings: { __type: "DataStoreRecord" },
    tag: { __type: "Tag", __args: { id: "ID" } },
    tags: {
      __type: "[Tag!]",
      __args: {
        filter: "TagFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    tagsAggregate: {
      __type: "TagAggregate",
      __args: { filter: "TagFilterInput", group: "ResourceGroupInput" },
    },
    timerTransaction: { __type: "TimerTransaction", __args: { id: "ID" } },
    timerTransactions: {
      __type: "[TimerTransaction!]",
      __args: {
        filter: "TimerTransactionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    timerTransactionsAggregate: {
      __type: "TimerTransactionAggregate",
      __args: {
        filter: "TimerTransactionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    timers: {
      __type: "[ProcessTimer!]",
      __args: {
        filter: "ProcessTimerFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    timersAggregate: {
      __type: "ProcessTimerAggregate",
      __args: {
        filter: "ProcessTimerFilterInput",
        group: "ResourceGroupInput",
      },
    },
    uploadRequestUrl: {
      __type: "UploadRequestUrl",
      __args: {
        area: "String!",
        fileName: "String!",
        jobNumber: "String!",
        notes: "String!",
      },
    },
    user: { __type: "User", __args: { id: "ID" } },
    userIdentities: {
      __type: "[UserIdentity!]",
      __args: {
        filter: "UserIdentityFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    userIdentitiesAggregate: {
      __type: "UserIdentityAggregate",
      __args: {
        filter: "UserIdentityFilterInput",
        group: "ResourceGroupInput",
      },
    },
    userIdentity: { __type: "UserIdentity", __args: { id: "ID" } },
    userPermission: { __type: "UserPermission", __args: { id: "ID" } },
    userPermissions: {
      __type: "[UserPermission!]",
      __args: {
        filter: "UserPermissionFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    userPermissionsAggregate: {
      __type: "UserPermissionAggregate",
      __args: {
        filter: "UserPermissionFilterInput",
        group: "ResourceGroupInput",
      },
    },
    users: {
      __type: "[User!]",
      __args: {
        filter: "UserFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    usersAggregate: {
      __type: "UserAggregate",
      __args: { filter: "UserFilterInput", group: "ResourceGroupInput" },
    },
    warehouse: { __type: "Warehouse", __args: { id: "ID" } },
    warehouses: {
      __type: "[Warehouse!]",
      __args: {
        filter: "WarehouseFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    warehousesAggregate: {
      __type: "WarehouseAggregate",
      __args: { filter: "WarehouseFilterInput", group: "ResourceGroupInput" },
    },
    webhook: { __type: "Webhook", __args: { id: "ID" } },
    webhooks: {
      __type: "[Webhook!]",
      __args: {
        filter: "WebhookFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    webhooksAggregate: {
      __type: "WebhookAggregate",
      __args: { filter: "WebhookFilterInput", group: "ResourceGroupInput" },
    },
    weeks: { __type: "[Week!]", __args: { filter: "WeekFilterInput" } },
    workflowNote: { __type: "WorkflowNote", __args: { id: "ID" } },
    workflowNotes: {
      __type: "[WorkflowNote!]",
      __args: {
        filter: "WorkflowNoteFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    workflowNotesAggregate: {
      __type: "WorkflowNoteAggregate",
      __args: {
        filter: "WorkflowNoteFilterInput",
        group: "ResourceGroupInput",
      },
    },
    workflowTemplate: { __type: "WorkflowTemplate", __args: { id: "ID" } },
    workflowTemplates: {
      __type: "[WorkflowTemplate!]",
      __args: {
        filter: "WorkflowTemplateFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    workflowTemplatesAggregate: {
      __type: "WorkflowTemplateAggregate",
      __args: {
        filter: "WorkflowTemplateFilterInput",
        group: "ResourceGroupInput",
      },
    },
    workflowType: { __type: "WorkflowType", __args: { id: "ID" } },
    workflowTypes: {
      __type: "[WorkflowType!]",
      __args: {
        filter: "WorkflowTypeFilterInput",
        group: "ResourceGroupInput",
        options: "OptionsInput",
      },
    },
    workflowTypesAggregate: {
      __type: "WorkflowTypeAggregate",
      __args: {
        filter: "WorkflowTypeFilterInput",
        group: "ResourceGroupInput",
      },
    },
  },
  subscription: {
    __typename: { __type: "String!" },
    dummySubscription: { __type: "String" },
  },
  [SchemaUnionsKey]: {
    PaginatedResultInterface: ["PagedJobs", "PaginatedResult"],
  },
} as const;

/**
 * displayName=ActAsUser
 * defaultQuery=actAsUsers
 * aggregateQuery=actAsUsersAggregate
 * grouping=true
 * queryPermission=Act_As_User
 * conditionalPolicyPermissions=Admin_Act_As_User
 */
export interface ActAsUser {
  __typename?: "ActAsUser";
  /**
   * sortable=false
   * groupable=false
   */
  allPermissions: (args?: {
    filter?: Maybe<AssignedPermissionFilterInput>;
  }) => Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  allScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=true
   */
  assignedRoles: (args?: {
    filter?: Maybe<RoleUserFilterInput>;
  }) => Array<RoleUser>;
  /**
   * sortable=true
   * groupable=false
   */
  authProvider: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  authProviderUid: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  branch?: Maybe<Branch>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  email?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  firebaseAuthId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  fullName?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  hasPin: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=true
   */
  identities: (args?: {
    filter?: Maybe<UserIdentityFilterInput>;
  }) => Array<UserIdentity>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedPermissions: (args?: {
    filter?: Maybe<AssignedPermissionFilterInput>;
  }) => Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedScreens: Array<Screen>;
  /**
   * sortable=true
   * groupable=false
   */
  initials: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  isActive: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  ownPermissions: (args?: {
    filter?: Maybe<AssignedPermissionFilterInput>;
  }) => Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  ownScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=false
   */
  roles: Array<Role>;
  /**
   * sortable=false
   * groupable=true
   */
  timers: (args?: {
    filter?: Maybe<ProcessTimerFilterInput>;
  }) => Array<ProcessTimer>;
  /**
   * sortable=true
   * groupable=false
   */
  username?: Maybe<ScalarsEnums["String"]>;
}

export interface ActAsUserAggregate {
  __typename?: "ActAsUserAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=An asset, such as a machine, that can be assigned to a manufacturing process.
 * displayName=Asset
 * module=Manufacturing
 * defaultQuery=assets
 * iconName=cog
 * colour=#A96500
 * aggregateQuery=assetsAggregate
 * grouping=true
 * queryPermission=Query_Assets
 */
export interface Asset {
  __typename?: "Asset";
  /**
   * sortable=true
   * groupable=false
   */
  assetType?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
}

/**
 * description=An asset, such as a machine, that can be assigned to a manufacturing process.
 */
export interface AssetAggregate {
  __typename?: "AssetAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface AssignedPermission {
  __typename?: "AssignedPermission";
  conditions: ScalarsEnums["String"];
  id: ScalarsEnums["String"];
  /**
   * Useful for getting the underlying UserPermission or RolePermission ID,
   * eg when wanting to unassign it.
   */
  originalId: ScalarsEnums["String"];
  /**
   * sortable=true
   */
  permission: Permission;
  /**
   * sortable=true
   */
  policy: ScalarsEnums["Policy"];
  /**
   * TODO: Use batching
   */
  role?: Maybe<Role>;
  subjectId: ScalarsEnums["String"];
  /**
   * sortable=true
   */
  subjectName: ScalarsEnums["String"];
  user?: Maybe<User>;
}

/**
 * description=The status and result of a background task.
 * displayName=Async Task
 * module=Admin
 * defaultQuery=asyncTasks
 * iconName=time
 * colour=#5D35A6
 * aggregateQuery=asyncTasksAggregate
 * grouping=true
 * queryPermission=Query_Async_Tasks
 */
export interface AsyncTask {
  __typename?: "AsyncTask";
  /**
   * sortable=true
   * groupable=true
   */
  created: ScalarsEnums["DateTime"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  payload?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  status?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=The status and result of a background task.
 */
export interface AsyncTaskAggregate {
  __typename?: "AsyncTaskAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=An attachment configuration belonging to a subscription notification template.
 * displayName=Attachment Template
 * module=Admin
 * defaultQuery=attachmentTemplates
 * iconName=paperclip
 * colour=#5D35A6
 * aggregateQuery=attachmentTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Attachment_Templates
 */
export interface AttachmentTemplate {
  __typename?: "AttachmentTemplate";
  /**
   * sortable=true
   * groupable=false
   */
  bodyTemplateId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  fileName: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  notificationTemplate?: Maybe<NotificationTemplate>;
  /**
   * sortable=true
   * groupable=true
   */
  type: ScalarsEnums["String"];
}

/**
 * description=An attachment configuration belonging to a subscription notification template.
 */
export interface AttachmentTemplateAggregate {
  __typename?: "AttachmentTemplateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A recorded domain event linked to the user and record that triggered it.
 * displayName=Audit Log
 * module=Admin
 * defaultQuery=auditLogs
 * iconName=history
 * colour=#5D35A6
 * aggregateQuery=auditLogsAggregate
 * grouping=true
 * queryPermission=Query_Audit_Logs
 */
export interface AuditLog {
  __typename?: "AuditLog";
  /**
   * sortable=true
   * groupable=true
   */
  created: ScalarsEnums["DateTime"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  event: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  recordId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  recordType: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  user?: Maybe<User>;
}

/**
 * description=A manufacturing batch grouping work to be scheduled and produced together.
 * displayName=Batch
 * module=Manufacturing
 * defaultQuery=batches
 * iconName=layers
 * colour=#A96500
 * aggregateQuery=batchesAggregate
 * grouping=true
 * queryPermission=Query_Batches
 */
export interface Batch {
  __typename?: "Batch";
  /**
   * sortable=true
   * groupable=false
   */
  batchNumber: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  benchtopSupplier?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  branch: Branch;
  /**
   * sortable=true
   * groupable=false
   */
  cubicMetres?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  installationHours?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=true
   */
  job?: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  lineItemAggregate: (args?: {
    filter?: Maybe<LineItemFilterInput>;
  }) => Maybe<LineItemAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  lineItems: (args?: {
    filter?: Maybe<LineItemFilterInput>;
  }) => Array<LineItem>;
  /**
   * sortable=true
   * groupable=false
   */
  name?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=true
   */
  schedules: (args?: {
    filter?: Maybe<BatchScheduleFilterInput>;
  }) => Array<BatchSchedule>;
  /**
   * sortable=true
   * groupable=false
   */
  sheets?: Maybe<ScalarsEnums["Int"]>;
}

/**
 * description=A manufacturing batch grouping work to be scheduled and produced together.
 */
export interface BatchAggregate {
  __typename?: "BatchAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  sheetCount: ScalarsEnums["Int"];
}

/**
 * Batch
 */
export interface BatchCreatedEvent {
  __typename?: "BatchCreatedEvent";
  batchId: ScalarsEnums["String"];
  batchName: ScalarsEnums["String"];
}

/**
 * Batch
 */
export interface BatchDeletedEvent {
  __typename?: "BatchDeletedEvent";
  batchId: ScalarsEnums["String"];
  batchName: ScalarsEnums["String"];
}

export interface BatchRecalculateDueDateEvent {
  __typename?: "BatchRecalculateDueDateEvent";
  batchId: ScalarsEnums["String"];
}

/**
 * A Batch identity or a typed nested report dimension.
 */
export interface BatchReportDimensionValue {
  __typename?: "BatchReportDimensionValue";
  branch?: Maybe<BranchReportDimensionValue>;
  job?: Maybe<JobReportDimensionValue>;
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A scheduled manufacturing batch for a specific process type.
 * displayName=Batch Schedule
 * module=Manufacturing
 * defaultQuery=batchSchedules
 * iconName=calendar-days
 * colour=#A96500
 * aggregateQuery=batchSchedulesAggregate
 * reportQuery=batchScheduleReport
 * grouping=true
 * queryPermission=Query_Batch_Schedules
 */
export interface BatchSchedule {
  __typename?: "BatchSchedule";
  /**
   * sortable=true
   * groupable=true
   */
  batch?: Maybe<Batch>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  dueDate?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  processInstances: (args?: {
    filter?: Maybe<ProcessInstanceFilterInput>;
  }) => Array<ProcessInstance>;
  /**
   * sortable=true
   * groupable=true
   */
  processType?: Maybe<ProcessType>;
  /**
   * sortable=true
   * groupable=true
   */
  scheduled?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A scheduled manufacturing batch for a specific process type.
 */
export interface BatchScheduleAggregate {
  __typename?: "BatchScheduleAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * description=Total batch sheets across matching schedules. Filter by process type to count that process workload.
   * sortable=true
   * groupable=false
   */
  sheetCount: ScalarsEnums["Int"];
  /**
   * description=Confirmed line-item sale value across matching schedules, grouped by schedule date rather than confirmation date. Each process schedule contributes its batch value.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  totalConfirmedSale?: Maybe<ScalarsEnums["Float"]>;
}

/**
 * Typed Batch Schedule report dimension values.
 */
export interface BatchScheduleReportDimensions {
  __typename?: "BatchScheduleReportDimensions";
  batch?: Maybe<BatchReportDimensionValue>;
  dueDate?: Maybe<ReportDimensionValue>;
  processType?: Maybe<ProcessTypeReportDimensionValue>;
  scheduled?: Maybe<ReportDimensionValue>;
}

/**
 * One grouped Batch Schedule report row.
 */
export interface BatchScheduleReportRow {
  __typename?: "BatchScheduleReportRow";
  /**
   * The generated BatchSchedule aggregate, constrained to this dimension row.
   */
  aggregate: (args?: {
    filter?: Maybe<BatchScheduleFilterInput>;
  }) => BatchScheduleAggregate;
  /**
   * Typed values for every selected report dimension.
   */
  dimensions: BatchScheduleReportDimensions;
  /**
   * The first dimension key, retained for single-dimension report compatibility.
   */
  key: ScalarsEnums["String"];
  /**
   * The first dimension label, retained for single-dimension report compatibility.
   */
  label: ScalarsEnums["String"];
}

export interface BatchStatusCheckEvent {
  __typename?: "BatchStatusCheckEvent";
  batchId: ScalarsEnums["String"];
}

/**
 * Batch
 */
export interface BatchUpdatedEvent {
  __typename?: "BatchUpdatedEvent";
  batchId: ScalarsEnums["String"];
  batchName: ScalarsEnums["String"];
}

export interface BillOfMaterialsImport {
  __typename?: "BillOfMaterialsImport";
  externalStorageConnection: ExternalStorageConnection;
  matchedItems: Array<BillOfMaterialsLine>;
  rawItems: ScalarsEnums["String"];
}

export interface BillOfMaterialsLine {
  __typename?: "BillOfMaterialsLine";
  description: ScalarsEnums["String"];
  group?: Maybe<ScalarsEnums["String"]>;
  price?: Maybe<ScalarsEnums["String"]>;
  product?: Maybe<Product>;
  quantity: ScalarsEnums["String"];
  room?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A company branch or location used to organise jobs, users, and operations.
 * displayName=Branch
 * module=Admin
 * defaultQuery=branches
 * iconName=office
 * colour=#5D35A6
 * aggregateQuery=branchesAggregate
 * grouping=true
 * queryPermission=Query_Branches
 */
export interface Branch {
  __typename?: "Branch";
  /**
   * sortable=true
   * groupable=false
   */
  code: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  colour: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  darkColour: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=false
   */
  jobAggregate: (args?: {
    filter?: Maybe<JobFilterInput>;
  }) => Maybe<JobAggregate>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * description=The number of people assigned to this branch.
   * sortable=false
   * groupable=false
   */
  personAggregate: (args?: {
    filter?: Maybe<PersonFilterInput>;
  }) => Maybe<PersonAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  users: (args?: { filter?: Maybe<UserFilterInput> }) => Array<User>;
}

/**
 * description=A company branch or location used to organise jobs, users, and operations.
 */
export interface BranchAggregate {
  __typename?: "BranchAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Branch
 */
export interface BranchCreatedEvent {
  __typename?: "BranchCreatedEvent";
  branchId: ScalarsEnums["Int"];
  branchName: ScalarsEnums["String"];
}

/**
 * Branch
 */
export interface BranchDeletedEvent {
  __typename?: "BranchDeletedEvent";
  branchId: ScalarsEnums["Int"];
  branchName: ScalarsEnums["String"];
}

/**
 * A Branch identity or a typed nested report dimension.
 */
export interface BranchReportDimensionValue {
  __typename?: "BranchReportDimensionValue";
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

/**
 * Branch
 */
export interface BranchRestoredEvent {
  __typename?: "BranchRestoredEvent";
  branchId: ScalarsEnums["Int"];
  branchName: ScalarsEnums["String"];
}

/**
 * Branch
 */
export interface BranchUpdatedEvent {
  __typename?: "BranchUpdatedEvent";
  branchId: ScalarsEnums["Int"];
  branchName: ScalarsEnums["String"];
}

/**
 * description=A sales classification describing the type of build for a job.
 * displayName=Build Type
 * module=Sales
 * defaultQuery=buildTypes
 * colour=#A91F54
 * aggregateQuery=buildTypesAggregate
 * grouping=true
 * queryPermission=Query_Build_Types
 */
export interface BuildType {
  __typename?: "BuildType";
  /**
   * sortable=true
   * groupable=false
   */
  code?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
}

/**
 * description=A sales classification describing the type of build for a job.
 */
export interface BuildTypeAggregate {
  __typename?: "BuildTypeAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * A Build Type identity or a typed nested report dimension.
 */
export interface BuildTypeReportDimensionValue {
  __typename?: "BuildTypeReportDimensionValue";
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A building company or builder associated with sales jobs.
 * displayName=Builder
 * module=Sales
 * defaultQuery=builders
 * iconName=inbox
 * colour=#A91F54
 * aggregateQuery=buildersAggregate
 * grouping=true
 * queryPermission=Query_Builders
 */
export interface Builder {
  __typename?: "Builder";
  /**
   * sortable=true
   * groupable=false
   */
  address: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  code: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
}

/**
 * description=A building company or builder associated with sales jobs.
 */
export interface BuilderAggregate {
  __typename?: "BuilderAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * A Builder identity or a typed nested report dimension.
 */
export interface BuilderReportDimensionValue {
  __typename?: "BuilderReportDimensionValue";
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A business role that describes how a person can be assigned to work.
 * displayName=Business Role
 * module=Admin
 * defaultQuery=businessRoles
 * iconName=briefcase
 * colour=#5D35A6
 * aggregateQuery=businessRolesAggregate
 * grouping=true
 * queryPermission=Query_Business_Roles
 */
export interface BusinessRole {
  __typename?: "BusinessRole";
  /**
   * description=The number of active people assigned this business role.
   * sortable=true
   * groupable=false
   */
  activePersonBusinessRoleCount: ScalarsEnums["Int"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * description=The number of current and historical assignments for this business role.
   * sortable=false
   * groupable=false
   */
  personBusinessRoleAggregate: (args?: {
    filter?: Maybe<PersonBusinessRoleFilterInput>;
  }) => Maybe<PersonBusinessRoleAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  personBusinessRoles: (args?: {
    filter?: Maybe<PersonBusinessRoleFilterInput>;
  }) => Array<PersonBusinessRole>;
}

/**
 * description=A business role that describes how a person can be assigned to work.
 */
export interface BusinessRoleAggregate {
  __typename?: "BusinessRoleAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * A Business Role identity or a typed nested report dimension.
 */
export interface BusinessRoleReportDimensionValue {
  __typename?: "BusinessRoleReportDimensionValue";
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=An AI-generated draft record awaiting review and approval.
 * displayName=Candidate
 * module=Sales
 * defaultQuery=candidates
 * colour=#A91F54
 * aggregateQuery=candidatesAggregate
 * grouping=true
 * queryPermission=Query_Candidates
 */
export interface Candidate {
  __typename?: "Candidate";
  /**
   * sortable=true
   * groupable=false
   */
  candidateTypeName: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  conversionErrors: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  created?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  generatedData?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  shortSummary: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  source?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  status?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  targetRecordId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * sortable=true
   * groupable=false
   */
  targetRecordType?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  type: ScalarsEnums["String"];
}

/**
 * description=An AI-generated draft record awaiting review and approval.
 */
export interface CandidateAggregate {
  __typename?: "CandidateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Candidate
 */
export interface CandidateCreatedEvent {
  __typename?: "CandidateCreatedEvent";
  candidateId: ScalarsEnums["Int"];
  shortSummary: ScalarsEnums["String"];
  type: ScalarsEnums["String"];
}

/**
 * description=Controls whether messages from an identified sender can create or automatically convert Candidates.
 * displayName=CandidateIngestionPolicy
 * module=Admin
 * defaultQuery=candidateIngestionPolicies
 * colour=#5D35A6
 * aggregateQuery=candidateIngestionPoliciesAggregate
 * grouping=true
 * queryPermission=Query_Candidate_Ingestion_Policies
 */
export interface CandidateIngestionPolicy {
  __typename?: "CandidateIngestionPolicy";
  /**
   * sortable=true
   * groupable=false
   */
  candidateType: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  created?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=false
   */
  emailAddresses: Array<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  mode: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  modified?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=false
   */
  senderRecordId: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  senderRecordType: ScalarsEnums["String"];
}

/**
 * description=Controls whether messages from an identified sender can create or automatically convert Candidates.
 */
export interface CandidateIngestionPolicyAggregate {
  __typename?: "CandidateIngestionPolicyAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A customer or household contact associated with sales work.
 * displayName=Client
 * module=Sales
 * defaultQuery=clients
 * iconName=people
 * colour=#A91F54
 * aggregateQuery=clientsAggregate
 * grouping=true
 * queryPermission=Query_Clients
 */
export interface Client {
  __typename?: "Client";
  /**
   * sortable=true
   * groupable=false
   */
  address?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  email?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  faxHome?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  faxWork?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  firstName?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  fullName: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=true
   */
  jobs: (args?: { filter?: Maybe<JobFilterInput> }) => Maybe<Array<Job>>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  lastName?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  notes?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  phoneCell?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  phoneHome?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  phoneWork?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A customer or household contact associated with sales work.
 */
export interface ClientAggregate {
  __typename?: "ClientAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * A Client identity or a typed nested report dimension.
 */
export interface ClientReportDimensionValue {
  __typename?: "ClientReportDimensionValue";
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

export interface ComponentAction {
  __typename?: "ComponentAction";
  action: ScalarsEnums["String"];
  colour: ScalarsEnums["String"];
  icon: ScalarsEnums["String"];
  id: ScalarsEnums["ID"];
  index: ScalarsEnums["Int"];
  label: ScalarsEnums["String"];
  name: ScalarsEnums["String"];
}

export interface ComponentGridColumn {
  __typename?: "ComponentGridColumn";
  field: ScalarsEnums["String"];
  id: ScalarsEnums["ID"];
  index: ScalarsEnums["Int"];
  name: ScalarsEnums["String"];
  sort: ScalarsEnums["String"];
}

/**
 * displayName=Shortcut
 * module=Admin
 * defaultQuery=configuredLinkedActions
 * colour=#5D35A6
 * aggregateQuery=configuredLinkedActionsAggregate
 * grouping=true
 * queryPermission=Query_Configured_Linked_Actions
 */
export interface ConfiguredLinkedAction {
  __typename?: "ConfiguredLinkedAction";
  /**
   * sortable=true
   * groupable=false
   */
  actionId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  bindings: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  displayOrder: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  enabled: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  isGlobal: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  recordPath: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  roleIds: Array<ScalarsEnums["ID"]>;
  /**
   * sortable=false
   * groupable=false
   */
  seedRoleIds: Array<ScalarsEnums["ID"]>;
  /**
   * sortable=false
   * groupable=false
   */
  seedUserIds: Array<ScalarsEnums["ID"]>;
  /**
   * sortable=true
   * groupable=false
   */
  source: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  userIds: Array<ScalarsEnums["ID"]>;
}

export interface ConfiguredLinkedActionAggregate {
  __typename?: "ConfiguredLinkedActionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A note, email, phone call, or other correspondence item linked to a record.
 * displayName=Correspondence
 * module=Sales
 * defaultQuery=correspondence
 * iconName=comment
 * colour=#A91F54
 * aggregateQuery=correspondenceAggregate
 * grouping=true
 * queryPermission=Query_Correspondence
 */
export interface Correspondence {
  __typename?: "Correspondence";
  /**
   * sortable=true
   * groupable=true
   */
  created?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=true
   */
  createdBy?: Maybe<User>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  date?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  recordId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * sortable=true
   * groupable=false
   */
  recordType?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  text: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  type?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A note, email, phone call, or other correspondence item linked to a record.
 */
export interface CorrespondenceAggregate {
  __typename?: "CorrespondenceAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * displayName=Costing
 * defaultQuery=costings
 * aggregateQuery=costingsAggregate
 * grouping=true
 * queryPermission=Query_Costings
 */
export interface Costing {
  __typename?: "Costing";
  /**
   * sortable=true
   * groupable=false
   */
  costTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplateRevision?: Maybe<CostingTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  currentRevision?: Maybe<CostingRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  job?: Maybe<Job>;
  /**
   * sortable=true
   * groupable=true
   */
  jobComponent?: Maybe<JobComponent>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  lines: (args?: {
    filter?: Maybe<CostingLineFilterInput>;
  }) => Array<CostingLine>;
  /**
   * sortable=true
   * groupable=false
   */
  marginPercent: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  markupTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  revisions: (args?: {
    filter?: Maybe<CostingRevisionFilterInput>;
  }) => Array<CostingRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  sellTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  status: ScalarsEnums["String"];
}

export interface CostingAggregate {
  __typename?: "CostingAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * displayName=CostingLine
 * defaultQuery=costingLines
 * aggregateQuery=costingLinesAggregate
 * grouping=true
 * queryPermission=Query_Costing_Lines
 */
export interface CostingLine {
  __typename?: "CostingLine";
  /**
   * sortable=true
   * groupable=false
   */
  code?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  costing?: Maybe<Costing>;
  /**
   * sortable=true
   * groupable=true
   */
  costingRevision?: Maybe<CostingRevision>;
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplateRevision?: Maybe<CostingTemplateRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  line: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  lineTemplateId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=true
   */
  lines: (args?: {
    filter?: Maybe<CostingLineFilterInput>;
  }) => Array<CostingLine>;
  /**
   * sortable=true
   * groupable=false
   */
  markupAmount?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  markupExpression: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  parentLine?: Maybe<CostingLine>;
  /**
   * sortable=true
   * groupable=true
   */
  product?: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  productId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  supplierQuote?: Maybe<SupplierQuote>;
  /**
   * sortable=true
   * groupable=false
   */
  supplierQuoteId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * sortable=true
   * groupable=false
   */
  total: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  type: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPrice: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  unitSellPrice: ScalarsEnums["String"];
}

export interface CostingLineAggregate {
  __typename?: "CostingLineAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: ScalarsEnums["Float"];
}

/**
 * displayName=CostingLineTemplate
 * defaultQuery=costingLineTemplates
 * aggregateQuery=costingLineTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Costing_Line_Templates
 */
export interface CostingLineTemplate {
  __typename?: "CostingLineTemplate";
  /**
   * sortable=true
   * groupable=false
   */
  category: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplateRevision?: Maybe<CostingTemplateRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  descriptionEditable: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  markupEditable: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  markupExpression: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  quantity: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  quantityEditable: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPrice: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPriceEditable: ScalarsEnums["Boolean"];
}

export interface CostingLineTemplateAggregate {
  __typename?: "CostingLineTemplateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * displayName=CostingRevision
 * defaultQuery=costingRevisions
 * aggregateQuery=costingRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Revisions
 */
export interface CostingRevision {
  __typename?: "CostingRevision";
  /**
   * sortable=true
   * groupable=false
   */
  costTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  costing: Costing;
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplateRevision?: Maybe<CostingTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  lines: (args?: {
    filter?: Maybe<CostingLineFilterInput>;
  }) => Array<CostingLine>;
  /**
   * sortable=true
   * groupable=false
   */
  marginPercent: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  markupTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  sellTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  status: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  version: ScalarsEnums["Int"];
}

export interface CostingRevisionAggregate {
  __typename?: "CostingRevisionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * displayName=CostingTemplate
 * defaultQuery=costingTemplates
 * aggregateQuery=costingTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Costing_Templates
 */
export interface CostingTemplate {
  __typename?: "CostingTemplate";
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  currentRevision?: Maybe<CostingTemplateRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=false
   */
  draftRevision?: Maybe<CostingTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  isDefault: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  version: ScalarsEnums["Int"];
}

export interface CostingTemplateAggregate {
  __typename?: "CostingTemplateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * displayName=CostingTemplateExpression
 * defaultQuery=costingTemplateExpressions
 * aggregateQuery=costingTemplateExpressionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Template_Expressions
 */
export interface CostingTemplateExpression {
  __typename?: "CostingTemplateExpression";
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplateRevision?: Maybe<CostingTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  costingTemplateRevisionId: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  value: ScalarsEnums["String"];
}

export interface CostingTemplateExpressionAggregate {
  __typename?: "CostingTemplateExpressionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * displayName=CostingTemplateRevision
 * defaultQuery=costingTemplateRevisions
 * aggregateQuery=costingTemplateRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Costing_Template_Revisions
 */
export interface CostingTemplateRevision {
  __typename?: "CostingTemplateRevision";
  /**
   * sortable=true
   * groupable=true
   */
  costingTemplate: CostingTemplate;
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=false
   */
  defaultLines: Array<CostingLine>;
  /**
   * sortable=false
   * groupable=true
   */
  expressions: (args?: {
    filter?: Maybe<CostingTemplateExpressionFilterInput>;
  }) => Array<CostingTemplateExpression>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  lineTemplates: (args?: {
    filter?: Maybe<CostingLineTemplateFilterInput>;
  }) => Array<CostingLineTemplate>;
  /**
   * sortable=true
   * groupable=false
   */
  status: ScalarsEnums["CostingTemplateRevisionStatus"];
  /**
   * sortable=true
   * groupable=false
   */
  version: ScalarsEnums["Int"];
}

export interface CostingTemplateRevisionAggregate {
  __typename?: "CostingTemplateRevisionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=Custom form data associated with a record and schema version.
 * displayName=Custom Data
 * module=Admin
 * defaultQuery=customData
 * iconName=form
 * colour=#5D35A6
 * aggregateQuery=customDataAggregate
 * grouping=true
 * queryPermission=Query_Custom_Data
 */
export interface CustomData {
  __typename?: "CustomData";
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  data?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  recordId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  schema: Schema;
  /**
   * sortable=true
   * groupable=false
   */
  schemaId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  schemaVersion?: Maybe<SchemaVersion>;
}

/**
 * description=Custom form data associated with a record and schema version.
 */
export interface CustomDataAggregate {
  __typename?: "CustomDataAggregate";
  /**
   * sortable=true
   * groupable=false
   */
  average: (args: {
    path: ScalarsEnums["String"];
  }) => Maybe<ScalarsEnums["Float"]>;
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  max: (args: { path: ScalarsEnums["String"] }) => Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=false
   */
  min: (args: { path: ScalarsEnums["String"] }) => Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=false
   */
  sum: (args: { path: ScalarsEnums["String"] }) => ScalarsEnums["Float"];
}

/**
 * CustomData
 */
export interface CustomDataSetEvent {
  __typename?: "CustomDataSetEvent";
  customDataId: ScalarsEnums["String"];
  data: ScalarsEnums["String"];
  description: ScalarsEnums["String"];
  recordId: ScalarsEnums["String"];
  recordType: ScalarsEnums["String"];
  schemaId: ScalarsEnums["String"];
  schemaVersionId: ScalarsEnums["String"];
}

/**
 * description=A reusable custom template for generating application content.
 * displayName=Custom Template
 * module=Admin
 * defaultQuery=customTemplates
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=customTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Custom_Templates
 */
export interface CustomTemplate {
  __typename?: "CustomTemplate";
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  default: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  entity?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  query?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  sampleDataOverride?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  source: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  template: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  type: ScalarsEnums["Int"];
}

/**
 * description=A reusable custom template for generating application content.
 */
export interface CustomTemplateAggregate {
  __typename?: "CustomTemplateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface DataStore {
  __typename?: "DataStore";
  id: ScalarsEnums["ID"];
  name?: Maybe<ScalarsEnums["String"]>;
}

export interface DataStoreRecord {
  __typename?: "DataStoreRecord";
  data?: Maybe<ScalarsEnums["String"]>;
  id: ScalarsEnums["ID"];
}

export interface Day {
  __typename?: "Day";
  createdLeadAggregate: (args?: {
    filter?: Maybe<LeadFilterInput>;
  }) => Maybe<LeadAggregate>;
  createdPurchaseOrderAggregate: (args?: {
    filter?: Maybe<PurchaseOrderFilterInput>;
  }) => Maybe<PurchaseOrderAggregate>;
  createdPurchaseOrderLineAggregate: (args?: {
    filter?: Maybe<PurchaseOrderLineFilterInput>;
  }) => Maybe<PurchaseOrderLineAggregate>;
  date: ScalarsEnums["String"];
}

/**
 * description=A default native folder shown for every record of its configured type.
 * displayName=Default Folder
 * defaultQuery=defaultFolders
 * iconName=folder-close
 * aggregateQuery=defaultFoldersAggregate
 * grouping=true
 * queryPermission=Query_Default_Folders
 */
export interface DefaultFolder {
  __typename?: "DefaultFolder";
  /**
   * sortable=false
   * groupable=false
   */
  allowedMimeTypes?: Maybe<Array<ScalarsEnums["String"]>>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  enabled: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: ScalarsEnums["String"];
}

/**
 * description=A default native folder shown for every record of its configured type.
 */
export interface DefaultFolderAggregate {
  __typename?: "DefaultFolderAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A reusable delivery address for purchase orders.
 * displayName=Delivery Address
 * module=Inventory
 * defaultQuery=deliveryAddresses
 * iconName=map-marker
 * colour=#596600
 * aggregateQuery=deliveryAddressesAggregate
 * grouping=true
 * queryPermission=Query_Delivery_Addresses
 */
export interface DeliveryAddress {
  __typename?: "DeliveryAddress";
  /**
   * sortable=true
   * groupable=false
   */
  address?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  code?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  color?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A reusable delivery address for purchase orders.
 */
export interface DeliveryAddressAggregate {
  __typename?: "DeliveryAddressAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface Document {
  __typename?: "Document";
  /**
   * TODO: Rename as might output formats other than HTML, eg plaintext, images etc
   */
  html: ScalarsEnums["String"];
  id: ScalarsEnums["ID"];
  pdfBase64: ScalarsEnums["String"];
  template: DocumentTemplate;
}

export interface DocumentPreview {
  __typename?: "DocumentPreview";
  html: ScalarsEnums["String"];
  pdfBase64: ScalarsEnums["String"];
}

/**
 * description=A document template with its rendering query and default selection.
 * displayName=Document Template
 * module=Admin
 * defaultQuery=documentTemplates
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=documentTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Document_Templates
 */
export interface DocumentTemplate {
  __typename?: "DocumentTemplate";
  /**
   * sortable=true
   * groupable=true
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  default: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  description: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  entity: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  html: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  query?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  sampleDataOverride?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  source: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  template: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  type: ScalarsEnums["String"];
}

/**
 * description=A document template with its rendering query and default selection.
 */
export interface DocumentTemplateAggregate {
  __typename?: "DocumentTemplateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface EffectivePermission {
  __typename?: "EffectivePermission";
  assigned: ScalarsEnums["Boolean"];
  conditions?: Maybe<ScalarsEnums["String"]>;
  permission: Permission;
  policy: ScalarsEnums["Policy"];
}

/**
 * description=A persisted transactional email and its delivery status.
 * displayName=Transactional Email
 * module=Admin
 * defaultQuery=emails
 * iconName=envelope
 * colour=#5D35A6
 * aggregateQuery=emailsAggregate
 * grouping=true
 * queryPermission=Query_Transactional_Emails
 */
export interface Email {
  __typename?: "Email";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  messageId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  purchaseOrder?: Maybe<PurchaseOrder>;
  /**
   * sortable=true
   * groupable=false
   */
  recipient?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  sender?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  sentAt?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=false
   */
  status?: Maybe<ScalarsEnums["EmailDeliveryStatus"]>;
  /**
   * sortable=true
   * groupable=false
   */
  subject?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  type?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  typeDisplayName?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  updatedAt?: Maybe<ScalarsEnums["DateTime"]>;
}

/**
 * description=A persisted transactional email and its delivery status.
 */
export interface EmailAggregate {
  __typename?: "EmailAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface EmailCreatedEvent {
  __typename?: "EmailCreatedEvent";
  entity: ScalarsEnums["String"];
}

/**
 * Email
 */
export interface EmailStatusChangedEvent {
  __typename?: "EmailStatusChangedEvent";
  description?: Maybe<ScalarsEnums["String"]>;
  emailId: ScalarsEnums["String"];
  previousStatus?: Maybe<ScalarsEnums["Int"]>;
  recipient?: Maybe<ScalarsEnums["String"]>;
  status: ScalarsEnums["Int"];
  subject?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A configured storage provider and its remote and device access settings.
 * displayName=External Storage Connection
 * module=Admin
 * defaultQuery=externalStorageConnections
 * iconName=cloud
 * colour=#5D35A6
 * aggregateQuery=externalStorageConnectionsAggregate
 * grouping=true
 * queryPermission=Query_Storage_Connections
 */
export interface ExternalStorageConnection {
  __typename?: "ExternalStorageConnection";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  deviceAccessEnabled: ScalarsEnums["Boolean"];
  /**
   * sortable=false
   * groupable=false
   */
  dropboxAuthToken?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  dropboxNamespaceId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  enabled: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=false
   */
  item: (args: {
    /**
     * @defaultValue `""`
     */
    path?: Maybe<ScalarsEnums["String"]>;
  }) => ExternalStorageItem;
  /**
   * sortable=false
   * groupable=false
   */
  items: (args: {
    /**
     * @defaultValue `""`
     */
    path?: Maybe<ScalarsEnums["String"]>;
    /**
     * @defaultValue `""`
     */
    pathPrefix?: Maybe<ScalarsEnums["String"]>;
  }) => Array<ExternalStorageItem>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  localPathSeparator: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  localRoot?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  root: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  storageMappings: (args?: {
    filter?: Maybe<ExternalStorageResourceMappingFilterInput>;
  }) => Array<ExternalStorageResourceMapping>;
  /**
   * sortable=true
   * groupable=false
   */
  type: ScalarsEnums["String"];
}

/**
 * description=A configured storage provider and its remote and device access settings.
 */
export interface ExternalStorageConnectionAggregate {
  __typename?: "ExternalStorageConnectionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface ExternalStorageItem {
  __typename?: "ExternalStorageItem";
  canOpen?: Maybe<ScalarsEnums["Boolean"]>;
  fileId?: Maybe<ScalarsEnums["String"]>;
  folderBadgeIconColour?: Maybe<ScalarsEnums["String"]>;
  folderBadgeIconName?: Maybe<ScalarsEnums["String"]>;
  id: ScalarsEnums["String"];
  isFolder: ScalarsEnums["Boolean"];
  label: ScalarsEnums["String"];
  largeThumbnailUrl?: Maybe<ScalarsEnums["String"]>;
  /**
   * Returns the "local" path (if it exists) for this item
   * Eg you may have dropbox mounted locally on your PC,
   * this will let you access that file directly.
   */
  localPath?: Maybe<ScalarsEnums["String"]>;
  /**
   * Signed local-device URL consumed by the Windows jmfile protocol handler.
   */
  localUrl?: Maybe<ScalarsEnums["String"]>;
  mediumThumbnailUrl?: Maybe<ScalarsEnums["String"]>;
  metadata?: Maybe<ScalarsEnums["String"]>;
  /**
   * groupable=true
   */
  mimeType?: Maybe<ScalarsEnums["String"]>;
  /**
   * groupable=true
   */
  modified?: Maybe<ScalarsEnums["DateTime"]>;
  name: ScalarsEnums["String"];
  path: ScalarsEnums["String"];
  previewUrl?: Maybe<ScalarsEnums["String"]>;
  recordFileId?: Maybe<ScalarsEnums["String"]>;
  size?: Maybe<ScalarsEnums["Int"]>;
  smallThumbnailUrl?: Maybe<ScalarsEnums["String"]>;
  temporaryUrl?: Maybe<ScalarsEnums["String"]>;
  /**
   * groupable=true
   */
  type: ScalarsEnums["String"];
  uploadMimeTypes?: Maybe<Array<ScalarsEnums["String"]>>;
}

/**
 * description=A storage connection path made available to records matching a resource filter.
 * displayName=External Storage Resource Mapping
 * module=Admin
 * defaultQuery=externalStorageResourceMappings
 * iconName=folder-open
 * colour=#5D35A6
 * aggregateQuery=externalStorageResourceMappingsAggregate
 * grouping=true
 * queryPermission=Query_Storage_Resource_Mappings
 */
export interface ExternalStorageResourceMapping {
  __typename?: "ExternalStorageResourceMapping";
  /**
   * sortable=true
   * groupable=false
   */
  created?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  enabled: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  externalStorageConnection: ExternalStorageConnection;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  path?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  resourceFilter?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  resourceType?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A storage connection path made available to records matching a resource filter.
 */
export interface ExternalStorageResourceMappingAggregate {
  __typename?: "ExternalStorageResourceMappingAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=An uploaded file and its stored metadata and preview URLs.
 * displayName=File
 * module=Admin
 * defaultQuery=files
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=fileAggregates
 * grouping=true
 * queryPermission=Query_Files
 */
export interface File {
  __typename?: "File";
  /**
   * sortable=true
   * groupable=true
   */
  created: ScalarsEnums["DateTime"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  hash?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  largeThumbnailUrl?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  mediumThumbnailUrl?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  mimeType?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  modified: ScalarsEnums["DateTime"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  sizeBytes: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  smallThumbnailUrl?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  temporaryUrl?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  user?: Maybe<User>;
}

/**
 * description=An uploaded file and its stored metadata and preview URLs.
 */
export interface FileAggregate {
  __typename?: "FileAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * A File identity or a typed nested report dimension.
 */
export interface FileReportDimensionValue {
  __typename?: "FileReportDimensionValue";
  created?: Maybe<ReportDimensionValue>;
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
  modified?: Maybe<ReportDimensionValue>;
  user?: Maybe<UserReportDimensionValue>;
}

export interface FileUploadedEvent {
  __typename?: "FileUploadedEvent";
  file: ScalarsEnums["String"];
}

/**
 * description=A group within a running line-item manufacturing workflow.
 * displayName=Group Instance
 * module=Manufacturing
 * iconName=data-lineage
 * colour=#A96500
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export interface GroupInstance {
  __typename?: "GroupInstance";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  lineItemMasterWorkflow?: Maybe<LineItemMasterWorkflow>;
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  workflow: Workflow;
}

/**
 * description=A reusable grouped workflow step inside a workflow template.
 * displayName=Group Template
 * module=Manufacturing
 * defaultQuery=groupTemplates
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=groupTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Group_Templates
 */
export interface GroupTemplate {
  __typename?: "GroupTemplate";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  placeHolder: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  workflowTemplate?: Maybe<WorkflowTemplate>;
}

/**
 * description=A reusable grouped workflow step inside a workflow template.
 */
export interface GroupTemplateAggregate {
  __typename?: "GroupTemplateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A housing company associated with sales jobs.
 * displayName=Housing Company
 * module=Sales
 * defaultQuery=housingCompanies
 * iconName=office
 * colour=#A91F54
 * aggregateQuery=housingCompaniesAggregate
 * grouping=true
 * queryPermission=Query_Housing_Companies
 */
export interface HousingCompany {
  __typename?: "HousingCompany";
  /**
   * sortable=true
   * groupable=false
   */
  code?: Maybe<ScalarsEnums["String"]>;
  /**
   * description=Completed-month YTD confirmed sales minus the equivalent period in the previous year.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  confirmedSalesYtdChange?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=true
   */
  created?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  image?: Maybe<File>;
  /**
   * sortable=false
   * groupable=false
   */
  jobAggregate: (args?: {
    filter?: Maybe<JobFilterInput>;
  }) => Maybe<JobAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  jobs: (args?: { filter?: Maybe<JobFilterInput> }) => Array<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  modified?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=false
   */
  name?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A housing company associated with sales jobs.
 */
export interface HousingCompanyAggregate {
  __typename?: "HousingCompanyAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * A Housing Company identity or a typed nested report dimension.
 */
export interface HousingCompanyReportDimensionValue {
  __typename?: "HousingCompanyReportDimensionValue";
  created?: Maybe<ReportDimensionValue>;
  image?: Maybe<FileReportDimensionValue>;
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
  modified?: Maybe<ReportDimensionValue>;
}

/**
 * PurchaseOrder
 */
export interface InternalCommentUpdatedEvent {
  __typename?: "InternalCommentUpdatedEvent";
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

export interface InvalidateCacheEvent {
  __typename?: "InvalidateCacheEvent";
  shutdown: ScalarsEnums["String"];
}

/**
 * PurchaseOrder
 */
export interface InvoiceCheckedEvent {
  __typename?: "InvoiceCheckedEvent";
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

/**
 * PurchaseOrder
 */
export interface InvoiceUncheckedEvent {
  __typename?: "InvoiceUncheckedEvent";
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

/**
 * description=A maintenance issue tracked against a record.
 * displayName=Issue
 * module=Sales
 * defaultQuery=issues
 * iconName=issue
 * colour=#A91F54
 * aggregateQuery=issuesAggregate
 * grouping=true
 * queryPermission=Query_Issues
 */
export interface Issue {
  __typename?: "Issue";
  /**
   * sortable=true
   * groupable=false
   */
  completed: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  createdAt?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=true
   */
  files: (args?: {
    filter?: Maybe<RecordFileFilterInput>;
  }) => Array<RecordFile>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  job?: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  modifiedAt?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=false
   */
  notes?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  recordId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * description=The Job linked through the issue record reference.
   * sortable=true
   * groupable=true
   */
  recordJob?: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  recordType?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  reportedBy?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  requiredDate?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=true
   */
  scheduledDate?: Maybe<ScalarsEnums["DateTime"]>;
}

/**
 * description=A maintenance issue tracked against a record.
 */
export interface IssueAggregate {
  __typename?: "IssueAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface IssueCompletionStatus {
  __typename?: "IssueCompletionStatus";
  completed: ScalarsEnums["Boolean"];
  id: ScalarsEnums["ID"];
  issueAggregate: (args?: {
    filter?: Maybe<IssueFilterInput>;
  }) => Maybe<IssueAggregate>;
  label: ScalarsEnums["String"];
  name: ScalarsEnums["String"];
}

/**
 * Issue
 */
export interface IssueCreatedEvent {
  __typename?: "IssueCreatedEvent";
  description?: Maybe<ScalarsEnums["String"]>;
  issueId: ScalarsEnums["Int"];
}

/**
 * Issue
 */
export interface IssueUpdatedEvent {
  __typename?: "IssueUpdatedEvent";
  description?: Maybe<ScalarsEnums["String"]>;
  issueId: ScalarsEnums["Int"];
}

/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 * displayName=Job
 * module=Sales
 * defaultQuery=jobs
 * iconName=briefcase
 * colour=#A91F54
 * aggregateQuery=jobsAggregate
 * reportQuery=jobReport
 * grouping=true
 * queryPermission=Query_Jobs
 */
export interface Job {
  __typename?: "Job";
  /**
   * sortable=false
   * groupable=true
   */
  batches: (args?: { filter?: Maybe<BatchFilterInput> }) => Array<Batch>;
  /**
   * sortable=true
   * groupable=false
   */
  benchtopOnly: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  branch?: Maybe<Branch>;
  /**
   * sortable=true
   * groupable=true
   */
  buildType?: Maybe<BuildType>;
  /**
   * sortable=true
   * groupable=false
   */
  buildTypeId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  builder?: Maybe<Builder>;
  /**
   * sortable=true
   * groupable=false
   */
  builderId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  builderPhone?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  client?: Maybe<Client>;
  /**
   * sortable=false
   * groupable=true
   */
  costings: (args?: { filter?: Maybe<CostingFilterInput> }) => Array<Costing>;
  /**
   * sortable=true
   * groupable=true
   */
  createdDate?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  designer?: Maybe<PersonBusinessRole>;
  /**
   * sortable=true
   * groupable=false
   */
  designerId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  difficultAccess: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  dueDate?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=false
   * groupable=false
   */
  externalStorageConnection?: Maybe<ExternalStorageConnection>;
  /**
   * sortable=false
   * groupable=false
   */
  externalStorageItems: (args?: {
    path?: Maybe<ScalarsEnums["String"]>;
  }) => Maybe<Array<ExternalStorageItem>>;
  /**
   * description=We won't store this in the database, but will use centralised tenant-specific logic to map a job to the right external path
   * sortable=true
   * groupable=false
   */
  externalStoragePath?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  hcJobNumber?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  hcPmPhone?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  hcProjectManager?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  housingCompany?: Maybe<HousingCompany>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=true
   */
  issues: (args?: { filter?: Maybe<IssueFilterInput> }) => Array<Issue>;
  /**
   * sortable=false
   * groupable=true
   */
  jobComponents: (args?: {
    filter?: Maybe<JobComponentFilterInput>;
  }) => Array<JobComponent>;
  /**
   * sortable=true
   * groupable=false
   */
  jobFolderLink?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  jobName?: Maybe<ScalarsEnums["String"]>;
  /**
   * description=A unique number for this job
   * sortable=true
   * groupable=false
   */
  jobNumber?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  lead?: Maybe<Lead>;
  /**
   * sortable=false
   * groupable=false
   */
  lineItemAggregate: (args?: {
    filter?: Maybe<LineItemFilterInput>;
  }) => Maybe<LineItemAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  lineItems: (args?: {
    filter?: Maybe<LineItemFilterInput>;
  }) => Array<LineItem>;
  /**
   * sortable=true
   * groupable=true
   */
  lostReason?: Maybe<LostReason>;
  /**
   * sortable=true
   * groupable=false
   */
  lostReasonNotes?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  note?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  projectManager?: Maybe<PersonBusinessRole>;
  /**
   * sortable=true
   * groupable=false
   */
  projectManagerId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  purchaseOrderAggregate?: Maybe<PurchaseOrderAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  purchaseOrders: (args?: {
    filter?: Maybe<PurchaseOrderFilterInput>;
  }) => Array<PurchaseOrder>;
  /**
   * sortable=false
   * groupable=true
   */
  quotes: (args?: { filter?: Maybe<QuoteFilterInput> }) => Array<Quote>;
  /**
   * sortable=true
   * groupable=true
   */
  region?: Maybe<Region>;
  /**
   * sortable=true
   * groupable=false
   */
  regionId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  saleType?: Maybe<SaleType>;
  /**
   * sortable=true
   * groupable=false
   */
  saleTypeId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=true
   */
  salesOrders: (args?: {
    filter?: Maybe<SalesOrderFilterInput>;
  }) => Array<SalesOrder>;
  /**
   * sortable=true
   * groupable=false
   */
  showHome: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  siteAddress?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  siteNotes?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  sssp: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  status: ScalarsEnums["Int"];
  /**
   * sortable=false
   * groupable=true
   */
  supplierQuoteRequests: (args?: {
    filter?: Maybe<SupplierQuoteRequestFilterInput>;
  }) => Array<SupplierQuoteRequest>;
  /**
   * sortable=false
   * groupable=true
   */
  supplierQuotes: (args?: {
    filter?: Maybe<SupplierQuoteFilterInput>;
  }) => Array<SupplierQuote>;
  /**
   * sortable=true
   * groupable=false
   */
  tristoneJoin: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  tristoneSpecified: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  unit: ScalarsEnums["Boolean"];
}

/**
 * description=A customer job tracking sales, production, purchasing, and delivery work.
 */
export interface JobAggregate {
  __typename?: "JobAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  /**
   * description=Estimated line-item sheets for matching jobs, grouped by job date.
   * sortable=true
   * groupable=false
   */
  estimatedSheets: ScalarsEnums["Float"];
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * description=Total confirmed line-item sales for matching jobs.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  totalConfirmedSale: (args?: {
    confirmedDate?: Maybe<DateTimeFilterInput>;
  }) => Maybe<ScalarsEnums["Float"]>;
}

/**
 * Job
 */
export interface JobBuilderUpdatedEvent {
  __typename?: "JobBuilderUpdatedEvent";
  jobId: ScalarsEnums["String"];
  jobNumber: ScalarsEnums["String"];
}

/**
 * Job
 */
export interface JobClientUpdatedEvent {
  __typename?: "JobClientUpdatedEvent";
  clientName: ScalarsEnums["String"];
  jobId: ScalarsEnums["String"];
  jobNumber: ScalarsEnums["String"];
}

/**
 * description=A stable unit of scope within a job.
 * displayName=Job Component
 * module=Sales
 * defaultQuery=jobComponents
 * iconName=cube
 * colour=#A91F54
 * aggregateQuery=jobComponentsAggregate
 * grouping=true
 * queryPermission=Query_Job_Components
 */
export interface JobComponent {
  __typename?: "JobComponent";
  /**
   * sortable=true
   * groupable=false
   */
  code: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  costings: (args?: { filter?: Maybe<CostingFilterInput> }) => Array<Costing>;
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  estimatingSellTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  job: Job;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  partType?: Maybe<PartType>;
  /**
   * sortable=false
   * groupable=true
   */
  quoteLines: (args?: {
    filter?: Maybe<QuoteLineFilterInput>;
  }) => Array<QuoteLine>;
  /**
   * sortable=false
   * groupable=true
   */
  salesOrderLines: (args?: {
    filter?: Maybe<SalesOrderLineFilterInput>;
  }) => Array<SalesOrderLine>;
}

/**
 * description=A stable unit of scope within a job.
 */
export interface JobComponentAggregate {
  __typename?: "JobComponentAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Job
 */
export interface JobCreatedEvent {
  __typename?: "JobCreatedEvent";
  jobId: ScalarsEnums["String"];
  jobNumber: ScalarsEnums["String"];
  leadId?: Maybe<ScalarsEnums["String"]>;
}

/**
 * Job
 */
export interface JobDetailsUpdatedEvent {
  __typename?: "JobDetailsUpdatedEvent";
  jobId: ScalarsEnums["String"];
  jobNumber: ScalarsEnums["String"];
}

/**
 * LineItem
 */
export interface JobPartBatchChangedEvent {
  __typename?: "JobPartBatchChangedEvent";
  lineItemId: ScalarsEnums["String"];
  lineItemName: ScalarsEnums["String"];
  newBatchId: ScalarsEnums["String"];
  newBatchName: ScalarsEnums["String"];
  oldBatchId?: Maybe<ScalarsEnums["String"]>;
}

/**
 * LineItem
 */
export interface JobPartConfirmedEvent {
  __typename?: "JobPartConfirmedEvent";
  lineItemId: ScalarsEnums["String"];
  lineItemName: ScalarsEnums["String"];
}

/**
 * LineItem
 */
export interface JobPartCreatedEvent {
  __typename?: "JobPartCreatedEvent";
  jobNumber: ScalarsEnums["String"];
  lineItemId: ScalarsEnums["String"];
  lineItemName: ScalarsEnums["String"];
}

/**
 * LineItem
 */
export interface JobPartDeletedEvent {
  __typename?: "JobPartDeletedEvent";
  batchId?: Maybe<ScalarsEnums["String"]>;
  lineItemId: ScalarsEnums["String"];
  lineItemName: ScalarsEnums["String"];
}

/**
 * LineItem
 */
export interface JobPartUpdatedEvent {
  __typename?: "JobPartUpdatedEvent";
  lineItemId: ScalarsEnums["String"];
  lineItemName: ScalarsEnums["String"];
}

/**
 * A Job identity or a typed nested report dimension.
 */
export interface JobReportDimensionValue {
  __typename?: "JobReportDimensionValue";
  branch?: Maybe<BranchReportDimensionValue>;
  buildType?: Maybe<BuildTypeReportDimensionValue>;
  builder?: Maybe<BuilderReportDimensionValue>;
  client?: Maybe<ClientReportDimensionValue>;
  createdDate?: Maybe<ReportDimensionValue>;
  designer?: Maybe<PersonBusinessRoleReportDimensionValue>;
  dueDate?: Maybe<ReportDimensionValue>;
  housingCompany?: Maybe<HousingCompanyReportDimensionValue>;
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
  lead?: Maybe<LeadReportDimensionValue>;
  lostReason?: Maybe<LostReasonReportDimensionValue>;
  projectManager?: Maybe<PersonBusinessRoleReportDimensionValue>;
  region?: Maybe<RegionReportDimensionValue>;
  saleType?: Maybe<SaleTypeReportDimensionValue>;
}

/**
 * Typed Job report dimension values.
 */
export interface JobReportDimensions {
  __typename?: "JobReportDimensions";
  branch?: Maybe<BranchReportDimensionValue>;
  buildType?: Maybe<BuildTypeReportDimensionValue>;
  builder?: Maybe<BuilderReportDimensionValue>;
  client?: Maybe<ClientReportDimensionValue>;
  createdDate?: Maybe<ReportDimensionValue>;
  designer?: Maybe<PersonBusinessRoleReportDimensionValue>;
  dueDate?: Maybe<ReportDimensionValue>;
  housingCompany?: Maybe<HousingCompanyReportDimensionValue>;
  lead?: Maybe<LeadReportDimensionValue>;
  lostReason?: Maybe<LostReasonReportDimensionValue>;
  projectManager?: Maybe<PersonBusinessRoleReportDimensionValue>;
  region?: Maybe<RegionReportDimensionValue>;
  saleType?: Maybe<SaleTypeReportDimensionValue>;
}

/**
 * One grouped Job report row.
 */
export interface JobReportRow {
  __typename?: "JobReportRow";
  /**
   * The generated Job aggregate, constrained to this dimension row.
   */
  aggregate: (args?: { filter?: Maybe<JobFilterInput> }) => JobAggregate;
  /**
   * Typed values for every selected report dimension.
   */
  dimensions: JobReportDimensions;
  /**
   * The first dimension key, retained for single-dimension report compatibility.
   */
  key: ScalarsEnums["String"];
  /**
   * The first dimension label, retained for single-dimension report compatibility.
   */
  label: ScalarsEnums["String"];
}

/**
 * Job
 */
export interface JobSiteUpdatedEvent {
  __typename?: "JobSiteUpdatedEvent";
  jobId: ScalarsEnums["String"];
  jobNumber: ScalarsEnums["String"];
}

export interface JobStatus {
  __typename?: "JobStatus";
  id: ScalarsEnums["ID"];
  intent: ScalarsEnums["String"];
  jobAggregate: (args?: {
    filter?: Maybe<JobFilterInput>;
  }) => Maybe<JobAggregate>;
  label: ScalarsEnums["String"];
  name: ScalarsEnums["String"];
}

/**
 * Job
 */
export interface JobStatusChangedEvent {
  __typename?: "JobStatusChangedEvent";
  jobId: ScalarsEnums["String"];
  jobNumber?: Maybe<ScalarsEnums["String"]>;
  newStatus: ScalarsEnums["String"];
  oldStatus?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A sales enquiry or prospect before it is converted into a job.
 * displayName=Lead
 * module=Sales
 * defaultQuery=leads
 * iconName=filter-list
 * colour=#A91F54
 * aggregateQuery=leadsAggregate
 * reportQuery=leadReport
 * grouping=true
 * queryPermission=Query_Leads
 */
export interface Lead {
  __typename?: "Lead";
  /**
   * sortable=true
   * groupable=false
   */
  address?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  assignedDate?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=true
   */
  assignedTo?: Maybe<PersonBusinessRole>;
  /**
   * sortable=true
   * groupable=true
   */
  branch?: Maybe<Branch>;
  /**
   * sortable=true
   * groupable=false
   */
  builderName?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  builderType?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  city?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  client: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  correspondence: (args?: {
    filter?: Maybe<CorrespondenceFilterInput>;
  }) => Array<Correspondence>;
  /**
   * sortable=true
   * groupable=true
   */
  createdAt?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  email?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  job?: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  joineryTypes?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  latestCorrespondence?: Maybe<Correspondence>;
  /**
   * sortable=true
   * groupable=true
   */
  lostReason?: Maybe<LostReason>;
  /**
   * sortable=true
   * groupable=false
   */
  lostReasonNotes?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  notes?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  phone?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  priceRangeBottom?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=false
   */
  priceRangeTop?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=false
   */
  priority: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  projectType: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  requiredBy?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=false
   */
  source: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  status: LeadStatus;
  /**
   * sortable=true
   * groupable=false
   */
  suburb?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A sales enquiry or prospect before it is converted into a job.
 */
export interface LeadAggregate {
  __typename?: "LeadAggregate";
  /**
   * sortable=true
   * groupable=false
   */
  avgAssignTimeDays?: Maybe<ScalarsEnums["Int"]>;
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * sortable=false
   * groupable=false
   */
  ids: Array<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  newStatusCount: ScalarsEnums["Int"];
}

/**
 * Lead
 */
export interface LeadAssignedEvent {
  __typename?: "LeadAssignedEvent";
  assignedToId: ScalarsEnums["Int"];
  assignedToName: ScalarsEnums["String"];
  clientName: ScalarsEnums["String"];
  leadId: ScalarsEnums["Int"];
}

/**
 * Lead
 */
export interface LeadBranchChangedEvent {
  __typename?: "LeadBranchChangedEvent";
  clientName: ScalarsEnums["String"];
  leadId: ScalarsEnums["Int"];
  newBranchId?: Maybe<ScalarsEnums["String"]>;
  newBranchName?: Maybe<ScalarsEnums["String"]>;
  oldBranchId?: Maybe<ScalarsEnums["String"]>;
  oldBranchName?: Maybe<ScalarsEnums["String"]>;
}

/**
 * Lead
 */
export interface LeadConvertedToJobEvent {
  __typename?: "LeadConvertedToJobEvent";
  jobNumber: ScalarsEnums["String"];
  leadId: ScalarsEnums["String"];
  leadLabel: ScalarsEnums["String"];
}

/**
 * Lead
 */
export interface LeadCreatedEvent {
  __typename?: "LeadCreatedEvent";
  clientName: ScalarsEnums["String"];
  leadId: ScalarsEnums["Int"];
}

/**
 * Lead
 */
export interface LeadDetailsUpdatedEvent {
  __typename?: "LeadDetailsUpdatedEvent";
  clientName: ScalarsEnums["String"];
  leadId: ScalarsEnums["Int"];
}

/**
 * Lead
 */
export interface LeadOverrideStatusEvent {
  __typename?: "LeadOverrideStatusEvent";
  clientName: ScalarsEnums["String"];
  leadId: ScalarsEnums["Int"];
  newStatus: ScalarsEnums["String"];
  oldStatus: ScalarsEnums["String"];
}

export interface LeadProjectType {
  __typename?: "LeadProjectType";
  id: ScalarsEnums["ID"];
  leadAggregate: (args?: {
    filter?: Maybe<LeadFilterInput>;
  }) => Maybe<LeadAggregate>;
  name: ScalarsEnums["String"];
}

/**
 * A Lead identity or a typed nested report dimension.
 */
export interface LeadReportDimensionValue {
  __typename?: "LeadReportDimensionValue";
  assignedDate?: Maybe<ReportDimensionValue>;
  assignedTo?: Maybe<PersonBusinessRoleReportDimensionValue>;
  branch?: Maybe<BranchReportDimensionValue>;
  createdAt?: Maybe<ReportDimensionValue>;
  job?: Maybe<JobReportDimensionValue>;
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
  lostReason?: Maybe<LostReasonReportDimensionValue>;
  requiredBy?: Maybe<ReportDimensionValue>;
}

/**
 * Typed Lead report dimension values.
 */
export interface LeadReportDimensions {
  __typename?: "LeadReportDimensions";
  assignedDate?: Maybe<ReportDimensionValue>;
  assignedTo?: Maybe<PersonBusinessRoleReportDimensionValue>;
  branch?: Maybe<BranchReportDimensionValue>;
  createdAt?: Maybe<ReportDimensionValue>;
  job?: Maybe<JobReportDimensionValue>;
  lostReason?: Maybe<LostReasonReportDimensionValue>;
  requiredBy?: Maybe<ReportDimensionValue>;
}

/**
 * One grouped Lead report row.
 */
export interface LeadReportRow {
  __typename?: "LeadReportRow";
  /**
   * The generated Lead aggregate, constrained to this dimension row.
   */
  aggregate: (args?: { filter?: Maybe<LeadFilterInput> }) => LeadAggregate;
  /**
   * Typed values for every selected report dimension.
   */
  dimensions: LeadReportDimensions;
  /**
   * The first dimension key, retained for single-dimension report compatibility.
   */
  key: ScalarsEnums["String"];
  /**
   * The first dimension label, retained for single-dimension report compatibility.
   */
  label: ScalarsEnums["String"];
}

export interface LeadSource {
  __typename?: "LeadSource";
  id: ScalarsEnums["ID"];
  label: ScalarsEnums["String"];
  leadAggregate: (args?: {
    filter?: Maybe<LeadFilterInput>;
  }) => Maybe<LeadAggregate>;
  name: ScalarsEnums["String"];
}

export interface LeadStatus {
  __typename?: "LeadStatus";
  id: ScalarsEnums["LeadStatusEnum"];
  intent: ScalarsEnums["String"];
  label: ScalarsEnums["String"];
  leadAggregate: (args?: {
    filter?: Maybe<LeadFilterInput>;
  }) => Maybe<LeadAggregate>;
  name: ScalarsEnums["String"];
}

/**
 * Lead
 */
export interface LeadStatusChangedEvent {
  __typename?: "LeadStatusChangedEvent";
  clientName: ScalarsEnums["String"];
  leadId: ScalarsEnums["Int"];
  newStatus: ScalarsEnums["String"];
  oldStatus: ScalarsEnums["String"];
}

/**
 * description=A manufactured or supplied part, unit, or work item within a job.
 * displayName=Work Order
 * module=Manufacturing
 * defaultQuery=lineItems
 * iconName=wrench
 * colour=#A96500
 * aggregateQuery=lineItemsAggregate
 * reportQuery=lineItemReport
 * grouping=true
 * queryPermission=Query_Job_Parts
 */
export interface LineItem {
  __typename?: "LineItem";
  /**
   * sortable=true
   * groupable=true
   */
  batch?: Maybe<Batch>;
  /**
   * sortable=true
   * groupable=false
   */
  batchId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  confirmed: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  confirmedDate?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  confirmedSale?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  job?: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  masterWorkflow?: Maybe<LineItemMasterWorkflow>;
  /**
   * sortable=true
   * groupable=false
   */
  name?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  oldSpecification?: Maybe<Specification>;
  /**
   * sortable=true
   * groupable=false
   */
  partNumber?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  partType?: Maybe<PartType>;
  /**
   * sortable=true
   * groupable=false
   */
  salePrice?: Maybe<ScalarsEnums["Float"]>;
}

/**
 * description=A manufactured or supplied part, unit, or work item within a job.
 */
export interface LineItemAggregate {
  __typename?: "LineItemAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * description=Total confirmed sale value.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  totalConfirmedSale?: Maybe<ScalarsEnums["Float"]>;
}

/**
 * description=The workflow subject that tracks manufacturing process instances for a line item.
 * displayName=Line Item Master Workflow
 * module=Manufacturing
 * defaultQuery=lineItemMasterWorkflows
 * iconName=git-branch
 * colour=#A96500
 * aggregateQuery=lineItemMasterWorkflowsAggregate
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export interface LineItemMasterWorkflow {
  __typename?: "LineItemMasterWorkflow";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=true
   */
  groupInstances: (args?: {
    filter?: Maybe<GroupInstanceFilterInput>;
  }) => Array<GroupInstance>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=true
   */
  items: (args?: {
    filter?: Maybe<WorkflowNodeFilterInput>;
  }) => Array<WorkflowNode>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  lineItem?: Maybe<LineItem>;
  /**
   * sortable=true
   * groupable=false
   */
  lineItemId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  orderedItems: Array<WorkflowNode>;
  /**
   * sortable=false
   * groupable=false
   */
  orderedProcessInstances: Array<ProcessInstance>;
  /**
   * sortable=false
   * groupable=true
   */
  processAssets: (args?: {
    filter?: Maybe<ProcessAssetFilterInput>;
  }) => Array<ProcessAsset>;
  /**
   * sortable=false
   * groupable=false
   */
  processInstanceAggregate: (args?: {
    filter?: Maybe<ProcessInstanceFilterInput>;
  }) => Maybe<ProcessInstanceAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  processInstances: (args?: {
    filter?: Maybe<ProcessInstanceFilterInput>;
  }) => Array<ProcessInstance>;
}

/**
 * description=The workflow subject that tracks manufacturing process instances for a line item.
 */
export interface LineItemMasterWorkflowAggregate {
  __typename?: "LineItemMasterWorkflowAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface LineItemMasterWorkflowCompletedEvent {
  __typename?: "LineItemMasterWorkflowCompletedEvent";
  lineItemMasterWorkflowId: ScalarsEnums["String"];
}

/**
 * A Line Item Master Workflow identity or a typed nested report dimension.
 */
export interface LineItemMasterWorkflowReportDimensionValue {
  __typename?: "LineItemMasterWorkflowReportDimensionValue";
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
  lineItem?: Maybe<LineItemReportDimensionValue>;
}

/**
 * A Work Order identity or a typed nested report dimension.
 */
export interface LineItemReportDimensionValue {
  __typename?: "LineItemReportDimensionValue";
  batch?: Maybe<BatchReportDimensionValue>;
  confirmedDate?: Maybe<ReportDimensionValue>;
  job?: Maybe<JobReportDimensionValue>;
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
  masterWorkflow?: Maybe<LineItemMasterWorkflowReportDimensionValue>;
  partType?: Maybe<PartTypeReportDimensionValue>;
}

/**
 * Typed Work Order report dimension values.
 */
export interface LineItemReportDimensions {
  __typename?: "LineItemReportDimensions";
  batch?: Maybe<BatchReportDimensionValue>;
  confirmedDate?: Maybe<ReportDimensionValue>;
  job?: Maybe<JobReportDimensionValue>;
  masterWorkflow?: Maybe<LineItemMasterWorkflowReportDimensionValue>;
  partType?: Maybe<PartTypeReportDimensionValue>;
}

/**
 * One grouped Work Order report row.
 */
export interface LineItemReportRow {
  __typename?: "LineItemReportRow";
  /**
   * The generated LineItem aggregate, constrained to this dimension row.
   */
  aggregate: (args?: {
    filter?: Maybe<LineItemFilterInput>;
  }) => LineItemAggregate;
  /**
   * Typed values for every selected report dimension.
   */
  dimensions: LineItemReportDimensions;
  /**
   * The first dimension key, retained for single-dimension report compatibility.
   */
  key: ScalarsEnums["String"];
  /**
   * The first dimension label, retained for single-dimension report compatibility.
   */
  label: ScalarsEnums["String"];
}

/**
 * description=A global or role/user-assigned configured action, or current-user favourite, with bindings from its source record.
 * displayName=Shortcut
 * defaultQuery=linkedActions
 * aggregateQuery=linkedActionsAggregate
 * grouping=true
 * queryPermission=Query_Linked_Actions
 */
export interface LinkedAction {
  __typename?: "LinkedAction";
  /**
   * sortable=true
   * groupable=false
   */
  actionId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  bindings: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  displayOrder: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  enabled: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  ownerUserId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * sortable=true
   * groupable=false
   */
  recordPath: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: ScalarsEnums["String"];
}

/**
 * description=A global or role/user-assigned configured action, or current-user favourite, with bindings from its source record.
 */
export interface LinkedActionAggregate {
  __typename?: "LinkedActionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A list of reasons to choose from for lost jobs or leads.
 * displayName=Lost Reason
 * module=Admin
 * defaultQuery=lostReasons
 * colour=#5D35A6
 * aggregateQuery=lostReasonsAggregate
 * grouping=true
 * queryPermission=Query_Lost_Reasons
 */
export interface LostReason {
  __typename?: "LostReason";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
}

/**
 * description=A list of reasons to choose from for lost jobs or leads.
 */
export interface LostReasonAggregate {
  __typename?: "LostReasonAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * A Lost Reason identity or a typed nested report dimension.
 */
export interface LostReasonReportDimensionValue {
  __typename?: "LostReasonReportDimensionValue";
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

export interface Machine {
  __typename?: "Machine";
  id: ScalarsEnums["ID"];
  machineTypeId: ScalarsEnums["String"];
  name: ScalarsEnums["String"];
}

export interface MachineType {
  __typename?: "MachineType";
  id: ScalarsEnums["ID"];
  machines: (args?: { filter?: Maybe<MachineFilterInput> }) => Array<Machine>;
  name: ScalarsEnums["String"];
}

export interface Money {
  __typename?: "Money";
  amount: ScalarsEnums["String"];
  currency: ScalarsEnums["String"];
}

export interface Month {
  __typename?: "Month";
  createdLeadAggregate: (args?: {
    filter?: Maybe<LeadFilterInput>;
  }) => Maybe<LeadAggregate>;
  createdPurchaseOrderAggregate: (args?: {
    filter?: Maybe<PurchaseOrderFilterInput>;
  }) => Maybe<PurchaseOrderAggregate>;
  createdPurchaseOrderLineAggregate: (args?: {
    filter?: Maybe<PurchaseOrderLineFilterInput>;
  }) => Maybe<PurchaseOrderLineAggregate>;
  monthNumber: ScalarsEnums["String"];
  monthNumberAndYear: ScalarsEnums["String"];
  quoteLineAggregateByJobEstDue: (args?: {
    filter?: Maybe<QuoteLineFilterInput>;
  }) => Maybe<QuoteLineAggregate>;
  year: ScalarsEnums["String"];
}

export interface NZRegion {
  __typename?: "NZRegion";
  id: ScalarsEnums["String"];
  jobAggregate: (args?: {
    filter?: Maybe<JobFilterInput>;
  }) => Maybe<JobAggregate>;
  name: ScalarsEnums["String"];
}

/**
 * description=A subscription notification channel with its body and attachment templates.
 * displayName=Notification Template
 * module=Admin
 * defaultQuery=notificationTemplates
 * iconName=notifications
 * colour=#5D35A6
 * aggregateQuery=notificationTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Notification_Templates
 */
export interface NotificationTemplate {
  __typename?: "NotificationTemplate";
  /**
   * sortable=false
   * groupable=true
   */
  attachmentTemplates: (args?: {
    filter?: Maybe<AttachmentTemplateFilterInput>;
  }) => Array<AttachmentTemplate>;
  /**
   * sortable=true
   * groupable=false
   */
  bodyTemplateId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  subscription?: Maybe<SubscriptionReal>;
  /**
   * sortable=true
   * groupable=true
   */
  type: ScalarsEnums["String"];
}

/**
 * description=A subscription notification channel with its body and attachment templates.
 */
export interface NotificationTemplateAggregate {
  __typename?: "NotificationTemplateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface OrderEmailStatusUpdatedEvent {
  __typename?: "OrderEmailStatusUpdatedEvent";
  orderEmail: ScalarsEnums["String"];
}

/**
 * PurchaseOrder
 */
export interface OrderOverrideStatusEvent {
  __typename?: "OrderOverrideStatusEvent";
  newStatus: ScalarsEnums["String"];
  oldStatus?: Maybe<ScalarsEnums["String"]>;
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

/**
 * PurchaseOrderReceipt
 */
export interface OrderReceiptCreatedEvent {
  __typename?: "OrderReceiptCreatedEvent";
  lineData: Array<Maybe<ScalarsEnums["String"]>>;
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
  receiptId: ScalarsEnums["Int"];
  warehouseId: ScalarsEnums["Int"];
}

export interface OrderRevisionCreatedEvent {
  __typename?: "OrderRevisionCreatedEvent";
  orderRevision: ScalarsEnums["String"];
}

export interface PageInfo {
  __typename?: "PageInfo";
  limit: ScalarsEnums["Int"];
  offset: ScalarsEnums["Int"];
  totalCount: ScalarsEnums["Int"];
}

export interface PagedJobs {
  __typename?: "PagedJobs";
  items: Array<Job>;
  pageInfo: PageInfo;
}

export interface PaginatedResult {
  __typename?: "PaginatedResult";
  pageInfo: PageInfo;
}

export interface PaginatedResultInterface {
  __typename?: "PagedJobs" | "PaginatedResult";
  pageInfo: PageInfo;
  $on: $PaginatedResultInterface;
}

/**
 * description=A reusable dashboard panel configuration.
 * displayName=Panel
 * module=Admin
 * defaultQuery=panels
 * iconName=panel
 * colour=#5D35A6
 * aggregateQuery=panelsAggregate
 * grouping=true
 * queryPermission=Query_Panels
 */
export interface Panel {
  __typename?: "Panel";
  /**
   * sortable=false
   * groupable=false
   */
  compatibleRecordTypes?: Maybe<Array<ScalarsEnums["String"]>>;
  /**
   * sortable=true
   * groupable=false
   */
  config: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  recordTags: (args?: {
    filter?: Maybe<RecordTagFilterInput>;
  }) => Array<RecordTag>;
  /**
   * sortable=true
   * groupable=false
   */
  source: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  type: ScalarsEnums["String"];
}

/**
 * description=A reusable dashboard panel configuration.
 */
export interface PanelAggregate {
  __typename?: "PanelAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A sales classification used to group job components and work-order parts.
 * displayName=Part Type
 * module=Sales
 * defaultQuery=partTypes
 * iconName=wrench
 * colour=#A91F54
 * aggregateQuery=partTypesAggregate
 * grouping=true
 * queryPermission=Query_Part_Types
 */
export interface PartType {
  __typename?: "PartType";
  /**
   * sortable=true
   * groupable=false
   */
  code: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  colour: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  created?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  modified?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
}

/**
 * description=A sales classification used to group job components and work-order parts.
 */
export interface PartTypeAggregate {
  __typename?: "PartTypeAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * PartType
 */
export interface PartTypeCreatedEvent {
  __typename?: "PartTypeCreatedEvent";
  partTypeId: ScalarsEnums["String"];
  partTypeName: ScalarsEnums["String"];
}

/**
 * PartType
 */
export interface PartTypeDeletedEvent {
  __typename?: "PartTypeDeletedEvent";
  partTypeId: ScalarsEnums["String"];
  partTypeName: ScalarsEnums["String"];
}

/**
 * A Part Type identity or a typed nested report dimension.
 */
export interface PartTypeReportDimensionValue {
  __typename?: "PartTypeReportDimensionValue";
  created?: Maybe<ReportDimensionValue>;
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
  modified?: Maybe<ReportDimensionValue>;
}

/**
 * PartType
 */
export interface PartTypeRestoredEvent {
  __typename?: "PartTypeRestoredEvent";
  partTypeId: ScalarsEnums["String"];
  partTypeName: ScalarsEnums["String"];
}

/**
 * PartType
 */
export interface PartTypeUpdatedEvent {
  __typename?: "PartTypeUpdatedEvent";
  partTypeId: ScalarsEnums["String"];
  partTypeName: ScalarsEnums["String"];
}

export interface Permission {
  __typename?: "Permission";
  category: ScalarsEnums["String"];
  categoryGroup: ScalarsEnums["String"];
  /**
   * The GraphQL input type to use for conditional policies
   */
  conditionalPolicyInputType?: Maybe<ScalarsEnums["String"]>;
  description: ScalarsEnums["String"];
  id: ScalarsEnums["ID"];
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   */
  name: ScalarsEnums["String"];
}

export interface PermissionPolicy {
  __typename?: "PermissionPolicy";
  conditions?: Maybe<ScalarsEnums["String"]>;
  permission: Permission;
  policy: ScalarsEnums["Policy"];
  /**
   * The Role this permission came from, if any
   */
  role?: Maybe<Role>;
}

export interface PermissionScope {
  __typename?: "PermissionScope";
  description: ScalarsEnums["String"];
  id: ScalarsEnums["String"];
  name: ScalarsEnums["String"];
}

/**
 * description=An individual person who can be assigned to work in the system.
 * displayName=Person
 * module=Admin
 * defaultQuery=people
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=peopleAggregate
 * grouping=true
 * queryPermission=Query_People
 */
export interface Person {
  __typename?: "Person";
  /**
   * description=The number of currently assigned leads attached to this person as a designer.
   * sortable=true
   * groupable=false
   */
  assignedDesignerLeadCount: ScalarsEnums["Int"];
  /**
   * sortable=false
   * groupable=true
   */
  assignedWork: (args?: {
    filter?: Maybe<PersonAssignedWorkFilterInput>;
  }) => Array<PersonAssignedWork>;
  /**
   * sortable=true
   * groupable=true
   */
  branch?: Maybe<Branch>;
  /**
   * sortable=true
   * groupable=false
   */
  businessRoleLabels: ScalarsEnums["String"];
  /**
   * description=The number of confirmed jobs assigned to this person as a designer.
   * sortable=true
   * groupable=false
   */
  confirmedDesignerJobCount: ScalarsEnums["Int"];
  /**
   * description=The system user account connected to this person.
   * sortable=true
   * groupable=true
   */
  connectedUser?: Maybe<User>;
  /**
   * sortable=true
   * groupable=true
   */
  created: ScalarsEnums["DateTime"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * description=Confirmed sales for the equivalent completed-month YTD period in the previous year.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  designerPreviousYtdSales?: Maybe<ScalarsEnums["Float"]>;
  /**
   * description=Completed-month YTD confirmed sales for jobs assigned to this person as a designer.
   * permission=Report_Confirmed_Sales
   * sortable=true
   * groupable=false
   */
  designerSalesYtd?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  isActive: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * description=The number of issued quotes awaiting a customer outcome for jobs assigned to this person as a designer.
   * sortable=true
   * groupable=false
   */
  outstandingDesignerQuoteCount: ScalarsEnums["Int"];
  /**
   * sortable=false
   * groupable=true
   */
  personBusinessRoles: (args?: {
    filter?: Maybe<PersonBusinessRoleFilterInput>;
  }) => Array<PersonBusinessRole>;
  /**
   * description=Seconds on process timers since midnight in the application database timezone (New Zealand), including running intervals and excluding pauses. Refreshed when queried.
   * sortable=true
   * groupable=false
   */
  processTimeTodaySeconds: ScalarsEnums["Int"];
  /**
   * description=The number of unconfirmed jobs assigned to this person as a designer.
   * sortable=true
   * groupable=false
   */
  unconfirmedDesignerJobCount: ScalarsEnums["Int"];
}

/**
 * description=An individual person who can be assigned to work in the system.
 */
export interface PersonAggregate {
  __typename?: "PersonAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A normalized read model of work assigned to a person across role-specific assignment sources.
 * displayName=Person Assigned Work
 * module=Admin
 * defaultQuery=personAssignedWork
 * iconName=briefcase
 * colour=#5D35A6
 * aggregateQuery=personAssignedWorkAggregate
 * grouping=true
 * queryPermission=Query_Person_Assigned_Work
 */
export interface PersonAssignedWork {
  __typename?: "PersonAssignedWork";
  /**
   * sortable=true
   * groupable=false
   */
  assignmentType: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  businessRole?: Maybe<BusinessRole>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  person: Person;
  /**
   * sortable=true
   * groupable=true
   */
  personBusinessRole?: Maybe<PersonBusinessRole>;
  /**
   * description=Identity metadata for the assigned record, without loading the destination record.
   * sortable=false
   * groupable=false
   */
  record: PersonAssignedWorkRecordReference;
  /**
   * sortable=true
   * groupable=false
   */
  recordId: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  recordLabel: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  status?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  statusLabel: ScalarsEnums["String"];
}

/**
 * description=A normalized read model of work assigned to a person across role-specific assignment sources.
 */
export interface PersonAssignedWorkAggregate {
  __typename?: "PersonAssignedWorkAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface PersonAssignedWorkRecordReference {
  __typename?: "PersonAssignedWorkRecordReference";
  recordId: ScalarsEnums["ID"];
  recordType: ScalarsEnums["String"];
}

/**
 * description=A role assignment that makes a person available for a type of business work.
 * displayName=Person Business Role
 * module=Admin
 * defaultQuery=personBusinessRoles
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=personBusinessRolesAggregate
 * grouping=true
 * queryPermission=Query_Person_Business_Roles
 */
export interface PersonBusinessRole {
  __typename?: "PersonBusinessRole";
  /**
   * sortable=false
   * groupable=true
   */
  assignedWork: (args?: {
    filter?: Maybe<PersonAssignedWorkFilterInput>;
  }) => Array<PersonAssignedWork>;
  /**
   * sortable=true
   * groupable=true
   */
  businessRole: BusinessRole;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  isActive: ScalarsEnums["Boolean"];
  /**
   * description=Jobs assigned to this person in this business role through legacy assignment columns.
   * sortable=false
   * groupable=false
   */
  jobs: (args?: {
    filter?: Maybe<JobFilterInput>;
    options?: Maybe<OptionsInput>;
  }) => Array<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  person: Person;
  /**
   * sortable=false
   * groupable=true
   */
  processAssignments: (args?: {
    filter?: Maybe<ProcessAssignmentFilterInput>;
  }) => Array<ProcessAssignment>;
}

/**
 * description=A role assignment that makes a person available for a type of business work.
 */
export interface PersonBusinessRoleAggregate {
  __typename?: "PersonBusinessRoleAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * A Person Business Role identity or a typed nested report dimension.
 */
export interface PersonBusinessRoleReportDimensionValue {
  __typename?: "PersonBusinessRoleReportDimensionValue";
  businessRole?: Maybe<BusinessRoleReportDimensionValue>;
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
  person?: Maybe<PersonReportDimensionValue>;
}

/**
 * A Person identity or a typed nested report dimension.
 */
export interface PersonReportDimensionValue {
  __typename?: "PersonReportDimensionValue";
  branch?: Maybe<BranchReportDimensionValue>;
  connectedUser?: Maybe<UserReportDimensionValue>;
  created?: Maybe<ReportDimensionValue>;
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

export interface PersonStatus {
  __typename?: "PersonStatus";
  id: ScalarsEnums["ID"];
  name: ScalarsEnums["String"];
  peopleAggregate: (args?: {
    filter?: Maybe<PersonFilterInput>;
  }) => Maybe<PersonAggregate>;
}

/**
 * description=An asset assigned to a process type for a workflow subject.
 * displayName=Process Asset
 * module=Manufacturing
 * defaultQuery=processAssets
 * iconName=cog
 * colour=#A96500
 * aggregateQuery=processAssetsAggregate
 * grouping=true
 * queryPermission=Query_Process_Assets
 */
export interface ProcessAsset {
  __typename?: "ProcessAsset";
  /**
   * sortable=true
   * groupable=true
   */
  asset?: Maybe<Asset>;
  /**
   * sortable=true
   * groupable=false
   */
  assetId: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  lineItemMasterWorkflow?: Maybe<LineItemMasterWorkflow>;
  /**
   * sortable=true
   * groupable=true
   */
  processType?: Maybe<ProcessType>;
  /**
   * sortable=true
   * groupable=false
   */
  processTypeId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  workflowSubjectId: ScalarsEnums["String"];
}

/**
 * description=An asset assigned to a process type for a workflow subject.
 */
export interface ProcessAssetAggregate {
  __typename?: "ProcessAssetAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A user role assigned to a process type for a workflow subject.
 * displayName=Process Assignment
 * module=Manufacturing
 * defaultQuery=processAssignments
 * iconName=people
 * colour=#A96500
 * aggregateQuery=processAssignmentsAggregate
 * grouping=true
 * queryPermission=Query_Process_Assignments
 */
export interface ProcessAssignment {
  __typename?: "ProcessAssignment";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  personBusinessRoleId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * sortable=true
   * groupable=true
   */
  processType: ProcessType;
  /**
   * sortable=true
   * groupable=false
   */
  processTypeId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  userRole?: Maybe<UserRole>;
  /**
   * sortable=true
   * groupable=false
   */
  userRoleId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  workflowSubject: LineItemMasterWorkflow;
  /**
   * sortable=true
   * groupable=false
   */
  workflowSubjectId: ScalarsEnums["String"];
}

/**
 * description=A user role assigned to a process type for a workflow subject.
 */
export interface ProcessAssignmentAggregate {
  __typename?: "ProcessAssignmentAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A running manufacturing workflow process for a specific item or job.
 * displayName=Process Instance
 * module=Manufacturing
 * defaultQuery=processInstances
 * colour=#A96500
 * aggregateQuery=processInstancesAggregate
 * grouping=true
 * queryPermission=Query_Process_Instances
 */
export interface ProcessInstance {
  __typename?: "ProcessInstance";
  /**
   * sortable=false
   * groupable=false
   */
  assignableUserRoles: Array<UserRole>;
  /**
   * sortable=true
   * groupable=false
   */
  assignedHours?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  dueDate?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  elapsedTime?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  leadDays?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=true
   */
  lineItemMasterWorkflow?: Maybe<LineItemMasterWorkflow>;
  /**
   * sortable=false
   * groupable=false
   */
  processAssets: Array<ProcessAsset>;
  /**
   * sortable=false
   * groupable=false
   */
  processAssignments: Array<ProcessAssignment>;
  /**
   * sortable=true
   * groupable=true
   */
  processType?: Maybe<ProcessType>;
  /**
   * sortable=true
   * groupable=true
   */
  scheduled?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  startBy?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  status?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=true
   */
  workflow?: Maybe<Workflow>;
}

/**
 * description=A running manufacturing workflow process for a specific item or job.
 */
export interface ProcessInstanceAggregate {
  __typename?: "ProcessInstanceAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A reusable process step inside a workflow template.
 * displayName=Process Template
 * module=Manufacturing
 * defaultQuery=processTemplates
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=processTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Process_Templates
 */
export interface ProcessTemplate {
  __typename?: "ProcessTemplate";
  /**
   * sortable=true
   * groupable=false
   */
  assignedHours?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  leadDays?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  processType?: Maybe<ProcessType>;
}

/**
 * description=A reusable process step inside a workflow template.
 */
export interface ProcessTemplateAggregate {
  __typename?: "ProcessTemplateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A user timer with process items and elapsed time across its transactions.
 * displayName=Process Timer
 * module=Manufacturing
 * defaultQuery=timers
 * iconName=time
 * colour=#A96500
 * aggregateQuery=timersAggregate
 * grouping=true
 * queryPermission=Query_Process_Timers
 */
export interface ProcessTimer {
  __typename?: "ProcessTimer";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  elapsedTime?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=false
   */
  itemAggregate: (args?: {
    filter?: Maybe<ProcessTimerItemFilterInput>;
  }) => Maybe<ProcessTimerItemAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  items: (args?: {
    filter?: Maybe<ProcessTimerItemFilterInput>;
  }) => Array<ProcessTimerItem>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  status?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=true
   */
  transactions: (args?: {
    filter?: Maybe<TimerTransactionFilterInput>;
  }) => Array<TimerTransaction>;
  /**
   * sortable=true
   * groupable=false
   */
  type?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  user: User;
}

/**
 * description=A user timer with process items and elapsed time across its transactions.
 */
export interface ProcessTimerAggregate {
  __typename?: "ProcessTimerAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A process type and workflow subject assigned to a process timer.
 * displayName=Process Timer Item
 * module=Manufacturing
 * defaultQuery=processTimerItems
 * iconName=timer
 * colour=#A96500
 * aggregateQuery=processTimerItemsAggregate
 * grouping=true
 * queryPermission=Query_Process_Timer_Items
 */
export interface ProcessTimerItem {
  __typename?: "ProcessTimerItem";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  lineItemMasterWorkflow: LineItemMasterWorkflow;
  /**
   * sortable=true
   * groupable=true
   */
  processType: ProcessType;
  /**
   * sortable=true
   * groupable=false
   */
  processTypeId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  timer: ProcessTimer;
  /**
   * sortable=true
   * groupable=false
   */
  timerId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  workflowSubjectId: ScalarsEnums["String"];
}

/**
 * description=A process type and workflow subject assigned to a process timer.
 */
export interface ProcessTimerItemAggregate {
  __typename?: "ProcessTimerItemAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A reusable manufacturing process definition used by workflow types.
 * displayName=Process Type
 * module=Manufacturing
 * defaultQuery=processTypes
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=processTypesAggregate
 * grouping=true
 * queryPermission=Query_Process_Types
 */
export interface ProcessType {
  __typename?: "ProcessType";
  /**
   * sortable=false
   * groupable=true
   */
  assignments: (args?: {
    filter?: Maybe<ProcessAssignmentFilterInput>;
  }) => Array<ProcessAssignment>;
  /**
   * sortable=true
   * groupable=false
   */
  code: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  created: ScalarsEnums["DateTime"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  modified: ScalarsEnums["DateTime"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  roles: (args?: {
    filter?: Maybe<ProcessTypeRoleFilterInput>;
  }) => Array<ProcessTypeRole>;
}

/**
 * description=A reusable manufacturing process definition used by workflow types.
 */
export interface ProcessTypeAggregate {
  __typename?: "ProcessTypeAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * ProcessType
 */
export interface ProcessTypeCreatedEvent {
  __typename?: "ProcessTypeCreatedEvent";
  processTypeId: ScalarsEnums["String"];
  processTypeName: ScalarsEnums["String"];
}

/**
 * ProcessType
 */
export interface ProcessTypeDeletedEvent {
  __typename?: "ProcessTypeDeletedEvent";
  processTypeId: ScalarsEnums["String"];
  processTypeName: ScalarsEnums["String"];
}

/**
 * description=A schedule note assigned to one or more manufacturing process types.
 * displayName=Process Type Note
 * module=Manufacturing
 * defaultQuery=processTypeNotes
 * iconName=message-square-text
 * colour=#A96500
 * aggregateQuery=processTypeNotesAggregate
 * grouping=true
 * queryPermission=Query_Process_Type_Notes
 */
export interface ProcessTypeNote {
  __typename?: "ProcessTypeNote";
  /**
   * sortable=false
   * groupable=false
   */
  assignedProcessTypes: Array<ProcessType>;
  /**
   * sortable=true
   * groupable=true
   */
  created?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  date?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  note?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A schedule note assigned to one or more manufacturing process types.
 */
export interface ProcessTypeNoteAggregate {
  __typename?: "ProcessTypeNoteAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * A Process Type identity or a typed nested report dimension.
 */
export interface ProcessTypeReportDimensionValue {
  __typename?: "ProcessTypeReportDimensionValue";
  created?: Maybe<ReportDimensionValue>;
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
  modified?: Maybe<ReportDimensionValue>;
}

/**
 * ProcessType
 */
export interface ProcessTypeRestoredEvent {
  __typename?: "ProcessTypeRestoredEvent";
  processTypeId: ScalarsEnums["String"];
  processTypeName: ScalarsEnums["String"];
}

/**
 * description=A role type that may be assigned to users working on a manufacturing process type.
 * displayName=Process Type Role
 * module=Manufacturing
 * defaultQuery=processTypeRoles
 * iconName=people
 * colour=#A96500
 * aggregateQuery=processTypeRolesAggregate
 * grouping=true
 * queryPermission=Query_Process_Type_Roles
 */
export interface ProcessTypeRole {
  __typename?: "ProcessTypeRole";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  processType: ProcessType;
  /**
   * sortable=true
   * groupable=false
   */
  roleType: ScalarsEnums["String"];
}

/**
 * description=A role type that may be assigned to users working on a manufacturing process type.
 */
export interface ProcessTypeRoleAggregate {
  __typename?: "ProcessTypeRoleAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * ProcessType
 */
export interface ProcessTypeUpdatedEvent {
  __typename?: "ProcessTypeUpdatedEvent";
  processTypeId: ScalarsEnums["String"];
  processTypeName: ScalarsEnums["String"];
}

/**
 * description=An inventory product that can be stocked, purchased, priced, and used on jobs.
 * displayName=Product
 * module=Inventory
 * defaultQuery=products
 * iconName=box
 * colour=#596600
 * aggregateQuery=productsAggregate
 * grouping=true
 * queryPermission=Query_Products
 */
export interface Product {
  __typename?: "Product";
  /**
   * sortable=true
   * groupable=false
   */
  availableStock?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=true
   */
  category?: Maybe<ProductCategory>;
  /**
   * sortable=true
   * groupable=false
   */
  code?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  currentBuyPrice?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=false
   */
  currentSellPrice?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  daysStockLeft?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  forecastedDemandQty: ScalarsEnums["Float"];
  /**
   * sortable=true
   * groupable=false
   */
  forecastedReorderUrgencyQty: ScalarsEnums["Float"];
  /**
   * sortable=true
   * groupable=false
   */
  forecastedStockRemainingQty: ScalarsEnums["Float"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=false
   */
  image?: Maybe<ExternalStorageItem>;
  /**
   * sortable=true
   * groupable=false
   */
  indent: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  isStockItem: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  leadTime?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  purchaseOrderLineAggregate: (args?: {
    filter?: Maybe<PurchaseOrderLineFilterInput>;
  }) => Maybe<PurchaseOrderLineAggregate>;
  /**
   * sortable=true
   * groupable=false
   */
  qtyReviewThreshold?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=false
   * groupable=false
   */
  quoteLineAggregate: (args?: {
    filter?: Maybe<QuoteLineFilterInput>;
  }) => Maybe<QuoteLineAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  recordTags: (args?: {
    filter?: Maybe<RecordTagFilterInput>;
  }) => Array<RecordTag>;
  /**
   * sortable=true
   * groupable=false
   */
  reorderLevel?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=false
   */
  safetyStockDays: ScalarsEnums["Float"];
  /**
   * sortable=true
   * groupable=false
   */
  safetyStockQty: ScalarsEnums["Float"];
  /**
   * sortable=true
   * groupable=false
   */
  starred: ScalarsEnums["Boolean"];
  /**
   * sortable=false
   * groupable=true
   */
  stock: (args?: {
    filter?: Maybe<StockFilterInput>;
  }) => Maybe<Array<Maybe<Stock>>>;
  /**
   * sortable=false
   * groupable=true
   */
  stockByWarehouse: (args?: {
    filter?: Maybe<StockFilterInput>;
  }) => Array<Stock>;
  /**
   * sortable=true
   * groupable=false
   */
  stockGapDays?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=false
   */
  stockedQty?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=true
   */
  supplier?: Maybe<Supplier>;
  /**
   * sortable=true
   * groupable=false
   */
  template: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  type?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=false
   */
  unitOfMeasure?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  url?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=An inventory product that can be stocked, purchased, priced, and used on jobs.
 */
export interface ProductAggregate {
  __typename?: "ProductAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=An inventory category used to group and filter products.
 * displayName=Product Category
 * module=Inventory
 * defaultQuery=productCategories
 * iconName=group-item
 * colour=#596600
 * aggregateQuery=productCategoriesAggregate
 * grouping=true
 * queryPermission=Query_Product_Categories
 */
export interface ProductCategory {
  __typename?: "ProductCategory";
  /**
   * sortable=false
   * groupable=false
   */
  childProductCategoriesAggregate: (args?: {
    filter?: Maybe<ProductCategoryFilterInput>;
  }) => Maybe<ProductCategoryAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  children: (args?: {
    filter?: Maybe<ProductCategoryFilterInput>;
  }) => Array<ProductCategory>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  group: ProductCategoryGroup;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  parent?: Maybe<ProductCategory>;
  /**
   * sortable=false
   * groupable=true
   */
  products: (args?: {
    filter?: Maybe<ProductFilterInput>;
  }) => Maybe<Array<Maybe<Product>>>;
}

/**
 * description=An inventory category used to group and filter products.
 */
export interface ProductCategoryAggregate {
  __typename?: "ProductCategoryAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A grouping used to organise related inventory product categories.
 * displayName=Product Category Group
 * module=Inventory
 * defaultQuery=productCategoryGroups
 * colour=#596600
 * aggregateQuery=productCategoryGroupsAggregate
 * grouping=true
 * queryPermission=Query_Product_Category_Groups
 */
export interface ProductCategoryGroup {
  __typename?: "ProductCategoryGroup";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
}

/**
 * description=A grouping used to organise related inventory product categories.
 */
export interface ProductCategoryGroupAggregate {
  __typename?: "ProductCategoryGroupAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Product
 */
export interface ProductCreatedEvent {
  __typename?: "ProductCreatedEvent";
  productId: ScalarsEnums["String"];
  productName: ScalarsEnums["String"];
}

/**
 * Product
 */
export interface ProductDetailsUpdatedEvent {
  __typename?: "ProductDetailsUpdatedEvent";
  productId: ScalarsEnums["String"];
  productName: ScalarsEnums["String"];
}

/**
 * description=A dated buy or sell price for an inventory product.
 * displayName=Product Price
 * module=Inventory
 * defaultQuery=productPrices
 * iconName=dollar
 * colour=#596600
 * aggregateQuery=productPricesAggregate
 * grouping=true
 * queryPermission=Query_Product_Prices
 */
export interface ProductPrice {
  __typename?: "ProductPrice";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  effectiveDate: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  product: Product;
  /**
   * sortable=true
   * groupable=false
   */
  type: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  unitPrice?: Maybe<ScalarsEnums["Float"]>;
}

/**
 * description=A dated buy or sell price for an inventory product.
 */
export interface ProductPriceAggregate {
  __typename?: "ProductPriceAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface ProductPriceCreatedEvent {
  __typename?: "ProductPriceCreatedEvent";
  entity: ScalarsEnums["String"];
}

export interface ProductPriceDeletedEvent {
  __typename?: "ProductPriceDeletedEvent";
  entity: ScalarsEnums["String"];
}

/**
 * description=A sales project used to group related work.
 * displayName=Project
 * module=Sales
 * defaultQuery=projects
 * iconName=projects
 * colour=#A91F54
 * aggregateQuery=projectsAggregate
 * grouping=true
 * queryPermission=Query_Projects
 */
export interface Project {
  __typename?: "Project";
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
}

/**
 * description=A sales project used to group related work.
 */
export interface ProjectAggregate {
  __typename?: "ProjectAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=An order for products or services placed with a supplier.
 * displayName=Purchase Order
 * module=Inventory
 * defaultQuery=purchaseOrders
 * iconName=cargo-ship
 * colour=#596600
 * aggregateQuery=purchaseOrdersAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Orders
 */
export interface PurchaseOrder {
  __typename?: "PurchaseOrder";
  /**
   * sortable=true
   * groupable=false
   */
  acknowledgedBy?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  amended: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  approved: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  category?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  created?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deliveryAddress?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  deliveryAddressEntity?: Maybe<DeliveryAddress>;
  /**
   * sortable=false
   * groupable=false
   */
  documents: (args?: {
    filter?: Maybe<DocumentTemplateFilterInput>;
  }) => Array<Document>;
  /**
   * sortable=false
   * groupable=true
   */
  emails: (args?: { filter?: Maybe<EmailFilterInput> }) => Array<Email>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  incomplete: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  internalComment?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  invoiceChecked: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  job?: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  lines: (args?: {
    filter?: Maybe<PurchaseOrderLineFilterInput>;
  }) => Array<PurchaseOrderLine>;
  /**
   * sortable=true
   * groupable=false
   */
  notificationStatus?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=false
   */
  notifySupplierWhenPlaced: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  placedBy?: Maybe<User>;
  /**
   * sortable=true
   * groupable=false
   */
  poNumber?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  purchaseOrderLineAggregate: (args?: {
    filter?: Maybe<PurchaseOrderLineFilterInput>;
  }) => Maybe<PurchaseOrderLineAggregate>;
  /**
   * sortable=true
   * groupable=false
   */
  reference: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  required?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=false
   * groupable=true
   */
  reviews: (args?: {
    filter?: Maybe<PurchaseOrderReviewFilterInput>;
  }) => Array<PurchaseOrderReview>;
  /**
   * sortable=true
   * groupable=false
   */
  shippingMethod?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  shippingTerms?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  siteVisitRequired: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  ssspCompleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  status?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=false
   */
  statusWhenPlaced?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  supplier?: Maybe<Supplier>;
  /**
   * sortable=true
   * groupable=false
   */
  supplierComment?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  supplierStatus?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=true
   */
  template?: Maybe<DocumentTemplate>;
  /**
   * sortable=true
   * groupable=false
   */
  urgent: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  warehouse?: Maybe<Warehouse>;
}

/**
 * description=An order for products or services placed with a supplier.
 */
export interface PurchaseOrderAggregate {
  __typename?: "PurchaseOrderAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  incompleteSupplierSssp: ScalarsEnums["Boolean"];
}

/**
 * PurchaseOrder
 */
export interface PurchaseOrderAmendedEvent {
  __typename?: "PurchaseOrderAmendedEvent";
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

/**
 * PurchaseOrder
 */
export interface PurchaseOrderApprovedEvent {
  __typename?: "PurchaseOrderApprovedEvent";
  comment?: Maybe<ScalarsEnums["String"]>;
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
  placedByUserId: ScalarsEnums["String"];
}

/**
 * PurchaseOrder
 */
export interface PurchaseOrderCancelledEvent {
  __typename?: "PurchaseOrderCancelledEvent";
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

export interface PurchaseOrderEvent {
  __typename?: "PurchaseOrderEvent";
  created: ScalarsEnums["String"];
  id: ScalarsEnums["ID"];
  payload?: Maybe<ScalarsEnums["String"]>;
  purchaseOrder?: Maybe<PurchaseOrder>;
  type: ScalarsEnums["Int"];
  userId: ScalarsEnums["String"];
}

/**
 * PurchaseOrder
 */
export interface PurchaseOrderIncompleteEvent {
  __typename?: "PurchaseOrderIncompleteEvent";
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

/**
 * description=A product or service line ordered from a supplier on a purchase order.
 * displayName=Purchase Order Line
 * module=Inventory
 * defaultQuery=purchaseOrderLines
 * colour=#596600
 * aggregateQuery=purchaseOrderLinesAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Lines
 */
export interface PurchaseOrderLine {
  __typename?: "PurchaseOrderLine";
  /**
   * sortable=true
   * groupable=false
   */
  buyPrice?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=false
   */
  code?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  line: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  orderedQty?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=true
   */
  product?: Maybe<Product>;
  /**
   * sortable=true
   * groupable=true
   */
  purchaseOrder?: Maybe<PurchaseOrder>;
  /**
   * sortable=true
   * groupable=false
   */
  receivedQty?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=false
   */
  totalPrice?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  unit?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A product or service line ordered from a supplier on a purchase order.
 */
export interface PurchaseOrderLineAggregate {
  __typename?: "PurchaseOrderLineAggregate";
  /**
   * sortable=true
   * groupable=false
   */
  averageDailyQuantity: ScalarsEnums["Float"];
  /**
   * sortable=true
   * groupable=false
   */
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  quantity: ScalarsEnums["Float"];
}

/**
 * PurchaseOrder
 */
export interface PurchaseOrderPendingReviewEvent {
  __typename?: "PurchaseOrderPendingReviewEvent";
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

/**
 * PurchaseOrder
 */
export interface PurchaseOrderPlacedEvent {
  __typename?: "PurchaseOrderPlacedEvent";
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

export interface PurchaseOrderPreview {
  __typename?: "PurchaseOrderPreview";
  html: ScalarsEnums["String"];
}

/**
 * description=A receipt recording goods received against a purchase order.
 * displayName=Purchase Order Receipt
 * module=Inventory
 * defaultQuery=purchaseOrderReceipts
 * iconName=receipt
 * colour=#596600
 * aggregateQuery=purchaseOrderReceiptsAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Receipts
 */
export interface PurchaseOrderReceipt {
  __typename?: "PurchaseOrderReceipt";
  /**
   * sortable=true
   * groupable=true
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  lines: (args?: {
    filter?: Maybe<PurchaseOrderReceiptLineFilterInput>;
  }) => Array<PurchaseOrderReceiptLine>;
  /**
   * sortable=true
   * groupable=false
   */
  notes?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  purchaseOrder?: Maybe<PurchaseOrder>;
  /**
   * sortable=true
   * groupable=false
   */
  reference?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  user?: Maybe<User>;
}

/**
 * description=A receipt recording goods received against a purchase order.
 */
export interface PurchaseOrderReceiptAggregate {
  __typename?: "PurchaseOrderReceiptAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=The quantity received for one purchase order line on a receipt.
 * displayName=Purchase Order Receipt Line
 * module=Inventory
 * defaultQuery=purchaseOrderReceiptLines
 * iconName=list
 * colour=#596600
 * aggregateQuery=purchaseOrderReceiptLinesAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Receipt_Lines
 */
export interface PurchaseOrderReceiptLine {
  __typename?: "PurchaseOrderReceiptLine";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  line?: Maybe<PurchaseOrderLine>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=true
   */
  receipt?: Maybe<PurchaseOrderReceipt>;
}

/**
 * description=The quantity received for one purchase order line on a receipt.
 */
export interface PurchaseOrderReceiptLineAggregate {
  __typename?: "PurchaseOrderReceiptLineAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * PurchaseOrder
 */
export interface PurchaseOrderReceivedEvent {
  __typename?: "PurchaseOrderReceivedEvent";
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

/**
 * PurchaseOrder
 */
export interface PurchaseOrderRejectedEvent {
  __typename?: "PurchaseOrderRejectedEvent";
  comment?: Maybe<ScalarsEnums["String"]>;
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
  placedByUserId: ScalarsEnums["String"];
}

/**
 * PurchaseOrder
 */
export interface PurchaseOrderReleasedEvent {
  __typename?: "PurchaseOrderReleasedEvent";
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

/**
 * description=A reviewer decision on a purchase order.
 * displayName=Purchase Order Review
 * module=Inventory
 * defaultQuery=purchaseOrderReviews
 * iconName=endorsed
 * colour=#596600
 * aggregateQuery=purchaseOrderReviewsAggregate
 * grouping=true
 * queryPermission=Query_Purchase_Order_Reviews
 */
export interface PurchaseOrderReview {
  __typename?: "PurchaseOrderReview";
  /**
   * sortable=true
   * groupable=false
   */
  comment?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  completedAt?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  purchaseOrder?: Maybe<PurchaseOrder>;
  /**
   * sortable=true
   * groupable=false
   */
  status?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=true
   */
  user?: Maybe<User>;
  /**
   * sortable=true
   * groupable=false
   */
  userId?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A reviewer decision on a purchase order.
 */
export interface PurchaseOrderReviewAggregate {
  __typename?: "PurchaseOrderReviewAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface PurchaseOrderSavePayload {
  __typename?: "PurchaseOrderSavePayload";
  purchaseOrderId: ScalarsEnums["ID"];
  status: ScalarsEnums["OrderStatus"];
}

export interface PurchaseOrderStatus {
  __typename?: "PurchaseOrderStatus";
  id: ScalarsEnums["ID"];
  label: ScalarsEnums["String"];
  name: ScalarsEnums["String"];
  purchaseOrderAggregate: (args?: {
    filter?: Maybe<PurchaseOrderFilterInput>;
  }) => Maybe<PurchaseOrderAggregate>;
}

/**
 * PurchaseOrder
 */
export interface PurchaseOrderSupplierNotificationManuallySentEvent {
  __typename?: "PurchaseOrderSupplierNotificationManuallySentEvent";
  orderId: ScalarsEnums["Int"];
  orderReference?: Maybe<ScalarsEnums["String"]>;
}

/**
 * PurchaseOrder
 */
export interface PurchaseOrderSupplierNotificationSentEvent {
  __typename?: "PurchaseOrderSupplierNotificationSentEvent";
  orderId: ScalarsEnums["Int"];
  orderReference?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A sales quote containing priced work offered to a client.
 * displayName=Quote
 * module=Sales
 * defaultQuery=quotes
 * iconName=th
 * colour=#A91F54
 * aggregateQuery=quotesAggregate
 * grouping=true
 * queryPermission=Query_Quotes
 */
export interface Quote {
  __typename?: "Quote";
  /**
   * sortable=true
   * groupable=true
   */
  acceptedAt?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=false
   */
  clientAddress: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  clientName: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  contactName: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  currentRevision?: Maybe<QuoteRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  issuedAt?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=true
   * groupable=true
   */
  job?: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  lineItem?: Maybe<LineItem>;
  /**
   * sortable=false
   * groupable=false
   */
  lines: Array<QuoteLine>;
  /**
   * sortable=true
   * groupable=false
   */
  quoteNumber?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  quoteTemplateRevision?: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  reference: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  salesTax: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  status: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  subTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  total: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  version: ScalarsEnums["Int"];
}

/**
 * description=A sales quote containing priced work offered to a client.
 */
export interface QuoteAggregate {
  __typename?: "QuoteAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  total: ScalarsEnums["Float"];
}

export interface QuoteApprovalRequestedEvent {
  __typename?: "QuoteApprovalRequestedEvent";
  quote: ScalarsEnums["String"];
  user: ScalarsEnums["String"];
}

/**
 * description=A costed line item within a sales quote.
 * displayName=Quote Line
 * module=Sales
 * defaultQuery=quoteLines
 * colour=#A91F54
 * aggregateQuery=quoteLinesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Lines
 */
export interface QuoteLine {
  __typename?: "QuoteLine";
  /**
   * sortable=true
   * groupable=false
   */
  code?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  costingRevision?: Maybe<CostingRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  costingRevisionId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  jobComponent?: Maybe<JobComponent>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  line: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  lineTemplateId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  lines: Array<QuoteLine>;
  /**
   * sortable=true
   * groupable=false
   */
  markupAmount?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  markupExpression: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  parentLine?: Maybe<QuoteLine>;
  /**
   * sortable=true
   * groupable=true
   */
  product?: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  productId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  quote?: Maybe<Quote>;
  /**
   * sortable=true
   * groupable=true
   */
  quoteRevision?: Maybe<QuoteRevision>;
  /**
   * sortable=true
   * groupable=true
   */
  quoteTemplateRevision?: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  total: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  type: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPrice: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  unitSellPrice: ScalarsEnums["String"];
}

/**
 * description=A costed line item within a sales quote.
 */
export interface QuoteLineAggregate {
  __typename?: "QuoteLineAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: ScalarsEnums["Float"];
}

/**
 * description=A reusable quote line definition used when building quote templates.
 * displayName=Quote Line Template
 * module=Sales
 * defaultQuery=quoteLineTemplates
 * colour=#A91F54
 * aggregateQuery=quoteLineTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Line_Templates
 */
export interface QuoteLineTemplate {
  __typename?: "QuoteLineTemplate";
  /**
   * sortable=true
   * groupable=false
   */
  category: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  descriptionEditable: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  markupEditable: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  markupExpression: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  quantity: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  quantityEditable: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  quoteTemplateRevision?: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPrice: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  unitCostPriceEditable: ScalarsEnums["Boolean"];
}

/**
 * description=A reusable quote line definition used when building quote templates.
 */
export interface QuoteLineTemplateAggregate {
  __typename?: "QuoteLineTemplateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface QuotePreview {
  __typename?: "QuotePreview";
  html: ScalarsEnums["String"];
}

export interface QuoteRequestAcceptedEvent {
  __typename?: "QuoteRequestAcceptedEvent";
  quoteRequest: ScalarsEnums["String"];
  user: ScalarsEnums["String"];
}

export interface QuoteRequestPlacedEvent {
  __typename?: "QuoteRequestPlacedEvent";
  quoteRequest: ScalarsEnums["String"];
  user: ScalarsEnums["String"];
}

export interface QuoteRequestQuotedEvent {
  __typename?: "QuoteRequestQuotedEvent";
  quoteRequest: ScalarsEnums["String"];
  user: ScalarsEnums["String"];
}

/**
 * description=A saved revision of a quote at a particular point in its lifecycle.
 * displayName=Quote Revision
 * module=Sales
 * defaultQuery=quoteRevisions
 * colour=#A91F54
 * aggregateQuery=quoteRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Revisions
 */
export interface QuoteRevision {
  __typename?: "QuoteRevision";
  /**
   * sortable=true
   * groupable=false
   */
  clientAddress: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  clientName: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  contactName: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  lines: (args?: { filter?: Maybe<QuoteLineFilterInput> }) => Array<QuoteLine>;
  /**
   * sortable=true
   * groupable=true
   */
  quote: Quote;
  /**
   * sortable=true
   * groupable=false
   */
  reference?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  salesTax: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  status: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  subTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  total: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  version: ScalarsEnums["Int"];
}

/**
 * description=A saved revision of a quote at a particular point in its lifecycle.
 */
export interface QuoteRevisionAggregate {
  __typename?: "QuoteRevisionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface QuoteStatus {
  __typename?: "QuoteStatus";
  id: ScalarsEnums["ID"];
  name: ScalarsEnums["String"];
  quoteAggregate: (args?: {
    filter?: Maybe<QuoteFilterInput>;
  }) => Maybe<QuoteAggregate>;
}

/**
 * description=A reusable sales quoting template for generating quote lines and pricing.
 * displayName=Quote Template
 * module=Sales
 * defaultQuery=quoteTemplates
 * iconName=document
 * colour=#A91F54
 * aggregateQuery=quoteTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Templates
 */
export interface QuoteTemplate {
  __typename?: "QuoteTemplate";
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  currentRevision?: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=false
   */
  draftRevision?: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  isDefault: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  version: ScalarsEnums["Int"];
}

/**
 * description=A reusable sales quoting template for generating quote lines and pricing.
 */
export interface QuoteTemplateAggregate {
  __typename?: "QuoteTemplateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A formula or expression used by quote templates to calculate quote content.
 * displayName=Quote Template Expression
 * module=Sales
 * defaultQuery=quoteTemplateExpressions
 * colour=#A91F54
 * aggregateQuery=quoteTemplateExpressionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Template_Expressions
 */
export interface QuoteTemplateExpression {
  __typename?: "QuoteTemplateExpression";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  quoteTemplateRevision?: Maybe<QuoteTemplateRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  quoteTemplateRevisionId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  value: ScalarsEnums["String"];
}

/**
 * description=A formula or expression used by quote templates to calculate quote content.
 */
export interface QuoteTemplateExpressionAggregate {
  __typename?: "QuoteTemplateExpressionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface QuoteTemplatePreview {
  __typename?: "QuoteTemplatePreview";
  html: ScalarsEnums["String"];
}

/**
 * description=A saved revision of a quote template used to preserve template history.
 * displayName=Quote Template Revision
 * module=Sales
 * defaultQuery=quoteTemplateRevisions
 * colour=#A91F54
 * aggregateQuery=quoteTemplateRevisionsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Template_Revisions
 */
export interface QuoteTemplateRevision {
  __typename?: "QuoteTemplateRevision";
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=false
   * groupable=false
   */
  defaultLines: Array<QuoteLine>;
  /**
   * sortable=false
   * groupable=true
   */
  expressions: (args?: {
    filter?: Maybe<QuoteTemplateExpressionFilterInput>;
  }) => Array<QuoteTemplateExpression>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  lineTemplates: (args?: {
    filter?: Maybe<QuoteLineTemplateFilterInput>;
  }) => Array<QuoteLineTemplate>;
  /**
   * sortable=true
   * groupable=true
   */
  quoteTemplate: QuoteTemplate;
  /**
   * sortable=true
   * groupable=false
   */
  status: ScalarsEnums["QuoteTemplateRevisionStatus"];
  /**
   * sortable=true
   * groupable=false
   */
  version: ScalarsEnums["Int"];
}

/**
 * description=A saved revision of a quote template used to preserve template history.
 */
export interface QuoteTemplateRevisionAggregate {
  __typename?: "QuoteTemplateRevisionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A file attached to a record, including its folder and metadata.
 * displayName=Record File
 * module=Admin
 * defaultQuery=recordFiles
 * iconName=document
 * colour=#5D35A6
 * aggregateQuery=recordFileAggregates
 * grouping=true
 * queryPermission=Query_Record_Files
 */
export interface RecordFile {
  __typename?: "RecordFile";
  /**
   * sortable=true
   * groupable=true
   */
  created?: Maybe<ScalarsEnums["DateTime"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=true
   */
  file?: Maybe<File>;
  /**
   * sortable=true
   * groupable=false
   */
  fileId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  folder?: Maybe<RecordFolder>;
  /**
   * sortable=true
   * groupable=false
   */
  folderId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  isPrimaryImage: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  metadata?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  path: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  resourceId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  resourceType?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  user?: Maybe<User>;
}

/**
 * description=A file attached to a record, including its folder and metadata.
 */
export interface RecordFileAggregate {
  __typename?: "RecordFileAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface RecordFileDeletedEvent {
  __typename?: "RecordFileDeletedEvent";
  fileId: ScalarsEnums["String"];
  id: ScalarsEnums["String"];
}

/**
 * RecordFile
 */
export interface RecordFilesUploadedEvent {
  __typename?: "RecordFilesUploadedEvent";
  fileCount: ScalarsEnums["Int"];
  folderId?: Maybe<ScalarsEnums["String"]>;
  folderName?: Maybe<ScalarsEnums["String"]>;
  recordFileIds: Array<Maybe<ScalarsEnums["String"]>>;
  recordId: ScalarsEnums["String"];
  recordType: ScalarsEnums["String"];
}

/**
 * description=A native folder belonging to a record; file contents remain in UUID-based storage.
 * displayName=Record Folder
 * defaultQuery=recordFolders
 * iconName=folder-close
 * aggregateQuery=recordFoldersAggregate
 * grouping=true
 * queryPermission=Query_Record_Folders
 */
export interface RecordFolder {
  __typename?: "RecordFolder";
  /**
   * sortable=false
   * groupable=true
   */
  children: (args?: {
    filter?: Maybe<RecordFolderFilterInput>;
  }) => Array<RecordFolder>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  defaultFolderId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  parentFolder?: Maybe<RecordFolder>;
  /**
   * sortable=true
   * groupable=false
   */
  parentFolderId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * sortable=true
   * groupable=false
   */
  resourceId: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  resourceType: ScalarsEnums["String"];
}

/**
 * description=A native folder belonging to a record; file contents remain in UUID-based storage.
 */
export interface RecordFolderAggregate {
  __typename?: "RecordFolderAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface RecordNavigationRecord {
  __typename?: "RecordNavigationRecord";
  groupLabel?: Maybe<ScalarsEnums["String"]>;
  label: ScalarsEnums["String"];
  recordId: ScalarsEnums["String"];
  recordType: ScalarsEnums["RecordType"];
  relation?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=An application screen assigned directly to a user or role.
 * displayName=Record Screen
 * module=Admin
 * defaultQuery=recordScreens
 * iconName=dashboard
 * colour=#5D35A6
 * aggregateQuery=recordScreensAggregate
 * grouping=true
 * queryPermission=Query_Record_Screens
 */
export interface RecordScreen {
  __typename?: "RecordScreen";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=false
   */
  inheritedFrom?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * description=Identity of the user or role assigned to this screen, without loading the destination record.
   * sortable=false
   * groupable=false
   */
  record: RecordScreenRecordReference;
  /**
   * sortable=true
   * groupable=false
   */
  recordId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: ScalarsEnums["RecordScreenType"];
  /**
   * sortable=true
   * groupable=true
   */
  role?: Maybe<Role>;
  /**
   * sortable=true
   * groupable=true
   */
  screen: Screen;
  /**
   * sortable=true
   * groupable=false
   */
  source?: Maybe<ScalarsEnums["RecordSource"]>;
  /**
   * sortable=true
   * groupable=true
   */
  user?: Maybe<User>;
}

/**
 * description=An application screen assigned directly to a user or role.
 */
export interface RecordScreenAggregate {
  __typename?: "RecordScreenAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface RecordScreenRecordReference {
  __typename?: "RecordScreenRecordReference";
  recordId: ScalarsEnums["ID"];
  recordType: ScalarsEnums["String"];
}

/**
 * description=A tag assignment linking a reusable tag to another record.
 * displayName=Record Tag
 * module=Admin
 * defaultQuery=recordTags
 * iconName=tag
 * colour=#5D35A6
 * aggregateQuery=recordTagsAggregate
 * grouping=true
 * queryPermission=Query_Record_Tags
 */
export interface RecordTag {
  __typename?: "RecordTag";
  /**
   * sortable=true
   * groupable=false
   */
  colour?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  resourceType?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  tag: Tag;
}

/**
 * description=A tag assignment linking a reusable tag to another record.
 */
export interface RecordTagAggregate {
  __typename?: "RecordTagAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A geographic region used for grouping sales and operational records.
 * displayName=Region
 * module=Admin
 * defaultQuery=regions
 * iconName=map
 * colour=#5D35A6
 * aggregateQuery=regionsAggregate
 * grouping=true
 * queryPermission=Query_Regions
 */
export interface Region {
  __typename?: "Region";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  nzRegion: ScalarsEnums["String"];
}

/**
 * description=A geographic region used for grouping sales and operational records.
 */
export interface RegionAggregate {
  __typename?: "RegionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * A Region identity or a typed nested report dimension.
 */
export interface RegionReportDimensionValue {
  __typename?: "RegionReportDimensionValue";
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

/**
 * A stable machine-readable dimension key and its display label.
 */
export interface ReportDimensionValue {
  __typename?: "ReportDimensionValue";
  key: ScalarsEnums["String"];
  label: ScalarsEnums["String"];
}

export interface ResourceAggregate {
  __typename?: "ResourceAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface ResourceGroup {
  __typename?: "ResourceGroup";
  count: ScalarsEnums["Int"];
  key: ScalarsEnums["String"];
  label: ScalarsEnums["String"];
}

export interface ResourceGroupPage {
  __typename?: "ResourceGroupPage";
  items: Array<ResourceGroup>;
  totalCount: ScalarsEnums["Int"];
}

/**
 * description=An application authorization role assigned to users and inherited by other roles.
 * displayName=Role
 * module=Admin
 * defaultQuery=roles
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=rolesAggregate
 * grouping=true
 * queryPermission=Query_Roles
 */
export interface Role {
  __typename?: "Role";
  /**
   * sortable=false
   * groupable=false
   */
  allPermissions: (args?: {
    filter?: Maybe<AssignedPermissionFilterInput>;
  }) => Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  allScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=true
   */
  assignedUsers: (args?: {
    filter?: Maybe<RoleUserFilterInput>;
  }) => Array<RoleUser>;
  /**
   * sortable=false
   * groupable=false
   */
  childRoles: Array<Role>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=false
   */
  inheritFrom: Array<Role>;
  /**
   * sortable=false
   * groupable=true
   */
  inheritances: (args?: {
    filter?: Maybe<RoleInheritanceFilterInput>;
  }) => Array<RoleInheritance>;
  /**
   * sortable=false
   * groupable=true
   */
  inheritedBy: (args?: {
    filter?: Maybe<RoleInheritanceFilterInput>;
  }) => Array<RoleInheritance>;
  /**
   * sortable=true
   * groupable=false
   */
  inheritedFromName?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedPermissions: (args?: {
    filter?: Maybe<AssignedPermissionFilterInput>;
  }) => Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedScreens: Array<Screen>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  ownPermissions: (args?: {
    filter?: Maybe<AssignedPermissionFilterInput>;
  }) => Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  ownScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=false
   */
  parentRoles: Array<Role>;
  /**
   * sortable=false
   * groupable=false
   */
  screenAggregate: (args?: {
    filter?: Maybe<RecordScreenFilterInput>;
  }) => Maybe<RecordScreenAggregate>;
  /**
   * sortable=true
   * groupable=false
   */
  source: ScalarsEnums["RecordSource"];
  /**
   * description=The number of users directly assigned to this role.
   * sortable=false
   * groupable=false
   */
  userAggregate: (args?: {
    filter?: Maybe<RoleUserFilterInput>;
  }) => Maybe<RoleUserAggregate>;
  /**
   * description=Users directly assigned to this role or to a child role that inherits it.
   * sortable=false
   * groupable=false
   */
  users: Array<User>;
}

/**
 * description=An application authorization role assigned to users and inherited by other roles.
 */
export interface RoleAggregate {
  __typename?: "RoleAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Role
 */
export interface RoleCreatedEvent {
  __typename?: "RoleCreatedEvent";
  description: ScalarsEnums["String"];
  inheritedFrom: Array<Maybe<ScalarsEnums["String"]>>;
  roleId: ScalarsEnums["String"];
  roleName: ScalarsEnums["String"];
}

/**
 * Role
 */
export interface RoleDeletedEvent {
  __typename?: "RoleDeletedEvent";
  roleId: ScalarsEnums["String"];
  roleName: ScalarsEnums["String"];
}

/**
 * Role
 */
export interface RoleDetailsUpdatedEvent {
  __typename?: "RoleDetailsUpdatedEvent";
  description?: Maybe<ScalarsEnums["String"]>;
  roleId: ScalarsEnums["String"];
  roleName: ScalarsEnums["String"];
}

/**
 * description=An inheritance edge from a child application role to a parent role.
 * displayName=Role Inheritance
 * module=Admin
 * defaultQuery=roleInheritances
 * iconName=diagram-tree
 * colour=#5D35A6
 * aggregateQuery=roleInheritancesAggregate
 * grouping=true
 * queryPermission=Query_Role_Inheritances
 */
export interface RoleInheritance {
  __typename?: "RoleInheritance";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  parentId: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  parentRole: Role;
  /**
   * sortable=true
   * groupable=true
   */
  role: Role;
  /**
   * sortable=true
   * groupable=false
   */
  roleId: ScalarsEnums["String"];
}

/**
 * description=An inheritance edge from a child application role to a parent role.
 */
export interface RoleInheritanceAggregate {
  __typename?: "RoleInheritanceAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Role
 */
export interface RoleInheritanceAssignmentUpdatedEvent {
  __typename?: "RoleInheritanceAssignmentUpdatedEvent";
  assignedInheritance?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  roleId: ScalarsEnums["String"];
  roleName: ScalarsEnums["String"];
  unassignedInheritance?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
}

/**
 * description=A permission assigned directly to an application role.
 * displayName=Role Permission
 * module=Admin
 * defaultQuery=rolePermissions
 * iconName=key
 * colour=#5D35A6
 * aggregateQuery=rolePermissionsAggregate
 * grouping=true
 * queryPermission=Query_Role_Permissions
 */
export interface RolePermission {
  __typename?: "RolePermission";
  /**
   * sortable=true
   * groupable=false
   */
  conditions: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  permission: Permission;
  /**
   * sortable=true
   * groupable=false
   */
  policy: ScalarsEnums["Policy"];
  /**
   * sortable=true
   * groupable=true
   */
  role: Role;
}

/**
 * description=A permission assigned directly to an application role.
 */
export interface RolePermissionAggregate {
  __typename?: "RolePermissionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Role
 */
export interface RolePermissionsAssignmentUpdatedEvent {
  __typename?: "RolePermissionsAssignmentUpdatedEvent";
  assignedPermissions?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  roleId: ScalarsEnums["String"];
  roleName: ScalarsEnums["String"];
  unassignedPermissions?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
}

/**
 * Role
 */
export interface RoleScreensAssignmentUpdatedEvent {
  __typename?: "RoleScreensAssignmentUpdatedEvent";
  assignedScreens?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  roleId: ScalarsEnums["String"];
  roleName: ScalarsEnums["String"];
  unassignedScreens?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
}

/**
 * description=A direct assignment of an application role to a user.
 * displayName=Role User
 * module=Admin
 * defaultQuery=roleUsers
 * iconName=people
 * colour=#5D35A6
 * aggregateQuery=roleUsersAggregate
 * grouping=true
 * queryPermission=Query_Role_Users
 */
export interface RoleUser {
  __typename?: "RoleUser";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  role: Role;
  /**
   * sortable=true
   * groupable=true
   */
  user: User;
}

/**
 * description=A direct assignment of an application role to a user.
 */
export interface RoleUserAggregate {
  __typename?: "RoleUserAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Role
 */
export interface RoleUsersAssignmentUpdatedEvent {
  __typename?: "RoleUsersAssignmentUpdatedEvent";
  assignedUserIds?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  roleId: ScalarsEnums["String"];
  roleName: ScalarsEnums["String"];
  unassignedUserIds?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
}

/**
 * description=A sales classification describing how a job or quote was sold.
 * displayName=Sale Type
 * module=Sales
 * defaultQuery=saleTypes
 * colour=#A91F54
 * aggregateQuery=saleTypesAggregate
 * grouping=true
 * queryPermission=Query_Sale_Types
 */
export interface SaleType {
  __typename?: "SaleType";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
}

/**
 * description=A sales classification describing how a job or quote was sold.
 */
export interface SaleTypeAggregate {
  __typename?: "SaleTypeAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * A Sale Type identity or a typed nested report dimension.
 */
export interface SaleTypeReportDimensionValue {
  __typename?: "SaleTypeReportDimensionValue";
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A sales order accepted for client work.
 * displayName=Sales Order
 * module=Sales
 * defaultQuery=salesOrders
 * iconName=shopping-cart
 * colour=#A91F54
 * aggregateQuery=salesOrdersAggregate
 * grouping=true
 * queryPermission=Query_Sales_Orders
 */
export interface SalesOrder {
  __typename?: "SalesOrder";
  /**
   * sortable=true
   * groupable=true
   */
  client?: Maybe<Client>;
  /**
   * sortable=true
   * groupable=false
   */
  clientAddress?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  clientName: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  confirmedAt?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  contactName?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  currency: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  job?: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  lines: (args?: {
    filter?: Maybe<SalesOrderLineFilterInput>;
  }) => Array<SalesOrderLine>;
  /**
   * sortable=true
   * groupable=false
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  reference?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  salesOrderNumber?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  salesTax: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  status: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  subTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  total: ScalarsEnums["String"];
}

/**
 * description=A sales order accepted for client work.
 */
export interface SalesOrderAggregate {
  __typename?: "SalesOrderAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A product or service line on a sales order.
 * displayName=Sales Order Line
 * module=Sales
 * defaultQuery=salesOrderLines
 * colour=#A91F54
 * aggregateQuery=salesOrderLinesAggregate
 * grouping=true
 * queryPermission=Query_Sales_Order_Lines
 */
export interface SalesOrderLine {
  __typename?: "SalesOrderLine";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  jobComponent?: Maybe<JobComponent>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  line: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  lineTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  quantity: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  salesOrder: SalesOrder;
  /**
   * sortable=true
   * groupable=true
   */
  sourceQuote?: Maybe<Quote>;
  /**
   * sortable=true
   * groupable=true
   */
  sourceQuoteLine?: Maybe<QuoteLine>;
  /**
   * sortable=true
   * groupable=true
   */
  sourceQuoteRevision?: Maybe<QuoteRevision>;
  /**
   * sortable=true
   * groupable=false
   */
  unit?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  unitSellPrice: ScalarsEnums["String"];
}

/**
 * description=A custom form schema and its published and draft versions.
 * displayName=Schema
 * module=Admin
 * defaultQuery=schemas
 * iconName=form
 * colour=#5D35A6
 * aggregateQuery=schemasAggregate
 * grouping=true
 * queryPermission=Query_Schemas
 */
export interface Schema {
  __typename?: "Schema";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  latestVersion?: Maybe<SchemaVersion>;
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  recordType: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  versions: (args?: {
    filter?: Maybe<SchemaVersionFilterInput>;
  }) => Array<SchemaVersion>;
}

/**
 * description=A custom form schema and its published and draft versions.
 */
export interface SchemaAggregate {
  __typename?: "SchemaAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface SchemaCreatedEvent {
  __typename?: "SchemaCreatedEvent";
  schema: ScalarsEnums["String"];
}

export interface SchemaDeletedEvent {
  __typename?: "SchemaDeletedEvent";
  schema: ScalarsEnums["String"];
}

export interface SchemaType {
  __typename?: "SchemaType";
  id: ScalarsEnums["ID"];
  label: ScalarsEnums["String"];
  name: ScalarsEnums["String"];
}

export interface SchemaUpdatedEvent {
  __typename?: "SchemaUpdatedEvent";
  schema: ScalarsEnums["String"];
}

/**
 * description=A version of a custom form and its data definition.
 * displayName=Schema Version
 * module=Admin
 * defaultQuery=schemaVersions
 * iconName=form
 * colour=#5D35A6
 * aggregateQuery=schemaVersionsAggregate
 * grouping=true
 * queryPermission=Query_Schema_Versions
 */
export interface SchemaVersion {
  __typename?: "SchemaVersion";
  /**
   * sortable=true
   * groupable=false
   */
  created?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  dataDefinition?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  extra?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  formDefinition?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  latestActive: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  modified?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  schema?: Maybe<Schema>;
  /**
   * sortable=true
   * groupable=false
   */
  schemaId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * sortable=true
   * groupable=true
   */
  status?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=true
   * groupable=false
   */
  version?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  versionNo?: Maybe<ScalarsEnums["String"]>;
}

export interface SchemaVersionActiveEvent {
  __typename?: "SchemaVersionActiveEvent";
  schemaVersion: ScalarsEnums["String"];
}

/**
 * description=A version of a custom form and its data definition.
 */
export interface SchemaVersionAggregate {
  __typename?: "SchemaVersionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface SchemaVersionCreatedEvent {
  __typename?: "SchemaVersionCreatedEvent";
  schemaVersion: ScalarsEnums["String"];
}

export interface SchemaVersionDeletedEvent {
  __typename?: "SchemaVersionDeletedEvent";
  schemaVersion: ScalarsEnums["String"];
}

export interface SchemaVersionUpdatedEvent {
  __typename?: "SchemaVersionUpdatedEvent";
  schemaVersion: ScalarsEnums["String"];
}

/**
 * description=An application screen definition made from one or more panels.
 * displayName=Screen
 * module=Admin
 * defaultQuery=screens
 * iconName=dashboard
 * colour=#5D35A6
 * aggregateQuery=screensAggregate
 * grouping=true
 * queryPermission=Query_Screens
 */
export interface Screen {
  __typename?: "Screen";
  /**
   * sortable=false
   * groupable=false
   */
  assignmentAggregate: (args?: {
    filter?: Maybe<RecordScreenFilterInput>;
  }) => Maybe<RecordScreenAggregate>;
  /**
   * sortable=true
   * groupable=true
   */
  created?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  group?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  icon?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  recordType?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  resolvedScreenCfg: (args?: {
    recordId?: Maybe<ScalarsEnums["ID"]>;
    recordType?: Maybe<ScalarsEnums["String"]>;
  }) => Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  roles?: Maybe<Array<Role>>;
  /**
   * sortable=true
   * groupable=false
   */
  screenCfg?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  source: ScalarsEnums["String"];
}

/**
 * description=An application screen definition made from one or more panels.
 */
export interface ScreenAggregate {
  __typename?: "ScreenAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Screen
 */
export interface ScreenCreatedEvent {
  __typename?: "ScreenCreatedEvent";
  screenCfg: ScalarsEnums["String"];
  screenId: ScalarsEnums["String"];
  screenName: ScalarsEnums["String"];
}

/**
 * Screen
 */
export interface ScreenDeletedEvent {
  __typename?: "ScreenDeletedEvent";
  screenId: ScalarsEnums["String"];
  screenName: ScalarsEnums["String"];
}

/**
 * Screen
 */
export interface ScreenUpdatedEvent {
  __typename?: "ScreenUpdatedEvent";
  screenCfg?: Maybe<ScalarsEnums["String"]>;
  screenGroup?: Maybe<ScalarsEnums["String"]>;
  screenId: ScalarsEnums["String"];
  screenName: ScalarsEnums["String"];
}

export interface SignedUploadUrlPayload {
  __typename?: "SignedUploadUrlPayload";
  fileId: ScalarsEnums["String"];
  uploadToken: ScalarsEnums["String"];
  uploadUrl: ScalarsEnums["String"];
}

export interface Specification {
  __typename?: "Specification";
  id: ScalarsEnums["ID"];
}

export interface SpecificationLookupOption {
  __typename?: "SpecificationLookupOption";
  id: ScalarsEnums["ID"];
  name: ScalarsEnums["String"];
  type: ScalarsEnums["String"];
  value: ScalarsEnums["String"];
}

/**
 * PurchaseOrderReview
 */
export interface StatusChangedEvent {
  __typename?: "StatusChangedEvent";
  comment?: Maybe<ScalarsEnums["String"]>;
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
  orderReviewId: ScalarsEnums["String"];
  review: ScalarsEnums["String"];
  reviewerUserName: ScalarsEnums["String"];
}

export interface StatusUpdatedEvent {
  __typename?: "StatusUpdatedEvent";
  quoteRequestEmail: ScalarsEnums["String"];
}

/**
 * description=Current inventory quantities and values for products in warehouses.
 * displayName=Stock
 * module=Inventory
 * defaultQuery=stock
 * iconName=package
 * colour=#596600
 * aggregateQuery=stockAggregate
 * grouping=true
 * queryPermission=Query_Stock
 */
export interface Stock {
  __typename?: "Stock";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  product?: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  totalCostPrice?: Maybe<Money>;
  /**
   * sortable=true
   * groupable=true
   */
  warehouse?: Maybe<Warehouse>;
}

/**
 * description=Current inventory quantities and values for products in warehouses.
 */
export interface StockAggregate {
  __typename?: "StockAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * sortable=false
   * groupable=false
   */
  totalCostPrice: Money;
  /**
   * sortable=true
   * groupable=false
   */
  totalQuantity: ScalarsEnums["Float"];
}

export interface StockTakeCreatedEvent {
  __typename?: "StockTakeCreatedEvent";
  stockTakeId: ScalarsEnums["String"];
}

/**
 * description=An inventory movement that receives, transfers, adjusts, or withdraws stock.
 * displayName=Stock Transaction
 * module=Inventory
 * defaultQuery=stockTransactions
 * colour=#596600
 * aggregateQuery=stockTransactionsAggregate
 * grouping=true
 * queryPermission=Query_Stock_Transactions
 */
export interface StockTransaction {
  __typename?: "StockTransaction";
  /**
   * sortable=true
   * groupable=true
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  lines: (args?: {
    filter?: Maybe<StockTransactionLineFilterInput>;
  }) => Array<StockTransactionLine>;
  /**
   * sortable=true
   * groupable=false
   */
  type: ScalarsEnums["StockTransactionType"];
  /**
   * sortable=true
   * groupable=true
   */
  user: User;
  /**
   * sortable=true
   * groupable=true
   */
  warehouse: Warehouse;
}

/**
 * description=An inventory movement that receives, transfers, adjusts, or withdraws stock.
 */
export interface StockTransactionAggregate {
  __typename?: "StockTransactionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
  /**
   * sortable=true
   * groupable=false
   */
  totalCostPrice: ScalarsEnums["Float"];
  /**
   * sortable=true
   * groupable=false
   */
  totalQuantity: ScalarsEnums["Float"];
}

export interface StockTransactionCreatedEvent {
  __typename?: "StockTransactionCreatedEvent";
  stockTransactionId: ScalarsEnums["Int"];
  type: ScalarsEnums["String"];
}

/**
 * description=A product quantity movement within an inventory stock transaction.
 * displayName=Stock Transaction Line
 * module=Inventory
 * defaultQuery=stockTransactionLines
 * colour=#596600
 * aggregateQuery=stockTransactionLinesAggregate
 * grouping=true
 * queryPermission=Query_Stock_Transaction_Lines
 */
export interface StockTransactionLine {
  __typename?: "StockTransactionLine";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  product?: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: ScalarsEnums["Float"];
  /**
   * sortable=true
   * groupable=true
   */
  stockTransaction: StockTransaction;
}

/**
 * description=A product quantity movement within an inventory stock transaction.
 */
export interface StockTransactionLineAggregate {
  __typename?: "StockTransactionLineAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=An event subscription defining notification recipients and templates.
 * displayName=Subscription
 * module=Admin
 * defaultQuery=subscriptions
 * iconName=notifications
 * colour=#5D35A6
 * aggregateQuery=subscriptionsAggregate
 * grouping=true
 * queryPermission=Query_Subscriptions
 */
export interface SubscriptionReal {
  __typename?: "SubscriptionReal";
  /**
   * sortable=true
   * groupable=true
   */
  channels: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  enabled: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  event: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  maxRecipients?: Maybe<ScalarsEnums["Int"]>;
  /**
   * sortable=false
   * groupable=true
   */
  notificationTemplates: (args?: {
    filter?: Maybe<NotificationTemplateFilterInput>;
  }) => Array<NotificationTemplate>;
  /**
   * sortable=true
   * groupable=false
   */
  sourceFilter?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  targetFilter?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=An event subscription defining notification recipients and templates.
 */
export interface SubscriptionRealAggregate {
  __typename?: "SubscriptionRealAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A supplier that provides products or services for purchasing and inventory.
 * displayName=Supplier
 * module=Inventory
 * defaultQuery=suppliers
 * iconName=shop
 * colour=#596600
 * aggregateQuery=suppliersAggregate
 * grouping=true
 * queryPermission=Query_Suppliers
 */
export interface Supplier {
  __typename?: "Supplier";
  /**
   * sortable=true
   * groupable=false
   */
  address?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  category?: Maybe<SupplierCategory>;
  /**
   * sortable=true
   * groupable=false
   */
  cell?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  currency?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  email?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  image?: Maybe<File>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  numberOfReviews: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  orderEmails: Array<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  productAggregate: (args?: {
    filter?: Maybe<ProductFilterInput>;
  }) => Maybe<ProductAggregate>;
  /**
   * sortable=false
   * groupable=true
   */
  products: (args?: {
    filter?: Maybe<ProductFilterInput>;
  }) => Maybe<Array<Maybe<Product>>>;
  /**
   * sortable=true
   * groupable=false
   */
  quantityThreshold: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  quoteEmails: Array<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  reviewType: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  reviewers: Array<User>;
  /**
   * sortable=true
   * groupable=false
   */
  url?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A supplier that provides products or services for purchasing and inventory.
 */
export interface SupplierAggregate {
  __typename?: "SupplierAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=An inventory category used to group suppliers.
 * displayName=Supplier Category
 * module=Inventory
 * defaultQuery=supplierCategories
 * iconName=tag
 * colour=#596600
 * aggregateQuery=supplierCategoriesAggregate
 * grouping=true
 * queryPermission=Query_Supplier_Categories
 */
export interface SupplierCategory {
  __typename?: "SupplierCategory";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
}

/**
 * description=An inventory category used to group suppliers.
 */
export interface SupplierCategoryAggregate {
  __typename?: "SupplierCategoryAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Supplier
 */
export interface SupplierCreatedEvent {
  __typename?: "SupplierCreatedEvent";
  supplierId: ScalarsEnums["Int"];
  supplierName: ScalarsEnums["String"];
}

/**
 * Supplier
 */
export interface SupplierDeletedEvent {
  __typename?: "SupplierDeletedEvent";
  supplierId: ScalarsEnums["Int"];
  supplierName: ScalarsEnums["String"];
}

/**
 * Supplier
 */
export interface SupplierDetailsUpdatedEvent {
  __typename?: "SupplierDetailsUpdatedEvent";
  address: ScalarsEnums["String"];
  category?: Maybe<ScalarsEnums["String"]>;
  cell: ScalarsEnums["String"];
  currency: ScalarsEnums["String"];
  email: ScalarsEnums["String"];
  orderEmails?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  quoteEmails?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  supplierId: ScalarsEnums["Int"];
  supplierName: ScalarsEnums["String"];
  url: ScalarsEnums["String"];
}

/**
 * description=A priced offer received from a supplier.
 * displayName=Supplier Quote
 * module=Inventory
 * defaultQuery=supplierQuotes
 * iconName=document
 * colour=#596600
 * aggregateQuery=supplierQuotesAggregate
 * grouping=true
 * queryPermission=Query_Supplier_Quotes
 */
export interface SupplierQuote {
  __typename?: "SupplierQuote";
  /**
   * sortable=false
   * groupable=true
   */
  costingLines: (args?: {
    filter?: Maybe<CostingLineFilterInput>;
  }) => Array<CostingLine>;
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  currency: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  job?: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  lines: (args?: {
    filter?: Maybe<SupplierQuoteLineFilterInput>;
  }) => Array<SupplierQuoteLine>;
  /**
   * sortable=true
   * groupable=false
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  quoteRequest?: Maybe<SupplierQuoteRequest>;
  /**
   * sortable=true
   * groupable=false
   */
  reference?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  salesTax: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  status: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=false
   */
  subTotal: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  supplier?: Maybe<Supplier>;
  /**
   * sortable=true
   * groupable=false
   */
  supplierAddress: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  supplierName: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  supplierQuoteNumber?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  total: ScalarsEnums["String"];
}

/**
 * description=A priced offer received from a supplier.
 */
export interface SupplierQuoteAggregate {
  __typename?: "SupplierQuoteAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A product or service line offered on a supplier quote.
 * displayName=Supplier Quote Line
 * module=Inventory
 * defaultQuery=supplierQuoteLines
 * colour=#596600
 * aggregateQuery=supplierQuoteLinesAggregate
 * grouping=true
 * queryPermission=Query_Supplier_Quote_Lines
 */
export interface SupplierQuoteLine {
  __typename?: "SupplierQuoteLine";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  line: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=true
   */
  product?: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  supplierQuote?: Maybe<SupplierQuote>;
  /**
   * sortable=true
   * groupable=false
   */
  total: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  unitPrice: ScalarsEnums["String"];
}

/**
 * description=A request sent to a supplier for pricing on products or services.
 * displayName=Supplier Quote Request
 * module=Inventory
 * defaultQuery=supplierQuoteRequests
 * iconName=send-message
 * colour=#596600
 * aggregateQuery=supplierQuoteRequestsAggregate
 * grouping=true
 * queryPermission=Query_Quote_Requests
 */
export interface SupplierQuoteRequest {
  __typename?: "SupplierQuoteRequest";
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=true
   */
  job?: Maybe<Job>;
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  lines: (args?: {
    filter?: Maybe<SupplierQuoteRequestLineFilterInput>;
  }) => Array<SupplierQuoteRequestLine>;
  /**
   * sortable=true
   * groupable=false
   */
  noteForSupplier: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  reference: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  status: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=true
   */
  supplier?: Maybe<Supplier>;
}

/**
 * description=A request sent to a supplier for pricing on products or services.
 */
export interface SupplierQuoteRequestAggregate {
  __typename?: "SupplierQuoteRequestAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A product or service line included in a supplier quote request.
 * displayName=Supplier Quote Request Line
 * module=Inventory
 * defaultQuery=supplierQuoteRequestLines
 * colour=#596600
 * aggregateQuery=supplierQuoteRequestLinesAggregate
 * grouping=true
 * queryPermission=Query_Quote_Request_Lines
 */
export interface SupplierQuoteRequestLine {
  __typename?: "SupplierQuoteRequestLine";
  /**
   * sortable=true
   * groupable=false
   */
  code?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  line: ScalarsEnums["Int"];
  /**
   * sortable=true
   * groupable=true
   */
  product?: Maybe<Product>;
  /**
   * sortable=true
   * groupable=false
   */
  quantity?: Maybe<ScalarsEnums["Float"]>;
  /**
   * sortable=true
   * groupable=true
   */
  quoteRequest: SupplierQuoteRequest;
  /**
   * sortable=true
   * groupable=false
   */
  unit?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A product or service line included in a supplier quote request.
 */
export interface SupplierQuoteRequestLineAggregate {
  __typename?: "SupplierQuoteRequestLineAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Supplier
 */
export interface SupplierReviewersUpdatedEvent {
  __typename?: "SupplierReviewersUpdatedEvent";
  numberOfReviews: ScalarsEnums["Int"];
  quantityThreshold?: Maybe<ScalarsEnums["Int"]>;
  reviewType: ScalarsEnums["String"];
  supplierId: ScalarsEnums["Int"];
  supplierName: ScalarsEnums["String"];
}

/**
 * PurchaseOrder
 */
export interface SupplierStatusUpdatedEvent {
  __typename?: "SupplierStatusUpdatedEvent";
  orderId: ScalarsEnums["Int"];
  orderNumber: ScalarsEnums["String"];
}

/**
 * description=A reusable label that can be attached to supported records.
 * displayName=Tag
 * module=Admin
 * defaultQuery=tags
 * iconName=tag
 * colour=#5D35A6
 * aggregateQuery=tagsAggregate
 * grouping=true
 * queryPermission=Query_Tags
 */
export interface Tag {
  __typename?: "Tag";
  /**
   * sortable=true
   * groupable=false
   */
  colour?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  resourceType?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A reusable label that can be attached to supported records.
 */
export interface TagAggregate {
  __typename?: "TagAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * DocumentTemplate
 */
export interface TemplateCreatedEvent {
  __typename?: "TemplateCreatedEvent";
  templateId: ScalarsEnums["String"];
  templateName: ScalarsEnums["String"];
}

/**
 * DocumentTemplate
 */
export interface TemplateDeletedEvent {
  __typename?: "TemplateDeletedEvent";
  templateId: ScalarsEnums["String"];
  templateName: ScalarsEnums["String"];
}

/**
 * DocumentTemplate
 */
export interface TemplateUpdatedEvent {
  __typename?: "TemplateUpdatedEvent";
  templateId: ScalarsEnums["String"];
  templateName: ScalarsEnums["String"];
}

/**
 * description=A start and stop interval recorded against a process timer.
 * displayName=Timer Transaction
 * module=Manufacturing
 * defaultQuery=timerTransactions
 * iconName=timer
 * colour=#A96500
 * aggregateQuery=timerTransactionsAggregate
 * grouping=true
 * queryPermission=Query_Timer_Transactions
 */
export interface TimerTransaction {
  __typename?: "TimerTransaction";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  start?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  stop?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  timer?: Maybe<ProcessTimer>;
}

/**
 * description=A start and stop interval recorded against a process timer.
 */
export interface TimerTransactionAggregate {
  __typename?: "TimerTransactionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface UploadRequestUrl {
  __typename?: "UploadRequestUrl";
  headers: ScalarsEnums["String"];
  method: ScalarsEnums["String"];
  url: ScalarsEnums["String"];
}

/**
 * description=A system user account with application roles, identities, permissions, and screen access.
 * displayName=User
 * module=Admin
 * defaultQuery=users
 * iconName=user
 * colour=#5D35A6
 * aggregateQuery=usersAggregate
 * grouping=true
 * queryPermission=Query_Users
 */
export interface User {
  __typename?: "User";
  /**
   * sortable=false
   * groupable=false
   */
  allPermissions: (args?: {
    filter?: Maybe<AssignedPermissionFilterInput>;
  }) => Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  allScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=true
   */
  assignedRoles: (args?: {
    filter?: Maybe<RoleUserFilterInput>;
  }) => Array<RoleUser>;
  /**
   * sortable=true
   * groupable=false
   */
  authProvider: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  authProviderUid: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  branch?: Maybe<Branch>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  email?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  firebaseAuthId?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  fullName?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  hasPin: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=true
   */
  identities: (args?: {
    filter?: Maybe<UserIdentityFilterInput>;
  }) => Array<UserIdentity>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedPermissions: (args?: {
    filter?: Maybe<AssignedPermissionFilterInput>;
  }) => Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  inheritedScreens: Array<Screen>;
  /**
   * sortable=true
   * groupable=false
   */
  initials: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  isActive: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  ownPermissions: (args?: {
    filter?: Maybe<AssignedPermissionFilterInput>;
  }) => Array<AssignedPermission>;
  /**
   * sortable=false
   * groupable=false
   */
  ownScreens: Array<Screen>;
  /**
   * sortable=false
   * groupable=false
   */
  roles: Array<Role>;
  /**
   * sortable=false
   * groupable=true
   */
  timers: (args?: {
    filter?: Maybe<ProcessTimerFilterInput>;
  }) => Array<ProcessTimer>;
  /**
   * sortable=true
   * groupable=false
   */
  username?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A system user account with application roles, identities, permissions, and screen access.
 */
export interface UserAggregate {
  __typename?: "UserAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * User
 */
export interface UserCreatedEvent {
  __typename?: "UserCreatedEvent";
  userId: ScalarsEnums["Int"];
  userName: ScalarsEnums["String"];
}

/**
 * User
 */
export interface UserDeletedEvent {
  __typename?: "UserDeletedEvent";
  userId: ScalarsEnums["Int"];
  userName: ScalarsEnums["String"];
}

/**
 * User
 */
export interface UserDisabledEvent {
  __typename?: "UserDisabledEvent";
  userId: ScalarsEnums["Int"];
  userName: ScalarsEnums["String"];
}

/**
 * User
 */
export interface UserEnabledEvent {
  __typename?: "UserEnabledEvent";
  userId: ScalarsEnums["Int"];
  userName: ScalarsEnums["String"];
}

/**
 * description=A link between a system user and the domain record that user represents.
 * displayName=User Identity
 * module=Admin
 * defaultQuery=userIdentities
 * iconName=id-number
 * colour=#5D35A6
 * aggregateQuery=userIdentitiesAggregate
 * grouping=true
 * queryPermission=Query_User_Identities
 */
export interface UserIdentity {
  __typename?: "UserIdentity";
  /**
   * sortable=true
   * groupable=false
   */
  created?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * description=The schema type of the represented record.
   * sortable=true
   * groupable=false
   */
  entity?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * description=The person represented by a Person identity.
   * sortable=true
   * groupable=true
   */
  person?: Maybe<Person>;
  /**
   * sortable=true
   * groupable=false
   */
  recordId?: Maybe<ScalarsEnums["ID"]>;
  /**
   * sortable=true
   * groupable=false
   */
  recordLabel?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  user?: Maybe<User>;
  /**
   * sortable=true
   * groupable=false
   */
  userId?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A link between a system user and the domain record that user represents.
 */
export interface UserIdentityAggregate {
  __typename?: "UserIdentityAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface UserNotification {
  __typename?: "UserNotification";
  id: ScalarsEnums["ID"];
  initialPath: Array<ScalarsEnums["String"]>;
  initialTab?: Maybe<ScalarsEnums["String"]>;
  recordId?: Maybe<ScalarsEnums["ID"]>;
  recordType?: Maybe<ScalarsEnums["String"]>;
  text: ScalarsEnums["String"];
  timestamp: ScalarsEnums["Int"];
  title: ScalarsEnums["String"];
  unread: ScalarsEnums["Boolean"];
}

/**
 * description=A permission assigned directly to an application user.
 * displayName=User Permission
 * module=Admin
 * defaultQuery=userPermissions
 * iconName=key
 * colour=#5D35A6
 * aggregateQuery=userPermissionsAggregate
 * grouping=true
 * queryPermission=Query_User_Permissions
 */
export interface UserPermission {
  __typename?: "UserPermission";
  /**
   * sortable=true
   * groupable=false
   */
  conditions: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  permission: Permission;
  /**
   * sortable=true
   * groupable=false
   */
  policy: ScalarsEnums["Policy"];
  /**
   * sortable=true
   * groupable=true
   */
  user: User;
}

/**
 * description=A permission assigned directly to an application user.
 */
export interface UserPermissionAggregate {
  __typename?: "UserPermissionAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * User
 */
export interface UserPermissionsUpdatedEvent {
  __typename?: "UserPermissionsUpdatedEvent";
  assignedPermissions?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  unassignedPermissions?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  userId: ScalarsEnums["Int"];
  userName: ScalarsEnums["String"];
}

/**
 * A User identity or a typed nested report dimension.
 */
export interface UserReportDimensionValue {
  __typename?: "UserReportDimensionValue";
  branch?: Maybe<BranchReportDimensionValue>;
  /**
   * Stable machine-readable Resource identity.
   */
  key?: Maybe<ScalarsEnums["String"]>;
  /**
   * Display label for the Resource identity.
   */
  label?: Maybe<ScalarsEnums["String"]>;
}

/**
 * User
 */
export interface UserRestoredEvent {
  __typename?: "UserRestoredEvent";
  userId: ScalarsEnums["Int"];
  userName: ScalarsEnums["String"];
}

/**
 * description=A legacy operational role type attached to a user for workflow assignments.
 * displayName=Legacy User Role
 * module=Admin
 * defaultQuery=legacyUserRoles
 * iconName=person
 * colour=#5D35A6
 * aggregateQuery=legacyUserRolesAggregate
 * grouping=true
 * queryPermission=Query_Legacy_User_Roles
 */
export interface UserRole {
  __typename?: "UserRole";
  /**
   * sortable=true
   * groupable=true
   */
  businessRole?: Maybe<BusinessRole>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  processAssignments: (args?: {
    filter?: Maybe<ProcessAssignmentFilterInput>;
  }) => Array<ProcessAssignment>;
  /**
   * sortable=true
   * groupable=false
   */
  type?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=true
   */
  user?: Maybe<User>;
}

/**
 * description=A legacy operational role type attached to a user for workflow assignments.
 */
export interface UserRoleAggregate {
  __typename?: "UserRoleAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * User
 */
export interface UserRolesUpdatedEvent {
  __typename?: "UserRolesUpdatedEvent";
  assignedRoles?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  unassignedRoles?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  userId: ScalarsEnums["Int"];
  userName: ScalarsEnums["String"];
}

/**
 * User
 */
export interface UserScreensUpdatedEvent {
  __typename?: "UserScreensUpdatedEvent";
  assignedScreens?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  unassignedScreens?: Maybe<Array<Maybe<ScalarsEnums["String"]>>>;
  userId: ScalarsEnums["Int"];
  userName: ScalarsEnums["String"];
}

/**
 * User
 */
export interface UserUpdatedEvent {
  __typename?: "UserUpdatedEvent";
  authProvider: ScalarsEnums["String"];
  branch?: Maybe<ScalarsEnums["String"]>;
  fullName: ScalarsEnums["String"];
  userId: ScalarsEnums["Int"];
  userName: ScalarsEnums["String"];
}

/**
 * description=A warehouse or stock location used to hold inventory products.
 * displayName=Warehouse
 * module=Inventory
 * defaultQuery=warehouses
 * iconName=office
 * colour=#596600
 * aggregateQuery=warehousesAggregate
 * grouping=true
 * queryPermission=Query_Warehouses
 */
export interface Warehouse {
  __typename?: "Warehouse";
  /**
   * sortable=true
   * groupable=false
   */
  address: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  code?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  color?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=true
   */
  stock: (args?: { filter?: Maybe<StockFilterInput> }) => Array<Stock>;
  /**
   * sortable=false
   * groupable=false
   */
  stockAggregate: (args?: {
    filter?: Maybe<StockFilterInput>;
  }) => Maybe<StockAggregate>;
}

/**
 * description=A warehouse or stock location used to hold inventory products.
 */
export interface WarehouseAggregate {
  __typename?: "WarehouseAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Warehouse
 */
export interface WarehouseCreatedEvent {
  __typename?: "WarehouseCreatedEvent";
  warehouseId: ScalarsEnums["Int"];
  warehouseName: ScalarsEnums["String"];
}

/**
 * Warehouse
 */
export interface WarehouseDeletedEvent {
  __typename?: "WarehouseDeletedEvent";
  warehouseId: ScalarsEnums["Int"];
  warehouseName: ScalarsEnums["String"];
}

/**
 * Warehouse
 */
export interface WarehouseStockReceivedEvent {
  __typename?: "WarehouseStockReceivedEvent";
  stock: Array<Maybe<ScalarsEnums["String"]>>;
  warehouseId: ScalarsEnums["Int"];
  warehouseName: ScalarsEnums["String"];
}

/**
 * Warehouse
 */
export interface WarehouseStockTakeEvent {
  __typename?: "WarehouseStockTakeEvent";
  countedStock: Array<Maybe<ScalarsEnums["String"]>>;
  stockDelta: Array<Maybe<ScalarsEnums["String"]>>;
  warehouseId: ScalarsEnums["Int"];
  warehouseName: ScalarsEnums["String"];
}

/**
 * Warehouse
 */
export interface WarehouseStockTransferReceivedEvent {
  __typename?: "WarehouseStockTransferReceivedEvent";
  receivedWarehouseId: ScalarsEnums["Int"];
  receivedWarehouseName: ScalarsEnums["String"];
  stock: Array<Maybe<ScalarsEnums["String"]>>;
  withdrawnWarehouseId: ScalarsEnums["Int"];
  withdrawnWarehouseName: ScalarsEnums["String"];
}

/**
 * Warehouse
 */
export interface WarehouseStockTransferWithdrawnEvent {
  __typename?: "WarehouseStockTransferWithdrawnEvent";
  receivedWarehouseId: ScalarsEnums["Int"];
  receivedWarehouseName: ScalarsEnums["String"];
  stock: Array<Maybe<ScalarsEnums["String"]>>;
  withdrawnWarehouseId: ScalarsEnums["Int"];
  withdrawnWarehouseName: ScalarsEnums["String"];
}

/**
 * Warehouse
 */
export interface WarehouseStockWithdrawnEvent {
  __typename?: "WarehouseStockWithdrawnEvent";
  stock: Array<Maybe<ScalarsEnums["String"]>>;
  warehouseId: ScalarsEnums["Int"];
  warehouseName: ScalarsEnums["String"];
}

/**
 * Warehouse
 */
export interface WarehouseUpdatedEvent {
  __typename?: "WarehouseUpdatedEvent";
  warehouseId: ScalarsEnums["Int"];
  warehouseName: ScalarsEnums["String"];
}

/**
 * description=An outbound webhook configured for an event and source filter.
 * displayName=Webhook
 * module=Admin
 * defaultQuery=webhooks
 * iconName=data-connection
 * colour=#5D35A6
 * aggregateQuery=webhooksAggregate
 * grouping=true
 * queryPermission=Query_Webhooks
 */
export interface Webhook {
  __typename?: "Webhook";
  /**
   * sortable=true
   * groupable=false
   */
  authType: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  enabled: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  event: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  recordType: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  sourceFilter?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  url: ScalarsEnums["String"];
}

/**
 * description=An outbound webhook configured for an event and source filter.
 */
export interface WebhookAggregate {
  __typename?: "WebhookAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * Webhook
 */
export interface WebhookCallFailedEvent {
  __typename?: "WebhookCallFailedEvent";
  error: ScalarsEnums["String"];
  statusCode?: Maybe<ScalarsEnums["Int"]>;
  url: ScalarsEnums["String"];
  webhookId: ScalarsEnums["String"];
}

/**
 * Webhook
 */
export interface WebhookCalledEvent {
  __typename?: "WebhookCalledEvent";
  response: ScalarsEnums["String"];
  url: ScalarsEnums["String"];
  webhookId: ScalarsEnums["String"];
}

export interface WebhookCreatedEvent {
  __typename?: "WebhookCreatedEvent";
  webhook: ScalarsEnums["String"];
}

export interface WebhookDeletedEvent {
  __typename?: "WebhookDeletedEvent";
  webhook: ScalarsEnums["String"];
}

export interface WebhookUpdatedEvent {
  __typename?: "WebhookUpdatedEvent";
  webhook: ScalarsEnums["String"];
}

export interface Week {
  __typename?: "Week";
  createdLeadAggregate: (args?: {
    filter?: Maybe<LeadFilterInput>;
  }) => Maybe<LeadAggregate>;
  createdPurchaseOrderAggregate: (args?: {
    filter?: Maybe<PurchaseOrderFilterInput>;
  }) => Maybe<PurchaseOrderAggregate>;
  createdPurchaseOrderLineAggregate: (args?: {
    filter?: Maybe<PurchaseOrderLineFilterInput>;
  }) => Maybe<PurchaseOrderLineAggregate>;
  stockTransactionAggregate: (args?: {
    filter?: Maybe<StockTransactionFilterInput>;
  }) => Maybe<StockTransactionAggregate>;
  weekNumber: ScalarsEnums["String"];
  weekNumberAndYear: ScalarsEnums["String"];
  year: ScalarsEnums["String"];
}

/**
 * description=A workflow containing the process and group nodes for manufacturing work.
 * displayName=Workflow
 * module=Manufacturing
 * iconName=data-lineage
 * colour=#A96500
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export interface Workflow {
  __typename?: "Workflow";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  type?: Maybe<WorkflowType>;
}

/**
 * description=A process, group, or workflow node and its dependencies.
 * displayName=Workflow Node
 * module=Manufacturing
 * iconName=data-lineage
 * colour=#A96500
 * grouping=true
 * queryPermission=Query_Line_Item_Master_Workflows
 */
export interface WorkflowNode {
  __typename?: "WorkflowNode";
  /**
   * sortable=false
   * groupable=false
   */
  children: Array<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  lineItemMasterWorkflow?: Maybe<LineItemMasterWorkflow>;
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  nodeType: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  owner?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=false
   * groupable=false
   */
  parents: Array<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  status: ScalarsEnums["Int"];
}

/**
 * description=A note assigned directly to a workflow node.
 * displayName=Workflow Note
 * module=Manufacturing
 * defaultQuery=workflowNotes
 * iconName=message-square-text
 * colour=#A96500
 * aggregateQuery=workflowNotesAggregate
 * grouping=true
 * queryPermission=Query_Workflow_Notes
 */
export interface WorkflowNote {
  __typename?: "WorkflowNote";
  /**
   * sortable=true
   * groupable=true
   */
  created: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  createdBy?: Maybe<User>;
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=true
   */
  modified: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  nodeId: ScalarsEnums["ID"];
  /**
   * sortable=false
   * groupable=false
   */
  processInstance?: Maybe<ProcessInstance>;
  /**
   * sortable=true
   * groupable=true
   */
  processType: ProcessType;
}

/**
 * description=A note assigned directly to a workflow node.
 */
export interface WorkflowNoteAggregate {
  __typename?: "WorkflowNoteAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * description=A reusable workflow definition that can be assigned to workflow subjects.
 * displayName=Workflow Template
 * module=Manufacturing
 * defaultQuery=workflowTemplates
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=workflowTemplatesAggregate
 * grouping=true
 * queryPermission=Query_Workflow_Templates
 */
export interface WorkflowTemplate {
  __typename?: "WorkflowTemplate";
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  display: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  placeHolder: ScalarsEnums["Boolean"];
  /**
   * description=Placeholder workflow selections required by this template.
   * sortable=false
   * groupable=false
   */
  placeholders: Array<WorkflowTemplatePlaceholder>;
  /**
   * description=Workflow diagram group label data for previewing this template.
   * sortable=false
   * groupable=false
   */
  previewGroupInstances: Array<WorkflowTemplatePreviewGroupInstance>;
  /**
   * description=Workflow diagram item data for previewing this template.
   * sortable=false
   * groupable=false
   */
  previewItems: Array<WorkflowTemplatePreviewItem>;
  /**
   * sortable=true
   * groupable=false
   */
  valid: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  workflowType?: Maybe<WorkflowType>;
}

/**
 * description=A reusable workflow definition that can be assigned to workflow subjects.
 */
export interface WorkflowTemplateAggregate {
  __typename?: "WorkflowTemplateAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

export interface WorkflowTemplatePlaceholder {
  __typename?: "WorkflowTemplatePlaceholder";
  description?: Maybe<ScalarsEnums["String"]>;
  display: ScalarsEnums["String"];
  id: ScalarsEnums["ID"];
  options: Array<WorkflowTemplatePlaceholderOption>;
}

export interface WorkflowTemplatePlaceholderOption {
  __typename?: "WorkflowTemplatePlaceholderOption";
  description?: Maybe<ScalarsEnums["String"]>;
  display: ScalarsEnums["String"];
  id: ScalarsEnums["ID"];
  placeholders: Array<WorkflowTemplatePlaceholder>;
  previewGroupInstances: Array<WorkflowTemplatePreviewGroupInstance>;
  previewItems: Array<WorkflowTemplatePreviewItem>;
}

export interface WorkflowTemplatePreviewGroupInstance {
  __typename?: "WorkflowTemplatePreviewGroupInstance";
  id: ScalarsEnums["ID"];
  name: ScalarsEnums["String"];
  workflow: WorkflowTemplatePreviewGroupWorkflow;
}

export interface WorkflowTemplatePreviewGroupWorkflow {
  __typename?: "WorkflowTemplatePreviewGroupWorkflow";
  id: ScalarsEnums["ID"];
  type?: Maybe<WorkflowTemplatePreviewWorkflowType>;
}

export interface WorkflowTemplatePreviewItem {
  __typename?: "WorkflowTemplatePreviewItem";
  children: Array<ScalarsEnums["String"]>;
  id: ScalarsEnums["ID"];
  name: ScalarsEnums["String"];
  nodeType: ScalarsEnums["String"];
  owner?: Maybe<ScalarsEnums["String"]>;
  parents: Array<ScalarsEnums["String"]>;
  processTypeId?: Maybe<ScalarsEnums["String"]>;
  status: ScalarsEnums["Int"];
}

export interface WorkflowTemplatePreviewWorkflowType {
  __typename?: "WorkflowTemplatePreviewWorkflowType";
  id?: Maybe<ScalarsEnums["ID"]>;
  name?: Maybe<ScalarsEnums["String"]>;
}

/**
 * description=A manufacturing workflow definition made up of ordered process steps.
 * displayName=Workflow Type
 * module=Manufacturing
 * defaultQuery=workflowTypes
 * iconName=data-lineage
 * colour=#A96500
 * aggregateQuery=workflowTypesAggregate
 * grouping=true
 * queryPermission=Query_Workflow_Types
 */
export interface WorkflowType {
  __typename?: "WorkflowType";
  /**
   * sortable=true
   * groupable=true
   */
  created: ScalarsEnums["DateTime"];
  /**
   * sortable=false
   * groupable=false
   */
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<Array<Maybe<CustomData>>>;
  /**
   * sortable=true
   * groupable=false
   */
  deleted: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=false
   */
  description?: Maybe<ScalarsEnums["String"]>;
  /**
   * sortable=true
   * groupable=false
   */
  id: ScalarsEnums["ID"];
  /**
   * sortable=true
   * groupable=false
   */
  label: ScalarsEnums["String"];
  /**
   * sortable=true
   * groupable=false
   */
  master: ScalarsEnums["Boolean"];
  /**
   * sortable=true
   * groupable=true
   */
  modified: ScalarsEnums["DateTime"];
  /**
   * sortable=true
   * groupable=false
   */
  name: ScalarsEnums["String"];
}

/**
 * description=A manufacturing workflow definition made up of ordered process steps.
 */
export interface WorkflowTypeAggregate {
  __typename?: "WorkflowTypeAggregate";
  count: ScalarsEnums["Int"];
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
  }) => Maybe<CustomDataAggregate>;
  groups: (args: {
    by: ResourceGroupByInput;
    /**
     * @defaultValue `100`
     */
    limit?: Maybe<ScalarsEnums["Int"]>;
    /**
     * @defaultValue `0`
     */
    offset?: Maybe<ScalarsEnums["Int"]>;
  }) => ResourceGroupPage;
}

/**
 * WorkflowType
 */
export interface WorkflowTypeCreatedEvent {
  __typename?: "WorkflowTypeCreatedEvent";
  workflowTypeId: ScalarsEnums["String"];
  workflowTypeName: ScalarsEnums["String"];
}

/**
 * WorkflowType
 */
export interface WorkflowTypeDeletedEvent {
  __typename?: "WorkflowTypeDeletedEvent";
  workflowTypeId: ScalarsEnums["String"];
  workflowTypeName: ScalarsEnums["String"];
}

/**
 * WorkflowType
 */
export interface WorkflowTypeRestoredEvent {
  __typename?: "WorkflowTypeRestoredEvent";
  workflowTypeId: ScalarsEnums["String"];
  workflowTypeName: ScalarsEnums["String"];
}

/**
 * WorkflowType
 */
export interface WorkflowTypeUpdatedEvent {
  __typename?: "WorkflowTypeUpdatedEvent";
  workflowTypeId: ScalarsEnums["String"];
  workflowTypeName: ScalarsEnums["String"];
}

export interface Mutation {
  __typename?: "Mutation";
  acceptQuote: (args: { input: AcceptQuoteInput }) => Maybe<ScalarsEnums["ID"]>;
  activatePerson: (args: {
    personId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  amendPurchaseOrder: (args: {
    input: AmendPurchaseOrderInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  assignBusinessRolesToBatchSchedule: (args: {
    input: AssignBusinessRolesToBatchScheduleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  assignBusinessRolesToPerson: (args: {
    input: AssignBusinessRolesToPersonInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  assignInheritanceToRole: (args: {
    input: AssignInheritanceToRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  assignLeadsToSalesperson: (args: {
    input: AssignLeadsToSalespersonInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  assignPermissionsToRole: (args: {
    input: AssignPermissionsToRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  assignPermissionsToUser: (args: {
    input: AssignPermissionsToUserInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  assignRolesToUser: (args: {
    input: AssignRolesToUserInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  assignScreensToRole: (args: {
    input: AssignScreensToRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  assignScreensToUser: (args: {
    input: AssignScreensToUserInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  assignUsersToProcessInstance: (args: {
    processInstanceId: ScalarsEnums["ID"];
    userRoles: Array<ScalarsEnums["ID"]>;
  }) => ScalarsEnums["String"];
  assignUsersToRole: (args: {
    input: AssignUsersToRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  bulkCreatePurchaseOrder: (args: {
    orders: Array<CreatePurchaseOrderInput>;
    /**
     * @defaultValue `false`
     */
    place?: Maybe<ScalarsEnums["Boolean"]>;
  }) => Array<ScalarsEnums["ID"]>;
  bulkProductImport: (args: {
    productsToImport: Array<ProductImportInput>;
    updateFields: Array<ProductImportUpdateField>;
  }) => Maybe<ScalarsEnums["String"]>;
  bulkProductPriceAdjustment: (args: {
    productIds: Array<ScalarsEnums["ID"]>;
  }) => ScalarsEnums["ID"];
  cancelPurchaseOrders: (args: {
    input: CancelPurchaseOrdersInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  cancelSalesOrder: (args: {
    input: CancelSalesOrderInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  cancelSupplierQuoteRequest: (args: {
    input: CancelSupplierQuoteRequestInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  cleanupFiles?: Maybe<ScalarsEnums["Void"]>;
  clearPermissionCache?: Maybe<ScalarsEnums["Boolean"]>;
  commitPendingFiles: (args: {
    input: CommitPendingFilesInput;
  }) => Maybe<ScalarsEnums["String"]>;
  completeTimers: (args: {
    timerIds: Array<ScalarsEnums["ID"]>;
  }) => Maybe<ScalarsEnums["ID"]>;
  confirmSalesOrder: (args: {
    input: ConfirmSalesOrderInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  convertCandidate: (args: {
    id: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  convertLeadToJob: (args: {
    input: ConvertLeadToJobInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createAuthToken: (args: {
    userId: ScalarsEnums["String"];
  }) => ScalarsEnums["String"];
  createBatch: (args: { input: CreateBatchInput }) => Maybe<ScalarsEnums["ID"]>;
  createBranch: (args: {
    input: CreateBranchInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createBuilder: (args: { input: CreateBuilderInput }) => ScalarsEnums["ID"];
  createBusinessRole: (args: {
    input: CreateBusinessRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createCandidate: (args: { input: CreateCandidateInput }) => Maybe<AsyncTask>;
  createClient: (args: {
    input: CreateClientInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createCorrespondence: (args: {
    input: CreateCorrespondenceInput;
  }) => ScalarsEnums["ID"];
  createCosting: (args: {
    input: CreateCostingInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createCostingTemplate: (args: {
    input: CreateCostingTemplateInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createCostingTemplateRevision: (args: {
    input: CreateCostingTemplateRevisionInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createDocumentTemplate: (args: {
    input: CreateDocumentTemplateInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createFiles: (args: {
    files: Array<CreateFileInput>;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  createFirebaseAuthToken: (args: {
    userId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["String"]>;
  createFolder: (args: {
    input: CreateFolderInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createHousingCompany: (args: {
    input: CreateHousingCompanyInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createHousingCompanyImage: (args: {
    input: CreateHousingCompanyImageInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createIssue: (args: { input: CreateIssueInput }) => Maybe<ScalarsEnums["ID"]>;
  createJob: (args: {
    input: CreateJobInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  createJobComponent: (args: {
    input: CreateJobComponentInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createJobEmail: (args: { input: CreateJobEmailInput }) => ScalarsEnums["ID"];
  createJobFileUrl: (args: {
    jobId: ScalarsEnums["ID"];
  }) => ScalarsEnums["String"];
  createLead: (args: { input: CreateLeadInput }) => Maybe<ScalarsEnums["ID"]>;
  createLineItem: (args: {
    input: CreateLineItemInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createLostReason: (args: {
    input: CreateLostReasonInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createPanel: (args: { input: CreatePanelInput }) => Maybe<ScalarsEnums["ID"]>;
  createPartType: (args: {
    input: CreatePartTypeInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createPerson: (args: {
    input: CreatePersonInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createProcessAsset: (args: {
    assetId: ScalarsEnums["ID"];
    processInstanceId: ScalarsEnums["ID"];
  }) => ScalarsEnums["String"];
  createProcessTimer: (args: {
    input: CreateProcessTimerInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createProcessType: (args: {
    input: CreateProcessTypeInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createProcessTypeNote: (args: {
    input: CreateProcessTypeNoteInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createProcessTypeRole: (args: {
    input: CreateProcessTypeRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createProduct: (args: {
    input: CreateProductInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createProductCategory: (args: {
    input: CreateProductCategoryInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createProductPrice: (args: {
    input: CreateProductPriceInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createProject: (args: { input: CreateProjectInput }) => ScalarsEnums["ID"];
  createPurchaseOrder: (args: {
    /**
     * @defaultValue `false`
     */
    place?: Maybe<ScalarsEnums["Boolean"]>;
    purchaseOrder: CreatePurchaseOrderInput;
  }) => Maybe<PurchaseOrderSavePayload>;
  createPurchaseOrderFromSupplierQuote: (args: {
    input: CreatePurchaseOrderFromSupplierQuoteInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createPurchaseOrderReceipt: (args: {
    input: CreatePurchaseOrderReceiptInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createQuote: (args: { input: CreateQuoteInput }) => Maybe<ScalarsEnums["ID"]>;
  createQuoteApprovalRequest: (args: {
    input: CreateQuoteApprovalRequestInput;
  }) => ScalarsEnums["ID"];
  createQuoteTemplate: (args: {
    input: CreateQuoteTemplateInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createQuoteTemplateRevision: (args: {
    input: CreateQuoteTemplateRevisionInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createRecordFile: (args: {
    input: CreateRecordFileInput;
  }) => ScalarsEnums["ID"];
  createRole: (args: { input: CreateRoleInput }) => Maybe<ScalarsEnums["ID"]>;
  createSalesOrder: (args: {
    input: CreateSalesOrderInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createSchema: (args: { input: CreateSchemaInput }) => ScalarsEnums["ID"];
  createSchemaVersion: (args: {
    input: SchemaVersionInput;
  }) => ScalarsEnums["ID"];
  createScreen: (args: {
    input: CreateScreenInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createSignedUploadUrl: (args: {
    input: CreateSignedUploadUrlInput;
  }) => Maybe<SignedUploadUrlPayload>;
  createSpecification: (args: {
    lineItemId: ScalarsEnums["ID"];
  }) => ScalarsEnums["ID"];
  createStorageConnection: (args: {
    input: CreateStorageConnectionInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createStorageResourceMapping: (args: {
    input: CreateStorageResourceMappingInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createSubscription: (args: {
    input: CreateSubscriptionInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createSupplier: (args: {
    input: CreateSupplierInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createSupplierImage: (args: {
    input: CreateSupplierImageInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createSupplierQuote: (args: {
    input: CreateSupplierQuoteInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createSupplierQuoteRequest: (args: {
    input: CreateSupplierQuoteRequestInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  createTag: (args: { input: CreateTagInput }) => Maybe<ScalarsEnums["ID"]>;
  createUser: (args: { input: CreateUserInput }) => Maybe<ScalarsEnums["ID"]>;
  createUserIdentity: (args: {
    input: CreateUserIdentityInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createWarehouse: (args: {
    input: CreateWarehouseInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createWebhook: (args: {
    input: CreateWebhookInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  createWorkflowType: (args: {
    input: CreateWorkflowTypeInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  deactivatePerson: (args: {
    input: DeactivatePersonInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteBatches: (args: {
    input: DeleteBatchesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteBranches: (args: {
    input: DeleteBranchesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteBuilders: (args: {
    input: DeleteBuildersInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteBusinessRole: (args: {
    businessRoleId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteCandidate: (args: { id: ScalarsEnums["ID"] }) => ScalarsEnums["ID"];
  deleteClients: (args: {
    input: DeleteClientsInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteConfiguredLinkedActions: (args: {
    input: DeleteConfiguredLinkedActionsInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteCorrespondence: (args: {
    input: DeleteCorrespondenceInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteCosting: (args: {
    input: DeleteCostingInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteCustomData: (args: { id: ScalarsEnums["ID"] }) => ScalarsEnums["ID"];
  deleteDocumentTemplate: (args: {
    documentTemplateId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteDraftPurchaseOrders: (args: {
    input: DeleteDraftPurchaseOrdersInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteExternalStorageItems: (args: {
    input: DeleteExternalStorageItemsInput;
  }) => Maybe<ScalarsEnums["Boolean"]>;
  deleteFavouriteLinkedAction: (args: {
    id: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteHousingCompanies: (args: {
    input: DeleteHousingCompaniesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteHousingCompanyImage: (args: {
    input: DeleteHousingCompanyImageInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteJobComponent: (args: {
    input: DeleteJobComponentInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteLeads: (args: {
    input: DeleteLeadsInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteLineItems: (args: {
    input: DeleteLineItemsInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteLostReasons: (args: {
    input: DeleteLostReasonsInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deletePanels: (args: {
    input: DeletePanelsInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deletePartTypes: (args: {
    input: DeletePartTypesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteProcessTypeNote: (args: {
    input: DeleteProcessTypeNoteInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteProcessTypeRoles: (args: {
    input: DeleteProcessTypeRolesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteProcessTypes: (args: {
    input: DeleteProcessTypesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteProductCategories: (args: {
    input: DeleteProductCategoriesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteProductPrices: (args: {
    input: DeleteProductPricesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteQuote: (args: { id: ScalarsEnums["ID"] }) => Maybe<ScalarsEnums["ID"]>;
  deleteRecordFiles: (args: {
    input: DeleteRecordFilesInput;
  }) => Maybe<ScalarsEnums["Void"]>;
  deleteRole: (args: { id: ScalarsEnums["ID"] }) => Maybe<ScalarsEnums["ID"]>;
  deleteSalesOrder: (args: {
    input: DeleteSalesOrderInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteSchema: (args: { id: ScalarsEnums["ID"] }) => ScalarsEnums["ID"];
  deleteSchemaVersion: (args: { id: ScalarsEnums["ID"] }) => ScalarsEnums["ID"];
  deleteScreens: (args: {
    input: DeleteScreensInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteStorageConnection: (args: {
    id: ScalarsEnums["ID"];
  }) => ScalarsEnums["ID"];
  deleteStorageResourceMapping: (args: {
    id: ScalarsEnums["ID"];
  }) => ScalarsEnums["ID"];
  deleteSubscription: (args: {
    subscriptionId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteSupplierImage: (args: {
    input: DeleteSupplierImageInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteSupplierQuote: (args: {
    input: DeleteSupplierQuoteInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteSupplierQuoteRequest: (args: {
    input: DeleteSupplierQuoteRequestInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteSuppliers: (args: {
    input: DeleteSuppliersInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteTag: (args: { id: ScalarsEnums["ID"] }) => Maybe<ScalarsEnums["ID"]>;
  deleteUser: (args: {
    userId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteUserIdentities: (args: {
    input: DeleteUserIdentitiesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteWarehouse: (args: {
    id: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  deleteWebhooks: (args: {
    input: DeleteWebhooksInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  deleteWorkflowTypes: (args: {
    input: DeleteWorkflowTypesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  disableUser: (args: {
    userId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  enableUser: (args: {
    userId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  generateCurrentProductPricing?: Maybe<ScalarsEnums["Boolean"]>;
  issueQuote: (args: { input: IssueQuoteInput }) => Maybe<ScalarsEnums["ID"]>;
  markJobLost: (args: { input: MarkJobLostInput }) => Maybe<ScalarsEnums["ID"]>;
  markLeadLost: (args: {
    input: MarkLeadLostInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  markPurchaseOrderInvoiceAsChecked: (args: {
    purchaseOrderId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  markPurchaseOrderInvoiceAsUnchecked: (args: {
    purchaseOrderId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  notifyJobPhotoRecipients: (args: {
    area: ScalarsEnums["String"];
    jobNumber: ScalarsEnums["String"];
    notes?: Maybe<ScalarsEnums["String"]>;
  }) => ScalarsEnums["Boolean"];
  overrideLeadStatus: (args: {
    input: OverrideLeadStatusInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  overridePurchaseOrderStatus: (args: {
    input: OverridePurchaseOrderStatusInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  pauseTimers: (args: {
    timerIds: Array<ScalarsEnums["ID"]>;
  }) => Maybe<ScalarsEnums["ID"]>;
  promoteSchemaVersion: (args: {
    input: PromoteSchemaVersionInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  publishDraftCostingRevision: (args: {
    costingId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  publishDraftCostingTemplate: (args: {
    costingTemplateId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  publishDraftQuoteTemplate: (args: {
    quoteTemplateId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  /**
   * Supported for ONLY receiving product stock to a warehouse,
   * if you want to bulk update (e.g adding/removing) then use the transferstock or
   * stocktake endpoints.
   */
  receiveWarehouseStock: (args: {
    input: ReceiveWarehouseStockInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  releasePurchaseOrders: (args: {
    input: ReleasePurchaseOrdersInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  removeProcessAsset: (args: {
    assetId: ScalarsEnums["ID"];
    processInstanceId: ScalarsEnums["ID"];
  }) => ScalarsEnums["String"];
  rescheduleBatches: (args: {
    input: RescheduleBatchesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  rescheduleProcessTypeNote: (args: {
    date: ScalarsEnums["String"];
    processTypeNoteId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  resendPurchaseOrderSupplierNotification: (args: {
    id: ScalarsEnums["ID"];
  }) => Maybe<AsyncTask>;
  resetUserPassword: (args: {
    input: ResetUserPasswordInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  restorePartTypes: (args: {
    input: RestorePartTypesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  restoreProcessTypes: (args: {
    input: RestoreProcessTypesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  restoreWorkflowTypes: (args: {
    input: RestoreWorkflowTypesInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  resumeTimers: (args: {
    timerIds: Array<ScalarsEnums["ID"]>;
  }) => Maybe<ScalarsEnums["ID"]>;
  reviseQuote: (args: { input: ReviseQuoteInput }) => Maybe<ScalarsEnums["ID"]>;
  screenAssignment: (args: {
    input: ScreenAssignmentInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  screenUnassignment: (args: {
    input: ScreenUnassignmentInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  setCandidateIngestionPolicy: (args: {
    input: SetCandidateIngestionPolicyInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  setConfiguredLinkedAction: (args: {
    input: SetConfiguredLinkedActionInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  setCustomData: (args: { input: SetCustomDataInput }) => ScalarsEnums["ID"];
  setDefaultCostingTemplate: (args: {
    costingTemplateId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  setDefaultDocumentTemplate: (args: {
    documentTemplateId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  setDefaultFolder: (args: {
    input: SetDefaultFolderInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  setDefaultQuoteTemplate: (args: {
    quoteTemplateId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  setFavouriteLinkedAction: (args: {
    input: SetFavouriteLinkedActionInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  setLinkedActionRecipient: (args: {
    input: SetLinkedActionRecipientInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  setUserPin: (args: { input: SetUserPinInput }) => Maybe<ScalarsEnums["ID"]>;
  submitPurchaseOrderReview: (args: {
    input: SubmitPurchaseOrderReviewInput;
  }) => ScalarsEnums["ID"];
  submitQuoteForApproval: (args: {
    id: ScalarsEnums["ID"];
  }) => ScalarsEnums["ID"];
  transferWarehouseStock: (args: {
    input: TransferWarehouseStockInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  triggerWebhook: (args: {
    input: TriggerWebhookInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  unassignBusinessRolesFromPerson: (args: {
    input: UnassignBusinessRolesFromPersonInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  unassignInheritanceFromRole: (args: {
    input: UnassignInheritanceFromRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  unassignLeadsFromSalesperson: (args: {
    input: UnassignLeadsFromSalespersonInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  unassignPermissionsFromRole: (args: {
    input: UnassignPermissionsFromRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  unassignPermissionsFromUser: (args: {
    input: UnassignPermissionsFromUserInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  unassignRolesFromUser: (args: {
    input: UnassignRolesFromUserInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  unassignScreensFromRole: (args: {
    input: UnassignScreensFromRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  unassignScreensFromUser: (args: {
    input: UnassignScreensFromUserInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  unassignUsersFromRole: (args: {
    input: UnassignUsersFromRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  unmarkJobLost: (args: {
    input: UnmarkJobLostInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  unmarkLeadLost: (args: {
    input: UnmarkLeadLostInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  unsetUserPin: (args: {
    userId: ScalarsEnums["ID"];
  }) => Maybe<ScalarsEnums["ID"]>;
  updateBatchDetails: (args: {
    input: UpdateBatchDetailsInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateBranch: (args: {
    input: UpdateBranchInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateBuilder: (args: {
    input: UpdateBuilderInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateBusinessRole: (args: {
    input: UpdateBusinessRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateClient: (args: {
    input: UpdateClientInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateCorrespondence: (args: {
    input: UpdateCorrespondenceInput;
  }) => ScalarsEnums["ID"];
  updateCosting: (args: {
    input: UpdateCostingInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateCurrentUserNotifications: (args: {
    action: NotificationAction;
    ids: Array<ScalarsEnums["ID"]>;
  }) => ScalarsEnums["Boolean"];
  updateDocumentTemplate: (args: {
    input: UpdateDocumentTemplateInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateDraftCostingTemplateRevision: (args: {
    input: CreateCostingTemplateRevisionInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateDraftPurchaseOrder: (args: {
    /**
     * @defaultValue `false`
     */
    place?: Maybe<ScalarsEnums["Boolean"]>;
    purchaseOrder: UpdateDraftPurchaseOrderInput;
    purchaseOrderId: ScalarsEnums["ID"];
  }) => Maybe<PurchaseOrderSavePayload>;
  updateDraftQuoteTemplateRevision: (args: {
    input: CreateQuoteTemplateRevisionInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateDraftSchemaVersion: (args: {
    input: UpdateDraftSchemaVersionInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateHousingCompany: (args: {
    input: UpdateHousingCompanyInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateIssue: (args: { input: UpdateIssueInput }) => Maybe<ScalarsEnums["ID"]>;
  updateJobBuilder: (args: {
    input: UpdateJobBuilderInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateJobClient: (args: {
    input: UpdateJobClientInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateJobComponent: (args: {
    input: UpdateJobComponentInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateJobDetails: (args: {
    input: UpdateJobDetailsInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateJobNote: (args: {
    input: UpdateJobNoteInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateJobSite: (args: {
    input: UpdateJobSiteInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateLead: (args: { input: UpdateLeadInput }) => Maybe<ScalarsEnums["ID"]>;
  updateLineItem: (args: {
    input: UpdateLineItemInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateLineItemWorkflow: (args: {
    input: UpdateLineItemWorkflowInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateLostReason: (args: {
    input: UpdateLostReasonInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updatePanelConfig: (args: {
    input: UpdatePanelConfigInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updatePanelDetails: (args: {
    input: UpdatePanelDetailsInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updatePartType: (args: {
    input: UpdatePartTypeInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updatePermissionForRole: (args: {
    input: UpdatePermissionForRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updatePermissionForUser: (args: {
    input: UpdatePermissionForUserInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updatePerson: (args: {
    input: UpdatePersonInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateProcessInstanceDetails: (args: {
    input: UpdateProcessInstanceDetailsInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateProcessInstanceStatus: (args: {
    input: UpdateProcessInstanceStatusInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateProcessTypeDetails: (args: {
    input: UpdateProcessTypeDetailsInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateProcessTypeNote: (args: {
    input: UpdateProcessTypeNoteInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateProcessTypeRole: (args: {
    input: UpdateProcessTypeRoleInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateProductCategory: (args: {
    input: UpdateProductCategoryInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateProductDetails: (args: {
    input: UpdateProductDetailsInput;
  }) => Maybe<Array<ScalarsEnums["ID"]>>;
  updatePurchaseOrderInternalComment: (args: {
    input: UpdatePurchaseOrderInternalCommentInput;
  }) => ScalarsEnums["ID"];
  updateQuote: (args: { input: UpdateQuoteInput }) => Maybe<ScalarsEnums["ID"]>;
  updateRoleDetails: (args: {
    input: UpdateRoleDetailsInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateSalesOrder: (args: {
    input: UpdateSalesOrderInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateSchemaDetails: (args: {
    input: UpdateSchemaDetailsInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateScreenConfig: (args: {
    input: UpdateScreenConfigInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateScreenDetails: (args: {
    input: UpdateScreenDetailsInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateSettings: (args: { input: UpdateSettingsInput }) => ScalarsEnums["ID"];
  updateStorageConnection: (args: {
    input: UpdateStorageConnectionInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateStorageResourceMapping: (args: {
    input: UpdateStorageResourceMappingInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateSubscription: (args: {
    input: UpdateSubscriptionInput;
  }) => ScalarsEnums["Boolean"];
  updateSupplierDetails: (args: {
    input: UpdateSupplierDetailsInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateSupplierQuote: (args: {
    input: UpdateSupplierQuoteInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateSupplierQuoteRequest: (args: {
    input: UpdateSupplierQuoteRequestInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateSupplierReviewers: (args: {
    input: UpdateSupplierReviewersInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateTag: (args: { input: UpdateTagInput }) => Maybe<ScalarsEnums["ID"]>;
  updateUserDetails: (args: {
    input: UpdateUserDetailsInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateUserSubscriptions: (args: {
    input: UpdateUserSubscriptionsInput;
  }) => ScalarsEnums["Boolean"];
  updateWarehouse: (args: {
    input: UpdateWarehouseInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateWebhook: (args: {
    input: UpdateWebhookInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  updateWorkflowTypeDetails: (args: {
    input: UpdateWorkflowTypeDetailsInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  warehouseStockTake: (args: {
    input: WarehouseStockTakeInput;
  }) => Maybe<ScalarsEnums["ID"]>;
  /**
   * Supported for withdrawing product stock from a warehouse,
   * if you want to bulk update then use the transferstock or
   * stocktake endpoints.
   */
  withdrawWarehouseStock: (args: {
    input: WithdrawWarehouseStockInput;
  }) => Maybe<ScalarsEnums["ID"]>;
}

export interface Query {
  __typename?: "Query";
  actAsUser: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<ActAsUser>;
  actAsUsers: (args?: {
    filter?: Maybe<ActAsUserFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ActAsUser>>;
  actAsUsersAggregate: (args?: {
    filter?: Maybe<ActAsUserFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ActAsUserAggregate>;
  asset: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Asset>;
  assets: (args?: {
    filter?: Maybe<AssetFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Asset>>;
  assetsAggregate: (args?: {
    filter?: Maybe<AssetFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<AssetAggregate>;
  assignedPermissions: (args: {
    assignedId: ScalarsEnums["ID"];
    assignedType: ScalarsEnums["String"];
    filter?: Maybe<AssignedPermissionFilterInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<AssignedPermission>>;
  asyncTask: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<AsyncTask>;
  asyncTasks: (args?: {
    filter?: Maybe<AsyncTaskFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<AsyncTask>>;
  asyncTasksAggregate: (args?: {
    filter?: Maybe<AsyncTaskFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<AsyncTaskAggregate>;
  attachmentTemplate: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<AttachmentTemplate>;
  attachmentTemplates: (args?: {
    filter?: Maybe<AttachmentTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<AttachmentTemplate>>;
  attachmentTemplatesAggregate: (args?: {
    filter?: Maybe<AttachmentTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<AttachmentTemplateAggregate>;
  auditLog: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<AuditLog>;
  auditLogs: (args?: {
    filter?: Maybe<AuditLogFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<AuditLog>>;
  auditLogsAggregate: (args?: {
    filter?: Maybe<AuditLogFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ResourceAggregate>;
  batch: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Batch>;
  batchSchedule: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<BatchSchedule>;
  batchScheduleReport: (args: {
    groupBy: Array<BatchScheduleReportGroupByInput>;
  }) => Maybe<Array<BatchScheduleReportRow>>;
  batchSchedules: (args?: {
    filter?: Maybe<BatchScheduleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<BatchSchedule>>;
  batchSchedulesAggregate: (args?: {
    filter?: Maybe<BatchScheduleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<BatchScheduleAggregate>;
  batches: (args?: {
    filter?: Maybe<BatchFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Batch>>;
  batchesAggregate: (args?: {
    filter?: Maybe<BatchFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<BatchAggregate>;
  billOfMaterialsImport: (args: {
    jobId: ScalarsEnums["ID"];
    loader: ScalarsEnums["ID"];
    path: ScalarsEnums["String"];
  }) => Maybe<BillOfMaterialsImport>;
  branch: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Branch>;
  branches: (args?: {
    filter?: Maybe<BranchFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Branch>>;
  branchesAggregate: (args?: {
    filter?: Maybe<BranchFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<BranchAggregate>;
  buildType: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<BuildType>;
  buildTypes: (args?: {
    filter?: Maybe<BuildTypeFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<BuildType>>;
  buildTypesAggregate: (args?: {
    filter?: Maybe<BuildTypeFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<BuildTypeAggregate>;
  builder: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Builder>;
  builders: (args?: {
    filter?: Maybe<BuilderFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Builder>>;
  buildersAggregate: (args?: {
    filter?: Maybe<BuilderFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<BuilderAggregate>;
  businessRole: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<BusinessRole>;
  businessRoles: (args?: {
    filter?: Maybe<BusinessRoleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<BusinessRole>>;
  businessRolesAggregate: (args?: {
    filter?: Maybe<BusinessRoleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<BusinessRoleAggregate>;
  calculateQuote: (args: { input: CalculateQuoteInput }) => Maybe<Quote>;
  candidate: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Candidate>;
  candidateIngestionPolicies: (args?: {
    filter?: Maybe<CandidateIngestionPolicyFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<CandidateIngestionPolicy>>;
  candidateIngestionPoliciesAggregate: (args?: {
    filter?: Maybe<CandidateIngestionPolicyFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CandidateIngestionPolicyAggregate>;
  candidateIngestionPolicy: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<CandidateIngestionPolicy>;
  candidates: (args?: {
    filter?: Maybe<CandidateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Candidate>>;
  candidatesAggregate: (args?: {
    filter?: Maybe<CandidateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CandidateAggregate>;
  client: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Client>;
  clients: (args?: {
    filter?: Maybe<ClientFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Client>>;
  clientsAggregate: (args?: {
    filter?: Maybe<ClientFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ClientAggregate>;
  configuredLinkedAction: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ConfiguredLinkedAction>;
  configuredLinkedActions: (args?: {
    filter?: Maybe<ConfiguredLinkedActionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ConfiguredLinkedAction>>;
  configuredLinkedActionsAggregate: (args?: {
    filter?: Maybe<ConfiguredLinkedActionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ConfiguredLinkedActionAggregate>;
  correspondence: (args?: {
    filter?: Maybe<CorrespondenceFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Correspondence>>;
  correspondenceAggregate: (args?: {
    filter?: Maybe<CorrespondenceFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CorrespondenceAggregate>;
  correspondenceRecord: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<Correspondence>;
  costing: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Costing>;
  costingLine: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<CostingLine>;
  costingLineTemplate: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<CostingLineTemplate>;
  costingLineTemplates: (args?: {
    filter?: Maybe<CostingLineTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<CostingLineTemplate>>;
  costingLineTemplatesAggregate: (args?: {
    filter?: Maybe<CostingLineTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CostingLineTemplateAggregate>;
  costingLines: (args?: {
    filter?: Maybe<CostingLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<CostingLine>>;
  costingLinesAggregate: (args?: {
    filter?: Maybe<CostingLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CostingLineAggregate>;
  costingRevision: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<CostingRevision>;
  costingRevisions: (args?: {
    filter?: Maybe<CostingRevisionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<CostingRevision>>;
  costingRevisionsAggregate: (args?: {
    filter?: Maybe<CostingRevisionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CostingRevisionAggregate>;
  costingTemplate: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<CostingTemplate>;
  costingTemplateExpression: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<CostingTemplateExpression>;
  costingTemplateExpressions: (args?: {
    filter?: Maybe<CostingTemplateExpressionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<CostingTemplateExpression>>;
  costingTemplateExpressionsAggregate: (args?: {
    filter?: Maybe<CostingTemplateExpressionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CostingTemplateExpressionAggregate>;
  costingTemplateRevision: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<CostingTemplateRevision>;
  costingTemplateRevisions: (args?: {
    filter?: Maybe<CostingTemplateRevisionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<CostingTemplateRevision>>;
  costingTemplateRevisionsAggregate: (args?: {
    filter?: Maybe<CostingTemplateRevisionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CostingTemplateRevisionAggregate>;
  costingTemplates: (args?: {
    filter?: Maybe<CostingTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<CostingTemplate>>;
  costingTemplatesAggregate: (args?: {
    filter?: Maybe<CostingTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CostingTemplateAggregate>;
  costings: (args?: {
    filter?: Maybe<CostingFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Costing>>;
  costingsAggregate: (args?: {
    filter?: Maybe<CostingFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CostingAggregate>;
  currentUser?: Maybe<User>;
  currentUserNotifications?: Maybe<Array<UserNotification>>;
  customData: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<CustomData>>;
  customDataAggregate: (args?: {
    filter?: Maybe<CustomDataFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CustomDataAggregate>;
  customDataById: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<CustomData>;
  customTemplate: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<CustomTemplate>;
  customTemplates: (args?: {
    filter?: Maybe<CustomTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<CustomTemplate>>;
  customTemplatesAggregate: (args?: {
    filter?: Maybe<CustomTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<CustomTemplateAggregate>;
  days: (args?: { filter?: Maybe<DateTimeFilterInput> }) => Maybe<Array<Day>>;
  defaultFolder: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<DefaultFolder>;
  defaultFolders: (args?: {
    filter?: Maybe<DefaultFolderFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<DefaultFolder>>;
  defaultFoldersAggregate: (args?: {
    filter?: Maybe<DefaultFolderFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<DefaultFolderAggregate>;
  deliveryAddress: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<DeliveryAddress>;
  deliveryAddresses: (args?: {
    filter?: Maybe<DeliveryAddressFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<DeliveryAddress>>;
  deliveryAddressesAggregate: (args?: {
    filter?: Maybe<DeliveryAddressFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<DeliveryAddressAggregate>;
  documentNavigationRecords: (args: {
    recordId: ScalarsEnums["String"];
    recordType: ScalarsEnums["String"];
  }) => Maybe<Array<RecordNavigationRecord>>;
  documentPreview: (args: {
    input: GetDocumentPreviewInput;
  }) => Maybe<DocumentPreview>;
  documentTemplate: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<DocumentTemplate>;
  documentTemplates: (args?: {
    filter?: Maybe<DocumentTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<DocumentTemplate>>;
  documentTemplatesAggregate: (args?: {
    filter?: Maybe<DocumentTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<DocumentTemplateAggregate>;
  domainEventTypes?: Maybe<Array<ScalarsEnums["DomainEventType"]>>;
  effectiveUserPermissions: (args: {
    userId: ScalarsEnums["ID"];
  }) => Maybe<Array<EffectivePermission>>;
  email: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Email>;
  emails: (args?: {
    filter?: Maybe<EmailFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Email>>;
  emailsAggregate: (args?: {
    filter?: Maybe<EmailFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<EmailAggregate>;
  eventDescriptionPreview: (args: {
    eventName: ScalarsEnums["String"];
  }) => Maybe<ScalarsEnums["String"]>;
  externalStorageConnection: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ExternalStorageConnection>;
  externalStorageConnections: (args?: {
    filter?: Maybe<ExternalStorageConnectionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ExternalStorageConnection>>;
  externalStorageConnectionsAggregate: (args?: {
    filter?: Maybe<ExternalStorageConnectionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ExternalStorageConnectionAggregate>;
  externalStorageItem: (args: {
    id: ScalarsEnums["String"];
  }) => Maybe<ExternalStorageItem>;
  /**
   * aggregateQuery=externalStorageItemsAggregate
   * grouping=true
   */
  externalStorageItems: (args?: {
    filter?: Maybe<ExternalStorageItemFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    id?: Maybe<ScalarsEnums["String"]>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ExternalStorageItem>>;
  externalStorageItemsAggregate: (args?: {
    filter?: Maybe<ExternalStorageItemFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    id?: Maybe<ScalarsEnums["String"]>;
  }) => Maybe<ResourceAggregate>;
  externalStorageResourceMapping: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ExternalStorageResourceMapping>;
  externalStorageResourceMappings: (args?: {
    filter?: Maybe<ExternalStorageResourceMappingFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ExternalStorageResourceMapping>>;
  externalStorageResourceMappingsAggregate: (args?: {
    filter?: Maybe<ExternalStorageResourceMappingFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ExternalStorageResourceMappingAggregate>;
  file: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<File>;
  fileAggregates: (args?: {
    filter?: Maybe<FileFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<FileAggregate>;
  /**
   * TODO: Return an operation along with the file info eg "NEW" or "DELETED"
   *  so that our frontend can show pending changes to the user.
   * Would therefore need to return a slightly modified ExternalStorageItem.
   * Returns a list of files in targetPath as if changeset was applied.
   * Only supports native (Google Cloud) storage, no resource mappings.
   * $path must be of format {resourceType}/{resourceId}/{restOfPath...}
   */
  fileChangeset: (args: {
    filter?: Maybe<ExternalStorageItemFilterInput>;
    id: ScalarsEnums["ID"];
    targetPath: ScalarsEnums["String"];
  }) => Maybe<Array<ExternalStorageItem>>;
  files: (args?: {
    filter?: Maybe<FileFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<File>>;
  formNavigationRecords: (args: {
    recordId: ScalarsEnums["String"];
    recordType: ScalarsEnums["String"];
  }) => Maybe<Array<RecordNavigationRecord>>;
  googleDownloadFilesRequestUrl: (args: {
    /**
     * Array of file hash strings.
     */
    fileHashes: Array<ScalarsEnums["String"]>;
    firebaseTenantId: ScalarsEnums["String"];
    firebaseUserId: ScalarsEnums["String"];
  }) => Maybe<ScalarsEnums["String"]>;
  googleUploadRequestUrl: (args: {
    object: ScalarsEnums["String"];
  }) => Maybe<ScalarsEnums["String"]>;
  graphqlQueryGen: (args: {
    input: AIGenInput;
  }) => Maybe<ScalarsEnums["String"]>;
  groupTemplate: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<GroupTemplate>;
  groupTemplates: (args?: {
    filter?: Maybe<GroupTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<GroupTemplate>>;
  groupTemplatesAggregate: (args?: {
    filter?: Maybe<GroupTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<GroupTemplateAggregate>;
  housingCompanies: (args?: {
    filter?: Maybe<HousingCompanyFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<HousingCompany>>;
  housingCompaniesAggregate: (args?: {
    filter?: Maybe<HousingCompanyFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<HousingCompanyAggregate>;
  housingCompany: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<HousingCompany>;
  isPermitted: (args: {
    permissions: Array<PermissionCheckInput>;
    userId?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ScalarsEnums["Boolean"]>;
  issue: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Issue>;
  issueCompletionStatuses: (args?: {
    filter?: Maybe<IssueFilterInput>;
  }) => Maybe<Array<IssueCompletionStatus>>;
  issues: (args?: {
    filter?: Maybe<IssueFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Issue>>;
  issuesAggregate: (args?: {
    filter?: Maybe<IssueFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<IssueAggregate>;
  job: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Job>;
  jobComponent: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<JobComponent>;
  jobComponents: (args?: {
    filter?: Maybe<JobComponentFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<JobComponent>>;
  jobComponentsAggregate: (args?: {
    filter?: Maybe<JobComponentFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<JobComponentAggregate>;
  jobReport: (args: {
    groupBy: Array<JobReportGroupByInput>;
  }) => Maybe<Array<JobReportRow>>;
  jobStatuses: (args?: {
    filter?: Maybe<JobStatusFilterInput>;
  }) => Maybe<Array<JobStatus>>;
  jobs: (args?: {
    filter?: Maybe<JobFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Job>>;
  jobsAggregate: (args?: {
    filter?: Maybe<JobFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<JobAggregate>;
  lead: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Lead>;
  leadCandidateGen: (args: {
    input: AIGenInput;
  }) => Maybe<ScalarsEnums["String"]>;
  leadProjectTypes: (args?: {
    filter?: Maybe<LeadFilterInput>;
  }) => Maybe<Array<LeadProjectType>>;
  leadReport: (args: {
    groupBy: Array<LeadReportGroupByInput>;
  }) => Maybe<Array<LeadReportRow>>;
  leadSources: (args?: {
    filter?: Maybe<LeadSourceFilterInput>;
  }) => Maybe<Array<LeadSource>>;
  leadStatuses: (args?: {
    filter?: Maybe<LeadStatusFilterInput>;
  }) => Maybe<Array<LeadStatus>>;
  leads: (args?: {
    filter?: Maybe<LeadFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Lead>>;
  leadsAggregate: (args?: {
    filter?: Maybe<LeadFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<LeadAggregate>;
  legacyUserRole: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<UserRole>;
  legacyUserRoles: (args?: {
    filter?: Maybe<UserRoleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<UserRole>>;
  legacyUserRolesAggregate: (args?: {
    filter?: Maybe<UserRoleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<UserRoleAggregate>;
  lineItem: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<LineItem>;
  lineItemMasterWorkflow: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<LineItemMasterWorkflow>;
  lineItemMasterWorkflows: (args?: {
    filter?: Maybe<LineItemMasterWorkflowFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<LineItemMasterWorkflow>>;
  lineItemMasterWorkflowsAggregate: (args?: {
    filter?: Maybe<LineItemMasterWorkflowFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<LineItemMasterWorkflowAggregate>;
  lineItemReport: (args: {
    groupBy: Array<LineItemReportGroupByInput>;
  }) => Maybe<Array<LineItemReportRow>>;
  lineItems: (args?: {
    filter?: Maybe<LineItemFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<LineItem>>;
  lineItemsAggregate: (args?: {
    filter?: Maybe<LineItemFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<LineItemAggregate>;
  linkedAction: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<LinkedAction>;
  linkedActions: (args?: {
    filter?: Maybe<LinkedActionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<LinkedAction>>;
  linkedActionsAggregate: (args?: {
    filter?: Maybe<LinkedActionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<LinkedActionAggregate>;
  lostReason: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<LostReason>;
  lostReasons: (args?: {
    filter?: Maybe<LostReasonFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<LostReason>>;
  lostReasonsAggregate: (args?: {
    filter?: Maybe<LostReasonFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<LostReasonAggregate>;
  months: (args?: {
    filter?: Maybe<DateTimeFilterInput>;
  }) => Maybe<Array<Month>>;
  notificationTemplate: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<NotificationTemplate>;
  notificationTemplates: (args?: {
    filter?: Maybe<NotificationTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<NotificationTemplate>>;
  notificationTemplatesAggregate: (args?: {
    filter?: Maybe<NotificationTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<NotificationTemplateAggregate>;
  nzRegions: (args?: {
    filter?: Maybe<DateTimeFilterInput>;
  }) => Maybe<Array<NZRegion>>;
  panel: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Panel>;
  panels: (args?: {
    filter?: Maybe<PanelFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Panel>>;
  panelsAggregate: (args?: {
    filter?: Maybe<PanelFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<PanelAggregate>;
  partType: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<PartType>;
  partTypes: (args?: {
    filter?: Maybe<PartTypeFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<PartType>>;
  partTypesAggregate: (args?: {
    filter?: Maybe<PartTypeFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<PartTypeAggregate>;
  people: (args?: {
    filter?: Maybe<PersonFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Person>>;
  peopleAggregate: (args?: {
    filter?: Maybe<PersonFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<PersonAggregate>;
  permissions: (args?: {
    filter?: Maybe<PermissionFilterInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Permission>>;
  permitted: (args: {
    permission: ScalarsEnums["String"];
  }) => Maybe<ScalarsEnums["Boolean"]>;
  person: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Person>;
  personAssignedWork: (args?: {
    filter?: Maybe<PersonAssignedWorkFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<PersonAssignedWork>>;
  personAssignedWorkAggregate: (args?: {
    filter?: Maybe<PersonAssignedWorkFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<PersonAssignedWorkAggregate>;
  personAssignedWorkById: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<PersonAssignedWork>;
  personBusinessRole: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<PersonBusinessRole>;
  personBusinessRoles: (args?: {
    filter?: Maybe<PersonBusinessRoleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<PersonBusinessRole>>;
  personBusinessRolesAggregate: (args?: {
    filter?: Maybe<PersonBusinessRoleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<PersonBusinessRoleAggregate>;
  personStatuses?: Maybe<Array<PersonStatus>>;
  processAsset: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProcessAsset>;
  processAssets: (args?: {
    filter?: Maybe<ProcessAssetFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProcessAsset>>;
  processAssetsAggregate: (args?: {
    filter?: Maybe<ProcessAssetFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProcessAssetAggregate>;
  processAssignment: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProcessAssignment>;
  processAssignments: (args?: {
    filter?: Maybe<ProcessAssignmentFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProcessAssignment>>;
  processAssignmentsAggregate: (args?: {
    filter?: Maybe<ProcessAssignmentFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProcessAssignmentAggregate>;
  processInstance: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProcessInstance>;
  processInstances: (args?: {
    filter?: Maybe<ProcessInstanceFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProcessInstance>>;
  processInstancesAggregate: (args?: {
    filter?: Maybe<ProcessInstanceFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProcessInstanceAggregate>;
  processTemplate: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProcessTemplate>;
  processTemplates: (args?: {
    filter?: Maybe<ProcessTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProcessTemplate>>;
  processTemplatesAggregate: (args?: {
    filter?: Maybe<ProcessTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProcessTemplateAggregate>;
  processTimer: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProcessTimer>;
  processTimerItem: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProcessTimerItem>;
  processTimerItems: (args?: {
    filter?: Maybe<ProcessTimerItemFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProcessTimerItem>>;
  processTimerItemsAggregate: (args?: {
    filter?: Maybe<ProcessTimerItemFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProcessTimerItemAggregate>;
  processType: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProcessType>;
  processTypeNote: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProcessTypeNote>;
  processTypeNotes: (args?: {
    filter?: Maybe<ProcessTypeNoteFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProcessTypeNote>>;
  processTypeNotesAggregate: (args?: {
    filter?: Maybe<ProcessTypeNoteFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProcessTypeNoteAggregate>;
  processTypeRole: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProcessTypeRole>;
  processTypeRoles: (args?: {
    filter?: Maybe<ProcessTypeRoleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProcessTypeRole>>;
  processTypeRolesAggregate: (args?: {
    filter?: Maybe<ProcessTypeRoleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProcessTypeRoleAggregate>;
  processTypes: (args?: {
    filter?: Maybe<ProcessTypeFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProcessType>>;
  processTypesAggregate: (args?: {
    filter?: Maybe<ProcessTypeFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProcessTypeAggregate>;
  product: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Product>;
  productCategories: (args?: {
    filter?: Maybe<ProductCategoryFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProductCategory>>;
  productCategoriesAggregate: (args?: {
    filter?: Maybe<ProductCategoryFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProductCategoryAggregate>;
  productCategory: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProductCategory>;
  productCategoryGroup: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProductCategoryGroup>;
  productCategoryGroups: (args?: {
    filter?: Maybe<ProductCategoryGroupFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProductCategoryGroup>>;
  productCategoryGroupsAggregate: (args?: {
    filter?: Maybe<ProductCategoryGroupFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProductCategoryGroupAggregate>;
  productPrice: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<ProductPrice>;
  productPrices: (args?: {
    filter?: Maybe<ProductPriceFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProductPrice>>;
  productPricesAggregate: (args?: {
    filter?: Maybe<ProductPriceFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProductPriceAggregate>;
  products: (args?: {
    filter?: Maybe<ProductFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Product>>;
  productsAggregate: (args?: {
    filter?: Maybe<ProductFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProductAggregate>;
  project: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Project>;
  projects: (args?: {
    filter?: Maybe<ProjectFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Project>>;
  projectsAggregate: (args?: {
    filter?: Maybe<ProjectFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProjectAggregate>;
  purchaseOrder: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<PurchaseOrder>;
  purchaseOrderEvents: (args?: {
    filter?: Maybe<PurchaseOrderEventFilterInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<PurchaseOrderEvent>>;
  purchaseOrderLine: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<PurchaseOrderLine>;
  purchaseOrderLines: (args?: {
    filter?: Maybe<PurchaseOrderLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<PurchaseOrderLine>>;
  purchaseOrderLinesAggregate: (args?: {
    filter?: Maybe<PurchaseOrderLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<PurchaseOrderLineAggregate>;
  purchaseOrderPreview: (args: {
    purchaseOrderId: ScalarsEnums["ID"];
  }) => Maybe<PurchaseOrderPreview>;
  purchaseOrderReceipt: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<PurchaseOrderReceipt>;
  purchaseOrderReceiptLine: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<PurchaseOrderReceiptLine>;
  purchaseOrderReceiptLines: (args?: {
    filter?: Maybe<PurchaseOrderReceiptLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<PurchaseOrderReceiptLine>>;
  purchaseOrderReceiptLinesAggregate: (args?: {
    filter?: Maybe<PurchaseOrderReceiptLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<PurchaseOrderReceiptLineAggregate>;
  purchaseOrderReceipts: (args?: {
    filter?: Maybe<PurchaseOrderReceiptFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<PurchaseOrderReceipt>>;
  purchaseOrderReceiptsAggregate: (args?: {
    filter?: Maybe<PurchaseOrderReceiptFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<PurchaseOrderReceiptAggregate>;
  purchaseOrderReview: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<PurchaseOrderReview>;
  purchaseOrderReviews: (args?: {
    filter?: Maybe<PurchaseOrderReviewFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<PurchaseOrderReview>>;
  purchaseOrderReviewsAggregate: (args?: {
    filter?: Maybe<PurchaseOrderReviewFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<PurchaseOrderReviewAggregate>;
  purchaseOrderStatuses: (args?: {
    filter?: Maybe<PurchaseOrderStatusFilterInput>;
  }) => Maybe<Array<PurchaseOrderStatus>>;
  purchaseOrders: (args?: {
    filter?: Maybe<PurchaseOrderFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<PurchaseOrder>>;
  purchaseOrdersAggregate: (args?: {
    filter?: Maybe<PurchaseOrderFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<PurchaseOrderAggregate>;
  quote: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Quote>;
  quoteLine: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<QuoteLine>;
  quoteLineTemplate: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<QuoteLineTemplate>;
  quoteLineTemplates: (args?: {
    filter?: Maybe<QuoteLineTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<QuoteLineTemplate>>;
  quoteLineTemplatesAggregate: (args?: {
    filter?: Maybe<QuoteLineTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<QuoteLineTemplateAggregate>;
  quoteLines: (args?: {
    filter?: Maybe<QuoteLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<QuoteLine>>;
  quoteLinesAggregate: (args?: {
    filter?: Maybe<QuoteLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<QuoteLineAggregate>;
  quotePreview: (args: { quote: CreateQuoteInput }) => Maybe<QuotePreview>;
  quoteRevision: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<QuoteRevision>;
  quoteRevisions: (args?: {
    filter?: Maybe<QuoteRevisionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<QuoteRevision>>;
  quoteRevisionsAggregate: (args?: {
    filter?: Maybe<QuoteRevisionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<QuoteRevisionAggregate>;
  quoteStatuses: (args?: {
    filter?: Maybe<QuoteFilterInput>;
  }) => Maybe<Array<QuoteStatus>>;
  quoteTemplate: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<QuoteTemplate>;
  quoteTemplateExpression: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<QuoteTemplateExpression>;
  quoteTemplateExpressions: (args?: {
    filter?: Maybe<QuoteTemplateExpressionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<QuoteTemplateExpression>>;
  quoteTemplateExpressionsAggregate: (args?: {
    filter?: Maybe<QuoteTemplateExpressionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<QuoteTemplateExpressionAggregate>;
  quoteTemplatePreview: (args: {
    costings: ScalarsEnums["String"];
    twigTemplate: ScalarsEnums["String"];
  }) => Maybe<QuoteTemplatePreview>;
  quoteTemplateRevision: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<QuoteTemplateRevision>;
  quoteTemplateRevisions: (args?: {
    filter?: Maybe<QuoteTemplateRevisionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<QuoteTemplateRevision>>;
  quoteTemplateRevisionsAggregate: (args?: {
    filter?: Maybe<QuoteTemplateRevisionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<QuoteTemplateRevisionAggregate>;
  quoteTemplates: (args?: {
    filter?: Maybe<QuoteTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<QuoteTemplate>>;
  quoteTemplatesAggregate: (args?: {
    filter?: Maybe<QuoteTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<QuoteTemplateAggregate>;
  quotes: (args?: {
    filter?: Maybe<QuoteFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Quote>>;
  quotesAggregate: (args?: {
    filter?: Maybe<QuoteFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<QuoteAggregate>;
  recordDocuments: (args: {
    documentTemplateId?: Maybe<ScalarsEnums["ID"]>;
    recordId: ScalarsEnums["ID"];
    recordType: ScalarsEnums["String"];
  }) => Maybe<Array<Document>>;
  recordFile: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<RecordFile>;
  recordFileAggregates: (args?: {
    filter?: Maybe<RecordFileFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<RecordFileAggregate>;
  recordFiles: (args?: {
    filter?: Maybe<RecordFileFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<RecordFile>>;
  recordFolder: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<RecordFolder>;
  recordFolders: (args?: {
    filter?: Maybe<RecordFolderFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<RecordFolder>>;
  recordFoldersAggregate: (args?: {
    filter?: Maybe<RecordFolderFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<RecordFolderAggregate>;
  recordScreen: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<RecordScreen>;
  recordScreens: (args?: {
    filter?: Maybe<RecordScreenFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<RecordScreen>>;
  recordScreensAggregate: (args?: {
    filter?: Maybe<RecordScreenFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<RecordScreenAggregate>;
  recordTag: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<RecordTag>;
  recordTags: (args?: {
    filter?: Maybe<RecordTagFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<RecordTag>>;
  recordTagsAggregate: (args?: {
    filter?: Maybe<RecordTagFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<RecordTagAggregate>;
  recordTypes?: Maybe<Array<ScalarsEnums["RecordType"]>>;
  region: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Region>;
  regions: (args?: {
    filter?: Maybe<RegionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Region>>;
  regionsAggregate: (args?: {
    filter?: Maybe<RegionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<RegionAggregate>;
  resolvedRecordScreen: (args: {
    recordType: ScalarsEnums["String"];
  }) => Maybe<Screen>;
  role: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Role>;
  roleInheritance: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<RoleInheritance>;
  roleInheritances: (args?: {
    filter?: Maybe<RoleInheritanceFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<RoleInheritance>>;
  roleInheritancesAggregate: (args?: {
    filter?: Maybe<RoleInheritanceFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<RoleInheritanceAggregate>;
  rolePermission: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<RolePermission>;
  rolePermissions: (args?: {
    filter?: Maybe<RolePermissionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<RolePermission>>;
  rolePermissionsAggregate: (args?: {
    filter?: Maybe<RolePermissionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<RolePermissionAggregate>;
  roleUser: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<RoleUser>;
  roleUsers: (args?: {
    filter?: Maybe<RoleUserFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<RoleUser>>;
  roleUsersAggregate: (args?: {
    filter?: Maybe<RoleUserFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<RoleUserAggregate>;
  roles: (args?: {
    filter?: Maybe<RoleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Role>>;
  rolesAggregate: (args?: {
    filter?: Maybe<RoleFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<RoleAggregate>;
  saleType: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<SaleType>;
  saleTypes: (args?: {
    filter?: Maybe<SaleTypeFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<SaleType>>;
  saleTypesAggregate: (args?: {
    filter?: Maybe<SaleTypeFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<SaleTypeAggregate>;
  salesOrder: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<SalesOrder>;
  salesOrderLine: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<SalesOrderLine>;
  salesOrderLines: (args?: {
    filter?: Maybe<SalesOrderLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<SalesOrderLine>>;
  salesOrderLinesAggregate: (args?: {
    filter?: Maybe<SalesOrderLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ResourceAggregate>;
  salesOrders: (args?: {
    filter?: Maybe<SalesOrderFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<SalesOrder>>;
  salesOrdersAggregate: (args?: {
    filter?: Maybe<SalesOrderFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<SalesOrderAggregate>;
  schema: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Schema>;
  schemaTypes: (args?: {
    filter?: Maybe<SchemaTypeFilterInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<SchemaType>>;
  schemaVersion: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<SchemaVersion>;
  schemaVersions: (args?: {
    filter?: Maybe<SchemaVersionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<SchemaVersion>>;
  schemaVersionsAggregate: (args?: {
    filter?: Maybe<SchemaVersionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<SchemaVersionAggregate>;
  schemas: (args?: {
    filter?: Maybe<SchemaFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Schema>>;
  schemasAggregate: (args?: {
    filter?: Maybe<SchemaFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<SchemaAggregate>;
  screen: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Screen>;
  screenAssignments: (args?: {
    filter?: Maybe<RecordScreenFilterInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<RecordScreen>>;
  screens: (args?: {
    filter?: Maybe<ScreenFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Screen>>;
  screensAggregate: (args?: {
    filter?: Maybe<ScreenFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ScreenAggregate>;
  specification: (args: { id: ScalarsEnums["ID"] }) => Maybe<Specification>;
  specificationLookupOptions: (args: {
    limit?: Maybe<ScalarsEnums["Int"]>;
    search?: Maybe<ScalarsEnums["String"]>;
    type: ScalarsEnums["String"];
  }) => Maybe<Array<SpecificationLookupOption>>;
  stock: (args?: {
    filter?: Maybe<StockFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Stock>>;
  stockAggregate: (args?: {
    filter?: Maybe<StockFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<StockAggregate>;
  stockRecord: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Stock>;
  stockTransaction: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<StockTransaction>;
  stockTransactionLine: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<StockTransactionLine>;
  stockTransactionLines: (args?: {
    filter?: Maybe<StockTransactionLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<StockTransactionLine>>;
  stockTransactionLinesAggregate: (args?: {
    filter?: Maybe<StockTransactionLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<StockTransactionLineAggregate>;
  stockTransactions: (args?: {
    filter?: Maybe<StockTransactionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<StockTransaction>>;
  stockTransactionsAggregate: (args?: {
    filter?: Maybe<StockTransactionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<StockTransactionAggregate>;
  subscriptionReal: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<SubscriptionReal>;
  subscriptions: (args?: {
    filter?: Maybe<SubscriptionRealFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<SubscriptionReal>>;
  subscriptionsAggregate: (args?: {
    filter?: Maybe<SubscriptionRealFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<SubscriptionRealAggregate>;
  supplier: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Supplier>;
  supplierCategories: (args?: {
    filter?: Maybe<SupplierCategoryFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<SupplierCategory>>;
  supplierCategoriesAggregate: (args?: {
    filter?: Maybe<SupplierCategoryFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<SupplierCategoryAggregate>;
  supplierCategory: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<SupplierCategory>;
  supplierQuote: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<SupplierQuote>;
  supplierQuoteLine: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<SupplierQuoteLine>;
  supplierQuoteLines: (args?: {
    filter?: Maybe<SupplierQuoteLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<SupplierQuoteLine>>;
  supplierQuoteLinesAggregate: (args?: {
    filter?: Maybe<SupplierQuoteLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ResourceAggregate>;
  supplierQuoteRequest: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<SupplierQuoteRequest>;
  supplierQuoteRequestLine: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<SupplierQuoteRequestLine>;
  supplierQuoteRequestLines: (args?: {
    filter?: Maybe<SupplierQuoteRequestLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<SupplierQuoteRequestLine>>;
  supplierQuoteRequestLinesAggregate: (args?: {
    filter?: Maybe<SupplierQuoteRequestLineFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<SupplierQuoteRequestLineAggregate>;
  supplierQuoteRequests: (args?: {
    filter?: Maybe<SupplierQuoteRequestFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<SupplierQuoteRequest>>;
  supplierQuoteRequestsAggregate: (args?: {
    filter?: Maybe<SupplierQuoteRequestFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<SupplierQuoteRequestAggregate>;
  supplierQuotes: (args?: {
    filter?: Maybe<SupplierQuoteFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<SupplierQuote>>;
  supplierQuotesAggregate: (args?: {
    filter?: Maybe<SupplierQuoteFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<SupplierQuoteAggregate>;
  suppliers: (args?: {
    filter?: Maybe<SupplierFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Supplier>>;
  suppliersAggregate: (args?: {
    filter?: Maybe<SupplierFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<SupplierAggregate>;
  systemSettings?: Maybe<DataStoreRecord>;
  tag: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Tag>;
  tags: (args?: {
    filter?: Maybe<TagFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Tag>>;
  tagsAggregate: (args?: {
    filter?: Maybe<TagFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<TagAggregate>;
  timerTransaction: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<TimerTransaction>;
  timerTransactions: (args?: {
    filter?: Maybe<TimerTransactionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<TimerTransaction>>;
  timerTransactionsAggregate: (args?: {
    filter?: Maybe<TimerTransactionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<TimerTransactionAggregate>;
  timers: (args?: {
    filter?: Maybe<ProcessTimerFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<ProcessTimer>>;
  timersAggregate: (args?: {
    filter?: Maybe<ProcessTimerFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<ProcessTimerAggregate>;
  uploadRequestUrl: (args: {
    area: ScalarsEnums["String"];
    fileName: ScalarsEnums["String"];
    jobNumber: ScalarsEnums["String"];
    notes: ScalarsEnums["String"];
  }) => Maybe<UploadRequestUrl>;
  user: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<User>;
  userIdentities: (args?: {
    filter?: Maybe<UserIdentityFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<UserIdentity>>;
  userIdentitiesAggregate: (args?: {
    filter?: Maybe<UserIdentityFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<UserIdentityAggregate>;
  userIdentity: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<UserIdentity>;
  userPermission: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<UserPermission>;
  userPermissions: (args?: {
    filter?: Maybe<UserPermissionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<UserPermission>>;
  userPermissionsAggregate: (args?: {
    filter?: Maybe<UserPermissionFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<UserPermissionAggregate>;
  users: (args?: {
    filter?: Maybe<UserFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<User>>;
  usersAggregate: (args?: {
    filter?: Maybe<UserFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<UserAggregate>;
  warehouse: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Warehouse>;
  warehouses: (args?: {
    filter?: Maybe<WarehouseFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Warehouse>>;
  warehousesAggregate: (args?: {
    filter?: Maybe<WarehouseFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<WarehouseAggregate>;
  webhook: (args?: { id?: Maybe<ScalarsEnums["ID"]> }) => Maybe<Webhook>;
  webhooks: (args?: {
    filter?: Maybe<WebhookFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<Webhook>>;
  webhooksAggregate: (args?: {
    filter?: Maybe<WebhookFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<WebhookAggregate>;
  weeks: (args?: { filter?: Maybe<WeekFilterInput> }) => Maybe<Array<Week>>;
  workflowNote: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<WorkflowNote>;
  workflowNotes: (args?: {
    filter?: Maybe<WorkflowNoteFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<WorkflowNote>>;
  workflowNotesAggregate: (args?: {
    filter?: Maybe<WorkflowNoteFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<WorkflowNoteAggregate>;
  workflowTemplate: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<WorkflowTemplate>;
  workflowTemplates: (args?: {
    filter?: Maybe<WorkflowTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<WorkflowTemplate>>;
  workflowTemplatesAggregate: (args?: {
    filter?: Maybe<WorkflowTemplateFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<WorkflowTemplateAggregate>;
  workflowType: (args?: {
    id?: Maybe<ScalarsEnums["ID"]>;
  }) => Maybe<WorkflowType>;
  workflowTypes: (args?: {
    filter?: Maybe<WorkflowTypeFilterInput>;
    group?: Maybe<ResourceGroupInput>;
    options?: Maybe<OptionsInput>;
  }) => Maybe<Array<WorkflowType>>;
  workflowTypesAggregate: (args?: {
    filter?: Maybe<WorkflowTypeFilterInput>;
    group?: Maybe<ResourceGroupInput>;
  }) => Maybe<WorkflowTypeAggregate>;
}

export interface Subscription {
  __typename?: "Subscription";
  /**
   * A placeholder query used by thecodingmachine/graphqlite when there are no declared subscriptions.
   */
  dummySubscription?: Maybe<ScalarsEnums["String"]>;
}

export interface $PaginatedResultInterface {
  PagedJobs?: PagedJobs;
  PaginatedResult?: PaginatedResult;
}

export interface GeneratedSchema {
  query: Query;
  mutation: Mutation;
  subscription: Subscription;
}

export type ScalarsEnums = {
  [Key in keyof Scalars]: Scalars[Key] extends { output: unknown }
    ? Scalars[Key]["output"]
    : never;
} & {
  AuthProviderType: AuthProviderType;
  CandidateIngestionMode: CandidateIngestionMode;
  CostingLineType: CostingLineType;
  CostingTemplateRevisionStatus: CostingTemplateRevisionStatus;
  DomainEventType: DomainEventType;
  EmailDeliveryStatus: EmailDeliveryStatus;
  LeadStatusEnum: LeadStatusEnum;
  NotificationAction: NotificationAction;
  OrderCategory: OrderCategory;
  OrderReviewStatus: OrderReviewStatus;
  OrderShippingMethods: OrderShippingMethods;
  OrderShippingTerms: OrderShippingTerms;
  OrderStatus: OrderStatus;
  Policy: Policy;
  ProductImportUpdateField: ProductImportUpdateField;
  QuoteLineType: QuoteLineType;
  QuoteTemplateRevisionStatus: QuoteTemplateRevisionStatus;
  RecordScreenType: RecordScreenType;
  RecordSource: RecordSource;
  RecordType: RecordType;
  ReportDateInterval: ReportDateInterval;
  ResourceGroupDirection: ResourceGroupDirection;
  ScreenGroup: ScreenGroup;
  StockTransactionType: StockTransactionType;
};
